var _CUSTOM_COD_FORM_PROVINCES = {
  data: {
  "AGUASCALIENTES": {
    "AGUASCALIENTES": {
      "20000": {
        "AGUASCALIENTES CENTRO": true
      },
      "20010": {
        "COLINAS DEL RIO": true,
        "LAS BRISAS": true,
        "OLIVARES SANTANA": true,
        "RAMON ROMO FRANCO": true,
        "SAN CAYETANO": true
      },
      "20016": {
        "COLINAS DE SAN IGNACIO": true,
        "FUNDICIÓN II": true,
        "LA FUNDICIÓN": true,
        "LOS SAUCES": true
      },
      "20018": {
        "LÍNEA DE FUEGO": true
      },
      "20020": {
        "BUENOS AIRES": true,
        "CIRCUNVALACIÓN NORTE": true,
        "LAS ARBOLEDAS": true,
        "VILLAS DE SAN FRANCISCO": true
      },
      "20029": {
        "VILLAS DE LA UNIVERSIDAD": true
      },
      "20030": {
        "EL SOL": true,
        "GREMIAL": true,
        "INDUSTRIAL": true
      },
      "20040": {
        "ALTAVISTA": true,
        "CURTIDORES": true,
        "LA CONCORDIA": true,
        "MIRAVALLE": true,
        "PANORAMA": true,
        "RESIDENCIAL GUADALUPE": true
      },
      "20049": {
        "COLINAS DEL PONIENTE": true
      },
      "20050": {
        "BUGAMBILIAS": true,
        "DEL CARMEN": true,
        "LA FE": true,
        "PRIMAVERA": true,
        "SAN PABLO": true
      },
      "20059": {
        "GUADALUPE": true,
        "HELIODORO GARCIA": true
      },
      "20060": {
        "GÓMEZ": true,
        "MODERNO": true
      },
      "20064": {
        "VALLE DEL RIO SAN PEDRO": true
      },
      "20070": {
        "GUADALUPE POSADA": true,
        "SAN MARCOS": true
      },
      "20078": {
        "SAN MARCOS": true
      },
      "20080": {
        "MODELO": true,
        "RESIDENCIAL DEL VALLE I": true
      },
      "20089": {
        "RESIDENCIAL DEL VALLE II": true
      },
      "20100": {
        "CIUDAD UNIVERSITARIA": true,
        "CLUB CAMPESTRE": true,
        "JARDINES DEL CAMPESTRE": true,
        "LA HERRADURA": true,
        "LOS VERGELES": true,
        "RANCHO SAN ANTONIO": true
      },
      "20110": {
        "GRANJAS DEL CAMPESTRE": true,
        "LA ENRAMADA": true,
        "LAS CAVAS": true,
        "PUERTO LAS HADAS": true,
        "TALAMANTES PONCE": true,
        "VALLE DEL CAMPESTRE": true,
        "VILLAS DE MONTENEGRO": true
      },
      "20115": {
        "BARRIO DE SANTIAGO": true,
        "LA PALOMA": true,
        "SAN TELMO": true,
        "TROJES DE ORIENTE": true,
        "VALLE DE LAS TROJES": true,
        "VALLE DE SANTA TERESA": true,
        "VILLA DE LAS TROJES": true,
        "VILLAS DE SAN NICOLÁS": true
      },
      "20116": {
        "LA TROJE": true,
        "SAN TELMO RESIDENCIAL": true,
        "SANTA FÉ": true,
        "TROJES DE ALONSO": true
      },
      "20118": {
        "ANDORA RESIDENCIAL": true,
        "CADAQUÉS RESIDENCIAL": true,
        "CERRADA DE LA MEZQUITERA": true,
        "CERRADA DE LA MISIÓN": true,
        "CERRADA DEL VALLE": true,
        "CERRADA EL MOLINO": true,
        "LAS MISIONES": true,
        "LAS TROJES": true,
        "LOS CALICANTOS": true,
        "LOS JARALES": true,
        "MISIÓN DE SANTIAGO": true,
        "MISIÓN DEL CAMPANARIO": true,
        "RESIDENCIAL SANTA CLARA": true,
        "TERZETTO": true,
        "TROJES DE CRISTAL": true,
        "TROJES DEL SOL": true,
        "VALLE DEL CAMPANARIO": true,
        "VALLE REAL": true
      },
      "20119": {
        "LOMAS DEL CAMPESTRE 2A SECCIÓN": true,
        "VILLAS DEL CAMPESTRE": true
      },
      "20120": {
        "JARDINES DE LA CONCEPCIÓN": true,
        "LOS BOSQUES": true,
        "RINCONADA LOS BOSQUES": true
      },
      "20123": {
        "ARROYO EL MOLINO": true,
        "LA PERLA NORTE": true
      },
      "20124": {
        "GALERÍAS": true,
        "RESIDENCIAL ALTARIA": true
      },
      "20126": {
        "CAPITTALA": true,
        "CARTAGENA 1947": true,
        "CONSTITUCIÓN": true,
        "EL PUERTECITO": true,
        "EL ROSEDAL": true,
        "JARDINES DE MONTEBELLO": true,
        "LA SOLEDAD": true,
        "LAS PLAZAS": true,
        "LIBERTAD": true,
        "LOMAS DE LA ASUNCIÓN": true,
        "LOS NARANJOS": true,
        "LOS ÁNGELES": true,
        "MONTEBELLO DELLA STANZA": true,
        "NATURA": true,
        "NÁPOLI": true,
        "POZO BRAVO NORTE": true,
        "POZO BRAVO SUR": true,
        "PRIVADA GUADALUPE": true,
        "RECINTO DE LA MACARENA": true,
        "RINCONADA DEL PUERTECITO": true,
        "RINCONADA POZO BRAVO": true,
        "SAN JOSÉ DE POZO BRAVO": true,
        "SOBERANA CONVENCIÓN REVOLUCIONARIA": true,
        "VILLA DE NUESTRA SEÑORA DE LA ASUNCIÓN SECTOR ALAMEDA": true,
        "VILLA DE NUESTRA SEÑORA DE LA ASUNCIÓN SECTOR ENCINO": true,
        "VILLA DE NUESTRA SEÑORA DE LA ASUNCIÓN SECTOR ESTACIÓN": true,
        "VILLA DE NUESTRA SEÑORA DE LA ASUNCIÓN SECTOR GUADALUPE": true,
        "VILLA DE NUESTRA SEÑORA DE LA ASUNCIÓN SECTOR SAN MARCOS": true,
        "VILLA LOMA DORADA": true,
        "VILLA MONTAÑA": true,
        "VILLA NOTRE DAME": true,
        "VILLA TERESA": true,
        "VILLAS DE DON ANTONIO": true,
        "VILLAS DE LA CONVENCIÓN": true,
        "VILLAS DEL RÍO": true
      },
      "20127": {
        "BOSQUES DEL PRADO NORTE": true
      },
      "20129": {
        "LOMAS DEL CAMPESTRE 1A SECCIÓN": true
      },
      "20130": {
        "BOSQUES DEL PRADO SUR": true,
        "EL ROBLE": true,
        "FÁTIMA": true,
        "INDEPENDENCIA DE MÉXICO": true,
        "MURALIA": true,
        "NUEVA RINCONADA": true,
        "PALMA REAL": true,
        "PRIMO VERDAD": true,
        "PUERTA NAVARRA": true,
        "RESIDENCIAL CAMPESTRE CLUB DE GOLF": true,
        "RESIDENCIAL DEL REAL": true,
        "SAN JOSÉ DEL ARENAL": true,
        "SAN XAVIER": true,
        "UNIDAD GANADERA": true
      },
      "20135": {
        "AGROPECUARIO": true,
        "CENTRO DISTRIBUIDOR DE BÁSICOS": true
      },
      "20136": {
        "LA RINCONADA": true
      },
      "20137": {
        "EL PLATEADO": true
      },
      "20138": {
        "CERRADA SAN MIGUEL": true,
        "RESIDENCIAL PULGAS PANDAS NORTE": true,
        "RESIDENCIAL PULGAS PANDAS SUR": true,
        "VILLAS DEL VERGEL": true
      },
      "20140": {
        "ANDREA": true,
        "LAS HADAS": true,
        "MORELOS": true
      },
      "20146": {
        "LOS ARCOS": true
      },
      "20149": {
        "INDUSTRIAL": true
      },
      "20150": {
        "BUENAVISTA": true,
        "C.T.M.": true,
        "LA ESTRELLA": true,
        "LOMAS DEL COBANO": true,
        "MACIAS ARELLANO": true,
        "NUEVA ANDALUCIA COTO RESIDENCIAL": true,
        "TRENTO": true,
        "VÁLTICA": true
      },
      "20157": {
        "LA HIGUERILLA": true,
        "PARRAS": true
      },
      "20158": {
        "EL COBANO": true,
        "HACIENDA EL COBANO": true,
        "TROJES DEL COBANO": true,
        "VILLAS DEL COBANO": true
      },
      "20159": {
        "ALIANZA FERROCARRILERA": true,
        "BOSQUES DEL PRADO ORIENTE": true
      },
      "20160": {
        "FRANCISCO GUEL JIMENEZ": true,
        "LAS VIÑAS INFONAVIT": true
      },
      "20164": {
        "SANTA ANITA 4A SECCIÓN": true
      },
      "20169": {
        "SANTA ANITA": true,
        "SANTA ANITA 2A SECCIÓN": true
      },
      "20170": {
        "EL MAGUEY": true,
        "LAS CUMBRES": true,
        "LIC BENITO JUÁREZ": true,
        "NAZARIO ORTIZ GARZA": true,
        "RODOLFO LANDEROS GALLEGOS": true,
        "S.T.E.M.A.": true,
        "VILLA BONITA": true,
        "ZONA MILITAR": true
      },
      "20172": {
        "ANEXO BENITO PALOMINO DENA (CUMBRES II)": true,
        "CLAUSTROS LOMA DORADA": true,
        "CUMBRES III": true,
        "LA FLORIDA L": true,
        "LA FLORIDA LL": true,
        "LIC BENITO PALOMINO DENA": true
      },
      "20174": {
        "COLINAS DE ORIENTE": true,
        "EL ROCÍO": true,
        "LOMAS DE BELLAVISTA": true,
        "LOMAS DE LAS FUENTES": true,
        "LOS LAURELES": true,
        "LOS PERICOS": true,
        "MIRADOR DE LAS CULTURAS": true,
        "MIRADORES DE SANTA ELENA": true,
        "PASEOS DEL SOL": true,
        "VILLAS DE LA LOMA": true,
        "VILLAS DE LAS FUENTES": true,
        "VISTA DE LAS CUMBRES": true
      },
      "20175": {
        "EJIDO LAS CUMBRES": true,
        "J REFUGIO ESPARZA REYES": true,
        "LA HOJARASCA": true,
        "LOMAS DE ORIENTE": true,
        "RINCONADAS LAS CUMBRES": true
      },
      "20177": {
        "C.N.O.P. ORIENTE": true
      },
      "20179": {
        "CERRO ALTO": true,
        "LAS CUMBRES": true,
        "LUIS ORTEGA DOUGLAS": true,
        "PENSADORES MEXICANOS": true,
        "PINTORES MEXICANOS": true,
        "PROGRESO": true,
        "SANTA MARGARITA": true,
        "SANTA REGINA": true
      },
      "20180": {
        "ALAMEDA": true,
        "BOSQUES DE LA ALAMEDA": true,
        "DEL TRABAJO": true,
        "FERRONALES": true,
        "LOMAS DE SANTA ANITA": true,
        "LUIS GÓMEZ ZEPEDA (FERRONALES)": true,
        "NUEVA ALAMEDA": true,
        "RINCONADA DE LA ALAMEDA": true
      },
      "20190": {
        "HÉROES": true,
        "LA HACIENDA": true,
        "LA MANCHA": true
      },
      "20196": {
        "AMBROSÍA": true,
        "BALCONES DE ORIENTE": true,
        "BALCONES DEL VALLE": true,
        "CAMINO REAL": true,
        "COLINAS DE SAN PATRICIO": true,
        "COMUNIDAD EL ROCÍO": true,
        "EL POLVORÍN (MIRADOR TV AZTECA)": true,
        "HACIENDAS DE AGUASCALIENTES": true,
        "JOSÉ GUADALUPE PERALTA GÁMEZ": true,
        "JOSÉ GUADALUPE POSADA": true,
        "MOLINO DEL REY": true,
        "OJOCALIENTE": true,
        "OJOCALIENTE INEGI": true,
        "PASEO DE LOS CACTUS": true,
        "REAL DE HACIENDAS": true,
        "REAL DEL SOL": true,
        "RIBERA DEL SOL": true,
        "SOL NACIENTE": true,
        "SOLIDARIDAD 1A SECCIÓN": true,
        "TERRA NOVA": true,
        "VALLE DE LOS CACTUS": true,
        "VILLA DE LAS NORIAS": true,
        "VILLERÍAS": true,
        "VISTAS DE ORIENTE": true
      },
      "20198": {
        "EJIDO OJOCALIENTE": true,
        "EX HACIENDA OJOCALIENTE": true,
        "MISIÓN ALAMEDA": true
      },
      "20199": {
        "EL RIEGO": true,
        "FIDEL VELÁZQUEZ": true,
        "MUNICIPIO LIBRE": true
      },
      "20200": {
        "LOMA BONITA": true
      },
      "20205": {
        "EDUCACIÓN ÁLAMOS": true,
        "NUEVA ESPAÑA": true
      },
      "20206": {
        "BARANDALES DE SAN JOSÉ": true,
        "LA BARRANQUILLA": true,
        "LIC. JOSÉ LÓPEZ PORTILLO": true
      },
      "20207": {
        "CANTERAS DE SAN JAVIER": true,
        "CAPITAL CITY": true,
        "RINCONADA SAN JOSÉ": true
      },
      "20208": {
        "CANTERAS DE SAN JOSÉ": true
      },
      "20210": {
        "CIRCUNVALACIÓN PONIENTE": true,
        "ESPAÑA": true,
        "LA BARRANCA DE GUADALUPE": true,
        "PIRULES INFONAVIT": true
      },
      "20217": {
        "RESIDENCIAL LOS PIRULES": true
      },
      "20218": {
        "CANTERAS DE SAN AGUSTIN": true,
        "CANTERAS DE SANTA IMELDA": true,
        "FRANCISCO VILLA": true,
        "GRANNA": true,
        "JARDINES DEL LAGO": true,
        "LOS EUCALIPTOS": true,
        "LOS EUCALIPTOS 2A. SECCIÓN": true,
        "PRIVANZA LUCERNA": true,
        "SAN AGUSTÍN": true,
        "SAN MARTIN DE LA CANTERA": true,
        "SANTA BÁRBARA": true,
        "SANTA IMELDA": true,
        "TAHONA RESIDENCIAL": true
      },
      "20219": {
        "EL EDÉN": true,
        "MISIÓN JUAN PABLO II": true,
        "PARQUE INDUSTRIAL EL VERGEL": true
      },
      "20220": {
        "LAS FLORES": true,
        "VIVIENDA POPULAR": true
      },
      "20229": {
        "LAS TORRES": true
      },
      "20230": {
        "LAS AMÉRICAS": true,
        "OBRAJE": true,
        "SANTA ELENA": true
      },
      "20234": {
        "AGRICULTURA": true
      },
      "20235": {
        "EL DORADO 1A SECCIÓN": true,
        "EL DORADO 2A SECCIÓN": true,
        "VALLE DORADO": true,
        "VILLA JARDÍN": true
      },
      "20236": {
        "JARDINES DE SANTA ELENA": true
      },
      "20237": {
        "HERMANOS CARREÓN": true,
        "MONTEBELLO": true
      },
      "20238": {
        "SANTA ELENA 2A SECCIÓN": true
      },
      "20239": {
        "LA FUENTE": true
      },
      "20240": {
        "EL ENCINO": true,
        "EL LAUREL": true,
        "EL LLANITO": true,
        "LA LUNA": true,
        "LA SALUD": true,
        "LOS VIRREYES": true,
        "RESIDENCIAL COSÍO": true,
        "RESIDENCIAL EL ENCINO": true,
        "TRIANA": true
      },
      "20247": {
        "SAN FERNANDO INFONAVIT": true
      },
      "20248": {
        "JARDINES DE TRIANA": true
      },
      "20249": {
        "GÁMEZ": true
      },
      "20250": {
        "HÉROES DE AGUASCALIENTES": true,
        "JARDINES DE LA CRUZ": true,
        "JESÚS GÓMEZ PORTUGAL": true,
        "LA HUERTA": true,
        "SAN LUIS": true,
        "VILLAS DE KRISTAL": true,
        "VIVIENDA MILITAR": true
      },
      "20255": {
        "BONA GENS": true,
        "INFONAVIT LOS VOLCANES": true
      },
      "20256": {
        "FOVISSSTE OJOCALIENTE I": true,
        "OJOCALIENTE FOVISSSTE II": true,
        "OJOCALIENTE LAS TORRES": true,
        "PARQUE Y PRESA DEL CEDAZO": true,
        "RINCONADA DE LA CRUZ": true,
        "VILLAS DE OJOCALIENTE": true
      },
      "20257": {
        "LÁZARO CÁRDENAS": true
      },
      "20259": {
        "LA ESTACIÓN": true,
        "LA PURÍSIMA": true
      },
      "20260": {
        "IV CENTENARIO": true,
        "JESÚS TERÁN PEREDO": true,
        "OJO DE AGUA": true,
        "RINCONADA EL CEDAZO": true,
        "SIDUSA": true
      },
      "20263": {
        "AGUA CLARA": true,
        "BAJÍO DE LAS PALMAS": true,
        "BALCONES DE OJOCALIENTE": true,
        "CIELO CLARO": true,
        "CIMA DEL CHAPULÍN": true,
        "COBANO DE PALMITAS": true,
        "EL CEDAZO": true,
        "LA LOMITA": true,
        "LOMAS DEL CHAPULÍN": true,
        "LOMAS DEL GACHUPÍN": true,
        "OJO DE AGUA DE PALMITAS": true,
        "RINCONADA SAN ANTONIO I": true,
        "SALTO DE OJOCALIENTE": true,
        "SAN JORGE": true,
        "SAN ÁNGEL": true,
        "SOLIDARIDAD 2A SECCIÓN": true,
        "SOLIDARIDAD 3A SECCIÓN": true,
        "TIERRA BUENA": true,
        "VILLA LAS PALMAS": true,
        "VILLA TAURINA": true
      },
      "20264": {
        "MORELOS INFONAVIT": true,
        "VISTA DEL SOL 1A SECCIÓN": true,
        "VISTA DEL SOL 2A SECCIÓN": true,
        "VISTA DEL SOL 3A SECCIÓN": true
      },
      "20265": {
        "OJO DE AGUA INFONAVIT": true
      },
      "20266": {
        "JARDÍNES DEL SOL": true,
        "LA CRUZ": true,
        "MISIÓN DE SANTA FE": true
      },
      "20267": {
        "JARDINES DE LA CONVENCIÓN": true,
        "LIC PRIMO VERDAD INEGI": true,
        "OJO DE AGUA FOVISSSTE 1A SECCIÓN": true,
        "S.T.E.M.A.": true
      },
      "20268": {
        "FUENTES DE LA ASUNCIÓN": true
      },
      "20269": {
        "JARDINES DE LA LUZ": true
      },
      "20270": {
        "BULEVAR": true,
        "EL CAMINERO": true,
        "JARDINES DE AGUASCALIENTES": true,
        "JARDINES DE LA ASUNCIÓN": true,
        "LAS CANOAS": true,
        "LINDAVISTA": true,
        "LOS CEDROS": true,
        "MESONERO": true,
        "MÉXICO": true
      },
      "20276": {
        "JARDINES DE ALEJANDRÍA": true,
        "JARDINES DE LAS BUGAMBILIAS": true,
        "JARDINES DEL PARQUE": true
      },
      "20277": {
        "PIRÁMIDES": true,
        "RESIDENCIAL DEL PARQUE": true,
        "RINCONADA DEL PARQUE": true
      },
      "20278": {
        "JARDINES DE LAS FUENTES": true
      },
      "20280": {
        "AUSTRALIS": true,
        "CASASOLIDA": true,
        "CENTRAL DE ABASTOS": true,
        "CONJUNTO SAN FRANCISCO": true,
        "JARDINES DEL SUR": true,
        "MARTINEZ DOMINGUEZ": true,
        "PRADOS DE VILLASUNCIÓN": true,
        "PRADOS DEL SUR": true,
        "SAN FRANCISCO DEL ARENAL": true,
        "SAN PEDRO": true,
        "TORRES DE SAN FRANCISCO": true,
        "TROJES DEL SUR": true,
        "VILLAS DE SAN JOSÉ": true
      },
      "20283": {
        "KERARTA": true
      },
      "20284": {
        "INFONAVIT POTREROS DEL OESTE": true,
        "LA CASITA": true,
        "LA ESTANCIA": true,
        "RINCONADA DEL SUR": true,
        "VILLAS DE SANTA ROSA": true,
        "VILLAS DEL ENCINO": true,
        "VILLAS DEL OESTE": true,
        "VISTAS DEL SUR": true
      },
      "20285": {
        "VERSALLES 1A SECCIÓN": true,
        "VERSALLES 2A SECCIÓN": true
      },
      "20286": {
        "ABADÍA": true,
        "AMURA": true,
        "BARLOVENTO": true,
        "BOSQUE REAL": true,
        "CARANDAY": true,
        "LUZIA": true,
        "MANGATA": true,
        "PASEOS DE SANTA MÓNICA": true,
        "PROVIDENCIA": true,
        "RANCHO SANTA MÓNICA": true,
        "RINCONADA SANTA MÓNICA": true,
        "VICENTE GUERRERO": true,
        "VILLAS DEL PILAR 1A SECCIÓN": true,
        "VILLAS SAN ANTONIO": true
      },
      "20287": {
        "INSURGENTES": true
      },
      "20288": {
        "BULEVARES 1A. SECCIÓN": true,
        "BULEVARES 2A. SECCIÓN": true
      },
      "20289": {
        "PILAR BLANCO INFONAVIT": true
      },
      "20290": {
        "CIUDAD INDUSTRIAL": true
      },
      "20296": {
        "RESERVA SAN MATÍAS": true,
        "RESIDENCIAL SAN JAVIER": true,
        "RÚSTICOS CALPULLI": true,
        "SAN FRANCISCO DE LOS ARTEAGA": true,
        "VILLA SUR": true,
        "VILLAS DE BONATERRA": true
      },
      "20297": {
        "CASA BLANCA": true,
        "JARDINES DE CASABLANCA": true,
        "JARDINES DE CASANUEVA": true
      },
      "20298": {
        "EMILIANO ZAPATA": true
      },
      "20299": {
        "LOMAS DEL AJEDREZ": true
      },
      "20310": {
        "LOS NEGRITOS": true
      },
      "20313": {
        "CUAUHTÉMOC (LAS PALOMAS)": true
      },
      "20314": {
        "EL CARIÑÁN": true
      },
      "20320": {
        "ESTACIÓN CAÑADA HONDA": true
      },
      "20323": {
        "SANTA MARÍA DE GALLARDO": true
      },
      "20326": {
        "ALBANTA NORTE": true,
        "ALBANTA SUR": true,
        "BELAGO RESIDENCE": true,
        "BOSQUE SERENO": true,
        "CAVALIA": true,
        "EX-HACIENDA DE SAN IGNACIO": true,
        "HACIENDA PARAÍSO": true,
        "LA AURORA": true,
        "LA PERLA": true,
        "LA RIOJA": true,
        "LA SOLEDAD": true,
        "LA TRINIDAD": true,
        "LORETTA": true,
        "MISIÓN DE SAN JERÓNIMO": true,
        "PARQUE INDUSTRIAL TECNOPOLO 2 (PITP2)": true,
        "PASEOS LORETTA": true,
        "PORTÓN SAN IGNACIO": true,
        "PRIVADA LOS OLIVOS": true,
        "PUESTA DEL SOL": true,
        "QUINTA LOS OLIVOS": true,
        "RESIDENCIAL PUNTA DEL CIELO": true,
        "RINCONADA DE SAN IGNACIO": true,
        "SAN IGNACIO": true,
        "SAN IGNACIO II": true,
        "SAN IGNACIO III": true,
        "TAMARINDOS": true,
        "VALLE DE SAN IGNACIO (EL FILSO)": true,
        "XARAMÁ ENTORNO RESIDENCIAL": true
      },
      "20328": {
        "LOS FRESNOS": true,
        "PARQUE INDUSTRIAL TECNOPOLO POCITOS": true,
        "POCITOS": true,
        "RESERVA RESIDENCIAL": true,
        "TERRANZA": true,
        "VISTA CASTELLANA": true,
        "VISTA PIAMONTE": true
      },
      "20329": {
        "CONTADERO": true,
        "COTO ANDALUZ": true,
        "LA JOYA": true,
        "LA PLAZUELA": true,
        "LA PUNTA CAMPESTRE": true,
        "LA QUERENCIA": true,
        "PRIVADA ANDALUZ": true,
        "RESIDENCIAL LAS QUINTAS": true,
        "RINCÓN ANDALUZ": true,
        "RÍO VIEJO": true,
        "TORRES RESIDENCIAL CAMPESTRE SANTAMARÍA": true
      },
      "20340": {
        "PARQUE INDUSTRIAL DE LOGÍSTICA AUTOMOTRIZ (PILA)": true
      },
      "20342": {
        "SAN FRANCISCO": true
      },
      "20344": {
        "LA RINCONADA (LA ESCONDIDA)": true
      },
      "20345": {
        "MONTORO (MESA DEL SALTO)": true
      },
      "20346": {
        "LOS CAÑOS": true
      },
      "20348": {
        "SAN ANTONIO DE PEÑUELAS": true
      },
      "20363": {
        "SAN ANTONIO DE LOS PEDROZA": true
      },
      "20364": {
        "SAN NICOLÁS DE ARRIBA": true
      },
      "20366": {
        "LA HERRADA": true
      },
      "20367": {
        "2 DE OCTUBRE": true
      },
      "20369": {
        "EL MALACATE": true
      },
      "20370": {
        "PUERTO DE NIETO": true
      },
      "20372": {
        "CABECITA 3 MARÍAS (RANCHO NUEVO)": true
      },
      "20375": {
        "EL TANQUE DE LOS JIMÉNEZ": true
      },
      "20386": {
        "EL DURAZNILLO": true
      },
      "20389": {
        "LOS DURÓN": true
      },
      "20392": {
        "CAMPESTRE EL POTRERILLO": true
      },
      "20393": {
        "PARQUE INDUSTRIAL FINSA AGUASCALIENTES": true
      },
      "20395": {
        "COTORINA (COYOTES)": true
      },
      "20396": {
        "EL REFUGIO DE PEÑUELAS": true
      }
    },
    "JESÚS MARÍA": {
      "20900": {
        "CAMINO REAL": true,
        "CORRAL DE BARRANCOS": true,
        "LA NOGALERA": true,
        "LAS PÉRGOLAS": true,
        "LOS OLIVOS": true,
        "MARAVILLAS": true,
        "PUERTA NORTE": true,
        "RESIDENCIAL CAMPESTRE INGLES": true,
        "RESIDENCIAL MISIÓN DE SAN JOSÉ": true,
        "RESIDENCIAL VILLA CAMPESTRE": true,
        "RINCONADA MARAVILLAS": true,
        "SANTO DOMINGO": true,
        "VALLE ESCONDIDO": true
      },
      "20905": {
        "LA LOMITA DE PASO BLANCO (LAS CANOAS)": true,
        "LOS ARENALES": true,
        "LOS SAUCES": true,
        "MIRAVALLE": true,
        "PASO BLANCO": true
      },
      "20907": {
        "ARBOLEDAS DE PASO BLANCO": true,
        "CENTRAL DE ABASTOS VIÑEDOS SAN MARCOS": true,
        "JARDINES DE CAMPO REAL": true,
        "PASEOS DE AGUASCALIENTES": true,
        "PASEOS DEL COUNTRY": true,
        "RESIDENCIAL CAMPO REAL": true,
        "SANTA ELENA": true,
        "VIÑEDOS CASA LEAL": true,
        "VIÑEDOS EVA (FRACCIONAMIENTO PASO BLANCO)": true,
        "VIÑEDOS FRUTILANDIA": true
      },
      "20908": {
        "ALCÁZAR RESIDENCIAL": true,
        "ANDARES": true,
        "AUGUSTA": true,
        "BELMONDO": true,
        "BOSQUES DE LOS CIPRÉS": true,
        "BOSQUES DEL PARAÍSO I": true,
        "BOSQUES DEL PARAÍSO II": true,
        "BOSQUES DEL PARAÍSO III": true,
        "BOSQUES DEL PARAÍSO IV": true,
        "BOSQUES DEL PARAÍSO VI": true,
        "CARTAGENA": true,
        "CATANIA SPAZIO": true,
        "LA ARBORADA": true,
        "LOS GAVILANES": true,
        "MAYORAZGO SAN CRISTÓBAL": true,
        "NURA": true,
        "PORTA REAL": true,
        "PORTA VITTA RESIDENCIAL": true,
        "PRIVANZA GRATAMIRA": true,
        "PUNTA NORTE": true,
        "QUINTAS DE MONTICELLO": true,
        "RANCHO SAN MIGUEL RESIDENCIAL": true,
        "RESERVA SAN CRISTÓBAL": true,
        "RESIDENCIAL CEDROS": true,
        "RESIDENCIAL MARCELLANA": true,
        "RINCONADA CUAUHTÉMOC": true,
        "SAN MATEO": true,
        "SANTA ISABEL TOLA": true,
        "TEPETATES": true,
        "TIERRAVERDE (HABITAT GRAN CLASE)": true,
        "TROJES DE SAN CRISTÓBAL": true,
        "VILLAS DE SAN PEDRO": true,
        "VILLAS DEL MOLINO": true,
        "VIVANTA": true,
        "VIÑA ANTIGUA": true,
        "VIÑA REAL": true,
        "ZIBÁ": true
      },
      "20920": {
        "JESÚS MARÍA CENTRO": true
      },
      "20922": {
        "BELLAVISTA": true,
        "EL CALVARIO": true,
        "LA ESCALERA": true,
        "LA TROJE": true
      },
      "20923": {
        "FLORES MAGÓN": true,
        "LA CARDONA": true,
        "LA CUESTA": true,
        "LA MISIÓN": true,
        "LA VILLA RESIDENCIAL": true,
        "LOS ARROYITOS": true,
        "LOS ÁLAMOS": true,
        "REAL CAMPESTRE": true,
        "RESIDENCIAL JESÚS MARÍA": true,
        "RINCONADA JESÚS MARÍA": true,
        "RINCONADA SAN MIGUELITO": true,
        "RUISEÑORES": true,
        "SAN MIGUELITO": true
      },
      "20924": {
        "AGUA CLARA": true,
        "CIELO CLARO": true,
        "DEPORTIVA": true,
        "JACARANDAS": true,
        "PALMA DORADA": true,
        "RANCHO SAN PEDRO": true
      },
      "20925": {
        "AGUA ZARCA": true,
        "ARROYO DEL BOSQUE": true,
        "ARROYO SAN EMILIÓN RESIDENCIAL": true,
        "BENIGNO CHÁVEZ": true,
        "LA LOMA DE MARAVILLAS": true,
        "LOMAS DE JESÚS MARÍA": true,
        "MISANTLA": true,
        "PUERTA GRANDE": true,
        "VILLAS TEC": true,
        "VISTA DEL SAUZ": true
      },
      "20926": {
        "ABADA RESIDENCIAL": true,
        "ARBOLEDAS": true,
        "CHICAHUALES": true,
        "LA LOMA": true,
        "LA PALMA": true,
        "LA PIEDRA": true,
        "LAS PALMAS": true,
        "LOMAS DE LOS VERGELES": true,
        "LOMAS DEL VALLE": true,
        "MANANTIALES DEL PINAR": true,
        "MARTÍNEZ ANDRADE": true,
        "MIRABRUJAS": true,
        "MISIÓN DE SANTA MARÍA": true,
        "PORTA ARVENA": true,
        "QUINTAS MIGUEL JERÓNIMO": true,
        "RESIDENCIAL TRES ARROYOS": true,
        "RINCONADA BUGAMBILIAS": true,
        "RINCÓN DEL PILAR": true,
        "SOLIDARIDAD": true,
        "TULIPANES RESIDENCIAL": true,
        "VISTA HERMOSA": true,
        "YALTA CAMPESTRE": true
      },
      "20927": {
        "AMPLIACIÓN LA CAÑADA": true,
        "AYUNTAMIENTO": true,
        "LA CAÑADA": true,
        "OJOS DE AGUA": true,
        "POZO LA PALMA (LA VIZNAGA)": true
      },
      "20983": {
        "EL LLANO": true,
        "MARABELLA RESIDENCIAL": true,
        "MEZQUITAL DEL COUNTRY": true,
        "REAL DEL MOLINO": true,
        "RESIDENCIAL ANTIGUO COUNTRY": true,
        "RESIDENCIAL TROJES DEL NORTE": true,
        "RESIDENCIAL TROJES DEL NORTE II": true,
        "TROJES DEL PEDREGAL": true
      },
      "20984": {
        "ANDREA": true,
        "PROVIDENCIA": true,
        "VILLA NATTY RESIDENCIAL": true
      }
    }
  },
  "CAMPECHE": {
    "CAMPECHE": {
      "24000": {
        "SAN FRANCISCO DE CAMPECHE CENTRO": true
      },
      "24010": {
        "GUADALUPE": true
      },
      "24014": {
        "AH-KIM-PECH": true
      },
      "24020": {
        "RESIDENCIAL DEL BOSQUE": true
      },
      "24022": {
        "MONTECARLO": true
      },
      "24023": {
        "FIDEL VELÁZQUEZ": true
      },
      "24024": {
        "MÁRTIRES DE RÍO BLANCO": true
      },
      "24025": {
        "SOLIDARIDAD NACIONAL": true
      },
      "24026": {
        "GRANJAS": true
      },
      "24027": {
        "PALMAS": true
      },
      "24028": {
        "VILLAS DE AH-KIM-PECH": true
      },
      "24029": {
        "CENTRO SCT CAMPECHE": true
      },
      "24030": {
        "BOSQUES DE CAMPECHE": true
      },
      "24035": {
        "LOMAS DEL REY": true
      },
      "24036": {
        "ADOLFO LÓPEZ MATEOS (SUTERM)": true
      },
      "24037": {
        "CIUDAD MILITAR": true
      },
      "24038": {
        "KANISTÉ": true
      },
      "24039": {
        "BUENAVISTA": true
      },
      "24040": {
        "SAN JOSÉ": true
      },
      "24044": {
        "MONTECRISTO": true
      },
      "24049": {
        "BICENTENARIO I Y II": true
      },
      "24050": {
        "FOVISSSTE BELÉN": true
      },
      "24058": {
        "CARIBE": true
      },
      "24060": {
        "ALTAVISTA": true
      },
      "24063": {
        "PARQUE INDUSTRIAL BICENTENARIO": true
      },
      "24069": {
        "FLOR DE LIMÓN": true
      },
      "24070": {
        "AVIACIÓN": true
      },
      "24073": {
        "SIGLO XXI": true
      },
      "24075": {
        "EL CARMELO": true
      },
      "24079": {
        "CAMPECHE (INGENIERO ALBERTO ACUÑA ONGAY)": true
      },
      "24080": {
        "ESPERANZA": true
      },
      "24083": {
        "FÁTIMA": true
      },
      "24084": {
        "SIGLO XXIII": true
      },
      "24085": {
        "VILLAS DE KALA": true
      },
      "24086": {
        "VILLA FLORA": true
      },
      "24087": {
        "LOS REYES": true
      },
      "24088": {
        "ALAMEDA": true
      },
      "24089": {
        "PEÑA": true
      },
      "24090": {
        "FRACCIORAMA 2000": true
      },
      "24093": {
        "VILLAS RESIDENCIAL (IX-LOL-BE)": true
      },
      "24094": {
        "MIGUEL HIDALGO": true
      },
      "24095": {
        "RESIDENCIAL LOS ALMENDROS": true
      },
      "24096": {
        "LINDAVISTA C.T.M.": true
      },
      "24097": {
        "LAS FLORES": true
      },
      "24098": {
        "IGNACIO ZARAGOZA": true
      },
      "24099": {
        "LOMAS DE SAN RAFAEL": true
      }
    }
  },
  "CHIAPAS": {
    "TUXTLA GUTIÉRREZ": {
      "29000": {
        "EL MAGUEYITO": true
      },
      "29010": {
        "UNIDAD ADMINISTRATIVA": true
      },
      "29014": {
        "CANTERAS": true
      },
      "29016": {
        "ADONAHI": true
      },
      "29017": {
        "AGRIPINO GUTIÉRREZ": true
      },
      "29018": {
        "PISTIMBAK": true
      },
      "29019": {
        "CRUZ CON CASITA": true
      },
      "29020": {
        "BOULEVARES": true
      },
      "29023": {
        "MONTE REAL": true
      },
      "29024": {
        "FOVISSSTE 2 LOS LAURELES": true
      },
      "29025": {
        "ATENAS": true
      },
      "29026": {
        "CALICHAL": true
      },
      "29027": {
        "BUENAVISTA": true
      },
      "29028": {
        "LOS LAGUITOS INFONAVIT": true
      },
      "29030": {
        "BARRIO COVADONGA": true
      },
      "29034": {
        "ASTURIAS": true
      },
      "29037": {
        "LA ANTENITA": true
      },
      "29038": {
        "HACIENDA DE MÉXICO": true
      },
      "29039": {
        "MIRAVALLE": true
      },
      "29040": {
        "EL BRASILITO": true
      },
      "29044": {
        "EL VERGEL": true
      },
      "29045": {
        "BOSQUES DE PRIMAVERA": true
      },
      "29047": {
        "24 DE JUNIO": true
      },
      "29049": {
        "AMPLIACIÓN ARROYO BLANCO": true
      },
      "29050": {
        "ACACIA 2000": true
      },
      "29054": {
        "LA HERRADURA": true
      },
      "29055": {
        "RESIDENCIAL BONANZA": true
      },
      "29056": {
        "ARAMONI": true
      },
      "29057": {
        "CAMPESTRE ARENAL": true
      },
      "29058": {
        "CUCHILLA SANTA ROSA": true
      },
      "29059": {
        "VILLA VICTORIA": true
      },
      "29060": {
        "BUROCRÁTICA": true
      },
      "29064": {
        "LINDAVISTA": true
      },
      "29065": {
        "DOCTOR ROMEO RINCÓN": true
      },
      "29066": {
        "COLINAS DEL SUR": true
      },
      "29067": {
        "BELÉN": true
      },
      "29070": {
        "VILLAS ENSUEÑO": true
      },
      "29073": {
        "ZOCOTUMBAK": true
      },
      "29075": {
        "MODERNA": true
      },
      "29076": {
        "EMILIANO ZAPATA": true
      },
      "29077": {
        "BIENESTAR SOCIAL": true
      },
      "29078": {
        "LOS CHOFERES": true
      },
      "29080": {
        "REVOLUCIÓN": true
      },
      "29086": {
        "2 DE FEBRERO": true
      },
      "29087": {
        "RINCÓN DE LA MONTAÑA": true
      },
      "29089": {
        "POPULAR": true
      },
      "29090": {
        "SANTA ROSALÍA": true
      },
      "29094": {
        "ARROYO GRANDE": true
      },
      "29096": {
        "EL CEBOLLAL (EL ZIQUETE)": true
      },
      "29098": {
        "COLONIAL": true
      }
    }
  },
  "CIUDAD DE MÉXICO": {
    "AZCAPOTZALCO": {
      "2000": {
        "CENTRO DE AZCAPOTZALCO": true
      },
      "2010": {
        "LOS REYES": true,
        "NUEVO BARRIO SAN RAFAEL": true,
        "SAN RAFAEL": true
      },
      "2020": {
        "SAN MARCOS": true,
        "SANTO TOMÁS": true
      },
      "2040": {
        "DEL MAESTRO": true,
        "SAN SEBASTIÁN": true
      },
      "2050": {
        "LIBERTAD": true,
        "SANTA MARÍA MALINALCO": true
      },
      "2060": {
        "SINDICATO MEXICANO DE ELECTRICISTAS": true,
        "UN HOGAR PARA CADA TRABAJADOR": true
      },
      "2070": {
        "DEL RECREO": true,
        "NEXTENGO": true
      },
      "2080": {
        "CLAVERÍA": true,
        "SECTOR NAVAL": true
      },
      "2090": {
        "SAN ÁLVARO": true
      },
      "2099": {
        "ÁNGEL ZIMBRÓN": true
      },
      "2100": {
        "EL ROSARIO": true
      },
      "2120": {
        "SAN MARTÍN XOCHINAHUAC": true
      },
      "2128": {
        "NUEVA EL ROSARIO": true
      },
      "2129": {
        "NUEVA ESPAÑA": true
      },
      "2130": {
        "TIERRA NUEVA": true
      },
      "2140": {
        "SANTA INÉS": true
      },
      "2150": {
        "PASTEROS": true
      },
      "2160": {
        "SANTO DOMINGO": true
      },
      "2200": {
        "REYNOSA TAMAULIPAS": true
      },
      "2230": {
        "SANTA BÁRBARA": true
      },
      "2240": {
        "SAN ANDRÉS": true
      },
      "2250": {
        "SANTA CATARINA": true
      },
      "2300": {
        "INDUSTRIAL VALLEJO": true
      },
      "2310": {
        "FERRERÍA": true
      },
      "2320": {
        "SAN ANDRÉS DE LAS SALINAS": true
      },
      "2330": {
        "HUAUTLA DE LAS SALINAS": true
      },
      "2340": {
        "SANTA CRUZ DE LAS SALINAS": true
      },
      "2360": {
        "LAS SALINAS": true
      },
      "2400": {
        "SAN JUAN TLIHUACA": true
      },
      "2410": {
        "PRADOS DEL ROSARIO": true
      },
      "2420": {
        "EX-HACIENDA EL ROSARIO": true
      },
      "2440": {
        "PROVIDENCIA": true
      },
      "2459": {
        "TEZOZOMOC": true
      },
      "2460": {
        "LA PRECIOSA": true
      },
      "2470": {
        "AMPLIACIÓN PETROLERA": true
      },
      "2480": {
        "PETROLERA": true
      },
      "2490": {
        "SAN MATEO": true
      },
      "2500": {
        "UNIDAD CUITLÁHUAC": true
      },
      "2519": {
        "EL JAGÜEY": true
      },
      "2520": {
        "ESTACIÓN PANTACO": true
      },
      "2530": {
        "JARDÍN AZPEITIA": true
      },
      "2600": {
        "PRO-HOGAR": true
      },
      "2630": {
        "COLTONGO": true
      },
      "2640": {
        "MONTE ALTO": true
      },
      "2650": {
        "TRABAJADORES DE HIERRO": true
      },
      "2660": {
        "EUZKADI": true
      },
      "2670": {
        "COSMOPOLITA": true
      },
      "2680": {
        "POTRERO DEL LLANO": true
      },
      "2700": {
        "SAN MIGUEL AMANTLA": true
      },
      "2710": {
        "SAN PEDRO XALPA": true
      },
      "2719": {
        "AMPLIACIÓN SAN PEDRO XALPA": true
      },
      "2720": {
        "SAN ANTONIO": true,
        "SAN BARTOLO CAHUALTONGO": true
      },
      "2730": {
        "SAN FRANCISCO TETECALA": true
      },
      "2750": {
        "SANTIAGO AHUIZOTLA": true
      },
      "2760": {
        "INDUSTRIAL SAN ANTONIO": true,
        "SANTA LUCÍA": true
      },
      "2770": {
        "SANTA CRUZ ACAYUCAN": true
      },
      "2780": {
        "PLENITUD": true
      },
      "2790": {
        "SANTA APOLONIA": true
      },
      "2800": {
        "NUEVA SANTA MARÍA": true
      },
      "2810": {
        "IGNACIO ALLENDE": true,
        "VICTORIA DE LAS DEMOCRACIAS": true
      },
      "2830": {
        "SAN BERNABÉ": true
      },
      "2840": {
        "OBRERO POPULAR": true
      },
      "2860": {
        "TLATILCO": true
      },
      "2870": {
        "SAN SALVADOR XOCHIMANCA": true
      },
      "2900": {
        "AGUILERA": true
      },
      "2910": {
        "ALDANA": true
      },
      "2920": {
        "AMPLIACIÓN COSMOPOLITA": true
      },
      "2930": {
        "LIBERACIÓN": true
      },
      "2940": {
        "PORVENIR": true
      },
      "2950": {
        "DEL GAS": true
      },
      "2960": {
        "SAN FRANCISCO XOCOTITLA": true
      },
      "2970": {
        "AMPLIACIÓN DEL GAS": true
      },
      "2980": {
        "ARENAL": true,
        "PATRIMONIO FAMILIAR": true
      },
      "2990": {
        "LA RAZA": true
      }
    },
    "BENITO JUÁREZ": {
      "3000": {
        "PIEDAD NARVARTE": true
      },
      "3010": {
        "ATENOR SALAS": true
      },
      "3020": {
        "NARVARTE PONIENTE": true
      },
      "3023": {
        "NARVARTE ORIENTE": true
      },
      "3100": {
        "DEL VALLE CENTRO": true,
        "INSURGENTES SAN BORJA": true
      },
      "3103": {
        "DEL VALLE NORTE": true
      },
      "3104": {
        "DEL VALLE SUR": true
      },
      "3200": {
        "TLACOQUEMÉCATL": true
      },
      "3230": {
        "ACTIPAN": true
      },
      "3240": {
        "ACACIAS": true
      },
      "3300": {
        "PORTALES SUR": true
      },
      "3303": {
        "PORTALES NORTE": true
      },
      "3310": {
        "SANTA CRUZ ATOYAC": true
      },
      "3320": {
        "RESIDENCIAL EMPERADORES": true
      },
      "3330": {
        "XOCO": true
      },
      "3340": {
        "GENERAL PEDRO MARÍA ANAYA": true
      },
      "3400": {
        "ÁLAMOS": true
      },
      "3410": {
        "POSTAL": true
      },
      "3420": {
        "MIGUEL ALEMÁN": true
      },
      "3430": {
        "JOSEFA ORTIZ DE DOMÍNGUEZ": true
      },
      "3440": {
        "NIÑOS HÉROES": true
      },
      "3500": {
        "NATIVITAS": true
      },
      "3510": {
        "MODERNA": true
      },
      "3520": {
        "IZTACCIHUATL": true
      },
      "3530": {
        "VILLA DE CORTÉS": true
      },
      "3540": {
        "DEL CARMEN": true
      },
      "3550": {
        "ZACAHUITZCO": true
      },
      "3560": {
        "ALBERT": true
      },
      "3570": {
        "PORTALES ORIENTE": true
      },
      "3580": {
        "MIRAVALLE": true
      },
      "3590": {
        "ERMITA": true
      },
      "3600": {
        "VÉRTIZ NARVARTE": true
      },
      "3610": {
        "AMÉRICAS UNIDAS": true
      },
      "3620": {
        "PERIODISTA": true
      },
      "3630": {
        "INDEPENDENCIA": true
      },
      "3640": {
        "DEL LAGO": true
      },
      "3650": {
        "LETRÁN VALLE": true
      },
      "3660": {
        "SAN SIMÓN TICUMAC": true
      },
      "3700": {
        "SANTA MARÍA NONOALCO": true
      },
      "3710": {
        "CIUDAD DE LOS DEPORTES": true
      },
      "3720": {
        "NOCHEBUENA": true
      },
      "3730": {
        "SAN JUAN": true
      },
      "3740": {
        "EXTREMADURA INSURGENTES": true
      },
      "3800": {
        "SAN PEDRO DE LOS PINOS": true
      },
      "3810": {
        "NÁPOLES": true
      },
      "3820": {
        "8 DE AGOSTO": true
      },
      "3840": {
        "AMPLIACIÓN NÁPOLES": true
      },
      "3900": {
        "SAN JOSÉ INSURGENTES": true
      },
      "3910": {
        "MIXCOAC": true
      },
      "3920": {
        "INSURGENTES MIXCOAC": true
      },
      "3930": {
        "MERCED GÓMEZ": true
      },
      "3940": {
        "CRÉDITO CONSTRUCTOR": true
      },
      "4120": {
        "SAN MATEO": true
      },
      "4260": {
        "SAN FRANCISCO CULHUACÁN BARRIO DE LA MAGDALENA": true,
        "SAN FRANCISCO CULHUACÁN BARRIO DE SAN JUAN": true,
        "SAN FRANCISCO CULHUACÁN BARRIO DE SANTA ANA": true
      },
      "4320": {
        "PEDREGAL DE SAN FRANCISCO": true
      },
      "4330": {
        "DEL NIÑO JESÚS": true,
        "LOS REYES": true
      },
      "4360": {
        "COPILCO UNIVERSIDAD": true
      },
      "4370": {
        "CIUDAD JARDÍN": true
      },
      "4380": {
        "LA CANDELARIA": true
      },
      "4390": {
        "NUEVA DÍAZ ORDAZ": true
      },
      "4440": {
        "CULHUACÁN CTM SECCIÓN II": true
      }
    },
    "COYOACÁN": {
      "4000": {
        "VILLA COYOACÁN": true
      },
      "4010": {
        "SANTA CATARINA": true
      },
      "4020": {
        "LA CONCEPCIÓN": true
      },
      "4030": {
        "SAN LUCAS": true
      },
      "4040": {
        "PARQUE SAN ANDRÉS": true
      },
      "4100": {
        "DEL CARMEN": true
      },
      "4120": {
        "SAN DIEGO CHURUBUSCO": true,
        "SAN MATEO": true
      },
      "4200": {
        "CAMPESTRE CHURUBUSCO": true
      },
      "4210": {
        "CHURUBUSCO COUNTRY CLUB": true
      },
      "4230": {
        "PRADO CHURUBUSCO": true
      },
      "4240": {
        "HERMOSILLO": true
      },
      "4250": {
        "PASEOS DE TAXQUEÑA": true
      },
      "4260": {
        "SAN FRANCISCO CULHUACÁN BARRIO DE LA MAGDALENA": true,
        "SAN FRANCISCO CULHUACÁN BARRIO DE SAN FRANCISCO": true,
        "SAN FRANCISCO CULHUACÁN BARRIO DE SAN JUAN": true,
        "SAN FRANCISCO CULHUACÁN BARRIO DE SANTA ANA": true
      },
      "4300": {
        "AJUSCO": true
      },
      "4310": {
        "ROMERO DE TERREROS": true
      },
      "4318": {
        "OXTOPULCO UNIVERSIDAD": true
      },
      "4320": {
        "CUADRANTE DE SAN FRANCISCO": true,
        "PEDREGAL DE SAN FRANCISCO": true
      },
      "4330": {
        "DEL NIÑO JESÚS": true,
        "EL ROSEDAL": true,
        "LOS REYES": true
      },
      "4340": {
        "COPILCO EL BAJO": true
      },
      "4360": {
        "COPILCO EL ALTO": true,
        "COPILCO UNIVERSIDAD": true
      },
      "4369": {
        "PEDREGAL DE SANTO DOMINGO": true
      },
      "4370": {
        "ATLÁNTIDA": true,
        "CIUDAD JARDÍN": true
      },
      "4380": {
        "EL ROSARIO": true,
        "LA CANDELARIA": true
      },
      "4390": {
        "HUAYAMILPAS": true,
        "NUEVA DÍAZ ORDAZ": true
      },
      "4400": {
        "EDUCACIÓN": true
      },
      "4410": {
        "PETROLERA TAXQUEÑA": true
      },
      "4420": {
        "EX-EJIDO DE SAN FRANCISCO CULHUACÁN": true
      },
      "4440": {
        "CULHUACÁN CTM SECCIÓN I": true,
        "CULHUACÁN CTM SECCIÓN II": true,
        "CULHUACÁN CTM SECCIÓN V": true
      },
      "4450": {
        "EL CENTINELA": true
      },
      "4460": {
        "AVANTE": true
      },
      "4470": {
        "PRESIDENTES EJIDALES 1A SECCIÓN": true,
        "PRESIDENTES EJIDALES 2A SECCIÓN": true
      },
      "4480": {
        "CULHUACÁN CTM CROC": true,
        "CULHUACÁN CTM SECCIÓN III": true,
        "CULHUACÁN CTM SECCIÓN VI": true,
        "CULHUACÁN CTM SECCIÓN X-A": true
      },
      "4489": {
        "CULHUACÁN CTM SECCIÓN VII": true
      },
      "4490": {
        "CULHUACÁN CTM CANAL NACIONAL": true,
        "CULHUACÁN CTM SECCIÓN PILOTO": true
      },
      "4500": {
        "JARDINES DEL PEDREGAL DE SAN ÁNGEL": true
      },
      "4510": {
        "UNIVERSIDAD NACIONAL AUTÓNOMA DE MÉXICO": true
      },
      "4519": {
        "LA OTRA BANDA": true
      },
      "4530": {
        "INSURGENTES CUICUILCO": true
      },
      "4600": {
        "PEDREGAL DE SANTA ÚRSULA": true
      },
      "4610": {
        "XOTEPINGO": true
      },
      "4620": {
        "SAN PABLO TEPETLAPA": true
      },
      "4630": {
        "ADOLFO RUIZ CORTÍNES": true
      },
      "4640": {
        "EL RELOJ": true
      },
      "4650": {
        "SANTA ÚRSULA COAPA": true
      },
      "4660": {
        "JOYAS DEL PEDREGAL": true
      },
      "4700": {
        "PEDREGAL DE CARRASCO": true
      },
      "4710": {
        "OLÍMPICA": true
      },
      "4730": {
        "BOSQUES DE TETLAMEYA": true,
        "CANTIL DEL PEDREGAL": true
      },
      "4739": {
        "EL CARACOL": true
      },
      "4800": {
        "ALIANZA POPULAR REVOLUCIONARIA": true,
        "LOS CEDROS": true
      },
      "4810": {
        "PRADOS DE COYOACÁN": true
      },
      "4815": {
        "EMILIANO ZAPATA": true
      },
      "4830": {
        "LOS CIPRESES": true
      },
      "4840": {
        "EX-EJIDO DE SAN PABLO TEPETLAPA": true
      },
      "4870": {
        "ESPARTACO": true
      },
      "4890": {
        "JARDINES DE COYOACÁN": true,
        "LOS OLIVOS": true
      },
      "4899": {
        "EL PARQUE DE COYOACÁN": true
      },
      "4909": {
        "CULHUACÁN CTM SECCIÓN IX-A": true,
        "CULHUACÁN CTM SECCIÓN IX-B": true,
        "CULHUACÁN CTM SECCIÓN VIII": true
      },
      "4910": {
        "CARMEN SERDÁN": true
      },
      "4918": {
        "CAFETALES": true
      },
      "4919": {
        "EMILIANO ZAPATA FRACCIONAMIENTO POPULAR": true
      },
      "4920": {
        "LOS GIRASOLES": true
      },
      "4929": {
        "LAS CAMPANAS": true
      },
      "4930": {
        "SANTA CECILIA": true
      },
      "4938": {
        "CAMPESTRE COYOACÁN": true
      },
      "4939": {
        "CULHUACÁN CTM SECCIÓN X": true
      },
      "4940": {
        "LOS SAUCES": true
      },
      "4950": {
        "EL MIRADOR": true
      },
      "4960": {
        "VILLA QUIETUD": true
      },
      "4970": {
        "HACIENDAS DE COYOACÁN": true
      },
      "4980": {
        "EX-EJIDO DE SANTA ÚRSULA COAPA": true,
        "EX-HACIENDA COAPA": true,
        "VIEJO EJIDO DE SANTA ÚRSULA COAPA": true
      }
    },
    "CUAJIMALPA DE MORELOS": {
      "5000": {
        "CUAJIMALPA": true
      },
      "5010": {
        "ZENTLAPATL": true
      },
      "5020": {
        "LOMA DEL PADRE": true
      },
      "5030": {
        "LA MANZANITA": true,
        "SAN PEDRO": true
      },
      "5050": {
        "SAN PABLO CHIMALPA": true
      },
      "5100": {
        "LOMAS DE VISTA HERMOSA": true
      },
      "5110": {
        "COOPERATIVA PALO ALTO": true
      },
      "5118": {
        "GRANJAS PALO ALTO": true
      },
      "5119": {
        "CAMPESTRE PALO ALTO": true
      },
      "5120": {
        "BOSQUES DE LAS LOMAS": true
      },
      "5129": {
        "LOMAS DEL CHAMIZAL": true
      },
      "5200": {
        "SAN JOSÉ DE LOS CEDROS": true
      },
      "5219": {
        "GRANJAS NAVIDAD": true
      },
      "5220": {
        "TEPETONGO": true
      },
      "5230": {
        "EL ÉBANO": true
      },
      "5240": {
        "EL MOLINO": true
      },
      "5260": {
        "JESÚS DEL MONTE": true
      },
      "5269": {
        "AMADO NERVO": true
      },
      "5270": {
        "MANZANASTITLA": true
      },
      "5280": {
        "ADOLFO LÓPEZ MATEOS": true
      },
      "5310": {
        "EL MOLINITO": true
      },
      "5320": {
        "EL YAQUI": true
      },
      "5330": {
        "AMPLIACIÓN EL YAQUI": true,
        "AMPLIACIÓN MEMETLA": true,
        "LOMAS DE MEMETLA": true,
        "MEMETLA": true
      },
      "5348": {
        "SANTA FE CUAJIMALPA": true
      },
      "5360": {
        "LOCAXCO": true
      },
      "5370": {
        "LAS TINAJAS": true
      },
      "5379": {
        "LOMAS DE SAN PEDRO": true
      },
      "5400": {
        "EL TIANGUILLO": true
      },
      "5410": {
        "1° DE MAYO": true,
        "SAN LORENZO ACOPILCO": true
      },
      "5500": {
        "CONTADERO": true
      },
      "5520": {
        "LA VENTA": true
      },
      "5530": {
        "ABDÍAS GARCÍA SOTO": true
      },
      "5600": {
        "SAN MATEO TLALTENANGO": true
      },
      "5610": {
        "SANTA ROSA XOCHIAC": true
      },
      "5700": {
        "CRUZ BLANCA": true
      },
      "5710": {
        "LAS MAROMAS": true
      },
      "5730": {
        "XALPA": true
      },
      "5750": {
        "LA PILA": true
      },
      "5760": {
        "LAS LAJAS": true
      },
      "5780": {
        "AGUA BENDITA": true
      }
    },
    "CUAUHTEMOC": {
      "6000": {
        "CENTRO (ÁREA 1)": true
      },
      "6010": {
        "CENTRO (ÁREA 2)": true
      },
      "6020": {
        "CENTRO (ÁREA 3)": true
      },
      "6030": {
        "TABACALERA": true
      },
      "6040": {
        "CENTRO (ÁREA 4)": true
      },
      "6050": {
        "CENTRO (ÁREA 5)": true
      },
      "6060": {
        "CENTRO (ÁREA 6)": true
      },
      "6070": {
        "CENTRO (ÁREA 7)": true
      },
      "6080": {
        "CENTRO (ÁREA 8)": true
      },
      "6090": {
        "CENTRO (ÁREA 9)": true
      },
      "6100": {
        "HIPÓDROMO": true
      },
      "6140": {
        "CONDESA": true
      },
      "6170": {
        "HIPÓDROMO CONDESA": true
      },
      "6200": {
        "MORELOS": true
      },
      "6220": {
        "PERALVILLO": true
      },
      "6240": {
        "VALLE GÓMEZ": true
      },
      "6250": {
        "EX-HIPÓDROMO DE PERALVILLO": true
      },
      "6270": {
        "MAZA": true
      },
      "6280": {
        "FELIPE PESCADOR": true
      },
      "6300": {
        "GUERRERO": true
      },
      "6350": {
        "BUENAVISTA": true
      },
      "6400": {
        "SANTA MARÍA LA RIBERA": true
      },
      "6430": {
        "SANTA MARÍA INSURGENTES": true
      },
      "6450": {
        "ATLAMPA": true
      },
      "6470": {
        "SAN RAFAEL": true
      },
      "6500": {
        "CUAUHTÉMOC": true
      },
      "6600": {
        "JUÁREZ": true
      },
      "6700": {
        "ROMA NORTE": true
      },
      "6720": {
        "DOCTORES": true
      },
      "6760": {
        "ROMA SUR": true
      },
      "6780": {
        "BUENOS AIRES": true
      },
      "6800": {
        "OBRERA": true
      },
      "6820": {
        "TRÁNSITO": true
      },
      "6840": {
        "ESPERANZA": true
      },
      "6850": {
        "ASTURIAS": true
      },
      "6860": {
        "VISTA ALEGRE": true
      },
      "6870": {
        "PAULINO NAVARRO": true
      },
      "6880": {
        "ALGARIN": true
      },
      "6890": {
        "AMPLIACIÓN ASTURIAS": true
      },
      "6900": {
        "NONOALCO TLATELOLCO": true
      },
      "6920": {
        "SAN SIMÓN TOLNÁHUAC": true
      }
    },
    "GUSTAVO A. MADERO": {
      "7000": {
        "ARAGÓN LA VILLA": true
      },
      "7010": {
        "ROSAS DEL TEPEYAC": true,
        "SANTA ISABEL TOLA": true,
        "TEPETATES": true
      },
      "7020": {
        "TEPEYAC INSURGENTES": true
      },
      "7040": {
        "SANTIAGO ATZACOALCO": true
      },
      "7050": {
        "VILLA GUSTAVO A. MADERO": true
      },
      "7058": {
        "15 DE AGOSTO": true
      },
      "7060": {
        "ESTANZUELA": true
      },
      "7069": {
        "TRIUNFO DE LA REPÚBLICA": true
      },
      "7070": {
        "DINAMITA": true,
        "LA CRUZ": true,
        "MARTÍN CARRERA": true
      },
      "7080": {
        "GABRIEL HERNÁNDEZ": true
      },
      "7089": {
        "AMPLIACIÓN GABRIEL HERNÁNDEZ": true
      },
      "7090": {
        "C.T.M. ATZACOALCO": true,
        "C.T.M. EL RISCO": true
      },
      "7100": {
        "CUAUTEPEC BARRIO ALTO": true,
        "SAN MIGUEL": true
      },
      "7109": {
        "SAN ANTONIO": true
      },
      "7110": {
        "LOMAS DE CUAUTEPEC": true
      },
      "7119": {
        "AMPLIACIÓN MALACATES": true,
        "MALACATES": true
      },
      "7130": {
        "COMPOSITORES MEXICANOS": true,
        "EL TEPETATAL": true
      },
      "7140": {
        "AMPLIACIÓN ARBOLEDAS": true,
        "ARBOLEDAS": true,
        "FORESTAL": true,
        "FORESTAL I": true
      },
      "7144": {
        "FORESTAL II": true,
        "LA LENGÜETA": true
      },
      "7149": {
        "PARQUE METROPOLITANO": true
      },
      "7150": {
        "JUVENTINO ROSAS": true,
        "LA CASILDA": true
      },
      "7160": {
        "LOMA LA PALMA": true
      },
      "7164": {
        "GRACIANO SÁNCHEZ": true,
        "LUIS DONALDO COLOSIO": true,
        "PRADOS DE CUAUTEPEC": true,
        "TLACAÉLEL": true
      },
      "7170": {
        "PALMATITLA": true
      },
      "7180": {
        "AMPLIACIÓN COCOYOTES": true,
        "COCOYOTES": true,
        "GENERAL FELIPE BERRIOZABAL": true
      },
      "7183": {
        "6 DE JUNIO": true
      },
      "7187": {
        "VISTA HERMOSA": true
      },
      "7188": {
        "TLALPEXCO": true
      },
      "7189": {
        "AHUEHUETES": true
      },
      "7190": {
        "VALLE DE MADERO": true
      },
      "7199": {
        "DEL CARMEN": true
      },
      "7200": {
        "CUAUTEPEC DE MADERO": true
      },
      "7207": {
        "DEL BOSQUE": true
      },
      "7209": {
        "GUADALUPE VICTORIA CUAUTEPEC": true
      },
      "7210": {
        "CHALMA DE GUADALUPE": true
      },
      "7214": {
        "AMPLIACIÓN CHALMA DE GUADALUPE": true
      },
      "7220": {
        "CASTILLO CHICO": true,
        "CASTILLO GRANDE": true
      },
      "7224": {
        "AMPLIACIÓN CASTILLO GRANDE": true
      },
      "7230": {
        "ZONA ESCOLAR": true
      },
      "7239": {
        "ZONA ESCOLAR ORIENTE": true
      },
      "7240": {
        "EL ARBOLILLO": true
      },
      "7250": {
        "BENITO JUÁREZ": true
      },
      "7259": {
        "AMPLIACIÓN BENITO JUÁREZ": true
      },
      "7268": {
        "SOLIDARIDAD NACIONAL": true
      },
      "7270": {
        "RESIDENCIAL ACUEDUCTO DE GUADALUPE": true
      },
      "7279": {
        "ACUEDUCTO DE GUADALUPE": true
      },
      "7280": {
        "JORGE NEGRETE": true
      },
      "7290": {
        "LA PASTORA": true
      },
      "7300": {
        "LINDAVISTA NORTE": true,
        "LINDAVISTA SUR": true
      },
      "7310": {
        "CANDELARIA TICOMÁN": true
      },
      "7320": {
        "LA PURÍSIMA TICOMÁN": true,
        "RESIDENCIAL LA ESCALERA": true
      },
      "7330": {
        "SANTA MARÍA TICOMÁN": true
      },
      "7340": {
        "LA LAGUNA TICOMÁN": true,
        "SAN JOSÉ TICOMÁN": true
      },
      "7350": {
        "GUADALUPE TICOMÁN": true,
        "SAN JUAN Y GUADALUPE TICOMÁN": true
      },
      "7359": {
        "SAN RAFAEL TICOMÁN": true
      },
      "7360": {
        "SAN PEDRO ZACATENCO": true
      },
      "7369": {
        "RESIDENCIAL ZACATENCO": true
      },
      "7370": {
        "CAPULTITLAN": true
      },
      "7380": {
        "MAXIMINO ÁVILA CAMACHO": true,
        "TLACAMACA": true
      },
      "7400": {
        "SALVADOR DÍAZ MIRÓN": true
      },
      "7410": {
        "JUAN GONZÁLEZ ROMERO": true,
        "VILLA HERMOSA": true
      },
      "7420": {
        "EL COYOL": true,
        "NUEVA ATZACOALCO": true
      },
      "7430": {
        "DEL OBRERO": true
      },
      "7440": {
        "VASCO DE QUIROGA": true
      },
      "7450": {
        "DM NACIONAL": true
      },
      "7455": {
        "FERROCARRILERA": true
      },
      "7456": {
        "LI LEGISLATURA": true
      },
      "7458": {
        "AMPLIACIÓN MÁRTIRES DE RÍO BLANCO": true,
        "AMPLIACIÓN PROVIDENCIA": true,
        "AMPLIACIÓN SAN JUAN DE ARAGÓN": true,
        "ARAGÓN INGUARÁN": true,
        "ARAGÓN LA VILLA": true,
        "BARRIO CANDELARIA TICOMÁN": true,
        "BENITO JUÁREZ": true,
        "BONDOJITO": true,
        "EDUARDO MOLINA I": true
      },
      "7460": {
        "GRANJAS MODERNAS": true
      },
      "7469": {
        "CONSTITUCIÓN DE LA REPÚBLICA": true
      },
      "7470": {
        "AMPLIACIÓN SAN JUAN DE ARAGÓN": true
      },
      "7480": {
        "SAN PEDRO EL CHICO": true
      },
      "7500": {
        "LA PRADERA": true
      },
      "7509": {
        "PRADERA II SECCIÓN": true
      },
      "7510": {
        "SAN FELIPE DE JESÚS": true
      },
      "7520": {
        "25 DE JULIO": true
      },
      "7530": {
        "CAMPESTRE ARAGÓN": true
      },
      "7540": {
        "LA ESMERALDA": true
      },
      "7550": {
        "PROVIDENCIA": true
      },
      "7560": {
        "AMPLIACIÓN PROVIDENCIA": true
      },
      "7570": {
        "VILLA DE ARAGÓN": true
      },
      "7580": {
        "AMPLIACIÓN CASAS ALEMÁN": true
      },
      "7600": {
        "PROGRESO NACIONAL": true
      },
      "7620": {
        "SANTA ROSA": true
      },
      "7630": {
        "SAN JOSÉ DE LA ESCALERA": true
      },
      "7640": {
        "SANTIAGO ATEPETLAC": true
      },
      "7650": {
        "AMPLIACIÓN PROGRESO NACIONAL": true
      },
      "7670": {
        "GUADALUPE PROLETARIA": true
      },
      "7680": {
        "AMPLIACIÓN GUADALUPE PROLETARIA": true
      },
      "7700": {
        "NUEVA INDUSTRIAL VALLEJO": true
      },
      "7707": {
        "SIETE MARAVILLAS": true
      },
      "7708": {
        "TORRES LINDAVISTA": true
      },
      "7720": {
        "LINDAVISTA VALLEJO I SECCIÓN": true
      },
      "7730": {
        "CHURUBUSCO TEPEYAC": true,
        "MONTEVIDEO": true,
        "SAN BARTOLO ATEPEHUACAN": true
      },
      "7739": {
        "PLANETARIO LINDAVISTA": true
      },
      "7740": {
        "VALLE DEL TEPEYAC": true
      },
      "7750": {
        "NUEVA VALLEJO": true
      },
      "7754": {
        "LINDAVISTA VALLEJO III SECCIÓN": true
      },
      "7755": {
        "LINDAVISTA VALLEJO II SECCIÓN": true
      },
      "7760": {
        "MAGDALENA DE LAS SALINAS": true
      },
      "7770": {
        "AMPLIACIÓN PANAMERICANA": true,
        "PANAMERICANA": true
      },
      "7780": {
        "DEFENSORES DE LA REPÚBLICA": true,
        "HÉROE DE NACOZARI": true
      },
      "7790": {
        "GUADALUPE VICTORIA": true,
        "VALLEJO PONIENTE": true
      },
      "7800": {
        "INDUSTRIAL": true
      },
      "7810": {
        "ESTRELLA": true
      },
      "7820": {
        "ARAGÓN INGUARÁN": true,
        "TRES ESTRELLAS": true
      },
      "7830": {
        "GERTRUDIS SÁNCHEZ 1A SECCIÓN": true
      },
      "7838": {
        "GERTRUDIS SÁNCHEZ 3A SECCIÓN": true
      },
      "7839": {
        "GERTRUDIS SÁNCHEZ 2A SECCIÓN": true
      },
      "7840": {
        "7 DE NOVIEMBRE": true,
        "GUADALUPE TEPEYAC": true
      },
      "7850": {
        "BONDOJITO": true,
        "FAJA DE ORO": true
      },
      "7858": {
        "AMPLIACIÓN EMILIANO ZAPATA": true
      },
      "7859": {
        "AMPLIACIÓN MÁRTIRES DE RÍO BLANCO": true
      },
      "7860": {
        "LA JOYITA": true,
        "TABLAS DE SAN AGUSTÍN": true
      },
      "7869": {
        "BELISARIO DOMÍNGUEZ": true
      },
      "7870": {
        "GUADALUPE INSURGENTES": true,
        "VALLEJO": true
      },
      "7880": {
        "MÁRTIRES DE RÍO BLANCO": true
      },
      "7889": {
        "EMILIANO ZAPATA": true
      },
      "7890": {
        "CUCHILLA LA JOYA": true,
        "LA JOYA": true,
        "NUEVA TENOCHTITLÁN": true
      },
      "7899": {
        "LA MALINCHE": true
      },
      "7900": {
        "CUCHILLA DEL TESORO": true
      },
      "7910": {
        "SAN JUAN DE ARAGÓN VII SECCIÓN": true
      },
      "7918": {
        "SAN JUAN DE ARAGÓN VI SECCIÓN": true
      },
      "7919": {
        "EX EJIDO SAN JUAN DE ARAGÓN SECTOR 32": true
      },
      "7920": {
        "EL OLIVO": true,
        "SAN JUAN DE ARAGÓN": true
      },
      "7930": {
        "INDECO": true
      },
      "7939": {
        "HÉROES DE CHAPULTEPEC": true
      },
      "7940": {
        "EX EJIDO SAN JUAN DE ARAGÓN SECTOR 33": true
      },
      "7950": {
        "SAN JUAN DE ARAGÓN": true
      },
      "7960": {
        "EX ESCUELA DE TIRO": true,
        "FERNANDO CASAS ALEMÁN": true,
        "HÉROES DE CERRO PRIETO": true
      },
      "7969": {
        "SAN JUAN DE ARAGÓN I SECCIÓN": true,
        "SAN JUAN DE ARAGÓN II SECCIÓN": true
      },
      "7970": {
        "SAN JUAN DE ARAGÓN III SECCIÓN": true
      },
      "7979": {
        "SAN JUAN DE ARAGÓN IV SECCIÓN": true,
        "SAN JUAN DE ARAGÓN V SECCIÓN": true
      },
      "7980": {
        "NARCISO BASSOLS": true
      },
      "7990": {
        "C.T.M. ARAGÓN": true
      }
    },
    "IZTACALCO": {
      "8000": {
        "GABRIEL RAMOS MILLÁN SECCIÓN BRAMADERO": true
      },
      "8010": {
        "EX-EJIDO DE LA MAGDALENA MIXIUHCA": true
      },
      "8020": {
        "AMPLIACIÓN GABRIEL RAMOS MILLÁN": true
      },
      "8030": {
        "GABRIEL RAMOS MILLÁN SECCIÓN CUCHILLA": true
      },
      "8040": {
        "CARLOS ZAPATA VELA": true
      },
      "8100": {
        "AGRÍCOLA PANTITLÁN": true
      },
      "8200": {
        "VIADUCTO PIEDAD": true
      },
      "8210": {
        "NUEVA SANTA ANITA": true
      },
      "8220": {
        "SAN PEDRO": true
      },
      "8230": {
        "SAN FRANCISCO XICALTONGO": true
      },
      "8240": {
        "SANTIAGO NORTE": true
      },
      "8300": {
        "SANTA ANITA": true
      },
      "8310": {
        "LA CRUZ": true
      },
      "8320": {
        "FRACCIONAMIENTO COYUYA": true
      },
      "8400": {
        "GRANJAS MÉXICO": true
      },
      "8420": {
        "CUCHILLA AGRÍCOLA ORIENTAL": true
      },
      "8500": {
        "AGRÍCOLA ORIENTAL": true
      },
      "8510": {
        "EL RODEO": true
      },
      "8600": {
        "LA ASUNCIÓN": true
      },
      "8610": {
        "ZAPOTLA": true
      },
      "8620": {
        "LOS REYES": true
      },
      "8650": {
        "SAN MIGUEL": true
      },
      "8700": {
        "JUVENTINO ROSAS": true
      },
      "8710": {
        "TLAZINTLA": true
      },
      "8720": {
        "GABRIEL RAMOS MILLÁN SECCIÓN TLACOTAL": true
      },
      "8730": {
        "GABRIEL RAMOS MILLÁN": true
      },
      "8760": {
        "INPI PICOS": true,
        "LOS PICOS DE IZTACALCO SECCIÓN 1B": true,
        "LOS PICOS DE IZTACALCO SECCIÓN 2A": true
      },
      "8770": {
        "LOS PICOS DE IZTACALCO SECCIÓN 1A": true
      },
      "8800": {
        "SANTIAGO SUR": true
      },
      "8810": {
        "REFORMA IZTACCÍHUATL NORTE": true
      },
      "8830": {
        "MILITAR MARTE": true
      },
      "8840": {
        "REFORMA IZTACCÍHUATL SUR": true
      },
      "8900": {
        "INFONAVIT IZTACALCO": true
      },
      "8910": {
        "SANTA CRUZ": true
      },
      "8920": {
        "JARDINES TECMA": true
      },
      "8930": {
        "CAMPAMENTO 2 DE OCTUBRE": true
      }
    },
    "IZTAPALAPA": {
      "9000": {
        "LA ASUNCIÓN": true,
        "SAN IGNACIO": true,
        "SAN JOSÉ": true,
        "SAN LUCAS": true,
        "SAN PABLO": true,
        "SAN PEDRO": true,
        "SANTA BÁRBARA": true
      },
      "9010": {
        "REAL DEL MORAL": true
      },
      "9020": {
        "DOCTOR ALFONSO ORTIZ TIRADO": true,
        "DR. ALFONSO ORTIZ TIRADO": true
      },
      "9030": {
        "PASEOS DE CHURUBUSCO": true
      },
      "9040": {
        "CENTRAL DE ABASTO": true
      },
      "9060": {
        "ESCUADRÓN 201": true,
        "SECTOR POPULAR": true
      },
      "9070": {
        "GRANJAS DE SAN ANTONIO": true
      },
      "9080": {
        "CACAMA": true
      },
      "9089": {
        "UNIDAD MODELO": true
      },
      "9090": {
        "HÉROES DE CHURUBUSCO": true
      },
      "9099": {
        "MEXICALTZINGO": true
      },
      "9100": {
        "JUAN ESCUTIA": true
      },
      "9130": {
        "SAN LORENZO XICOTENCATL": true
      },
      "9140": {
        "SANTA MARTHA ACATITLA NORTE": true
      },
      "9180": {
        "ERMITA ZARAGOZA": true
      },
      "9200": {
        "UNIDAD VICENTE GUERRERO": true
      },
      "9208": {
        "CHINAMPAC DE JUÁREZ": true
      },
      "9209": {
        "RENOVACIÓN": true
      },
      "9210": {
        "TEPALCATES": true
      },
      "9220": {
        "UNIDAD EJÉRCITO CONSTITUCIONALISTA": true
      },
      "9230": {
        "EJÉRCITO DE ORIENTE": true,
        "EL PARAÍSO": true,
        "JOSÉ MARÍA MORELOS Y PAVÓN": true,
        "ÁLVARO OBREGÓN": true
      },
      "9239": {
        "EJÉRCITO DE ORIENTE ZONA PEÑÓN": true
      },
      "9240": {
        "PROGRESISTA": true
      },
      "9250": {
        "LA REGADERA": true
      },
      "9260": {
        "CONSTITUCIÓN DE 1917": true
      },
      "9270": {
        "COLONIAL IZTAPALAPA": true
      },
      "9280": {
        "JACARANDAS": true
      },
      "9290": {
        "SANTA CRUZ MEYEHUALCO": true
      },
      "9300": {
        "GUADALUPE DEL MORAL": true
      },
      "9310": {
        "LEYES DE REFORMA 1A SECCIÓN": true,
        "LEYES DE REFORMA 2A SECCIÓN": true,
        "LEYES DE REFORMA 3A SECCIÓN": true
      },
      "9319": {
        "CUCHILLA DEL MORAL": true
      },
      "9320": {
        "SIDERAL": true
      },
      "9350": {
        "ALBARRADA": true
      },
      "9359": {
        "EVA SÁMANO DE LÓPEZ MATEOS": true
      },
      "9360": {
        "AMPLIACIÓN SAN MIGUEL": true,
        "SAN MIGUEL": true
      },
      "9400": {
        "EL SIFÓN": true,
        "SAN JUANICO NEXTIPAC": true
      },
      "9410": {
        "ACULCO": true,
        "JARDINES DE CHURUBUSCO": true,
        "MAGDALENA ATLAZOLPA": true,
        "SAN JOSÉ ACULCO": true
      },
      "9420": {
        "LOS PICOS VI-B": true,
        "NUEVA ROSITA": true
      },
      "9429": {
        "PURÍSIMA ATLAZOLPA": true
      },
      "9430": {
        "APATLACO": true,
        "EL TRIUNFO": true
      },
      "9438": {
        "AMPLIACIÓN EL TRIUNFO": true
      },
      "9440": {
        "EL RETOÑO": true,
        "SAN ANDRÉS TETEPILCO": true,
        "ZACAHUITZCO": true
      },
      "9450": {
        "BANJIDAL": true
      },
      "9460": {
        "JUSTO SIERRA": true
      },
      "9470": {
        "SINATEL": true
      },
      "9479": {
        "AMPLIACIÓN SINATEL": true
      },
      "9480": {
        "EL PRADO": true
      },
      "9500": {
        "SANTA MARÍA AZTAHUACÁN": true,
        "SANTA MARÍA AZTAHUACÁN AMPLIACIÓN": true
      },
      "9510": {
        "SANTA MARTHA ACATITLA": true
      },
      "9520": {
        "EL EDÉN": true,
        "SAN SEBASTIÁN TECOLOXTITLA": true
      },
      "9530": {
        "SANTA MARTHA ACATITLA SUR": true
      },
      "9550": {
        "MONTE ALBÁN": true
      },
      "9560": {
        "PARAJE ZACATEPEC": true
      },
      "9570": {
        "SANTA MARÍA AZTAHUACÁN": true
      },
      "9578": {
        "EJÉRCITO DE AGUA PRIETA": true
      },
      "9600": {
        "SANTIAGO ACAHUALTEPEC": true
      },
      "9608": {
        "SANTIAGO ACAHUALTEPEC 1RA. AMPLIACIÓN": true
      },
      "9609": {
        "SANTIAGO ACAHUALTEPEC 2A. AMPLIACIÓN": true
      },
      "9620": {
        "LOMAS DE ZARAGOZA": true
      },
      "9630": {
        "SAN MIGUEL TEOTONGO SECCIÓN ACORRALADO": true,
        "SAN MIGUEL TEOTONGO SECCIÓN AVISADERO": true,
        "SAN MIGUEL TEOTONGO SECCIÓN CAPILLA": true,
        "SAN MIGUEL TEOTONGO SECCIÓN CORRALES": true,
        "SAN MIGUEL TEOTONGO SECCIÓN GUADALUPE": true,
        "SAN MIGUEL TEOTONGO SECCIÓN IZTLAHUACA": true,
        "SAN MIGUEL TEOTONGO SECCIÓN JARDINES": true,
        "SAN MIGUEL TEOTONGO SECCIÓN LA CRUZ": true,
        "SAN MIGUEL TEOTONGO SECCIÓN LOMA ALTA": true,
        "SAN MIGUEL TEOTONGO SECCIÓN MERCEDES": true,
        "SAN MIGUEL TEOTONGO SECCIÓN PALMITAS": true,
        "SAN MIGUEL TEOTONGO SECCIÓN PUENTE": true,
        "SAN MIGUEL TEOTONGO SECCIÓN RANCHITO": true,
        "SAN MIGUEL TEOTONGO SECCIÓN RANCHO BAJO": true,
        "SAN MIGUEL TEOTONGO SECCIÓN TORRES": true
      },
      "9637": {
        "CAMPESTRE POTRERO": true
      },
      "9638": {
        "AMPLIACIÓN EMILIANO ZAPATA": true
      },
      "9640": {
        "LOMAS DE LA ESTANCIA": true,
        "XALPA": true
      },
      "9648": {
        "SAN PABLO": true
      },
      "9660": {
        "CITLALLI": true
      },
      "9670": {
        "PALMITAS": true
      },
      "9680": {
        "TENORIOS": true
      },
      "9689": {
        "BARRANCA DE GUADALUPE": true
      },
      "9690": {
        "IZTLAHUACÁN": true
      },
      "9696": {
        "MIRAVALLES": true
      },
      "9698": {
        "MIGUEL DE LA MADRID HURTADO": true
      },
      "9700": {
        "BUENAVISTA": true,
        "CARLOS HANK GONZÁLEZ": true,
        "DESARROLLO URBANO QUETZALCÓATL": true,
        "SANTA CRUZ MEYEHUALCO": true
      },
      "9704": {
        "DEGOLLADO": true
      },
      "9705": {
        "DEGOLLADO - MEXICATLALLI": true
      },
      "9706": {
        "SAN JOSÉ BUENAVISTA": true
      },
      "9708": {
        "MIXCOATL": true
      },
      "9709": {
        "LOMAS DE SANTA CRUZ": true
      },
      "9710": {
        "LOS ÁNGELES APANOAYA": true
      },
      "9720": {
        "FRANCISCO VILLA": true,
        "LA ERA": true
      },
      "9730": {
        "REFORMA POLÍTICA": true
      },
      "9740": {
        "PRESIDENTES DE MÉXICO": true
      },
      "9750": {
        "INSURGENTES": true,
        "LA POLVORILLA": true,
        "LAS PEÑAS": true
      },
      "9760": {
        "CONSEJO AGRARISTA MEXICANO": true
      },
      "9769": {
        "EL TRIÁNGULO": true
      },
      "9770": {
        "PUENTE BLANCO": true
      },
      "9780": {
        "AÑO DE JUÁREZ": true,
        "LOMAS DE SAN LORENZO": true
      },
      "9790": {
        "SAN LORENZO TEZONCO": true
      },
      "9800": {
        "CULHUACÁN": true,
        "EL MIRADOR": true,
        "ESTRELLA CULHUACÁN": true,
        "FUEGO NUEVO": true,
        "SAN ANTONIO CULHUACÁN": true,
        "SAN SIMÓN CULHUACÁN": true,
        "TULA": true,
        "VALLE DE LUCES": true
      },
      "9810": {
        "GRANJAS ESMERALDA": true,
        "LOS CIPRESES": true,
        "MINERVA": true,
        "PROGRESO DEL SUR": true
      },
      "9819": {
        "VALLE DEL SUR": true
      },
      "9820": {
        "EL SANTUARIO": true,
        "ESTRELLA DEL SUR": true,
        "RICARDO FLORES MAGÓN": true,
        "SANTA ISABEL INDUSTRIAL": true
      },
      "9828": {
        "AMPLIACIÓN RICARDO FLORES MAGÓN": true
      },
      "9829": {
        "AMPLIACIÓN EL SANTUARIO": true
      },
      "9830": {
        "EL MANTO": true,
        "EL MOLINO": true,
        "LOMAS EL MANTO": true,
        "LOS ÁNGELES": true,
        "PARAJE SAN JUAN": true
      },
      "9837": {
        "SAN MIGUEL 8VA. AMPLIACIÓN": true
      },
      "9838": {
        "PLAN DE IGUALA": true
      },
      "9839": {
        "AMPLIACIÓN PARAJE SAN JUAN": true,
        "SAN JUAN JOYA": true
      },
      "9840": {
        "LOS REYES CULHUACÁN": true
      },
      "9849": {
        "AMPLIACIÓN LOS REYES": true
      },
      "9850": {
        "SAN JUAN XALPA": true,
        "SAN NICOLÁS TOLENTINO": true,
        "SANTA MARÍA DEL MONTE": true
      },
      "9856": {
        "AMPLIACIÓN VERACRUZANA": true,
        "ESTADO DE VERACRUZ": true
      },
      "9858": {
        "PARAJE SAN JUAN CERRO": true
      },
      "9859": {
        "BENITO JUÁREZ": true
      },
      "9860": {
        "AMPLIACIÓN BELLAVISTA": true,
        "BELLAVISTA": true,
        "CASA BLANCA": true,
        "CERRO DE LA ESTRELLA": true,
        "EL RODEO": true,
        "PARQUE NACIONAL CERRO DE LA ESTRELLA": true
      },
      "9868": {
        "SAN JUAN ESTRELLA": true
      },
      "9870": {
        "12 DE DICIEMBRE": true,
        "SAN ANDRÉS TOMATLÁN": true,
        "SANTA MARÍA TOMATLÁN": true
      },
      "9880": {
        "EL VERGEL": true,
        "GRANJAS ESTRELLA": true
      },
      "9890": {
        "LOMAS ESTRELLA": true
      },
      "9897": {
        "CARLOS JONGUITUD BARRIOS": true
      },
      "9900": {
        "GUADALUPE": true,
        "SAN ANTONIO": true,
        "SAN LORENZO": true
      },
      "9910": {
        "LA ESPERANZA": true
      },
      "9920": {
        "JOSÉ LÓPEZ PORTILLO": true
      },
      "9930": {
        "EL ROSARIO": true
      },
      "9940": {
        "JARDINES DE SAN LORENZO TEZONCO": true
      },
      "9960": {
        "ALLAPETLALLI": true,
        "CELOALLIOTLI": true,
        "EL MOLINO TEZONCO": true,
        "LA PLANTA": true,
        "USCOVI": true
      },
      "9969": {
        "CANANEA": true
      },
      "9970": {
        "VALLE DE SAN LORENZO": true
      }
    },
    "LA MAGDALENA CONTRERAS": {
      "10000": {
        "LOMAS QUEBRADAS": true
      },
      "10010": {
        "LA MALINCHE": true,
        "SAN BARTOLO AMEYALCO": true
      },
      "10020": {
        "CUAUHTÉMOC": true
      },
      "10130": {
        "EL MAESTRO": true
      },
      "10200": {
        "SAN JERÓNIMO LÍDICE": true
      },
      "10300": {
        "SAN BERNABÉ OCOTEPEC": true
      },
      "10320": {
        "EL TANQUE": true
      },
      "10330": {
        "LAS CRUCES": true
      },
      "10340": {
        "LOS PADRES": true
      },
      "10350": {
        "LOMAS DE SAN BERNABÉ": true
      },
      "10360": {
        "HUAYATLA": true
      },
      "10368": {
        "AMPLIACIÓN POTRERILLO": true
      },
      "10369": {
        "AMPLIACIÓN LOMAS DE SAN BERNABÉ": true,
        "TIERRA UNIDA": true
      },
      "10370": {
        "PALMAS": true
      },
      "10378": {
        "ATACAXCO": true
      },
      "10379": {
        "VISTA HERMOSA": true
      },
      "10380": {
        "BARROS SIERRA": true
      },
      "10400": {
        "SAN JERÓNIMO ACULCO": true
      },
      "10500": {
        "BARRIO SAN FRANCISCO": true
      },
      "10580": {
        "BARRANCA SECA": true
      },
      "10600": {
        "EL ROSAL": true
      },
      "10610": {
        "EL TORO": true
      },
      "10620": {
        "POTRERILLO": true
      },
      "10630": {
        "EL OCOTAL": true
      },
      "10640": {
        "LA CARBONERA": true,
        "PUEBLO NUEVO ALTO": true,
        "PUEBLO NUEVO BAJO": true
      },
      "10660": {
        "EL ERMITAÑO": true
      },
      "10700": {
        "HÉROES DE PADIERNA": true
      },
      "10710": {
        "SANTA TERESA": true
      },
      "10800": {
        "LA CRUZ": true
      },
      "10810": {
        "SAN FRANCISCO": true
      },
      "10820": {
        "LA GUADALUPE": true
      },
      "10830": {
        "LA CONCEPCIÓN": true
      },
      "10840": {
        "LAS CALLES": true,
        "PLAZUELA DEL PEDREGAL": true
      },
      "10900": {
        "SAN NICOLÁS TOTOLAPAN": true
      },
      "10910": {
        "LA MAGDALENA": true
      },
      "10920": {
        "LAS HUERTAS": true
      },
      "10926": {
        "TIERRA COLORADA": true
      }
    },
    "MIGUEL HIDALGO": {
      "11000": {
        "LOMAS DE CHAPULTEPEC I SECCIÓN": true,
        "LOMAS DE CHAPULTEPEC II SECCIÓN": true,
        "LOMAS DE CHAPULTEPEC III SECCIÓN": true,
        "LOMAS DE CHAPULTEPEC IV SECCIÓN": true,
        "LOMAS DE CHAPULTEPEC V SECCIÓN": true,
        "LOMAS DE CHAPULTEPEC VI SECCIÓN": true,
        "LOMAS DE CHAPULTEPEC VII SECCIÓN": true,
        "LOMAS DE CHAPULTEPEC VIII SECCIÓN": true
      },
      "11040": {
        "MOLINO DEL REY": true
      },
      "11100": {
        "BOSQUE DE CHAPULTEPEC II SECCIÓN": true,
        "BOSQUE DE CHAPULTEPEC III SECCIÓN": true
      },
      "11200": {
        "LOMAS DE SOTELO": true,
        "LOMAS HERMOSA": true
      },
      "11210": {
        "SAN LORENZO TLALTENANGO": true
      },
      "11220": {
        "PERIODISTA": true
      },
      "11230": {
        "ARGENTINA PONIENTE": true
      },
      "11240": {
        "IGNACIO MANUEL ALTAMIRANO": true
      },
      "11250": {
        "10 DE ABRIL": true
      },
      "11260": {
        "MÉXICO NUEVO": true,
        "SAN JOAQUÍN": true
      },
      "11270": {
        "ARGENTINA ANTIGUA": true
      },
      "11280": {
        "TORRE BLANCA": true
      },
      "11289": {
        "AMPLIACIÓN TORRE BLANCA": true
      },
      "11290": {
        "HUÍCHAPAN": true,
        "SAN DIEGO OCOYOACAC": true
      },
      "11300": {
        "VERÓNICA ANZURES": true
      },
      "11310": {
        "MARIANO ESCOBEDO": true
      },
      "11320": {
        "ANÁHUAC I SECCIÓN": true,
        "ANÁHUAC II SECCIÓN": true
      },
      "11330": {
        "UN HOGAR PARA NOSOTROS": true
      },
      "11340": {
        "SANTO TOMÁS": true
      },
      "11350": {
        "PLUTARCO ELÍAS CALLES": true
      },
      "11360": {
        "AGRICULTURA": true
      },
      "11370": {
        "TLAXPANA": true
      },
      "11400": {
        "POPOTLA": true
      },
      "11410": {
        "LEGARIA": true,
        "TACUBA": true
      },
      "11420": {
        "NEXTITLA": true
      },
      "11430": {
        "PENSIL NORTE": true,
        "VENTURA PÉREZ DE ALVA": true
      },
      "11440": {
        "REFORMA PENSIL": true,
        "SAN JUANICO": true
      },
      "11450": {
        "AHUEHUETES ANÁHUAC": true,
        "MODELO PENSIL": true,
        "PERALITOS": true
      },
      "11460": {
        "DOS LAGOS": true,
        "LAGO NORTE": true,
        "LAGO SUR": true,
        "LOS MANZANOS": true
      },
      "11470": {
        "5 DE MAYO": true,
        "DEPORTIVO PENSIL": true
      },
      "11480": {
        "FRANCISCO I MADERO": true,
        "POPO": true
      },
      "11489": {
        "AMPLIACIÓN POPO": true
      },
      "11490": {
        "CUAUHTÉMOC PENSIL": true,
        "PENSIL SUR": true
      },
      "11500": {
        "IRRIGACIÓN": true
      },
      "11510": {
        "POLANCO I SECCIÓN": true
      },
      "11520": {
        "GRANADA": true
      },
      "11529": {
        "AMPLIACIÓN GRANADA": true
      },
      "11530": {
        "POLANCO II SECCIÓN": true
      },
      "11540": {
        "POLANCO III SECCIÓN": true
      },
      "11550": {
        "POLANCO IV SECCIÓN": true
      },
      "11560": {
        "POLANCO V SECCIÓN": true
      },
      "11570": {
        "CHAPULTEPEC MORALES": true
      },
      "11580": {
        "BOSQUE DE CHAPULTEPEC I SECCIÓN": true
      },
      "11590": {
        "ANZURES": true
      },
      "11600": {
        "RESIDENCIAL MILITAR": true
      },
      "11610": {
        "MANUEL ÁVILA CAMACHO": true
      },
      "11619": {
        "CAMPO MILITAR 1": true
      },
      "11650": {
        "REFORMA SOCIAL": true
      },
      "11700": {
        "BOSQUE DE LAS LOMAS": true
      },
      "11800": {
        "ESCANDÓN I SECCIÓN": true,
        "ESCANDÓN II SECCIÓN": true
      },
      "11810": {
        "16 DE SEPTIEMBRE": true
      },
      "11820": {
        "AMÉRICA": true
      },
      "11830": {
        "DANIEL GARZA": true
      },
      "11840": {
        "AMPLIACIÓN DANIEL GARZA": true
      },
      "11850": {
        "SAN MIGUEL CHAPULTEPEC I SECCIÓN": true,
        "SAN MIGUEL CHAPULTEPEC II SECCIÓN": true
      },
      "11860": {
        "OBSERVATORIO": true
      },
      "11870": {
        "TACUBAYA": true
      },
      "11910": {
        "LOMAS DE BEZARES": true
      },
      "11920": {
        "REAL DE LAS LOMAS": true
      },
      "11930": {
        "LOMAS DE REFORMA": true
      },
      "11950": {
        "LOMAS ALTAS": true
      }
    },
    "MILPA ALTA": {
      "12070": {
        "SAN AGUSTÍN": true
      },
      "12080": {
        "SAN AGUSTIN OHTENCO": true
      },
      "12100": {
        "CRUZTITLA": true,
        "TECAXTITLA": true,
        "TENANTITLA": true,
        "XALTIPAC": true,
        "XOCHITEPEC": true
      },
      "12110": {
        "EMILIANO ZAPATA": true,
        "LA CONCHITA": true
      },
      "12200": {
        "NOCHTLA": true,
        "OCOTITLA": true,
        "PANCHIMALCO": true,
        "TULA": true
      },
      "12300": {
        "SAN SALVADOR CUAUHTENCO": true
      },
      "12400": {
        "CENTRO": true,
        "SAN JUAN": true,
        "SAN MIGUEL": true
      },
      "12410": {
        "CHALMITA": true
      },
      "12500": {
        "SAN LORENZO TLACOYUCAN": true
      },
      "12600": {
        "SAN JERÓNIMO MIACATLÁN": true
      },
      "12700": {
        "SAN FRANCISCO TECOXPA": true
      },
      "12800": {
        "SAN JUAN TEPENAHUAC": true
      },
      "12910": {
        "LA LUPITA TETICPAC": true
      },
      "12920": {
        "SAN MARCOS": true
      },
      "12930": {
        "SAN MIGUEL": true
      },
      "12940": {
        "SAN JOSÉ": true
      },
      "12950": {
        "LA LUPITA XOLCO": true
      }
    },
    "TLALPAN": {
      "14000": {
        "TLALPAN": true,
        "TLALPAN CENTRO": true
      },
      "14010": {
        "PARQUE DEL PEDREGAL": true
      },
      "14020": {
        "VILLA OLÍMPICA": true
      },
      "14030": {
        "ISIDRO FABELA": true
      },
      "14039": {
        "AMPLIACIÓN ISIDRO FABELA": true
      },
      "14040": {
        "CANTERA PUENTE DE PIEDRA": true,
        "PUEBLO QUIETO": true
      },
      "14049": {
        "COMUNEROS DE SANTA ÚRSULA": true
      },
      "14050": {
        "TORIELLO GUERRA": true
      },
      "14060": {
        "PEÑA POBRE": true
      },
      "14070": {
        "RÓMULO SÁNCHEZ MIRELES": true,
        "SAN PEDRO APÓSTOL": true
      },
      "14080": {
        "BELISARIO DOMÍNGUEZ SECCIÓN XVI": true,
        "DEL NIÑO JESÚS": true
      },
      "14090": {
        "LA JOYA": true
      },
      "14100": {
        "PEDREGAL DE SAN NICOLÁS 1A SECCIÓN": true,
        "PEDREGAL DE SAN NICOLÁS 2A SECCIÓN": true,
        "PEDREGAL DE SAN NICOLÁS 3A SECCIÓN": true,
        "PEDREGAL DE SAN NICOLÁS 4A SECCIÓN": true,
        "PEDREGAL DE SAN NICOLÁS 5ª SECCIÓN": true
      },
      "14108": {
        "CHICHICASPATL": true
      },
      "14110": {
        "AMPLIACIÓN FUENTES DEL PEDREGAL": true
      },
      "14120": {
        "RINCÓN DEL PEDREGAL": true
      },
      "14140": {
        "FUENTES DEL PEDREGAL": true
      },
      "14150": {
        "LOMAS DEL PEDREGAL FRAMBOYANES": true
      },
      "14160": {
        "POPULAR SANTA TERESA": true
      },
      "14200": {
        "HÉROES DE PADIERNA": true,
        "JARDINES DEL AJUSCO": true
      },
      "14208": {
        "COLINAS DEL AJUSCO": true
      },
      "14209": {
        "TORRES DE PADIERNA": true
      },
      "14210": {
        "JARDINES EN LA MONTAÑA": true
      },
      "14219": {
        "PARQUE NACIONAL BOSQUE DEL PEDREGAL": true,
        "SIX FLAGS (REINO AVENTURA)": true
      },
      "14220": {
        "CUCHILLA DE PADIERNA": true,
        "LOMAS DEL PEDREGAL": true
      },
      "14230": {
        "CULTURA MAYA": true
      },
      "14239": {
        "LOS ENCINOS": true
      },
      "14240": {
        "LOMAS DE PADIERNA": true,
        "LOMAS HIDALGO": true
      },
      "14248": {
        "CRUZ DEL FAROL": true
      },
      "14250": {
        "MIGUEL HIDALGO": true,
        "MIGUEL HIDALGO 2A SECCIÓN": true,
        "MIGUEL HIDALGO 3A SECCIÓN": true,
        "MIGUEL HIDALGO 4A SECCIÓN": true
      },
      "14260": {
        "EL CAPULÍN": true,
        "MIGUEL HIDALGO 1A SECCIÓN": true
      },
      "14266": {
        "ZACAYUCAN PEÑA POBRE": true
      },
      "14267": {
        "DE CARAMAGÜEY": true
      },
      "14268": {
        "LA LONJA": true
      },
      "14269": {
        "LA FAMA": true
      },
      "14270": {
        "PRIMAVERA": true,
        "VERANO": true
      },
      "14275": {
        "PARAJE 38": true
      },
      "14300": {
        "NUEVA ORIENTAL COAPA": true,
        "RESIDENCIAL ACOXPA": true,
        "RESIDENCIAL MIRAMONTES": true
      },
      "14308": {
        "EX HACIENDA COAPA": true
      },
      "14310": {
        "BELISARIO DOMÍNGUEZ": true,
        "FLORESTA COYOACÁN": true
      },
      "14320": {
        "VERGEL COAPA": true
      },
      "14325": {
        "RINCONADA COAPA 2A SECCIÓN": true
      },
      "14326": {
        "TENORIOS": true
      },
      "14330": {
        "GRANJAS COAPA": true,
        "RINCONADA COAPA 1A SECCIÓN": true
      },
      "14340": {
        "VERGEL DE COYOACÁN": true,
        "VERGEL DEL SUR": true
      },
      "14350": {
        "PRADO COAPA 1A SECCIÓN": true
      },
      "14357": {
        "PRADO COAPA 2A SECCIÓN": true,
        "PRADO COAPA 3A SECCIÓN": true
      },
      "14360": {
        "MAGISTERIAL": true,
        "MAGISTERIAL COAPA": true
      },
      "14370": {
        "RESIDENCIAL CHIMALI": true,
        "SAN LORENZO HUIPULCO": true,
        "VILLA LÁZARO CÁRDENAS": true
      },
      "14376": {
        "ARBOLEDAS DEL SUR": true
      },
      "14377": {
        "HACIENDA SAN JUAN": true
      },
      "14380": {
        "A.M.S.A": true,
        "SAN BARTOLO EL CHICO": true
      },
      "14386": {
        "RANCHO LOS COLORINES": true
      },
      "14387": {
        "EX HACIENDA SAN JUAN DE DIOS": true
      },
      "14388": {
        "GUADALUPE": true
      },
      "14389": {
        "ARENAL DE GUADALUPE": true
      },
      "14390": {
        "NARCISO MENDOZA": true,
        "RESIDENCIAL VILLA COAPA": true,
        "RINCONADA LAS HADAS": true,
        "VILLA COAPA": true
      },
      "14400": {
        "SAN ANDRÉS TOTOLTEPEC": true
      },
      "14406": {
        "DIVISADERO": true
      },
      "14408": {
        "NUEVO RENACIMIENTO DE AXALCO": true
      },
      "14409": {
        "TECORRAL": true
      },
      "14410": {
        "BOSQUES DE TEPEXIMILPA": true,
        "FUENTES BROTANTES": true
      },
      "14420": {
        "CUMBRES DE TEPETONGO": true,
        "MESA DE LOS HORNOS": true,
        "SANTA ÚRSULA XITLA": true
      },
      "14426": {
        "TEXCALTENCO": true,
        "TLAXCALTENCO LA MESA": true
      },
      "14427": {
        "SAN JUAN TEPEXIMILPA": true,
        "TEPEXIMILPA LA PAZ": true
      },
      "14429": {
        "SANTÍSIMA TRINIDAD": true
      },
      "14430": {
        "EL TRUENITO": true,
        "TLALCOLIGIA": true
      },
      "14438": {
        "PEDREGAL DE SANTA ÚRSULA XITLA": true
      },
      "14439": {
        "PEDREGAL DE LAS ÁGUILAS": true
      },
      "14440": {
        "LOS VOLCANES": true
      },
      "14449": {
        "EL MIRADOR 1A SECCIÓN": true,
        "EL MIRADOR 2A SECCIÓN": true,
        "EL MIRADOR 3A SECCIÓN": true
      },
      "14456": {
        "ACTOPA": true,
        "ACTOPA SUR": true
      },
      "14460": {
        "TLALPUENTE": true
      },
      "14470": {
        "PLAN DE AYALA": true
      },
      "14476": {
        "LA PALMA": true
      },
      "14479": {
        "VIVEROS COATECTLÁN": true
      },
      "14480": {
        "LA MAGDALENA PETLACALCO": true
      },
      "14490": {
        "SAN MIGUEL XICALCO": true
      },
      "14500": {
        "SAN MIGUEL TOPILEJO": true
      },
      "14600": {
        "VALLE ESCONDIDO": true
      },
      "14608": {
        "COLINAS DEL BOSQUE": true
      },
      "14609": {
        "LAS TÓRTOLAS": true
      },
      "14610": {
        "ARENAL TEPEPAN": true
      },
      "14620": {
        "CLUB DE GOLF MÉXICO": true
      },
      "14629": {
        "SAN BUENAVENTURA": true
      },
      "14630": {
        "CHIMALCOYOC": true,
        "VILLA TLALPAN": true
      },
      "14640": {
        "EJIDOS DE SAN PEDRO MÁRTIR": true
      },
      "14643": {
        "FUENTES DE TEPEPAN": true,
        "TECOANTITLA XOLALPA": true
      },
      "14646": {
        "VALLE DE TEPEPAN": true
      },
      "14647": {
        "JUVENTUD UNIDA": true,
        "MOVIMIENTO ORGANIZADO DE TLALPAN": true,
        "RINCONADA EL MIRADOR": true
      },
      "14650": {
        "SAN PEDRO MÁRTIR": true
      },
      "14653": {
        "HERÓICO COLEGIO MILITAR": true
      },
      "14654": {
        "DOLORES TLALLI": true
      },
      "14655": {
        "VALLE VERDE": true
      },
      "14657": {
        "TLALMILLE": true
      },
      "14658": {
        "MIRADOR DEL VALLE": true
      },
      "14659": {
        "MARÍA ESTHER ZUNO DE ECHEVERRÍA": true
      },
      "14700": {
        "SAN MIGUEL AJUSCO": true
      },
      "14710": {
        "SANTO TOMAS AJUSCO": true
      },
      "14720": {
        "BELVEDERE AJUSCO": true
      },
      "14730": {
        "LOMAS DE CUILOTEPEC": true
      },
      "14734": {
        "EL ZACATÓN": true
      },
      "14735": {
        "LOMAS DE CUILOTEPEC II SECCIÓN": true,
        "LOMAS DE TEPEMECATL": true
      },
      "14737": {
        "VISTAS DEL PEDREGAL": true
      },
      "14738": {
        "BOSQUES DEL PEDREGAL": true
      },
      "14739": {
        "2 DE OCTUBRE": true
      },
      "14740": {
        "LOMAS DE PADIERNA SUR": true
      },
      "14748": {
        "MIRADOR I": true,
        "MIRADOR II": true
      },
      "14749": {
        "CHIMILLI": true
      },
      "14760": {
        "HÉROES DE 1910": true
      },
      "14900": {
        "PARRES EL GUARDA": true
      }
    },
    "TLÁHUAC": {
      "13000": {
        "LA ASUNCIÓN": true
      },
      "13010": {
        "SANTA CECILIA": true
      },
      "13020": {
        "SAN JOSÉ": true
      },
      "13030": {
        "SAN JUAN": true
      },
      "13040": {
        "SAN MATEO": true
      },
      "13050": {
        "LA HABANA": true
      },
      "13060": {
        "LA GUADALUPE": true,
        "SANTA ANA": true
      },
      "13070": {
        "LA MAGDALENA": true,
        "SAN MIGUEL": true
      },
      "13080": {
        "LOS REYES": true
      },
      "13090": {
        "QUIAHUATLA": true
      },
      "13093": {
        "SAN SEBASTIÁN": true
      },
      "13094": {
        "SAN ISIDRO": true
      },
      "13099": {
        "SAN ANDRÉS": true
      },
      "13100": {
        "LA GUADALUPE": true
      },
      "13120": {
        "AMPLIACIÓN SANTA CATARINA": true,
        "SANTIAGO": true
      },
      "13150": {
        "LA CONCEPCIÓN": true
      },
      "13180": {
        "SAN MIGUEL": true
      },
      "13200": {
        "MIGUEL HIDALGO": true
      },
      "13210": {
        "LOS OLIVOS": true
      },
      "13219": {
        "AMPLIACIÓN LOS OLIVOS": true,
        "LAS ARBOLEDAS": true
      },
      "13220": {
        "LA NOPALERA": true
      },
      "13230": {
        "GRANJAS CABRERA": true
      },
      "13250": {
        "LA TURBA": true
      },
      "13270": {
        "DEL MAR": true
      },
      "13273": {
        "LA DRAGA": true
      },
      "13278": {
        "VILLA CENTROAMERICANA": true
      },
      "13280": {
        "AGRÍCOLA METROPOLITANA": true
      },
      "13300": {
        "SANTA ANA CENTRO": true,
        "SANTA ANA NORTE": true,
        "SANTA ANA PONIENTE": true,
        "SANTIAGO CENTRO": true,
        "SANTIAGO NORTE": true
      },
      "13310": {
        "ZAPOTITLA": true
      },
      "13315": {
        "AMPLIACIÓN ZAPOTITLA": true
      },
      "13319": {
        "LA ESTACIÓN": true
      },
      "13360": {
        "LA CONCHITA ZAPOTITLÁN": true,
        "SANTA ANA SUR": true,
        "SANTIAGO SUR": true
      },
      "13400": {
        "SAN FRANCISCO TLALTENCO": true
      },
      "13410": {
        "LÓPEZ PORTILLO": true
      },
      "13419": {
        "AMPLIACIÓN JOSÉ LÓPEZ PORTILLO": true
      },
      "13420": {
        "SELENE": true
      },
      "13430": {
        "AMPLIACIÓN SELENE": true
      },
      "13440": {
        "ZACATENCO": true
      },
      "13450": {
        "GUADALUPE TLALTENCO": true
      },
      "13460": {
        "EL TRIÁNGULO": true
      },
      "13508": {
        "SAN AGUSTÍN": true
      },
      "13509": {
        "LA CONCEPCIÓN": true
      },
      "13510": {
        "LA LUPITA": true
      },
      "13520": {
        "FRANCISCO VILLA": true
      },
      "13530": {
        "JAIME TORRES BODET": true,
        "LA ASUNCIÓN": true
      },
      "13540": {
        "EL ROSARIO": true,
        "TIERRA BLANCA": true
      },
      "13545": {
        "AMPLIACIÓN LA CONCHITA": true
      },
      "13549": {
        "PEÑA ALTA": true
      },
      "13550": {
        "JARDINES DEL LLANO": true,
        "POTRERO DEL LLANO": true
      },
      "13600": {
        "SAN BARTOLOMÉ": true
      },
      "13610": {
        "LOS REYES": true
      },
      "13625": {
        "SANTA CRUZ": true
      },
      "13630": {
        "SAN AGUSTÍN": true
      },
      "13640": {
        "SAN MIGUEL": true
      },
      "13700": {
        "SAN NICOLÁS TETELCO": true,
        "TEPANTITLAMILCO": true
      }
    },
    "VENUSTIANO CARRANZA": {
      "15000": {
        "GENERAL IGNACIO ZARAGOZA": true
      },
      "15010": {
        "VALENTÍN GÓMEZ FARIAS": true
      },
      "15020": {
        "PUEBLA": true
      },
      "15100": {
        "ZONA CENTRO": true
      },
      "15200": {
        "JANITZIO": true
      },
      "15210": {
        "VALLE GÓMEZ": true
      },
      "15220": {
        "NICOLÁS BRAVO": true,
        "POPULAR RASTRO": true
      },
      "15230": {
        "EMILIO CARRANZA": true
      },
      "15240": {
        "MICHOACANA": true
      },
      "15250": {
        "AMPLIACIÓN MICHOACANA": true
      },
      "15260": {
        "AMPLIACIÓN 20 DE NOVIEMBRE": true
      },
      "15270": {
        "MORELOS": true
      },
      "15280": {
        "PENITENCIARIA": true
      },
      "15290": {
        "10 DE MAYO": true
      },
      "15300": {
        "20 DE NOVIEMBRE": true
      },
      "15309": {
        "5O TRAMO 20 DE NOVIEMBRE": true
      },
      "15310": {
        "FELIPE ÁNGELES": true
      },
      "15320": {
        "AZTECA": true
      },
      "15330": {
        "TRES MOSQUETEROS": true
      },
      "15339": {
        "AMPLIACIÓN VENUSTIANO CARRANZA": true
      },
      "15340": {
        "VENUSTIANO CARRANZA": true
      },
      "15350": {
        "AMPLIACIÓN PENITENCIARIA": true
      },
      "15370": {
        "PROGRESISTA": true
      },
      "15380": {
        "ESCUELA DE TIRO": true
      },
      "15390": {
        "7 DE JULIO": true
      },
      "15400": {
        "ROMERO RUBIO": true
      },
      "15410": {
        "SIMÓN BOLÍVAR": true
      },
      "15420": {
        "AMPLIACIÓN SIMÓN BOLÍVAR": true
      },
      "15430": {
        "AQUILES SERDÁN": true
      },
      "15440": {
        "1° DE MAYO": true
      },
      "15450": {
        "DAMIÁN CARMONA": true
      },
      "15460": {
        "REVOLUCIÓN": true
      },
      "15470": {
        "MIGUEL HIDALGO": true
      },
      "15500": {
        "MOCTEZUMA 1A SECCIÓN": true
      },
      "15510": {
        "PENSADOR MEXICANO": true
      },
      "15520": {
        "PEÑÓN DE LOS BAÑOS": true
      },
      "15530": {
        "MOCTEZUMA 2A SECCIÓN": true
      },
      "15540": {
        "SANTA CRUZ AVIACIÓN": true
      },
      "15600": {
        "ARENAL 1A SECCIÓN": true
      },
      "15610": {
        "CUCHILLA PANTITLÁN": true
      },
      "15620": {
        "MÉXICO (LIC. BENITO JUÁREZ)": true,
        "MÉXICO (LICENCIADO BENITO JUÁREZ)": true
      },
      "15630": {
        "CARACOL": true
      },
      "15640": {
        "ARENAL 4A SECCIÓN": true,
        "ARENAL PUERTO AÉREO": true
      },
      "15650": {
        "AMPLIACIÓN CARACOL": true
      },
      "15660": {
        "ARENAL 3A SECCIÓN": true
      },
      "15670": {
        "ADOLFO LÓPEZ MATEOS": true
      },
      "15680": {
        "ARENAL 2A SECCIÓN": true
      },
      "15700": {
        "FEDERAL": true
      },
      "15710": {
        "INDUSTRIAL PUERTO AÉREO": true
      },
      "15730": {
        "4 ÁRBOLES": true
      },
      "15740": {
        "AVIACIÓN CIVIL": true
      },
      "15750": {
        "AMPLIACIÓN AVIACIÓN CIVIL": true
      },
      "15800": {
        "JAMAICA": true
      },
      "15810": {
        "MERCED BALBUENA": true
      },
      "15820": {
        "LORENZO BOTURINI": true
      },
      "15830": {
        "ARTES GRÁFICAS": true
      },
      "15840": {
        "SEVILLA": true
      },
      "15850": {
        "MAGDALENA MIXIUHCA": true
      },
      "15860": {
        "LA MAGDALENA MIXIUHCA": true
      },
      "15870": {
        "AARÓN SÁENZ": true
      },
      "15900": {
        "JARDÍN BALBUENA": true
      },
      "15960": {
        "DEL PARQUE": true
      },
      "15970": {
        "AERONÁUTICA MILITAR": true
      },
      "15980": {
        "24 DE ABRIL": true
      },
      "15990": {
        "ÁLVARO OBREGÓN": true
      }
    },
    "XOCHIMILCO": {
      "16000": {
        "LA CONCEPCIÓN TLACOAPA": true,
        "SAN ANTONIO": true,
        "SAN JUAN": true
      },
      "16010": {
        "BOSQUE RESIDENCIAL DEL SUR": true
      },
      "16020": {
        "SAN JUAN TEPEPAN": true
      },
      "16029": {
        "AMPLIACIÓN TEPEPAN": true
      },
      "16030": {
        "AMPLIACIÓN LA NORIA": true,
        "HUÍCHAPAN": true,
        "LA NORIA": true,
        "POTRERO DE SAN BERNARDINO": true
      },
      "16034": {
        "18": true
      },
      "16035": {
        "RINCONADA COAPA": true,
        "SAN LORENZO LA CEBADA": true
      },
      "16036": {
        "MERCADO DE FLORES PLANTAS Y HORTALIZAS": true
      },
      "16038": {
        "AMPLIACIÓN SAN MARCOS NORTE": true
      },
      "16040": {
        "LA ASUNCIÓN": true,
        "SAN LORENZO": true
      },
      "16050": {
        "JARDINES DEL SUR": true,
        "SAN MARCOS": true,
        "TIERRA NUEVA": true
      },
      "16059": {
        "PBLO. STGO.TEPALCATLALPAN, U. H. RINCONADA DEL SUR": true,
        "PUEBLO SANTIAGO TEPALCATLALPAN, U.H. RINCONADA DEL SUR": true
      },
      "16060": {
        "EL MIRADOR": true
      },
      "16070": {
        "BELÉN": true,
        "EL ROSARIO": true,
        "LA GUADALUPITA": true,
        "SANTA CRUCITA": true
      },
      "16080": {
        "LA SANTÍSIMA": true,
        "SAN CRISTÓBAL": true,
        "SAN DIEGO": true,
        "SAN ESTEBAN": true
      },
      "16083": {
        "CALTONGO": true
      },
      "16090": {
        "SAN PEDRO": true,
        "TABLAS DE SAN LORENZO": true,
        "XALTOCAN": true
      },
      "16100": {
        "SANTA CRUZ XOCHITEPEC": true
      },
      "16200": {
        "SANTIAGO TEPALCATLALPAN": true
      },
      "16210": {
        "LA CONCHA": true,
        "PUEBLO SANTIAGO TEPALCATLALPAN U.H. RES. SANTIAGO": true
      },
      "16240": {
        "TLAXOPAN": true
      },
      "16300": {
        "SAN LUCAS XOCHIMANCA": true
      },
      "16310": {
        "LA CAÑADA": true
      },
      "16320": {
        "SAN LUCAS ORIENTE": true
      },
      "16340": {
        "TEXMIC": true
      },
      "16400": {
        "SAN LORENZO ATEMOAYA": true
      },
      "16410": {
        "LOMAS DE TONALCO": true
      },
      "16420": {
        "SAN JERÓNIMO": true
      },
      "16428": {
        "EL JAZMÍN": true
      },
      "16429": {
        "RANCHO TEJOMULCO": true
      },
      "16430": {
        "XOCHIPILLI": true
      },
      "16440": {
        "AÑO DE JUÁREZ": true
      },
      "16443": {
        "POCITOS": true
      },
      "16450": {
        "SANTA MARÍA NATIVITAS": true
      },
      "16457": {
        "LOMAS DE NATIVITAS": true
      },
      "16459": {
        "AMPLIACIÓN NATIVITAS": true
      },
      "16500": {
        "SANTA CRUZ ACALPIXCA": true
      },
      "16513": {
        "APATLACO": true,
        "DEL PUENTE": true
      },
      "16514": {
        "CALPULCO": true,
        "LA GALLERA": true,
        "TETITLA": true
      },
      "16520": {
        "LA PLANTA": true
      },
      "16530": {
        "LAS CRUCES": true,
        "LAS FLORES": true
      },
      "16533": {
        "AHUALAPA": true
      },
      "16550": {
        "VALLE DE SANTA MARÍA": true
      },
      "16600": {
        "SAN GREGORIO ATLAPULCO": true
      },
      "16604": {
        "SAN ANDRÉS": true
      },
      "16605": {
        "LOS REYES": true
      },
      "16606": {
        "3 DE MAYO": true
      },
      "16607": {
        "SAN ANTONIO": true
      },
      "16609": {
        "LA CANDELARIA": true
      },
      "16610": {
        "SAN LUIS TLAXIALTEMALCO": true
      },
      "16614": {
        "NIÑOS HÉROES": true
      },
      "16615": {
        "LA ASUNCIÓN": true
      },
      "16616": {
        "SANTA CECILIA": true
      },
      "16617": {
        "SAN SEBASTIÁN": true
      },
      "16620": {
        "SAN JOSÉ": true
      },
      "16629": {
        "LA GUADALUPANA": true,
        "SAN JUAN": true
      },
      "16630": {
        "SAN JUAN MOYOTEPEC": true
      },
      "16640": {
        "SAN JUAN MINAS": true
      },
      "16710": {
        "QUIRINO MENDOZA": true
      },
      "16720": {
        "DEL CARMEN": true
      },
      "16739": {
        "SAN ISIDRO": true
      },
      "16740": {
        "GUADALUPITA": true
      },
      "16749": {
        "LAS ÁNIMAS": true
      },
      "16750": {
        "CALYEQUITA": true
      },
      "16770": {
        "SAN FELIPE": true
      },
      "16776": {
        "EL MIRADOR": true,
        "SANTIAGUITO": true
      },
      "16780": {
        "CERRILLOS PRIMERA SECCIÓN": true,
        "CERRILLOS SEGUNDA SECCIÓN": true,
        "CERRILLOS TERCERA SECCIÓN": true,
        "CRISTO REY": true,
        "EL SACRIFICIO": true
      },
      "16797": {
        "NATIVITAS": true
      },
      "16799": {
        "LAS MESITAS": true
      },
      "16800": {
        "SAN MATEO XALPA": true
      },
      "16810": {
        "ROSARIO TLALI": true,
        "SAN ANDRÉS AHUAYUCAN": true,
        "SANTA INÉS": true
      },
      "16813": {
        "EL CALVARIO": true
      },
      "16840": {
        "SANTA CRUZ CHAVARRIETA": true
      },
      "16850": {
        "CHAPULTEPEC": true
      },
      "16860": {
        "SANTA CRUZ DE GUADALUPE": true
      },
      "16880": {
        "SANTA CECILIA TEPETLAPA": true
      },
      "16900": {
        "SAN FRANCISCO TLALNEPANTLA": true
      }
    },
    "ÁLVARO OBREGÓN": {
      "1000": {
        "SAN ÁNGEL": true
      },
      "1010": {
        "LOS ALPES": true
      },
      "1020": {
        "GUADALUPE INN": true
      },
      "1030": {
        "AXOTLA": true,
        "FLORIDA": true
      },
      "1040": {
        "CAMPESTRE": true
      },
      "1049": {
        "TLACOPAC": true
      },
      "1050": {
        "EX-HACIENDA DE GUADALUPE CHIMALISTAC": true
      },
      "1060": {
        "ALTAVISTA": true,
        "SAN ÁNGEL INN": true
      },
      "1070": {
        "CHIMALISTAC": true
      },
      "1080": {
        "PROGRESO TIZAPAN": true
      },
      "1089": {
        "ERMITA TIZAPAN": true
      },
      "1090": {
        "LA OTRA BANDA": true,
        "LORETO": true,
        "TIZAPAN": true
      },
      "1100": {
        "PÓLVORA": true
      },
      "1109": {
        "LA CONCHITA": true
      },
      "1110": {
        "AMPLIACIÓN EL CAPULÍN": true,
        "BELÉM DE LAS FLORES": true,
        "EL CAPULÍN": true,
        "LIBERALES DE 1857": true
      },
      "1120": {
        "ACUEDUCTO": true,
        "COVE": true,
        "HIDALGO": true,
        "LAS AMÉRICAS": true
      },
      "1125": {
        "AMPLIACIÓN ACUEDUCTO": true
      },
      "1130": {
        "MOLINO DE SANTO DOMINGO": true,
        "PARAÍSO": true,
        "REAL DEL MONTE": true
      },
      "1139": {
        "REACOMODO PINO SUÁREZ": true
      },
      "1140": {
        "BELLAVISTA": true,
        "JOSÉ MARIA PINO SUÁREZ": true
      },
      "1150": {
        "CRISTO REY": true,
        "TOLTECA": true
      },
      "1160": {
        "1A VICTORIA": true,
        "BOSQUE": true,
        "ISIDRO FABELA": true,
        "MARIA G. DE GARCÍA RUIZ": true
      },
      "1170": {
        "ABRAHAM M. GONZÁLEZ": true
      },
      "1180": {
        "8 DE AGOSTO": true,
        "CAROLA": true,
        "SAN PEDRO DE LOS PINOS": true
      },
      "1200": {
        "ARTURO MARTÍNEZ": true
      },
      "1210": {
        "SANTA FÉ": true
      },
      "1219": {
        "LOMAS DE SANTA FE": true
      },
      "1220": {
        "BONANZA": true,
        "CUEVITAS": true,
        "EL CUERNITO": true,
        "LA ESTRELLA": true,
        "MÁRTIRES DE TACUBAYA": true,
        "ZENÓN DELGADO": true
      },
      "1230": {
        "CAMPO DE TIRO LOS GAMITOS": true,
        "EL PIRU 2A AMPLIACIÓN": true,
        "EL PIRU SANTA FE": true,
        "LOS GAMITOS": true,
        "TLAPECHICO": true
      },
      "1239": {
        "LA HUERTA": true
      },
      "1240": {
        "PUEBLO NUEVO": true
      },
      "1250": {
        "EL ÁRBOL": true,
        "LADERA": true,
        "LOMAS DE NUEVO MÉXICO": true,
        "MARGARITA MAZA DE JUÁREZ": true,
        "TECOLALCO": true
      },
      "1259": {
        "AMPLIACIÓN LA CEBADA": true,
        "LA MEXICANA 2A AMPLIACIÓN": true
      },
      "1260": {
        "AMPLIACIÓN LA MEXICANA": true,
        "CALZADA JALALPA": true,
        "LA MEXICANA": true,
        "LA PALMITA": true,
        "LIBERACIÓN PROLETARIA": true
      },
      "1269": {
        "1A SECCIÓN CAÑADA": true,
        "2A SECCIÓN CAÑADA": true
      },
      "1270": {
        "EL TEJOCOTE": true,
        "GOLONDRINAS": true,
        "GOLONDRINAS 1A SECCIÓN": true,
        "GOLONDRINAS 2A SECCIÓN": true,
        "LA PRESA": true,
        "LOMAS DE CAPULA": true
      },
      "1275": {
        "VILLA SOLIDARIDAD": true
      },
      "1276": {
        "EL PIRUL": true
      },
      "1278": {
        "DESARROLLO URBANO": true
      },
      "1279": {
        "LOMAS DE BECERRA": true
      },
      "1280": {
        "ARVIDE": true,
        "EL POCITO": true,
        "FRANCISCO VILLA": true,
        "LA JOYA": true
      },
      "1285": {
        "EL RODEO": true
      },
      "1289": {
        "REACOMODO EL CUERNITO": true
      },
      "1290": {
        "PILOTO ADOLFO LÓPEZ MATEOS": true,
        "PRESIDENTES": true
      },
      "1296": {
        "AMPLIACIÓN JALALPA": true,
        "JALALPA TEPITO": true,
        "JALALPA TEPITO 2A AMPLIACIÓN": true
      },
      "1298": {
        "AMPLIACIÓN PILOTO ADOLFO LÓPEZ MATEOS": true
      },
      "1299": {
        "1A AMPLIACIÓN PRESIDENTES": true,
        "2A AMPLIACIÓN PRESIDENTES": true
      },
      "1310": {
        "SAN GABRIEL": true
      },
      "1320": {
        "CARLOS A. MADRAZO": true
      },
      "1330": {
        "PASEO DE LAS LOMAS": true
      },
      "1340": {
        "BEJERO DEL PUEBLO SANTA FE": true
      },
      "1376": {
        "SANTA FE CENTRO CIUDAD": true,
        "SANTA FE LA LOMA": true,
        "SANTA FE PEÑA BLANCA": true,
        "SANTA FÉ": true
      },
      "1377": {
        "JALALPA EL GRANDE": true
      },
      "1389": {
        "SANTA FE TLAYAPACA": true
      },
      "1400": {
        "OLIVAR DEL CONDE 1A SECCIÓN": true,
        "PRECONCRETO": true
      },
      "1407": {
        "GALEANA": true
      },
      "1408": {
        "OLIVAR DEL CONDE 2A SECCIÓN": true
      },
      "1410": {
        "BARRIO NORTE": true,
        "PALMAS": true
      },
      "1419": {
        "MINAS CRISTO REY": true
      },
      "1420": {
        "SACRAMENTO": true,
        "SANTA MARÍA NONOALCO": true
      },
      "1430": {
        "COLINA DEL SUR": true
      },
      "1450": {
        "HOGAR Y REDENCIÓN": true
      },
      "1460": {
        "ALFONSO XIII": true
      },
      "1470": {
        "ALFALFAR": true,
        "MOLINO DE ROSAS": true
      },
      "1480": {
        "LOMAS DE PLATEROS": true
      },
      "1490": {
        "LA CASCADA": true
      },
      "1500": {
        "MIGUEL GAONA ARMENTA": true,
        "SANTA LUCÍA": true
      },
      "1509": {
        "SANTA LUCÍA CHANTEPEC": true
      },
      "1510": {
        "GARCIMARRERO": true,
        "LA ARAÑA": true,
        "LOS CEDROS": true
      },
      "1520": {
        "AMPLIACIÓN ESTADO DE HIDALGO": true,
        "AMPLIACIÓN LOS PIRULES": true,
        "EL POLITOCO": true,
        "ESTADO DE HIDALGO": true,
        "PIRU SANTA LUCÍA": true
      },
      "1530": {
        "CORPUS CHRISTY": true
      },
      "1538": {
        "TEPOPOTLA": true
      },
      "1539": {
        "ACUILOTLA": true,
        "COOPERATIVA UNIÓN OLIVOS": true
      },
      "1540": {
        "BALCONES DE CEHUAYO": true,
        "CEHUAYA": true,
        "LLANO REDONDO": true,
        "PUNTA DE CEHUAYA": true
      },
      "1548": {
        "VILLA PROGRESISTA": true
      },
      "1549": {
        "DOS RÍOS DEL PUEBLO SANTA LUCÍA": true
      },
      "1550": {
        "AMPLIACIÓN TEPEACA": true,
        "RINCONADA LAS CUEVITAS": true,
        "TEPEACA": true
      },
      "1560": {
        "AVE REAL": true,
        "CANUTILLO": true,
        "CANUTILLO 2A SECCIÓN": true,
        "CANUTILLO 3A SECCIÓN": true
      },
      "1566": {
        "HUEYTLALE": true
      },
      "1569": {
        "REACOMODO VALENTÍN GÓMEZ FARÍAS": true
      },
      "1588": {
        "TARANGO": true
      },
      "1590": {
        "EL RINCÓN": true
      },
      "1600": {
        "MERCED GÓMEZ": true
      },
      "1610": {
        "COLINAS DE TARANGO": true,
        "PROFESOR J. ARTURO LÓPEZ MARTÍNEZ": true
      },
      "1618": {
        "ARCOS CENTENARIO": true,
        "EX-HACIENDA DE TARANGO": true
      },
      "1619": {
        "LA MARTINICA": true,
        "RINCONADA DE TARANGO": true
      },
      "1620": {
        "LOMAS DE TARANGO": true
      },
      "1630": {
        "LOMAS DE PUERTA GRANDE": true,
        "LOS JURISTAS": true,
        "PUERTA GRANDE": true
      },
      "1640": {
        "HERÓN PROAL": true
      },
      "1645": {
        "PONCIANO ARRIAGA": true
      },
      "1650": {
        "2O REACOMODO TLACUITLAPA": true,
        "AMPLIACIÓN TLACUITLAPA": true,
        "EL RUEDO": true,
        "LA MILAGROSA": true,
        "PALMAS AXOTITLA": true,
        "SANTA LUCÍA CHANTEPEC": true,
        "TLACUITLAPA": true
      },
      "1700": {
        "2A DEL MORAL DEL PUEBLO TETELPAN": true,
        "LA JOYITA DEL PUEBLO TETELPAN": true,
        "OCOTILLOS DEL PUEBLO TETELPAN": true,
        "SAN AGUSTÍN DEL PUEBLO TETELPAN": true,
        "TECALCAPA DEL PUEBLO TETELPAN": true,
        "TETELPAN": true
      },
      "1708": {
        "EL ENCINO DEL PUEBLO TETELPAN": true,
        "EL MIRADOR DEL PUEBLO TETELPAN": true
      },
      "1710": {
        "AMPLIACIÓN ALPES": true,
        "LAS ÁGUILAS": true
      },
      "1720": {
        "LOMAS DE GUADALUPE": true
      },
      "1729": {
        "ALCANTARILLA": true
      },
      "1730": {
        "LOMAS DE LAS ÁGUILAS": true,
        "PUENTE COLORADO": true
      },
      "1740": {
        "LA PEÑITA DEL PUEBLO TETELPAN": true,
        "SAN CLEMENTE NORTE": true,
        "SAN CLEMENTE SUR": true
      },
      "1750": {
        "LAS ÁGUILAS 1A SECCIÓN": true,
        "LAS ÁGUILAS 2O PARQUE": true,
        "LAS ÁGUILAS 3ER. PARQUE": true
      },
      "1759": {
        "AMPLIACIÓN LAS ÁGUILAS": true
      },
      "1760": {
        "ATLAMAYA": true,
        "FLOR DE MARÍA": true,
        "LA HERRADURA DEL PUEBLO TETELPAN": true
      },
      "1770": {
        "LA ANGOSTURA": true,
        "SAN JOSÉ DEL OLIVAR": true
      },
      "1780": {
        "OLIVAR DE LOS PADRES": true,
        "TIZAMPAMPANO DEL PUEBLO TETELPAN": true
      },
      "1789": {
        "MIGUEL HIDALGO": true
      },
      "1790": {
        "LOMAS DE LOS ÁNGELES DEL PUEBLO TETELPAN": true,
        "LOMAS DE SAN ÁNGEL INN": true
      },
      "1800": {
        "SAN BARTOLO AMEYALCO": true
      },
      "1807": {
        "RANCHO SAN FRANCISCO PUEBLO SAN BARTOLO AMEYALCO": true
      },
      "1810": {
        "VILLA VERDÚN": true
      },
      "1820": {
        "EJIDO SAN MATEO": true,
        "LOMAS AXOMIATLA": true
      },
      "1830": {
        "SANTA ROSA XOCHIAC": true
      },
      "1840": {
        "TORRES DE POTRERO": true
      },
      "1849": {
        "RANCHO DEL CARMEN DEL PUEBLO SAN BARTOLO AMEYALCO": true,
        "RINCÓN DE LA BOLSA": true
      },
      "1857": {
        "LOMAS DE CHAMONTOYA": true
      },
      "1859": {
        "TLACOYAQUE": true
      },
      "1860": {
        "LOMAS DE LA ERA": true
      },
      "1863": {
        "LOMAS DEL CAPULÍN": true
      },
      "1870": {
        "LOMAS DE LOS CEDROS": true
      },
      "1900": {
        "JARDINES DEL PEDREGAL": true
      },
      "1904": {
        "SAN JERÓNIMO ACULCO": true
      }
    }
  },
  "COAHUILA DE ZARAGOZA": {
    "ARTEAGA": {
      "25350": {
        "ARTEAGA CENTRO": true
      },
      "25352": {
        "AUTOPISTA": true,
        "EL MIRADOR": true,
        "JARDÍN": true,
        "LA PARTICIÓN": true,
        "RESIDENCIAL LA NOGALERA": true,
        "SANTA ELENA": true
      },
      "25353": {
        "ABRAHAM CEPEDA": true,
        "AYUNTAMIENTO": true,
        "CUMBRES DE LOMA AZUL": true,
        "LAS HUERTAS RESIDENCIAL": true,
        "MESA DE LAS CABRAS": true,
        "SAN FRANCISCO": true,
        "SAN ISIDRO": true
      },
      "25354": {
        "CANOAS": true,
        "EJIDAL": true,
        "EL POTRERO": true,
        "EL REFUGIO": true,
        "ESTRELLA DE DAVID": true,
        "FRACCIONAMIENTO LAS CASAS": true,
        "HACIENDA DEL PEÑOL": true,
        "KILÓMETRO DOCE Y MEDIO": true,
        "LA JOYA": true,
        "LAS FLORES": true,
        "LOMA ALTA": true,
        "LOMA BONITA": true,
        "LOS CEDROS": true,
        "LOS PORTALES": true,
        "LUIS DONALDO COLOSIO": true,
        "PARQUE INDUSTRIAL DAVISA ARTEAGA II": true,
        "PEDREGAL DE LAS LOMAS": true,
        "PRIVADA ALAMEDA": true,
        "SAN ISIDRO DE LAS PALOMAS": true,
        "UNIVERSIDAD AUTÓNOMA DE COAHUILA": true,
        "VALLE REAL": true,
        "VALLE REAL Y LOS CEDROS": true
      },
      "25355": {
        "BELLA UNIÓN": true
      },
      "25356": {
        "11 DE OCTUBRE": true,
        "4 DE OCTUBRE": true,
        "AMPLIACIÓN CALIFORNIA": true,
        "ARTEAGA INDUSTRIAL PARK": true,
        "CAMPESTRE SAN ANTONIO": true,
        "LOS LAURELES": true,
        "MADERAS Y EMPAQUES INDUSTRIALES FORESTALES": true,
        "PARQUE INDUSTRIAL DAVISA ARTEAGA": true,
        "PARQUE INDUSTRIAL FUNDADORES": true,
        "PRIVADA BUENOS AIRES": true,
        "PRIVADAS LOS LLANOS": true,
        "SAN JERÓNIMO": true,
        "VALLE DEL ORIENTE": true
      },
      "25369": {
        "LA SOLEDAD": true,
        "PRIVANZAS DEL CAMPESTRE": true
      }
    },
    "RAMOS ARIZPE": {
      "25900": {
        "RAMOS ARIZPE CENTRO": true
      },
      "25902": {
        "AMPLIACIÓN LA CIÉNEGA": true,
        "ANACAHUITA": true,
        "ANALCO": true,
        "ARMILLITA": true,
        "CAÑADAS DEL MIRADOR": true,
        "EL BARATILLO": true,
        "EL CACTUS": true,
        "EL CURA": true,
        "EL ESCORIAL": true,
        "EL MIRADOR": true,
        "GIRÓN DE CASTRO": true,
        "HACIENDA DE LAS FLORES": true,
        "JARDINES DE ANALCO": true,
        "LA CIÉNEGA": true,
        "LA ESMERALDA": true,
        "LA ESTACIÓN": true,
        "LA LIBERTAD": true,
        "LA PALMA": true,
        "LA TENERÍA": true,
        "LOMAS DE VILLASOL": true,
        "LÁZARO CÁRDENAS": true,
        "PARAJES DEL VALLE": true,
        "PEÑA ALTA": true,
        "PRIVADA ENCINALES": true,
        "PRIVADA ESMERALDA": true,
        "REAL DEL VALLE": true,
        "RESIDENCIAL PALMERAS": true,
        "SANTA LUZ ANALCO": true,
        "SUBDIVISIÓN GIRÓN DE CASTRO": true,
        "URBIVILLA DEL REAL": true,
        "VALLE DE LOS PINOS": true,
        "VALLE PONIENTE": true,
        "VALPARAÍSO": true,
        "VILLA SOL": true
      },
      "25903": {
        "ALAMEDA": true,
        "AÑO DE JUÁREZ": true,
        "CAPELLANÍA": true,
        "DEL BOSQUE": true,
        "EL CAPITÁN": true,
        "EULALIO GUTIÉRREZ": true,
        "FIDEL VELÁZQUEZ": true,
        "INDUSTRIAL 360 2DA ETAPA": true,
        "JARDÍN": true,
        "LA ERMITA": true,
        "LA HACIENDA": true,
        "LOMA LINDA": true,
        "LOMAS DEL VALLE": true,
        "LOMAS DEL VALLE II": true,
        "MOLINOS DEL REY": true,
        "NUEVO RAMOS ARIZPE": true,
        "PARQUE INDUSTRIAL RAMOS ARIZPE": true,
        "PARQUE INDUSTRIAL SANTA MARÍA": true,
        "PRIVADAS EL CAMPANARIO": true,
        "RINCÓN DEL VALLE": true,
        "SAN ANTONIO": true,
        "SANTA MARÍA": true,
        "TORREMOLINOS": true,
        "VILLAMAGNA": true,
        "VILLAS DE SANTA MARÍA": true
      },
      "25904": {
        "ALYSSA": true,
        "ARBOREA": true,
        "BALCONES DE SANTA FE": true,
        "BLANCA ESTHELA": true,
        "BONTERRA": true,
        "CERRITO DE LA CRUZ": true,
        "DEL VALLE": true,
        "EL RANCHITO": true,
        "ELSA HERNANDEZ": true,
        "GUANAJUATO DE ABAJO": true,
        "GUANAJUATO DE ARRIBA": true,
        "HUERTA VIEJA": true,
        "LA GRAN HACIENDA": true,
        "LA NOGALERA": true,
        "LA SOLEDAD": true,
        "MANANTIALES DEL BOSQUE": true,
        "MANANTIALES DEL VALLE": true,
        "PARQUE INDUSTRIAL FINSA": true,
        "PORTAL LAS PALOMAS": true,
        "PORTALES": true,
        "QUINTA MANANTIALES": true,
        "REVOLUCIÓN MEXICANA": true,
        "RINCÓN BLANCA ESTHELA": true,
        "SAN FERNANDO": true,
        "SANTA FÉ": true,
        "SANTOS SAUCEDO": true,
        "SIERRA MORENA": true,
        "VALLE DE FONTANNA": true,
        "VILLA ALTA": true,
        "VILLAS DEL NOGALAR": true,
        "YURA": true
      },
      "25905": {
        "LOS CEDROS": true,
        "PARAJES DE LOS PINOS": true,
        "RAMOS ARIZPE INDUSTRIAL PARK": true,
        "VYNMSA RAMOS ARIZPE INDUSTRIAL PARK SECTOR II": true
      }
    },
    "SALTILLO": {
      "25000": {
        "SALTILLO CENTRO": true
      },
      "25008": {
        "PALACIO DEL GOBIERNO DEL ESTADO DE COAHUILA": true
      },
      "25010": {
        "LA FUENTE": true,
        "NUEVO SALTILLO": true,
        "PARAJES DE LA SIERRA": true,
        "PRIVADA DE SAN JAVIER": true,
        "PRIVADA LA CAMPANA": true,
        "PRIVADA LA MISIÓN": true,
        "SOLIDARIDAD": true,
        "VISTA HERMOSA": true
      },
      "25013": {
        "15 DE SEPTIEMBRE": true,
        "AMISTAD": true,
        "AMPLIACIÓN MORELOS": true,
        "BALCONES DE MORELOS": true,
        "COLIBRÍ": true,
        "CORDILLERA": true,
        "EL MONTE DEL SINAÍ": true,
        "LA CASCADA": true,
        "MILENIO": true,
        "MORELOS NUEVA CREACIÓN": true,
        "PARQUE INDUSTRIAL AMISTAD": true,
        "PRIVADA MORELOS": true,
        "VALLE DE MORELOS": true,
        "VILLA MORELOS": true
      },
      "25014": {
        "10 DE ABRIL": true,
        "CECILIA OCELLI DE SALINAS": true,
        "SAN PEDRO DE LOS PINOS": true
      },
      "25015": {
        "EDGAR PUENTE": true,
        "EL PEDREGAL": true,
        "FUENTES DEL PEDREGAL": true,
        "FUNDADORES": true,
        "INTRODUCTORES DE GANADO": true,
        "LOMAS DE SAN FRANCISCO": true,
        "LOMAS DE ZAPALINAME": true,
        "LOMAS DEL PEDREGAL": true,
        "NUEVA INDEPENDENCIA": true,
        "NUEVA VIDA": true,
        "NUEVO PROGRESO": true,
        "SALOMÓN ABEDROP": true,
        "VALLE DE LAS AVES": true,
        "VILLA DE SANTIAGO": true
      },
      "25016": {
        "CIUDAD MIRASIERRA": true,
        "COLINAS DE SANTIAGO": true,
        "FRANCISCO I MADERO RÚSTICO": true,
        "GASPAR VALDEZ": true,
        "IGNACIO ZARAGOZA": true,
        "LOMA LINDA": true,
        "LOMAS DEL BOSQUE": true,
        "MISIÓN CERRITOS": true,
        "NUEVO MIRASIERRA": true,
        "POPULAR LOMA BLANCA": true,
        "PRADOS DE SAN JOSÉ": true,
        "PRIVADA LOS MAGUEYES": true,
        "PRIVADA VILLAS DE SAN JOSÉ": true,
        "PRIVADAS LA TORRE": true,
        "PRIVADAS SIERRAS DEL ORIENTE": true,
        "PUERTA DEL ORIENTE": true,
        "REAL DEL SOL": true,
        "RECREATIVO SECCIÓN 38": true,
        "RESIDENCIAL LOS ROSALES": true,
        "SANTA LUCÍA": true,
        "SIERRA ALTA RESIDENCIAL": true,
        "SIERRA BLANCA": true,
        "TRES VIENTOS": true,
        "VALLE DE LOS ALMENDROS": true
      },
      "25017": {
        "AMPLIACIÓN MORELOS SEGUNDO SECTOR": true,
        "AMPLIACIÓN VALLE DE MORELOS": true,
        "MORELOS": true
      },
      "25019": {
        "CANDELARIAS RESIDENCIAL": true,
        "CONQUISTADORES": true,
        "EL CERRITO": true,
        "EL EJIDO": true,
        "EL NOGALAR": true,
        "LA MORITA": true,
        "LA NOGALERA": true,
        "LAS CANDELARIAS": true,
        "LAS MARAVILLAS": true,
        "LOS LIRIOS": true,
        "NUEVA IMAGEN": true,
        "NUEVA TLAXCALA": true,
        "NUEVO AMANECER": true,
        "POSTAL CERRITOS": true,
        "PRIVADA NOGAL I": true,
        "RUBÉN JARAMILLO": true,
        "SAN JOSÉ": true,
        "SANTA MARÍA": true,
        "TIERRA Y LIBERTAD": true,
        "VILLA FUNDADORES": true
      },
      "25020": {
        "INDIO": true,
        "PROVIVIENDA": true,
        "SAN ESTEBAN": true,
        "SAN RAMÓN": true,
        "URDIÑOLA": true,
        "VALLE DE SAN RAMÓN": true,
        "ZAPALINAME": true
      },
      "25022": {
        "CENTRO METROPOLITANO": true,
        "PARQUE LAS MARAVILLAS": true
      },
      "25023": {
        "ARBOLEDAS POPULAR": true,
        "CANTABRIA": true,
        "EL PARAÍSO": true,
        "LA PALMA": true,
        "LA ROSALEDA": true,
        "LOMA BONITA": true,
        "MONTEVISTA": true,
        "SAN VICENTE": true,
        "UNIVERSIDAD PUEBLO": true,
        "VALLE DE LAS PALMAS": true,
        "VALLE DE SANTA ELENA": true
      },
      "25030": {
        "AGUA AZUL": true,
        "ARCOS DE BELÉN": true,
        "GONZÁLEZ CEPEDA": true,
        "LOMA DE SANTA ANITA": true
      },
      "25034": {
        "ESTHER SANTOS": true,
        "MAGISTERIO SECCIÓN 38": true,
        "SANTA ANITA": true
      },
      "25036": {
        "HUERTAS DE VENANCIO": true
      },
      "25038": {
        "AMPLIACIÓN SAN RAMÓN": true,
        "CONDESA": true
      },
      "25039": {
        "DEIMOS": true
      },
      "25040": {
        "BALCONES DE BELLAVISTA": true,
        "BARRIO SANTA ANITA": true,
        "OJO DE AGUA": true,
        "SAN LORENZO": true,
        "VIRAMONTES": true
      },
      "25043": {
        "HÉROES DE CHAPULTEPEC": true
      },
      "25044": {
        "RESIDENCIAL DEL MIRADOR": true
      },
      "25045": {
        "PORTAL DE SANTIAGO": true,
        "ZAPATEROS": true
      },
      "25047": {
        "LOS ÁLAMOS": true
      },
      "25048": {
        "BURÓCRATAS DEL ESTADO": true,
        "LOMAS DE CHAPULTEPEC": true
      },
      "25049": {
        "SANTA MARÍA": true,
        "SIMÓN BOLÍVAR": true,
        "ÁGUILA DE ORO": true
      },
      "25050": {
        "BENITO JUÁREZ": true,
        "CENTENARIO": true,
        "CHAPULTEPEC": true,
        "LA MADRID": true,
        "MARÍA DEL CARMEN CABELLO": true,
        "ROSA MARÍA GUTIÉRREZ": true
      },
      "25056": {
        "EL SALVADOR": true
      },
      "25057": {
        "COLINAS DE SAN FRANCISCO": true,
        "EL VOLCÁN": true,
        "JESÚS CABELLO": true,
        "LA HERRADURA": true,
        "LOMAS DE SAN JAVIER": true,
        "LOS NOGALES": true,
        "LOS NOGALES II": true,
        "PARAJES DE ORIENTE": true
      },
      "25060": {
        "ACUEDUCTO": true,
        "BELLAVISTA": true,
        "BELLAVISTA MESA DE ARIZPE": true,
        "FRANCISCO I MADERO": true,
        "LA CENTRAL": true,
        "LOS ARCOS": true,
        "LUCIO BLANCO": true,
        "LUIS DONALDO COLOSIO": true,
        "LÁZARO CÁRDENAS": true,
        "MIRAVALLE": true,
        "SAN LORENZO ORIENTE": true,
        "SEGOVIA GIL": true
      },
      "25065": {
        "15 DE ABRIL": true,
        "CERRADA SAN LORENZO": true,
        "HUERTAS DE SAN LORENZO": true,
        "JESÚS GARCIA CORONA": true,
        "NUEVA REFORMA": true,
        "PATRIA LIBRE": true
      },
      "25067": {
        "QUINTA VALLE": true
      },
      "25068": {
        "QUINTA ESMERALDA": true
      },
      "25069": {
        "LAS HACIENDAS": true,
        "VALLE DE LOURDES": true,
        "VILLA UNIVERSIDAD": true
      },
      "25070": {
        "BALCONES DE LANDIN": true,
        "LANDIN": true,
        "LOMAS DE GUADALUPE": true,
        "LOMAS DE LANDÍN": true,
        "LOURDES": true,
        "PRIVADA OBREGÓN SUR": true,
        "PRIVADA RINCÓN DE SALAZAR": true
      },
      "25075": {
        "26 DE MARZO": true,
        "FERROCARRILERO 7 DE NOVIEMBRE": true
      },
      "25076": {
        "BUENOS AIRES": true
      },
      "25077": {
        "LOS BALCONES DE BUENAVISTA": true,
        "VALLE ALTO": true
      },
      "25080": {
        "EULALIO GUTIÉRREZ TREVIÑO": true,
        "FROYLÁN MIER NARRO": true,
        "GIRASOL": true,
        "LOS PERIODISTAS": true,
        "PARQUES DE LA CAÑADA": true
      },
      "25083": {
        "AMISTAD ALIANZAS": true,
        "EL REFUGIO LA SOLEDAD": true,
        "HACIENDA DEL REFUGIO": true,
        "HACIENDA EL MIMBRE": true,
        "PARQUE INDUSTRIAL LA ANGOSTURA": true,
        "SIERRA DEL SUR": true
      },
      "25084": {
        "69 BATALLÓN DE INFANTERÍA": true,
        "AMPLIACIÓN LA ESTRELLA": true,
        "COLINAS DE SAN LORENZO": true,
        "HACIENDA LAS ISABELES": true,
        "LA ESTRELLA": true,
        "LAS ROSAS": true,
        "LAS TERESITAS": true,
        "LOMAS DEL REFUGIO": true,
        "LOMAS DEL SUR": true,
        "NIÑOS HÉROES": true,
        "NUEVO TERESITAS": true,
        "PARAJES DE SANTA ELENA": true,
        "VALLE DE SAN LORENZO": true,
        "VILLAS DE LA ANGOSTURA": true
      },
      "25085": {
        "EL LATIFUNDIO": true,
        "FORET": true,
        "GENARO VÁZQUEZ ROJAS": true,
        "GUADALUPE VICTORIA": true,
        "RINCÓN DE FORET": true
      },
      "25086": {
        "AMPLIACIÓN 26 DE MARZO": true,
        "BURÓCRATAS MUNICIPALES": true,
        "PRIVADA COLOMBIA": true
      },
      "25087": {
        "AMPLIACIÓN GIRASOL": true
      },
      "25088": {
        "12 DE OCTUBRE": true,
        "23 DE NOVIEMBRE": true,
        "AGUA NUEVA": true,
        "AUSTRALIA": true,
        "EL PROGRESO": true,
        "EL ÁLAMO": true,
        "EL ÁLAMO II": true,
        "HACIENDA NARRO": true,
        "LA ESPERANZA": true,
        "MARIO ORTIZ RODRÍGUEZ": true,
        "MARÍA DEL CARMEN CAVAZOS": true,
        "NUEVA JERUSALÉN": true,
        "RICARDO FLORES MAGÓN": true,
        "SAN JUANITA": true,
        "VILLAS DE SAN FRANCISCO": true,
        "VIÑEDOS EL ÁLAMO": true
      },
      "25090": {
        "LOMAS DE LOURDES": true,
        "VALLE DORADO": true
      },
      "25092": {
        "HUMBERTO DÁVILA ESQUIVEL": true,
        "LAS HUERTAS DE LOURDES": true,
        "LOMAS DE SANTA CRUZ": true,
        "VILLAS DE SAN LORENZO": true
      },
      "25093": {
        "10 DE MAYO": true,
        "AMPLIACIÓN COLINAS DEL SUR": true,
        "COLINAS DEL SUR": true,
        "HACIENDA EL CORTIJO": true,
        "LOS BUITRES": true,
        "LOS BUITRES II": true,
        "MESA DE LOURDES": true,
        "PORTAL DEL SUR": true,
        "SANTA MÓNICA": true
      },
      "25094": {
        "BOSQUES DE LAS LOMAS RESIDENCIAL": true,
        "CUMBRES VISTA RESIDENCIAL": true,
        "MONTEVERDE RESIDENCIAL": true,
        "PASEO DE LA ESTRELLA": true,
        "PORTAL DE LAS LOMAS": true,
        "PRIVADAS LA ESTRELLA": true
      },
      "25096": {
        "FEDERICO BERRUETO RAMÓN": true,
        "FEDERICO BERRUETO RAMÓN POPULAR": true,
        "LOMAS VERDES": true,
        "MARÍA DE LEÓN": true,
        "MIGUEL HIDALGO": true,
        "VISTAS DE PEÑA": true,
        "VISTAS DE PEÑA SUR": true
      },
      "25097": {
        "LAS ROSAS": true,
        "VICENTE GUERRERO": true
      },
      "25100": {
        "HACIENDA SAN RAFAEL": true,
        "INDUSTRIAL VALLE DE SALTILLO": true,
        "LA PURÍSIMA": true,
        "NAZARIO S ORTIZ GARZA": true,
        "OMEGA": true
      },
      "25107": {
        "ASTURIAS": true,
        "NUEVO MÉXICO": true,
        "PORTAL DE ASTURIAS": true,
        "RINCÓN DE ASTURIAS": true,
        "VALLE VERDE SECTOR II": true
      },
      "25110": {
        "BALCONES DE LAS TORRES": true,
        "CIUDAD LAS TORRES": true,
        "EL RODEO": true,
        "EVARISTO PÉREZ ARREOLA": true,
        "FLORA ORTEGA": true,
        "LA FLORENCIA": true,
        "LAS TORRES": true,
        "NUEVO ATARDECER": true,
        "PORTALES": true,
        "VALLE AZTECA": true,
        "VALLE DE LAS TORRES": true,
        "VALLE DE LAS TORRES II": true,
        "VALLE SATÉLITE": true
      },
      "25113": {
        "SATÉLITE SUR": true
      },
      "25114": {
        "PARQUE INDUSTRIAL LAS TORRES": true
      },
      "25115": {
        "PORTAL DE LOS AGAVES": true,
        "PORTAL DEL PEDREGAL": true,
        "PORTAL DEL QUIJOTE": true,
        "SALTILLO 2000": true,
        "SAN JOSÉ DE FLORES": true,
        "SANTORINI": true,
        "SATÉLITE NORTE": true
      },
      "25116": {
        "ANDALUCÍA": true,
        "SAN ISIDRO": true,
        "VALENCIA": true
      },
      "25117": {
        "ANKARA RESIDENCIAL": true,
        "EL ROCAL RESIDENCIAL": true,
        "PRIVADA LANTANA": true,
        "PRIVADA LUXOR": true,
        "REAL ANKARA": true,
        "SANTA FÉ": true,
        "TRIANA": true,
        "VILLAS CASTELLANA": true
      },
      "25120": {
        "FRANCISCO I MADERO": true
      },
      "25123": {
        "EJIDO LA VEGA": true,
        "EJIDO PADRES SANTOS": true,
        "LA MAGUEYADA": true,
        "PEDREGAL DE LOS SANTOS SUR": true
      },
      "25124": {
        "IGNACIO ALLENDE": true,
        "LAS CUMBRES": true,
        "LOMA DORADA": true,
        "OCHO DE ENERO": true,
        "RANCHO FLORES": true,
        "RESIDENCIAL RINCÓN DE SAN VICENTE": true
      },
      "25125": {
        "ADOLFO LÓPEZ MATEOS": true,
        "ROMA": true
      },
      "25128": {
        "1° DE MAYO": true,
        "JOSEFA ORTIZ DE DOMÍNGUEZ": true,
        "PUERTO DE FLORES": true
      },
      "25130": {
        "ANTONIO CÁRDENAS": true,
        "ANÁHUAC": true,
        "GUSTAVO ESPINOSA MIRELES": true,
        "ISABEL AMALIA DÁVILA": true
      },
      "25137": {
        "HACIENDA LA MAGUEYADA": true,
        "PARAÍSO": true,
        "PUEBLO INSURGENTES": true
      },
      "25138": {
        "ALTARIA RESIDENCIAL": true,
        "CERRADA GUADALUPE": true,
        "EMILIO CARRANZA": true,
        "GONZÁLEZ NORTE": true,
        "PRIVADA GUADALUPE": true,
        "VALLE UNIVERSIDAD": true
      },
      "25140": {
        "ANTONIO CÁRDENAS SUR": true,
        "AZTECA": true,
        "CAMPO VERDE": true,
        "CERRO DEL PUEBLO": true,
        "EJÉRCITO CONSTITUCIONALISTA": true,
        "HACIENDA SAN PABLO": true,
        "INDEPENDENCIA": true,
        "LAS MITRAS": true,
        "MARÍA LUISA": true,
        "OBRERA": true,
        "PANTEONES": true,
        "SIERRAS DEL PONIENTE": true,
        "VALLE DE SAN ANTONIO": true
      },
      "25146": {
        "OSCAR FLORES TAPIA": true
      },
      "25147": {
        "LOMA ALTA": true
      },
      "25150": {
        "ALFREDO V BONFIL": true,
        "MIRADOR": true,
        "UNIVERSO": true,
        "VALLE DE LAS FLORES POPULAR": true
      },
      "25155": {
        "LAS MARGARITAS": true,
        "LOS BALCONES": true,
        "PUERTO DE LA VIRGEN": true,
        "RINCÓN DE GUADALUPE": true,
        "VALLE DEL PONIENTE": true
      },
      "25156": {
        "FRANCISCO VILLA": true
      },
      "25157": {
        "LOS FRESNOS": true,
        "VALLE ESCONDIDO": true,
        "VALLE ESCONDIDO SUR": true,
        "VENUSTIANO CARRANZA": true
      },
      "25160": {
        "ALAMEDA": true,
        "BORDO FERROCARRIL": true,
        "DEL VALLE": true,
        "HUERTA LOS PILARES": true,
        "PRIVADA QUINTA NARRO": true,
        "ZAMORA": true
      },
      "25167": {
        "AMPLIACIÓN PACHECO": true,
        "GUAYULERA TIERRA Y ESPERANZA": true,
        "PRIVADA COAHUILA Y ZACATECAS": true,
        "PROVIDENCIA": true
      },
      "25168": {
        "PRIVADA BETA CENTAURO": true
      },
      "25169": {
        "BRISAS DEL VALLE": true,
        "UNIDAD MODELO": true
      },
      "25170": {
        "EL BOSQUE": true,
        "LA MINITA": true,
        "LA PEÑITA": true
      },
      "25179": {
        "LOS CUERNITOS": true
      },
      "25180": {
        "CHAMIZAL": true,
        "GUAYULERA": true,
        "RUIZ CORTÍNES": true
      },
      "25186": {
        "EL EDÉN": true,
        "SAN MIGUEL": true
      },
      "25188": {
        "RÍO VERDE": true
      },
      "25190": {
        "5 DE MAYO": true,
        "EL TANQUECITO": true,
        "PROVIDENCIA": true
      },
      "25193": {
        "HÉROES DE NACOZARI": true,
        "RINCÓN DE LOS PASTORES": true
      },
      "25194": {
        "DIANA LAURA RIOJAS DE COLOSIO": true,
        "IGNACIO ZARAGOZA POPULAR": true,
        "JULIETA PÉREZ": true,
        "LOS BERROS": true,
        "VALLE VERDE": true
      },
      "25195": {
        "PATRIA NUEVA": true
      },
      "25196": {
        "SANTA TERESA": true
      },
      "25197": {
        "EL MORILLO": true,
        "LA ESMERALDA": true,
        "LA JOYITA": true,
        "LA ROMITA": true,
        "LADRILLEROS": true,
        "LOS ROSARIOS POPULAR": true
      },
      "25198": {
        "LOS PINOS": true
      },
      "25199": {
        "SAN ISIDRO": true
      },
      "25200": {
        "ARBOLEDAS RESIDENCIAL": true,
        "JARDINES DE VERSALLES": true,
        "LA RIOJA": true,
        "LA RIOJA TERRÁN": true,
        "LAS CABAÑAS": true,
        "LAS HUERTAS": true,
        "LOS RODRÍGUEZ": true,
        "LOS ZENDEJOS": true,
        "RINCÓN DE SAYAVEDRA": true,
        "VILLANATURA": true,
        "VILLAS DE SAYAVEDRA": true,
        "VILLAS DEL RANCHITO": true
      },
      "25203": {
        "JACARANDAS JARDÍN": true,
        "LAS MAGNOLIAS": true,
        "NUESTRA SEÑORA DE FÁTIMA": true
      },
      "25204": {
        "ALBAREDA RESIDENCIAL": true,
        "EL PORTAL": true,
        "HABITA": true,
        "HABITA II": true,
        "HACIENDA SAN JERÓNIMO": true,
        "LA CANTERA RESIDENCIAL": true,
        "LA JOYA": true,
        "LOS GONZÁLEZ": true,
        "LOS PINOS": true,
        "LOS SILLER": true,
        "PRIVADA EMILIO RODRÍGUEZ": true,
        "RESIDENCIAL SAN PATRICIO": true,
        "SAN ALBERTO": true,
        "SAN JOSÉ RESIDENCIAL": true,
        "SAN PATRICIO PLUS": true,
        "SAQQARA": true,
        "VALLE REAL": true,
        "VILLA TOSCANA": true,
        "VILLAS DE ARANJUEZ": true,
        "VILLAS DE SAN MIGUEL": true
      },
      "25205": {
        "VALLE REAL": true
      },
      "25206": {
        "JARDINES COLONIALES": true,
        "LAS QUINTAS": true,
        "PRIVADA COLONIALES": true
      },
      "25207": {
        "ALBATROS RESIDENCIAL": true,
        "COUNTRY CLUB RESIDENCIAL": true,
        "EL SUSPIRO": true,
        "LOS ALGODONES": true,
        "LOS CEDROS RESIDENCIAL": true,
        "PUERTA DEL SOL": true,
        "VALLE HERMOSO": true
      },
      "25208": {
        "CAMPESTRE CAPELLANÍA": true,
        "JARDINES DEL CAMPESTRE RESIDENCIAL": true,
        "LOMA BLANCA": true,
        "LOS BOSQUES": true,
        "NOGALAR DEL CAMPESTRE": true,
        "VIVENNTO RESIDENCIAL": true
      },
      "25209": {
        "CAMPESTRE LA POZA": true,
        "EL CAMPANARIO": true,
        "LA POZA": true,
        "LAS MISIONES": true,
        "LOMAS DE PEÑA": true,
        "LOS ARRAYANES": true,
        "LOS VALDEZ": true,
        "PEÑA ALTA": true,
        "PUNTA BOSQUE": true,
        "QUINTA REAL": true,
        "RINCÓN DE ALCÁNTARA": true,
        "RINCÓN DE LOS ADOBES": true,
        "RINCÓN DE LOS ENCINOS": true,
        "SAN JUAN BAUTISTA": true,
        "SANTA ROSA RESIDENCIAL": true,
        "SORRENTO": true,
        "TORREALTA RESIDENCIAL": true,
        "VILLA DEL CARMEN RESIDENCIAL": true,
        "VILLA SAN JUAN": true
      },
      "25210": {
        "HACIENDA DE PEÑA": true,
        "LA NORIA": true,
        "LAS BRISAS": true,
        "LOS ÁLAMOS": true,
        "NUEVA ESPAÑA": true,
        "OASIS": true,
        "PRIVADAS DE SANTIAGO": true,
        "RANCHO DE PEÑA": true,
        "RIVERA DEL VALLE": true,
        "VALLE LAS PALMAS": true,
        "VILLA VERGEL RESIDENCIAL": true
      },
      "25215": {
        "VALLE SAN AGUSTÍN": true
      },
      "25220": {
        "RESIDENCIAL LOS ENCINOS": true,
        "RÍO BRAVO": true,
        "VIRREYES OBRERA": true,
        "VIRREYES POPULAR": true,
        "ZONA INDUSTRIAL": true
      },
      "25225": {
        "BRISAS PONIENTE": true,
        "VIRREYES COLONIAL": true,
        "VIRREYES INDUSTRIAL": true
      },
      "25230": {
        "FOVISSSTE VIRREYES": true,
        "VILLA OLÍMPICA": true,
        "VIRREYES RESIDENCIAL": true
      },
      "25239": {
        "CIMA DE VIRREYES RESIDENCIAL": true,
        "VIRREYES PENSIONES": true
      },
      "25240": {
        "JARDÍN": true,
        "KIOSCO": true,
        "LA SALLE": true,
        "PRIVADAS LUXEMBURGO": true,
        "SAN LUIS": true,
        "SANTIAGO": true,
        "VILLA OLÍMPICA ORIENTE": true,
        "VILLAS DE SAN FERNANDO": true
      },
      "25250": {
        "LOS DOCTORES": true,
        "VILLAS DE SAN CARLOS": true,
        "VILLAS DE SAN GABRIEL": true,
        "VILLAS DE SAN ISIDRO": true
      },
      "25253": {
        "ALPES NORTE": true,
        "CENTRO DE INVESTIGACIÓN EN QUÍMICA APLICADA": true,
        "LAGOS CONTINENTAL": true,
        "RESIDENCIAL LOS REALES": true
      },
      "25254": {
        "SAN ISIDRO": true
      },
      "25256": {
        "REAL DE PEÑA": true
      },
      "25260": {
        "INSURGENTES": true,
        "JARDINES DEL VALLE": true,
        "LOS MAESTROS": true,
        "PRIVADA SANTA MARÍA": true,
        "UNIVERSIDAD": true
      },
      "25265": {
        "REPÚBLICA PONIENTE": true
      },
      "25270": {
        "ALPES": true,
        "CUMBRES": true,
        "LATINOAMERICANA": true,
        "LOS ÁNGELES": true
      },
      "25277": {
        "JARDÍN ORIENTE": true
      },
      "25279": {
        "RESIDENCIAL LOS PARQUES": true
      },
      "25280": {
        "EL OLMO": true,
        "GUANAJUATO": true,
        "ISSSTE": true,
        "JARDINES DEL LAGO": true,
        "RANCHO LAS VARAS": true,
        "REPÚBLICA": true,
        "REPÚBLICA NORTE": true,
        "REPÚBLICA ORIENTE": true,
        "TECNOLÓGICO": true
      },
      "25284": {
        "TOPO CHICO": true
      },
      "25285": {
        "JOYAS DEL BOULEVARD": true
      },
      "25286": {
        "GUANAJUATO ORIENTE": true,
        "LOS ADOBES": true
      },
      "25290": {
        "AMÉRICA": true,
        "AVÍCOLA": true,
        "EUROPA": true,
        "LAS FLORES": true,
        "OCEANÍA": true,
        "OCEANÍA BOULEVARES": true,
        "PORTALES DE ARAGÓN": true,
        "PRIVADAS DE ARAGÓN": true,
        "SALTILLO 400": true,
        "VALLE DE LAS FLORES INFONAVIT": true
      },
      "25293": {
        "REAL HIBERNIA": true,
        "RINCONADA DE LA HIBERNIA": true,
        "RINCÓN DEL CIELO": true,
        "VILLA HIBERNIA": true
      },
      "25294": {
        "CAMINO REAL": true,
        "EL SÁUZ": true,
        "EX HACIENDA LOS CERRITOS": true,
        "HACIENDA REAL": true,
        "LEANDRO VALLE": true,
        "LOS CERRITOS": true,
        "LOS ZACATONES": true,
        "MAGISTERIO SECCIÓN 38": true,
        "PARQUE INDUSTRIAL CERRITOS": true,
        "SAN JOSÉ DE LOS CERRITOS": true,
        "SANTA BÁRBARA": true,
        "TERRALTA": true,
        "TERRANOVA": true,
        "VISALTA": true
      },
      "25295": {
        "LAS MARGARITAS": true,
        "LAS PRADERAS": true,
        "RESIDENCIAL EL TAPANCO": true
      },
      "25296": {
        "BONANZA": true,
        "BUGAMBILIAS": true,
        "CRUZ DEL AIRE": true,
        "HACIENDA LA AURORA RESIDENCIAL": true,
        "LA FLORIDA": true,
        "LA ROSA": true,
        "LOS GERANIOS": true,
        "NUEVA AURORA": true,
        "RINCÓN DE LA FLORIDA": true,
        "VILLAS DE LA AURORA": true
      },
      "25297": {
        "ALCÁZAR RESIDENCIAL": true,
        "BALCONES DE LA AURORA": true,
        "EL BALUARTE": true,
        "EL ROSARIO": true,
        "GUSTAVO DÍAZ ORDAZ": true,
        "LA FRAGUA": true,
        "LA HIBERNIA": true,
        "LOS CHABACANOS": true,
        "LOS CIPRESES": true,
        "LOS OLIVOS RESIDENCIAL": true,
        "LOS TULIPANES": true,
        "NUEVA LIBERTAD": true,
        "PRIVADA TULIPANES": true
      },
      "25298": {
        "ALONDRA": true,
        "BOSQUES DE LA AURORA": true,
        "CERRADA DEL PLAZA": true,
        "CONEJO IXTLERO": true,
        "EL TOREO": true,
        "EMILIANO ZAPATA": true,
        "FAENA": true,
        "HACIENDA SAN CARLOS": true,
        "JARDINES DE LOS BOSQUES": true,
        "JARDINES DEL PLAZA": true,
        "LA AURORA": true,
        "LA CIENEGUITA": true,
        "LA CIUDADELA": true,
        "LA ESCONDIDA": true,
        "LA HERRADURA": true,
        "LA LIBERTAD": true,
        "LA LIBERTAD EL PUENTE": true,
        "LA PALMILLA": true,
        "LA TRINIDAD": true,
        "LAS CANTERAS": true,
        "LENNA RESIDENCIAL": true,
        "LOS MANANTIALES": true,
        "LOS MOLINOS": true,
        "PLAZA ARMILLITA": true,
        "PORTAREAL RESIDENCIAL": true,
        "PRIVADAS PLAZA": true,
        "PUERTA DEL REY": true,
        "REAL DE TORRECILLAS RESIDENCIAL": true,
        "REAL DE VILLAS DE LA AURORA": true,
        "RESIDENCIAL PLAZA": true,
        "RINCONES DE LA AURORA": true,
        "ROSALES DE LA AURORA": true,
        "SAN JOSÉ ORIENTE": true,
        "SAN LUIS": true,
        "SAN ÁNGEL": true,
        "SANTA CRISTINA": true,
        "TERRAZAS RESIDENCIAL": true,
        "TIERRA SANTA RESIDENCIAL": true,
        "TORRECILLAS Y RAMONES": true,
        "UNIVERSIDAD LA SALLE": true,
        "VILLA BONITA": true,
        "VILLA COLONIAL": true,
        "VILLA FONTANA": true,
        "VILLAS DE GUADALUPE": true,
        "VILLAS DE SAN SEBASTIÁN": true,
        "VILLAS DEL CAMINO REAL": true,
        "VILLAS LA JOYA": true
      }
    }
  },
  "GUANAJUATO": {
    "LEÓN": {
      "37000": {
        "CENTRO": true
      },
      "37004": {
        "SAN JUAN DE DIOS": true
      },
      "37010": {
        "LUZ MARÍA DIAZ INFANTE": true
      },
      "37020": {
        "ACRÓPOLIS": true,
        "ANDRADE": true,
        "FRANCISCO LOZORNIO": true,
        "TEPEYAC": true
      },
      "37100": {
        "BRISAS DE ECHEVESTE": true,
        "CANTERITAS DE ECHEVESTE": true,
        "ECHEVESTE 2000": true,
        "ECHEVESTE NORTE": true,
        "EL PALMAR": true,
        "EL TECOTÁN": true,
        "GRANJAS ECHEVESTE": true,
        "HACIENDA ECHEVESTE": true,
        "JARDINES DE ECHEVESTE": true,
        "LA MARINA": true,
        "LOS MEZQUITES": true,
        "PEDREGALES DE ECHEVESTE": true,
        "PORTALES DE LA ARBOLEDA": true,
        "PRIVADA ECHEVESTE": true,
        "RINCONADA DE ECHEVESTE": true,
        "RIVERA DE LA PRESA": true,
        "VILLA LA RIOJA": true,
        "VILLAS DE ECHEVESTE": true
      },
      "37104": {
        "RIVERA DE LA PRESA COUNTRY": true
      },
      "37105": {
        "LOMAS DE LA PRESA": true,
        "SANTA CECILIA": true,
        "SANTA CECILIA II": true,
        "SOLIDARIDAD LEONESA (PEDREGAL)": true
      },
      "37106": {
        "LA LAGUNITA": true
      },
      "37107": {
        "BALCONES DE LA PRESA": true,
        "LAS ARRAYANES II": true,
        "LUZ DE LA PRESA": true,
        "PROVINCIA CASTELL": true,
        "QUINTA LOS CASTILLOS": true,
        "VALLE DE LOS CASTILLOS": true
      },
      "37108": {
        "SAN NICOLÁS DEL PALOTE": true,
        "TORRES DE LA PRESA": true,
        "VALLE HERMOSO": true
      },
      "37109": {
        "ALAMEDA DE LA PRESA": true,
        "ARBOLEDAS DE LOS CASTILLOS I": true,
        "BALCONES TULIPANES": true,
        "EL PARADOR": true,
        "EL POCHOTE": true,
        "EL POTRERO": true,
        "JARDINES DE LA PRESA": true,
        "LA NORIA": true,
        "LA NORTEÑA": true,
        "LA PRADERA": true,
        "LAS TIRITAS": true,
        "LOS COLORINES": true,
        "LUZ DEL PARQUE": true,
        "POPULAR MAYA": true,
        "RESIDENCIAL CAMPO PALMYRA": true,
        "RUSTICO NORTEÑA": true,
        "VILLAS DE LA PRESA": true,
        "VILLAS DEL PEDREGAL": true
      },
      "37110": {
        "CIUDAD AURORA": true
      },
      "37118": {
        "HERNÁNDEZ ROUGON": true,
        "JARDINES DEL VALLE": true,
        "LAS ÁGUILAS": true,
        "PASEO DE LAS MORAS": true
      },
      "37119": {
        "EL PELUCHAN": true
      },
      "37120": {
        "CASA DE PIEDRA": true,
        "CLUB CAMPESTRE": true,
        "LA MEDALLA": true,
        "PLAZA MAYOR": true,
        "RANCHO LA FLORIDA": true,
        "RESIDENCIAL CLUB CAMPESTRE": true,
        "TORRES DE COUNTRY": true
      },
      "37123": {
        "BOSQUES DEL REFUGIO": true
      },
      "37125": {
        "BOSQUES DEL CAMPESTRE": true,
        "EL CAMPANARIO": true,
        "EL ROSARIO": true,
        "ENTRE DOS AGUAS": true,
        "FRACCIONES DEL ROSARIO": true,
        "LAGOS DEL CAMPESTRE": true,
        "LAS QUINTAS": true,
        "LOS SAUCES DEL MORAL": true,
        "MARFIL": true,
        "PUERTAS DE LA ALBORADA": true,
        "RESIDENCIAL DEL MORAL": true,
        "RESIDENCIAL PUERTAS DE LA ALBORADA": true,
        "TORRES METRÓPOLI": true
      },
      "37128": {
        "CUMBRES DEL CAMPESTRE": true,
        "JARDINES DEL CAMPESTRE": true,
        "LOS ALPES RESIDENCIAL": true,
        "MISIÓN LA CAÑADA": true,
        "PIRULES RESIDENCIAL": true,
        "PUNTA CAMPESTRE": true,
        "REAL CAMPESTRE": true,
        "SAN JOSÉ DE LAS PILETAS": true,
        "SEÑORA FRAUSTO": true,
        "TORRE CUMBRES": true
      },
      "37129": {
        "VILLAS DEL CAMPESTRE": true
      },
      "37130": {
        "EL PALOTE": true,
        "GRANJAS DEL ROSARIO": true,
        "GRANJAS EL PALOTE": true
      },
      "37134": {
        "COLINAS DE GRAN JARDÍN": true,
        "COUNTRY CLUB GRAN JARDÍN": true,
        "LOMAS DE GRAN JARDÍN": true,
        "PORTA FONTANA": true,
        "PORTA TOSCANA": true
      },
      "37138": {
        "BALCONES DEL CAMPESTRE": true,
        "BOSQUE AZUL": true,
        "EL MOLINO RESIDENCIAL Y GOLF": true,
        "GRAN JARDÍN": true,
        "MIRADOR DE GRAN JARDÍN": true,
        "PORTONES DEL CAMPESTRE": true,
        "PORTONES DEL GRAN JARDÍN": true,
        "RINCÓN DEL CAMPESTRE": true,
        "ZANDA": true
      },
      "37140": {
        "LA VIRGEN": true,
        "TABLAS DE LA VIRGEN": true,
        "VALLE DE LEÓN": true
      },
      "37147": {
        "INDUSTRIAL HIDALGO": true
      },
      "37148": {
        "CONJUNTO HABITACIONAL LOS NOGALES": true,
        "FRACCIONES DE LOS GÓMEZ": true,
        "SAN JERÓNIMO II": true
      },
      "37149": {
        "LOS CEDROS": true,
        "VALLE DEL SOL": true
      },
      "37150": {
        "CAÑADA DEL CAMPESTRE": true,
        "LOMAS DEL CAMPESTRE": true,
        "VALLE DEL CAMPESTRE": true
      },
      "37156": {
        "EL MIRADOR CAMPESTRE": true,
        "EL REFUGIO CAMPESTRE": true
      },
      "37157": {
        "EL PUEBLITO DEL CAMPESTRE": true,
        "LA LOMA": true,
        "LOMAS DEL SOL": true,
        "RESIDENCIAL BRISAS": true,
        "RESIDENCIAL LA LLUVIA": true
      },
      "37160": {
        "DEL ROCÍO": true,
        "JARDINES DEL MORAL": true,
        "PANORAMA": true,
        "VILLAS DEL MORAL": true
      },
      "37168": {
        "INSURGENTES": true
      },
      "37170": {
        "ARCOS ANTIQUA": true,
        "BOSQUES DE LOS CEDROS": true,
        "CASA BLANCA": true,
        "EL PALOTE SUR FRACCIONES": true,
        "FRACCIONES DEL PALOTE": true,
        "HACIENDA DEL CAMPESTRE": true,
        "JULIÁN CARRILLO": true,
        "LA ANTIQUA": true,
        "LA HERRADURA": true,
        "LOS CARCAMOS": true,
        "PEDREGAL DEL CAMPESTRE": true,
        "PORTONES DEL MORAL": true,
        "RESIDENCIAL EL MEZQUITE": true,
        "TORRES DEL LAGO": true
      },
      "37178": {
        "LA CANTERA": true,
        "LA HACIENDA": true,
        "LA PUERTA DE HIERRO": true,
        "PASEOS DEL BOSQUE": true,
        "REAL DE BUGAMBILIAS": true,
        "REAL DE CAMELINAS": true,
        "REAL DEL BOSQUE": true,
        "VALLE DEL MORAL": true,
        "VALLE JACARANDAS": true
      },
      "37179": {
        "BOSQUES DE LA PRESA": true,
        "FINCAS SAYAVEDRA": true,
        "HACIENDAS DEL CARMEN": true,
        "HACIENDAS DEL CARMEN II": true,
        "LA ESPERANZA": true,
        "LA PLACITA": true,
        "LAS ALAMEDAS": true,
        "LAS MANSIONES RESIDENCIAL": true,
        "MISIÓN DE LA PRESA": true,
        "RESIDENCIAL VERANDAS": true,
        "RINCONADA DEL BOSQUE": true,
        "SAN CRISTÓBAL": true,
        "UNIDAD OBRERA INFONAVIT": true
      },
      "37180": {
        "EL JUNCAL": true,
        "FUTURAMA MONTERREY": true,
        "LA MARGARITA": true,
        "PEÑITAS": true
      },
      "37187": {
        "PRIVADA DEL MORAL": true
      },
      "37188": {
        "EL TRIANON": true
      },
      "37189": {
        "FORD DEL CAMPESTRE": true
      },
      "37190": {
        "HÉROES DE CHAPULTEPEC": true,
        "LA FLORIDA": true
      },
      "37199": {
        "RINCÓN DE LA FLORIDA": true
      },
      "37200": {
        "ARBOLEDAS DE IBARRILLA": true,
        "ARBOLEDAS DEL VALLE": true,
        "ARIA BOSCAJE RESIDENCIAL": true,
        "INDUSTRIAL DEL NORTE": true,
        "JARDINES DEL BOSQUE": true,
        "PUNTA NOGAL MORELOS": true,
        "SAN JOSÉ DEL CONSUELO": true,
        "TRES CANTOS": true
      },
      "37204": {
        "ALAMEDA DIAMANTE": true,
        "ALAMEDAS DE ALCÁZAR": true,
        "ALAMEDAS DE ESPAÑA": true,
        "ALAMEDAS DE VILLAFRANCA RESIDENCIAL": true,
        "CIBELES": true,
        "HIDALGO DEL VALLE": true,
        "LAS TORRES DE SANTA ROSA": true,
        "LOS ABEDULES": true,
        "MISIÓN DE LA FLORIDA": true,
        "PLAZA HIDALGO": true,
        "SAN JERÓNIMO I": true,
        "VALLE DE LAS TORRES": true,
        "VILLA DE LAS TORRES": true,
        "VILLAFRANCA RESIDENCIAL": true
      },
      "37205": {
        "ARBOLEDAS DE SEÑORA": true,
        "VALLE DE SEÑORA": true
      },
      "37207": {
        "8 DE MARZO": true,
        "ANTENAS DE ARRIBA": true,
        "ARBOLEDAS DE LA LUZ": true,
        "ARBOLEDAS DE LA SELVA": true,
        "AZAHARES": true,
        "BOSQUES DE LA SELVA": true,
        "BRISAS DEL LAGO": true,
        "EL CONSUELO": true,
        "EL PENITENTE": true,
        "EL VALLADITO": true,
        "EL VIVERO": true,
        "ERMITA DE IBARRILLA": true,
        "HACIENDAS DE IBARRILLA": true,
        "LA CIMA DE LEÓN": true,
        "LA NOPALERA": true,
        "LA PERA": true,
        "LA SANTA CRUZ": true,
        "LA SELVA": true,
        "LADERAS DE IBARRILLA": true,
        "LAS PRESITAS": true,
        "LAS PRESITAS DEL CONSUELO": true,
        "LAS PRESITAS II": true,
        "LAURELES DE LA SELVA": true,
        "LOMAS DE IBARRILLA": true,
        "LOMAS DE LA SELVA": true,
        "LOMAS DE LAS PRESITAS": true,
        "MESITAS DEL CONSUELO": true,
        "ONCE DE JUNIO": true,
        "PALENQUE DE IBARRILLA": true,
        "REAL DE SAN ANTONIO": true,
        "RESIDENCIAL LA TOSCANA": true,
        "RESIDENCIAL REAL CAYETANA": true,
        "RINCONADA DE IBARRILLA": true,
        "RINCÓN DE IBARRILLA": true,
        "RIVERA DEL CARMEN (DIVINA INFANTITA)": true,
        "SAN NICOLÁS DE LOS REYES": true,
        "SAN PABLO": true,
        "UNIÓN COMUNITARIA LOS LAURELES": true,
        "VALLE DEL CONSUELO": true,
        "VILLA DE LA ROSA": true
      },
      "37208": {
        "FRACCIONES DE ECHEVESTE (PRO)": true,
        "LOMAS DE ECHEVESTE": true,
        "LYRATA RESIDENCIAL": true,
        "NUEVO LEÓN": true,
        "QUINTAS SAN LORENZO": true,
        "SAN JAVIER": true,
        "SAN JORGE (LOS CASTILLOS)": true,
        "VILLA MAGNA": true
      },
      "37209": {
        "ADQUIRIENTES DE IBARRILLA": true,
        "ALTAVISTA": true,
        "ARBOLEDAS DE LOS CASTILLOS II": true,
        "CANTARRANAS": true,
        "CASTILLOS VIEJOS": true,
        "CAÑÓN DE LA INDIA": true,
        "EL CASTILLO": true,
        "EL CHEPINQUE": true,
        "EL CUARENTEÑO": true,
        "LA INDIA": true,
        "LA LOMITA": true,
        "LOMAS DE GUADALUPE": true,
        "LOMAS DE LOS CASTILLOS": true,
        "LOS ARRAYANES": true,
        "LOS CASTILLOS": true,
        "PASO DEL RÍO DE LOS CASTILLO": true,
        "REAL DEL CASTILLO": true,
        "RIVERA DE LOS CASTILLO": true,
        "SAN GABRIEL": true,
        "SAN ISIDRO AZTECA": true,
        "SAN ISIDRO LABRADOR": true,
        "VALLE DE LAS TORONJAS": true,
        "VISTA AERO": true,
        "ZARCIHUILES": true
      },
      "37210": {
        "ARANCIA": true,
        "BOSQUES DE LOS NARANJOS": true,
        "CARMENA": true,
        "COLINAS DE PLATA": true,
        "EL LLANO GRANDE": true,
        "JARDINES DE LOS NARANJOS": true,
        "LOS NARANJOS": true,
        "NUEVA SANTA ROSA DE LIMA": true,
        "PASEO DE LOS NARANJOS": true,
        "PRADERAS DE SANTA ROSA": true,
        "PRIVANZA LOS NARANJOS": true,
        "QUINTA LOS NARANJOS": true,
        "REAL DE LOS NARANJOS": true,
        "RESIDENCIAL VILLA CONTEMPORÁNEA": true,
        "RIVERA DE SAN BERNARDO": true,
        "SAN BENIGNO": true,
        "SANTA ROSA DE LIMA": true,
        "SUR SANTA ROSA DE LIMA": true,
        "VALLE DE LOS NARANJOS": true,
        "VALLE DE SAN BERNARDO": true,
        "VASCO DE QUIROGA": true
      },
      "37217": {
        "EL ÁRBOL": true,
        "LOS PIRULES": true,
        "QUINTA HILARIO MEDINA": true,
        "RESIDENCIAL VICTORIA": true,
        "SAN JOSÉ DEL CONSUELO II": true,
        "SUR LOS NARANJOS": true,
        "TODOS LOS SANTOS": true
      },
      "37218": {
        "EL CONDADO PLUS": true,
        "MISIÓN DE SAN JOSÉ": true,
        "MISIÓN DE SAN JOSÉ 2A SECC": true,
        "PASEOS DEL ARROYO": true,
        "PRIVANZA DEL CONDADO": true,
        "QUINTA LOS NARANJOS": true,
        "REAL DE SAN JOSÉ": true,
        "SAN JOSÉ": true
      },
      "37219": {
        "HABITACIONAL COECILLO": true,
        "LOS MURALES": true,
        "LOS MURALES II": true,
        "MANANTIALES": true,
        "MISIÓN DEL NORTE": true,
        "REAL LOS MURALES": true
      },
      "37220": {
        "EL RETIRO": true,
        "HIDALGO": true,
        "VILLA INSURGENTES": true
      },
      "37225": {
        "INDEPENDENCIA INFONAVIT": true
      },
      "37227": {
        "CENTRO BODEGUERO LAS TROJES": true,
        "LAS TROJES": true
      },
      "37230": {
        "JARDINES DE PROVIDENCIA": true,
        "LINARES": true,
        "PRIVADA RINCONADA DE LAS FLORES": true,
        "SAN ANTONIO DEL ALAMBRADO": true
      },
      "37233": {
        "ALFARO": true,
        "LA CAPILLA DE ALFARO": true,
        "LA ESPERANZA DE ALFARO": true
      },
      "37234": {
        "BOSQUE DEL VALLE": true,
        "NTE. SAN ANTONIO DEL ALAMBRADO": true,
        "PROVIDENCIA": true,
        "REAL PROVIDENCIA": true
      },
      "37235": {
        "AMBERES RESIDENCIAL": true,
        "AMPLIACIÓN LEÓN I": true,
        "HACIENDA SAN MIGUEL": true,
        "HACIENDA SANTA CATALINA": true,
        "JARDÍNES DEL SOL": true,
        "LA PIRÁMIDE": true,
        "LEÓN I": true
      },
      "37236": {
        "BENITO JUÁREZ": true,
        "PRESIDENTES DE MÉXICO": true
      },
      "37237": {
        "UNIDAD DEPORTIVA": true
      },
      "37238": {
        "BOSQUES DE BREDA": true,
        "BOSQUES DEL PEDREGAL": true,
        "BRISAS DEL VERGEL": true,
        "CAÑADA DE ALFARO": true,
        "CUMBRES DE MEDINA": true,
        "EL PEÑÓN": true,
        "FRACCIONES DE MESA MEDINA": true,
        "HACIENDA DE GUADALUPE": true,
        "HACIENDA DE LOS NARANJOS": true,
        "HUERTAS DE MEDINA": true,
        "JARDINES DE MARAVILLAS": true,
        "JARDINES LOMAS DE MEDINA": true,
        "LAGOS DE MEDINA": true,
        "LOMAS DE LOS NARANJOS": true,
        "LOMAS DE MEDINA": true,
        "MARAVILLAS": true,
        "MARAVILLAS II": true,
        "MARAVILLAS III": true,
        "MEDINA": true,
        "PASEOS DE MARAVILLAS": true,
        "PEÑA ALTA": true,
        "PRADO HERMOSO": true,
        "SANTA MAGDALENA": true,
        "ÁNGELES Y MEDINA": true
      },
      "37239": {
        "REVOLUCIÓN": true,
        "UNIDAD DEPORTIVA II": true,
        "UNIÓN COMUNITARIA DE LEÓN": true
      },
      "37240": {
        "LA BRISA": true,
        "MICHOACÁN": true,
        "PALOMARES": true,
        "POPULAR ANAYA": true,
        "SAN AGUSTÍN": true,
        "SANTA FÉ": true
      },
      "37249": {
        "EL LUCERO": true
      },
      "37250": {
        "EL CORTIJO": true,
        "LA CARMONA": true,
        "SAN FELIPE DE JESÚS": true
      },
      "37257": {
        "JARDINES DE ORIENTE": true,
        "RESIDENCIAL PLATINO": true
      },
      "37258": {
        "JARDÍNES DEL SOL": true,
        "LOS PORTONES": true,
        "LOS ÁNGELES": true,
        "UNIDAD Y ESFUERZO POPULAR": true,
        "VILLAS DEL MAYAB": true
      },
      "37259": {
        "SAN MANUEL": true
      },
      "37260": {
        "EL COECILLO": true,
        "EX HACIENDA LA MORENA I": true,
        "EX HACIENDA LA MORENA II": true,
        "JOSEFINA": true,
        "KILLIAN": true,
        "KILLIAN II": true,
        "LA CANDELARIA": true,
        "LAURELES VALLARTA": true,
        "NUEVA CANDELARIA": true,
        "RESIDENCIAL LAS MAGNOLIAS": true,
        "VALTIERRA": true
      },
      "37266": {
        "ESPAÑITA": true,
        "ESTRELLA": true,
        "LOS GAVILANES": true
      },
      "37267": {
        "LA MORA (CRUZ DE CANTERA)": true
      },
      "37268": {
        "BELÉN": true
      },
      "37269": {
        "LOS PINITOS": true
      },
      "37270": {
        "BUGAMBILIAS": true,
        "EL REFUGIO": true,
        "LAS FUENTES": true,
        "RINCÓN DE BUGAMBILIAS": true
      },
      "37276": {
        "LAS GLORIAS": true
      },
      "37277": {
        "27 DE SEPTIEMBRE": true,
        "27 DE SEPTIEMBRE (CONST GTO)": true
      },
      "37278": {
        "BOSQUES DE RENTERÍA": true,
        "LAS FUENTES DE SAN PEDRO": true,
        "POPULAR INCA": true,
        "POPULAR LA LUZ": true,
        "PORTONES DE SAN PEDRITO": true,
        "PUEBLO NUEVO": true,
        "RESIDENCIAL COYOACÁN": true,
        "RESIDENCIAL TITANIO": true,
        "SAN MIGUEL DE RENTERÍA": true,
        "SAN PEDRO PLUS": true,
        "VILLA DE LAS FLORES": true,
        "VILLAS LA LUZ": true
      },
      "37279": {
        "LAS ROSAS": true,
        "MISIÓN DE LA LUZ": true
      },
      "37280": {
        "ARBOLEDAS DE SAN PEDRO": true,
        "PORTAL LA LUZ": true,
        "RINCONADA DE SAN PEDRO": true,
        "SAN PEDRO DE LOS HERNÁNDEZ": true
      },
      "37287": {
        "CLUB LOYOLA": true,
        "FRACCIONES DEL CRESPO": true,
        "RESIDENCIAL SAN ÁNGEL": true
      },
      "37288": {
        "EYUPOL": true,
        "JARDINES DE SAN PEDRO": true,
        "LA PECHUGA": true,
        "PREDIO SAN PEDRO O JESÚS MARÍA": true,
        "QUINTAS DEL SOL": true,
        "VERSALLES": true,
        "VILLA VERDE": true
      },
      "37289": {
        "ANTURIOS": true,
        "FRACCIONES SAN PEDRO": true,
        "GRANJA CERES": true,
        "GUADALUPE": true,
        "HACIENDA BUGAMBILIAS": true,
        "LA HACIENDITA": true,
        "NATURA": true,
        "NIZA": true,
        "OASIS": true,
        "PORTÓN DE BUGAMBILIAS": true,
        "PRIVADA DEL POZO": true,
        "SAN JORGE": true,
        "TORRES PREMIER": true,
        "VILLAS BUGAMBILIAS": true,
        "VILLAS DE GUADALUPE": true
      },
      "37290": {
        "ALBAZUL RESIDENCIAL": true,
        "CAMPO VIÑA": true,
        "FRACCIONES DEL PREDIO SANTA JULIA DE JEREZ": true,
        "INDUSTRIAL JULIÁN DE OBREGÓN": true,
        "INDUSTRIAL LAS CRUCES": true,
        "INDUSTRIAL SANTA JULIA": true,
        "LA CAMPIÑA": true,
        "LA VIGATTA": true,
        "LAS FLORES": true,
        "POLÍGONO INDUSTRIAL MILENIO": true,
        "PORTALES DE SANTA ÚRSULA": true,
        "PRADERAS DE AGUA AZUL": true,
        "PURÍSIMA DE JEREZ": true,
        "SAN JOSÉ DE LOS TANQUES": true
      },
      "37293": {
        "SIERRA NOGAL": true
      },
      "37294": {
        "BOSQUES DEL CARMEN": true,
        "CABO METROPOLITANO": true,
        "CRISTO REY": true,
        "CUESTA DEL ROCÍO": true,
        "ESMERALDA DEL BAJÍO": true,
        "GRAN PARAÍSO": true,
        "JARDINES DE LOS REYES": true,
        "LA TINAJA": true,
        "PARAÍSO REAL": true,
        "SAN NICOLÁS DE LOS GONZÁLEZ": true,
        "VALLE DE MÉXICO": true,
        "VILLAS DE SAN NICOLÁS": true,
        "VILLAS DEL CAMPO UNO": true
      },
      "37295": {
        "AMPLIACIÓN SAN FRANCISCO": true,
        "BOSQUES (MISAEL NÚÑEZ)": true,
        "BOSQUES DE SAN JUAN": true,
        "BRISAS DE SAN FRANCISCO": true,
        "BRISAS DEL PEDREGAL": true,
        "CAMPO FUERTE RESIDENCIAL": true,
        "CONJUNTO HABITACIONAL HERA": true,
        "EL CID": true,
        "EL LUCERO": true,
        "FUENTES DEL VALLE": true,
        "HACIENDA LOS OTATES": true,
        "JARDINES DE SAN JUAN": true,
        "LA HACIENDA DE LEÓN RESIDENCIAL Y GOLF": true,
        "LAS VILLAS": true,
        "LOMA VERDE": true,
        "MAR SOL I": true,
        "MARROKA RESIDENCIAL": true,
        "MARSOL II": true,
        "NUEVO SAN NICOLÁS": true,
        "PARQUE CHAPULTEPEC": true,
        "PARQUES DE SAN JUAN": true,
        "PASEOS DEL MOLINO": true,
        "PIEDRA AZUL II": true,
        "PIEDRA AZUL L": true,
        "PORTA ROMANI": true,
        "PRADOS DE SAN NICOLÁS": true,
        "PRADOS LA LUZ": true,
        "PUNTA NOGAL LA LUZ": true,
        "RESIDENCIAL HESTEA": true,
        "RINCÓN DE ASÍS": true,
        "RUBÍ DEL BAJÍO": true,
        "SAN FRANCISCO": true,
        "SANGRE DE CRISTO": true,
        "SANTA ANITA": true,
        "VALLE DE MORENO": true,
        "VESTALES": true,
        "VILLA OLÍMPICA": true,
        "VILLAS CONSTELACIONES": true,
        "VILLAS DE GUANAJUATO": true,
        "VILLAS DE NUESTRA SEÑORA DE LA LUZ I": true,
        "VILLAS DE NUESTRA SEÑORA DE LA LUZ II": true,
        "VILLAS DE NUESTRA SEÑORA DE LA LUZ III": true,
        "VILLAS DE SAN JUAN": true,
        "VILLAS DEL ROCÍO": true,
        "ZAFIRO RESIDENCIAL": true
      },
      "37296": {
        "DESARROLLO EL POTRERO": true,
        "EL CARMEN (C.T.M.)": true,
        "HACIENDA SAN ÁNGEL": true,
        "HACIENDA SANTA FE": true,
        "JARDINES DE SANTA FE": true,
        "JESÚS MARÍA (EL VERGEL)": true,
        "LAS VIZCAÍNAS": true,
        "MISIONES DE SANTA FE": true,
        "MISIÓN DEL CARMEN": true,
        "PEDREGAL DEL GIGANTE": true,
        "RESIDENCIAL LOMAS PUNTA DEL ESTE": true,
        "RESIDENCIAL PUNTA DEL ESTE": true,
        "RESIDENCIAL SANTA FE": true,
        "RESIDENCIAL SANTA LUCÍA": true,
        "RESIDENCIAL TABACHINES": true,
        "SAN JOSÉ DEL POTRERO": true,
        "TERRACOTA": true,
        "TORRES DE SAN NICOLÁS": true,
        "VILLAS DE SAN NICOLÁS II": true,
        "VILLAS DE SAN NICOLÁS III": true,
        "VILLAS DE SAN NICOLÁS III NORTE": true
      },
      "37297": {
        "AGUA AZUL": true,
        "BRISAS DE SAN FRANCISCO": true,
        "BRISAS DE SAN NICOLÁS": true,
        "BRISAS DEL CAMPO": true,
        "BRISAS DEL CAMPO II": true,
        "BRISAS DEL CARMEN": true,
        "EL ROTARIO": true,
        "INDUSTRIAL BRISAS DEL CAMPO": true,
        "INDUSTRIAL LA CAPILLA": true,
        "PORTÓN DE LOS GIRASOLES": true,
        "REAL DE VILLAS": true,
        "RÍO GRANDE": true,
        "VALLE DE LA LUZ": true
      },
      "37298": {
        "PUNTO VERDE": true
      },
      "37299": {
        "ALDABA": true,
        "CLUB HÍPICO": true,
        "COLINAS DEL CARMEN": true,
        "EL CARMEN": true,
        "EL PORVENIR": true,
        "MAGISTERIAL": true,
        "MEZQUITAL DEL CARMEN": true,
        "NUEVO AMANECER": true,
        "PEDREGAL DE SAN CARLOS": true,
        "PEDREGAL DEL CARMEN": true,
        "PORTONES DEL CARMEN": true,
        "PÍA MONTE": true,
        "RESIDENCIAL EL CARMEN": true,
        "RESIDENCIAL SAN CARLOS": true,
        "SOBERNA": true,
        "VALLE DEL CARMEN": true,
        "VILLA GRANDE": true,
        "VILLAS DEL CARMEN": true
      },
      "37300": {
        "LINDAVISTA": true,
        "LOMAS DE LA TRINIDAD": true
      },
      "37306": {
        "GRANADA": true
      },
      "37310": {
        "PILETAS I": true,
        "PILETAS II": true
      },
      "37315": {
        "PILETAS III": true
      },
      "37316": {
        "PILETAS IV": true
      },
      "37317": {
        "REAL DEL REFUGIO": true
      },
      "37318": {
        "DESARROLLO BALEARES": true,
        "REAL DE MARICHES": true
      },
      "37319": {
        "SAN JOSÉ OBRERO": true
      },
      "37320": {
        "EL DURAZNAL": true,
        "OBREGÓN": true
      },
      "37327": {
        "DE SANTIAGO": true
      },
      "37328": {
        "LOS PARAÍSOS": true,
        "MODERNA": true,
        "SAN ANTONIO": true
      },
      "37330": {
        "ESPAÑA": true,
        "LOMAS VISTA HERMOSA SUR": true,
        "SAN JUAN BOSCO (VISTA HERMOSA)": true
      },
      "37340": {
        "CHAPALITA": true,
        "INDUSTRIAL (HAB.)": true,
        "OBRERA": true
      },
      "37350": {
        "FLORES MAGÓN": true,
        "SAN MARTÍN DE PORRES": true
      },
      "37353": {
        "BRISAS DEL SOL": true,
        "CERRITO AMARILLO": true,
        "CERRITO DE GUADALUPE": true,
        "CERRITO DE LA JOYA": true,
        "CHALET LA CUMBRE": true,
        "CIMA DIAMANTE": true,
        "COLINA REAL": true,
        "COMPLEJO LA CIMA": true,
        "EL FARO": true,
        "EL OBSERVATORIO 2": true,
        "EL PARAÍSO": true,
        "EL YACIMIENTO": true,
        "FRUTALES DE LA HACIENDA": true,
        "JOL-GUA-BER": true,
        "LOMAS DE LA PAZ": true,
        "LOMAS DE LAS HILAMAS": true,
        "LOMAS DEL CONDADO": true,
        "LOMAS DEL EDÉN": true,
        "MINERAL DE LA JOYA": true,
        "MISIÓN SANTA FE": true,
        "OBSERVATORIO": true,
        "PALMAS 2000": true,
        "PEDREGAL DEL SOL": true,
        "REAL DE LEÓN": true,
        "VALLE ANTIGUA": true,
        "VALLE DE SAN PEDRO": true,
        "VIBAR": true
      },
      "37355": {
        "BALCONES DE LA JOYA": true,
        "COLINA DE LA HACIENDA": true,
        "CONVIVE": true,
        "EL RENACIMIENTO": true,
        "JOYAS DE CASTILLA": true,
        "JOYAS DE CASTILLA PLUS": true,
        "JOYAS DE LA LOMA": true,
        "LA PERLITA": true,
        "LAS TORRES": true,
        "LOMAS DEL SOL": true,
        "MISIÓN DE LA JOYA": true,
        "MONTAÑA DEL SOL DE LA JOYA": true,
        "PARAÍSO DE LAS JOYAS": true,
        "PASEOS DE LA JOYA": true,
        "PUNTA DEL SOL": true,
        "REAL 2000": true,
        "SAUCILLO DE LA JOYA": true
      },
      "37357": {
        "CAMINO A SAN JUAN": true,
        "CAÑADA DEL REAL": true,
        "CENTRO FAMILIAR LA PIEDAD": true,
        "CENTRO FAMILIAR SOLEDAD": true,
        "CRUZ DE LA SOLEDAD": true,
        "EL CACERÍO": true,
        "ESTANCIA DE LA JOYA": true,
        "LA FRAGUA": true,
        "LOMAS DE SAN JOSÉ DE LA JOYA": true,
        "PEDRALTA RESIDENCIAL": true,
        "REAL DE LA JOYA": true,
        "RIZOS DEL SAUCILLO": true,
        "SILGLO XXI": true,
        "SINARQUISTA": true,
        "VALLE DE LA JOYA": true,
        "VILLAS DE LA JOYA": true,
        "VISTA ESMERALDA": true
      },
      "37358": {
        "BALCONES DE LA FRAGUA": true,
        "BARRANCA DEL REFUGIO": true,
        "CARTAGENA": true,
        "CAÑADA DEL REFUGIO": true,
        "CAÑADA DIAMANTE": true,
        "COLINAS DE LA FRAGUA": true,
        "COLINAS DE LA FRAGUA PLUS": true,
        "COUNTRY DEL LAGO": true,
        "DANUBIO AZUL": true,
        "EL RUBÍ": true,
        "HORIZONTE AZUL": true,
        "LA ERMITA": true,
        "LA JOYA": true,
        "LA NUEVA ERMITA": true,
        "LA PRESA DE LA JOYA": true,
        "LAS CAMELINAS": true,
        "LOMAS DE CONTRERAS": true,
        "LOMAS DEL MIRADOR": true,
        "LOMAS DEL REFUGIO": true,
        "LOMBARDÍA RESIDENCIAL": true,
        "PASEOS DE LA FRAGUA": true,
        "PASEOS DEL COUNTRY": true,
        "PORTÓN CAÑADA": true,
        "PRADERAS DEL REFUGIO": true,
        "PUNTA CAÑADA": true,
        "RINCÓN DE LA JOYA": true,
        "RIVERA DE LA JOYA": true,
        "SAN JOSÉ DE LA JOYA": true,
        "TRENTO": true,
        "VALLE DIAMANTE": true,
        "VILLAS DE PALERMO": true,
        "VILLAS DEL COUNTRY": true
      },
      "37359": {
        "LA MARQUESA": true,
        "LA ORDEÑA": true,
        "LOMA DORADA": true,
        "PUERTA DORADA": true,
        "PUNTA DORADA": true,
        "TORRES DORADAS": true
      },
      "37360": {
        "ARBIDE": true,
        "BELLAVISTA": true,
        "FÁTIMA": true
      },
      "37364": {
        "LA MERCED (RAMÍREZ GARCÍA)": true
      },
      "37366": {
        "VILLA RESIDENCIAL ARBIDE": true
      },
      "37368": {
        "LOMAS DE ARBIDE": true
      },
      "37369": {
        "CUMBRES DE ARBIDE": true
      },
      "37380": {
        "GUADALUPE": true,
        "INDEPENDENCIA": true,
        "SAN RAFAEL": true
      },
      "37390": {
        "LAS AMÉRICAS": true,
        "LOS FRESNOS": true,
        "SAN MIGUEL": true
      },
      "37399": {
        "JUAN VALLE": true
      },
      "37400": {
        "CIUDAD SATÉLITE": true,
        "ISLAS DE LEÓN": true,
        "LOMAS DEL VALLE": true,
        "PASEOS DE SAN ÁNGEL": true,
        "PEDREGAL DE SATÉLITE": true
      },
      "37407": {
        "LAS HILAMAS": true
      },
      "37408": {
        "BALCÓN DE LAS HILAMAS": true,
        "BARRANCA DE VENADEROS": true,
        "LEÓN II": true,
        "LOMAS DEL PEDREGAL": true,
        "PASEOS DE LA CIMA": true,
        "PASEOS DE LA CIMA PLUS": true,
        "PASEOS DE MIRAVALLE": true,
        "VALLE IMPERIAL": true
      },
      "37410": {
        "JOHN F KENNEDY": true,
        "LOS OLIVOS": true,
        "RINCÓN DE LOS OLIVOS": true,
        "SAN MARCOS": true
      },
      "37414": {
        "LA PIEDRERA": true
      },
      "37415": {
        "LOMAS DE LOS OLIVOS": true
      },
      "37416": {
        "CUMBRES DE LA PISCINA": true,
        "DEL COSMOS (SAN BERNARDO)": true
      },
      "37417": {
        "HACIENDA LAS MANDARINAS": true
      },
      "37418": {
        "LA CAÑADA": true
      },
      "37419": {
        "LAS MANDARINAS": true,
        "LOMA REAL": true,
        "REAL DE LAS PALMAS": true
      },
      "37420": {
        "BUENAVISTA": true,
        "LOMA BONITA": true
      },
      "37425": {
        "LAS PALMAS": true,
        "PASEOS DE ANDALUCÍA": true
      },
      "37426": {
        "MIRADOR DE ARBIDE": true,
        "RESIDENCIAL VALLE DE ARBIDE": true
      },
      "37427": {
        "CHULAVISTA PRO VIVIENDA OBRERA": true,
        "MIGUEL DE CERVANTES SAAVEDRA": true,
        "VALLE DEL ROCÍO": true
      },
      "37428": {
        "EL SALTO": true
      },
      "37430": {
        "COLINAS DE LEÓN": true,
        "LAS HUERTAS": true
      },
      "37433": {
        "EL RECUERDO": true
      },
      "37434": {
        "BETANIA": true,
        "CAMPO VERDE": true,
        "LA LUCITA": true
      },
      "37436": {
        "MONTE DE CRISTO": true,
        "OTE. MONTE DE CRISTO": true
      },
      "37438": {
        "ARROYO HONDO": true,
        "FRACCIONES DEL GUAJE": true,
        "GRANJAS LAS AMALIAS": true,
        "INDUSTRIAL GÉNESIS": true,
        "INDUSTRIAL PAMPLONA": true,
        "INDUSTRIAL SAN JORGE": true,
        "MORELOS (EL GUAJE)": true
      },
      "37439": {
        "INDUSTRIAL SANTA CROCCE": true
      },
      "37440": {
        "COLINAS SAN FRANCISCO": true,
        "CUMBRES DEL SOL": true,
        "GRANJAS CAMPESTRE": true,
        "LA CONDESA": true,
        "LA PISCINA": true,
        "LOMAS DE LA PISCINA": true,
        "VALLE PALERMO": true
      },
      "37443": {
        "INDUSTRIAL SAN CRISPÍN": true
      },
      "37444": {
        "LA PISCINA CTM": true,
        "SANTA RITA DE LOS NARANJOS": true
      },
      "37446": {
        "LOS LAURELES": true
      },
      "37448": {
        "LOS LIMONES": true,
        "PORTALES DE SAN SEBASTIÁN": true
      },
      "37450": {
        "PLAZA DE TOROS": true,
        "RÍO ESCONDIDO": true,
        "SAN SEBASTIÁN": true,
        "SANTA RITA": true
      },
      "37455": {
        "PARQUE INDUSTRIAL LA TRINIDAD": true
      },
      "37456": {
        "SAN IGNACIO": true,
        "VALLE DE ALBORADA": true
      },
      "37457": {
        "INDUSTRIAL JUÁREZ": true
      },
      "37458": {
        "LA LUZ": true,
        "SAN LUIS": true
      },
      "37459": {
        "JARDINES DE SAN SEBASTIÁN": true
      },
      "37460": {
        "JARDÍNES DE SAN MIGUEL": true,
        "LOS AGUACATES": true,
        "VILLANUEVA": true
      },
      "37468": {
        "ARCOIRIS": true,
        "LAS MARGARITAS": true,
        "RÍO MAYO": true
      },
      "37470": {
        "LA ESCONDIDA": true,
        "LA FLORESTA": true,
        "LOURDES": true,
        "SAN MIGUEL INFONAVIT": true,
        "SANTA CLARA": true
      },
      "37477": {
        "FRACCIONES DE SAN NICOLÁS": true,
        "JARDINES DE SAN MIGUELITO": true
      },
      "37478": {
        "PASEOS DEL MAUREL": true
      },
      "37479": {
        "BUENOS AIRES": true
      },
      "37480": {
        "EL PAISAJE": true,
        "LAS ARBOLEDAS": true,
        "LEÓN MODERNO": true,
        "PRADOS VERDES": true,
        "PUERTA SAN RAFAEL": true,
        "SAN NICOLÁS": true
      },
      "37487": {
        "MIGUEL HIDALGO": true
      },
      "37490": {
        "CENTRAL DE ABASTOS": true,
        "ECOLÓGICO DE LEÓN (PIEL)": true,
        "FRACCIONAMIENTO INDUSTRIAL LA POMPA": true,
        "FRACCIONES DE HACIENDA LA POMPA": true,
        "LOS PINOS": true,
        "PARQUE ECOLÓGICO SANTA LUCÍA": true,
        "PRADERA DEL SOL": true,
        "SANTA LUCÍA": true
      },
      "37500": {
        "EL MIRADOR ORIENTAL": true,
        "EL TLACUACHE": true,
        "FRACCIÓN DEL COECILLO": true,
        "LA MARTINICA": true,
        "TORRES ORIÓN": true
      },
      "37510": {
        "ORIENTAL": true,
        "ORIENTAL ANAYA": true,
        "PARQUE MANZANARES": true,
        "SAN ISIDRO": true,
        "VILLAS PRADERA": true
      },
      "37520": {
        "AZTECAS": true,
        "PRADERAS DEL SUR": true,
        "SANTA MARÍA DEL GRANJENO": true,
        "VALLE DE SAN ISIDRO": true
      },
      "37526": {
        "EL TLACUACHE OTE.": true,
        "RESIDENCIAL BENEVENTO": true
      },
      "37530": {
        "CERRITO DE JEREZ": true,
        "COLINAS DE SAN ISIDRO": true,
        "COLINAS DE SANTA JULIA": true,
        "FRACCIONES DE JEREZ": true,
        "GRANJAS JARDINES DE JEREZ": true,
        "JAIME NUNÓ": true,
        "JARDINES DE JEREZ": true,
        "JARDINES DE JEREZ II": true,
        "JARDINES DE JEREZ III": true,
        "JARDINES DE LA BUFA": true,
        "JARDINES DE SANTA JULIA": true,
        "LOMAS DEL CERRITO": true,
        "MEGA PRICE": true,
        "OTE. VILLAS SANTA JULIA": true,
        "RESIDENCIAL DEL PARQUE": true,
        "RESIDENCIAL SAN ISIDRO": true,
        "SAN ISIDRO DE JEREZ": true,
        "SUR LOMA HERMOSA": true,
        "VILLAS DE SAN ISIDRO": true,
        "VILLAS MARIANA": true,
        "VILLAS SANTA JULIA": true,
        "VILLAS SANTA JULIA II SECCIÓN": true
      },
      "37536": {
        "JARDINES DE LA PRADERA": true,
        "LA YESCA": true,
        "PARQUES DE LA PRADERA": true,
        "PARQUES DEL SUR": true,
        "PASEO DE LA PRADERA": true,
        "PASEOS DE LA PRADERA": true,
        "RINCONADA DEL SUR": true
      },
      "37538": {
        "CAMPESTRE DE JEREZ": true,
        "CAÑADA DE JEREZ": true,
        "JARDÍN DELTA": true,
        "JESÚS MARÍA": true,
        "LA ESPERANZA DE JEREZ": true,
        "LA RAZA": true,
        "LOMA HERMOSA": true,
        "LOMAS DE JEREZ": true,
        "PEDREGAL DE JEREZ": true,
        "REAL DE JEREZ": true,
        "TORREMOLINOS": true,
        "VALLE DE JEREZ": true,
        "VALLE DELTA": true
      },
      "37539": {
        "BALCONES DE JEREZ": true,
        "CAMPESTRE NUEVO JEREZ": true,
        "LADERA DE JEREZ": true
      },
      "37544": {
        "ARBOLEDAS DEL CAMPO": true,
        "CAPITTALA": true,
        "EL ENCANTO": true,
        "GRANJAS SAN CARLOS": true,
        "JARDINES DE VERSALLES": true,
        "LA HERRADURA": true,
        "LOS HÉROES LEÓN": true,
        "MAYORCA RESIDENCIAL": true,
        "MURANO": true,
        "PUERTA LISBOA": true,
        "RESIDENCIAL HACIENDA VIÑEDOS": true,
        "SAN CARLOS": true,
        "SAN CARLOS LA RONCHA": true,
        "VALLE DEL ROBLE": true,
        "VILLA DE LOS ÁNGELES": true,
        "VILLA UNIVERSIDAD": true
      },
      "37545": {
        "ARBOLEDA SAN JOSÉ": true,
        "AZUL MAGUEY": true,
        "CASTELLO LL": true,
        "DELTA DE JEREZ": true,
        "INDUSTRIAL DELTA": true,
        "LAS TORRES": true,
        "MEZQUITAL 2000": true,
        "MEZQUITAL DE JEREZ": true,
        "PINAR DEL TAJO": true,
        "RESIDENCIAL CAMELINAS": true,
        "SAN JOSÉ EL ALTO": true,
        "SAN JUAN BAUTISTA": true,
        "VALLE DE LAS HACIENDAS": true,
        "VALLE DE LOS PINOS": true,
        "VALLE DE SAN JAVIER": true,
        "VALLE DE SAN NICOLÁS": true,
        "VALLE DEL MAGUEY": true,
        "VALLE DEL REAL": true,
        "VALLE DORADO": true
      },
      "37547": {
        "ALAMEDAS DE BARCELÓ": true,
        "CAMPESTRE EL TRÉBOL": true,
        "CAPELLANÍA": true,
        "EL MAYORAZGO RESIDENCIAL": true,
        "EL TRÉBOL": true,
        "EL ÁLAMO": true,
        "HACIENDA DE ALBA": true,
        "LA ROSA AMARILLA": true,
        "LOMAS DE SAN CARLOS": true,
        "LORETO RESIDENCIAL": true,
        "LOS AGAVES": true,
        "MARBELLA": true,
        "MARBELLA II": true,
        "MONTOLIVO": true,
        "PUERTA SAN CARLOS": true,
        "RESIDENCIAL SAN JOSÉ": true,
        "RIBERA DE BARCELÓ": true,
        "SACROMONTE": true,
        "SANTA CRUZ": true,
        "SANTA GERTRUDIS": true,
        "VALLE AZUL": true,
        "VALLE DE LA HACIENDA": true,
        "VALLE DE LAS AVES": true,
        "VALLE DE SAN CARLOS": true,
        "VILLAS ALTARIA": true,
        "VILLAS DE BARCELÓ": true,
        "VILLAS DE BARCELÓ II": true,
        "VILLAS DE BARCELÓ III": true
      },
      "37548": {
        "ARBOLEDA DEL REFUGIO": true,
        "FORESTA JARDÍN": true,
        "HACIENDA SAN JOSÉ": true,
        "JARDINES DE ANDALUCÍA": true,
        "JARDINES DEL RÍO": true,
        "LIBERTAD": true,
        "LUZ DEL REFUGIO": true,
        "NUEVO MILENIO": true,
        "POPULAR GUADALAJARA": true,
        "REFUGIO DE SAN JOSÉ": true,
        "VILLA SUR": true
      },
      "37549": {
        "10 DE MAYO": true,
        "ARBOLEDA SAN HILARIÓN": true,
        "DELTA 2000": true,
        "LA GLORIA": true,
        "MARÍA DE LA LUZ": true,
        "NEGRETE": true,
        "PASEOS DE LA CASTELLANA": true,
        "POPULAR POLANCO": true,
        "REAL DELTA": true,
        "SUR INDUSTRIAL DELTA": true,
        "UNIÓN OBRERA": true,
        "VALLE DE SAN JOSÉ": true,
        "VILLA DE CIRELLA": true,
        "VILLAS SANTA TERESITA": true,
        "XOCONOXTLE": true
      },
      "37550": {
        "BOSQUES DE SAN ANDRÉS": true,
        "BOSQUES DEL SUR": true,
        "BOSQUES REALES": true,
        "CUMBRES DE LA PRADERA": true,
        "EL GRANJENO": true,
        "FRACCIÓN DEL GRANJENO": true,
        "MARÍA DOLORES": true,
        "SAN ALFONSO": true,
        "SUR CEMENTOS": true,
        "SUR EL GRANJENO": true,
        "VILLAS JACARANDAS": true
      },
      "37555": {
        "BOSQUES DE LA PRADERA": true,
        "PRADERAS DEL BOSQUE": true,
        "SAN JOSÉ DE CEMENTOS": true
      },
      "37557": {
        "CAUDAL DEL RÍO": true,
        "LAS SENDAS": true,
        "NTE. SANTA MARÍA DE CEMENTOS": true,
        "RIVERA DEL RÍO": true,
        "SANTO DOMINGO": true,
        "VALLE DEL SUR": true
      },
      "37560": {
        "CEMENTOS": true,
        "SANTA MARÍA DE CEMENTOS": true
      },
      "37564": {
        "CENTRO DE PREVENCIÓN SOCIAL": true,
        "CIUDAD INDUSTRIAL": true,
        "CONDOMINIO INDUSTRIAL LEÓN": true,
        "FRACCIONES DE LOS ARCOS": true,
        "MAGURO A.C.": true,
        "SANTA ANA AC": true
      },
      "37566": {
        "FRACCIONES DE SANTA LUCIA": true
      },
      "37570": {
        "CONJUNTO HABITACIONAL CEDROS": true,
        "CONJUNTO HABITACIONAL LAURELES": true,
        "CONJUNTO HABITACIONAL TULIAS": true,
        "EL GUAJITO": true,
        "GRANJENO PLUS (IVEG)": true,
        "JESÚS DE NAZARET": true,
        "LA MOREÑA": true,
        "PARQUE LA NORIA": true,
        "PARQUES DEL SUR V": true,
        "TORRES DEL SUR": true,
        "VILLAS DE LEÓN": true
      },
      "37580": {
        "PURISIMA DE MUÑOZ": true
      },
      "37590": {
        "EL DORADO": true,
        "EL DORADO II": true,
        "FRACCIONES DEL ALTO": true
      },
      "37669": {
        "URBIVILLA DEL ROBLE": true
      },
      "37677": {
        "IBARRILLA": true
      },
      "37680": {
        "CAMINO A LOS PIRULES": true,
        "LADRILLERAS DEL REFUGIO": true,
        "LOMAS DE LA LOZA": true,
        "LOS LÓPEZ": true,
        "LOZA DE LOS PADRES": true,
        "SUR DE LOS LÓPEZ": true,
        "VALLE DEL GIGANTE": true,
        "ÁLVARO OBREGÓN (SANTA ANA DEL CONDE)": true
      },
      "37684": {
        "SAN JUAN DE ABAJO": true
      },
      "37685": {
        "ARBOLEDAS DE LOS LÓPEZ PRIMERA SECCIÓN": true,
        "BAJÍO DE BOLAS BLANCAS": true,
        "CAPELLANÍA DE LOERA": true,
        "EL CUIJE": true,
        "EL RESPLANDOR (EL CHORRO)": true,
        "EL TAJO (CARLOS MUÑOZ HORTA)": true,
        "ESTACIÓN TRINIDAD": true,
        "GRANJA SAN RAFAEL": true,
        "GUADALUPE VICTORIA": true,
        "LA ASTURIANA": true,
        "LA HUARACHA": true,
        "MONTEBELLO": true,
        "NUEVA COLONIA SAN CARLOS": true,
        "PARQUE INDUSTRIAL LEÓN-BAJÍO": true,
        "SAN JOSÉ DEL CLAVEL": true,
        "SAN RAFAEL DE LOS RAMÍREZ": true
      }
    }
  },
  "HIDALGO": {
    "MINERAL DE LA REFORMA": {
      "42180": {
        "PRIVADAS LINDA VISTA": true
      },
      "42181": {
        "SAN GUILLERMO LA REFORMA": true
      },
      "42182": {
        "RESIDENCIAL EL ÁLAMO": true
      },
      "42183": {
        "PRIVADAS DEL COBRE": true
      },
      "42184": {
        "RINCONADAS DEL PORTEZUELO": true
      },
      "42185": {
        "PRIVADAS BOSQUES DEL VENADO": true
      },
      "42186": {
        "PRADERAS DE VIRREYES": true
      },
      "42187": {
        "AMAQUE": true
      },
      "42188": {
        "ALVENTO HÁBITAT": true
      }
    },
    "PACHUCA DE SOTO": {
      "42000": {
        "CENTRO": true
      },
      "42004": {
        "LA GRANADA": true
      },
      "42010": {
        "LA ALCANTARILLA": true
      },
      "42014": {
        "NUEVA ESTRELLA": true
      },
      "42015": {
        "ASTA BANDERA": true
      },
      "42018": {
        "SAN NICOLÁS": true
      },
      "42020": {
        "CUAUHTÉMOC": true
      },
      "42026": {
        "LOMAS DE VISTA HERMOSA": true
      },
      "42027": {
        "ANTONIO DEL CASTILLO": true
      },
      "42029": {
        "UNIÓN POPULAR": true
      },
      "42030": {
        "EL CARMEN": true
      },
      "42032": {
        "PARQUE DE POBLAMIENTO": true
      },
      "42033": {
        "LOS CEDROS": true
      },
      "42034": {
        "AQUILES SERDÁN": true
      },
      "42035": {
        "PLUTARCO ELÍAS CALLES": true
      },
      "42036": {
        "NUEVO HIDALGO": true
      },
      "42037": {
        "CERESO DE PACHUCA": true
      },
      "42039": {
        "SIERRA BONITA": true
      },
      "42040": {
        "HILATURAS HIDALGO": true
      },
      "42050": {
        "EX-HACIENDA DE GUADALUPE": true
      },
      "42055": {
        "ANÁHUAC": true
      },
      "42056": {
        "CRUZ DE LOS CIEGOS": true
      },
      "42057": {
        "EL LUCERO": true
      },
      "42058": {
        "EL LOBO": true
      },
      "42060": {
        "MAESTRANZA": true
      },
      "42064": {
        "COLONIAL": true
      },
      "42070": {
        "BUENOS AIRES": true
      },
      "42075": {
        "CALABAZAS": true
      },
      "42078": {
        "CIUDAD DE LOS NIÑOS": true
      },
      "42079": {
        "GUADALUPE 1A. SECC": true
      },
      "42080": {
        "SAN MARINO": true
      },
      "42082": {
        "PASEOS DE LA PLATA": true
      },
      "42083": {
        "FUENTES DEL VALLE": true
      },
      "42084": {
        "RINCÓN DE LA PLATA": true
      },
      "42086": {
        "ARBOLEDAS SANTA ELENA": true
      },
      "42088": {
        "EL PALMAR": true
      },
      "42090": {
        "CÉSPEDES REFORMA": true
      },
      "42092": {
        "LOS MAESTROS": true
      },
      "42094": {
        "CERRO DE CUBITOS": true
      },
      "42095": {
        "LA RAZA": true
      },
      "42097": {
        "CERRO DE LAS ÁNIMAS": true
      },
      "42098": {
        "TERRAZAS": true
      },
      "42099": {
        "PACHUCA (ING. JUAN GUILLERMO VILLASANA)": true
      },
      "42100": {
        "SAN MIGUEL CEREZO (EL CEREZO)": true
      },
      "42101": {
        "CAMELIA": true
      },
      "42102": {
        "EL BORDO": true
      },
      "42110": {
        "SANTIAGO TLAPACOYA CENTRO": true
      },
      "42111": {
        "SANTA GERTRUDIS": true
      },
      "42113": {
        "PASEOS DE LA CONCEPCIÓN": true
      },
      "42115": {
        "EL HUIXMÍ": true
      },
      "42116": {
        "PITAYAS": true
      },
      "42117": {
        "LAS CAMPANITAS": true
      },
      "42119": {
        "OLIVENZA": true
      }
    }
  },
  "JALISCO": {
    "GUADALAJARA": {
      "44100": {
        "GUADALAJARA CENTRO": true
      },
      "44110": {
        "VALLARTA PONIENTE": true
      },
      "44130": {
        "ARCOS": true,
        "ARCOS VALLARTA": true
      },
      "44140": {
        "OBRERA CENTRO": true
      },
      "44150": {
        "BARRERA": true,
        "LAFAYETTE": true
      },
      "44158": {
        "DEITZ": true
      },
      "44160": {
        "AMERICANA": true
      },
      "44170": {
        "SAN ANTONIO": true
      },
      "44180": {
        "MEXICALTZINGO": true
      },
      "44190": {
        "MODERNA": true
      },
      "44200": {
        "ARTESANOS": true,
        "CAPILLA DE JESÚS": true,
        "EL SANTUARIO": true,
        "SAGRADA FAMILIA": true
      },
      "44210": {
        "JARDINES DEL COUNTRY": true,
        "JARDINES DEL COUNTRY 2A. SECCIÓN": true
      },
      "44214": {
        "UNIVERSIDAD": true
      },
      "44215": {
        "PARÍAN": true
      },
      "44216": {
        "DEL TRABAJO CTM": true,
        "FIDEL VELÁZQUEZ": true
      },
      "44217": {
        "RESIDENCIAL VALLARTA COUNTRY": true
      },
      "44218": {
        "FABRICA DE ATEMAJAC": true
      },
      "44219": {
        "CASA HOGAR CTM": true
      },
      "44220": {
        "CIRCUNVALACIÓN METRO CARBALLO": true,
        "GUADALUPANA NORTE": true,
        "GUADALUPANA SUR": true,
        "SANTA ELENA ALCALDE ORIENTE": true,
        "SANTA ELENA ALCALDE PONIENTE": true,
        "SANTA MÓNICA": true,
        "SIMÓN BOLÍVAR": true
      },
      "44227": {
        "JARDINES DE ATEMAJAC": true
      },
      "44230": {
        "AUTOCINEMA": true,
        "DIVISIÓN DEL NORTE": true,
        "SANTA ELENA DE LA CRUZ": true,
        "SANTA ELENA ESTADIO": true
      },
      "44240": {
        "COLOMOS INDEPENDENCIA": true,
        "ESTADIO": true,
        "FOVISSSTE INDEPENDENCIA": true,
        "INDEPENDENCIA INFONAVIT": true,
        "LOMAS DE INDEPENDENCIA": true,
        "NUEVO SUR": true,
        "PASEOS INDEPENDENCIA": true,
        "RANCHO NUEVO": true,
        "RESIDENCIAL SAN ELIAS": true,
        "RICARDO FLORES MAGÓN": true,
        "VILLAS DEL ESTADIO": true
      },
      "44246": {
        "ESTADIO PONIENTE": true
      },
      "44247": {
        "RANCHO NUEVO INFONAVIT": true
      },
      "44260": {
        "BARRIO MEZQUITAN": true,
        "LA NORMAL": true,
        "MEZQUITAN": true,
        "MEZQUITAN COUNTRY": true,
        "MIGUEL GALINDO": true,
        "NIÑOS HÉROES": true,
        "SAN BERNARDO": true,
        "SAN MIGUEL DE MEZQUITAN": true
      },
      "44265": {
        "RAMÓN CORONA": true
      },
      "44266": {
        "OBSERVATORIO": true
      },
      "44267": {
        "EUGENIA": true
      },
      "44268": {
        "COLONIAL INDEPENDENCIA PONIENTE": true
      },
      "44270": {
        "ALCALDE BARRANQUITAS": true,
        "COLINAS DE LA NORMAL": true,
        "MIRAFLORES": true
      },
      "44280": {
        "EL RETIRO": true
      },
      "44290": {
        "INDEPENDENCIA": true,
        "INDEPENDENCIA PONIENTE": true
      },
      "44298": {
        "JARDINES ALCALDE": true
      },
      "44299": {
        "VILLAS DE SAN JUAN": true
      },
      "44300": {
        "BATALLÓN DE SAN PATRICIO": true,
        "COLONIA NO. 9": true,
        "ESPERANZA": true,
        "JARDINES DE SANTA ISABEL": true,
        "LA FEDERACHA": true,
        "LA JOYA": true,
        "MARGARITA MAZA DE JUÁREZ": true,
        "SAN MIGUEL DE HUENTITÁN EL ALTO 1A SECC": true
      },
      "44306": {
        "BOSQUES DE LA CANTERA": true,
        "LA CANTERA": true,
        "VILLAS DE LA CANTERA": true
      },
      "44307": {
        "ESTADIO": true
      },
      "44320": {
        "BELISARIO DOMÍNGUEZ": true,
        "MONUMENTAL": true
      },
      "44329": {
        "BELISARIO DOMÍNGUEZ": true
      },
      "44330": {
        "CIRCUNVALACIÓN BELISARIO": true,
        "SAN MARCOS ORIENTE": true,
        "SAN MARCOS PONIENTE": true,
        "SAN VICENTE": true,
        "VICENTE GUERRERO": true
      },
      "44340": {
        "INDEPENDENCIA ORIENTE": true
      },
      "44350": {
        "LOMAS INDEPENDENCIA": true,
        "POSTES CUATES (FEDERALISMO)": true,
        "SANTA MARÍA": true,
        "SANTA MARÍA ORIENTE": true
      },
      "44360": {
        "LA NATIVIDAD": true,
        "LA PERLA": true,
        "SAGRADO CORAZÓN": true,
        "SAN JUAN DE DIOS": true
      },
      "44370": {
        "EL MIRADOR": true,
        "SAN RAMÓN": true
      },
      "44380": {
        "SAN FELIPE": true
      },
      "44400": {
        "GRAL. REAL": true,
        "LA DIVINA PROVIDENCIA": true,
        "REAL": true,
        "REVOLUCIÓN": true
      },
      "44410": {
        "LA LOMA": true,
        "MEDRANO": true
      },
      "44420": {
        "OBRERA": true,
        "UNIDAD MODELO": true,
        "VALENTÍN GÓMEZ FARIAS": true
      },
      "44430": {
        "EL PERIODISTA": true,
        "GONZÁLEZ GALLO": true,
        "OLÍMPICA": true,
        "QUINTA VELARDE": true
      },
      "44440": {
        "EL DEAN": true,
        "FERROCARRIL": true,
        "VALLE DEL ÁLAMO": true
      },
      "44450": {
        "ANALCO": true
      },
      "44460": {
        "LA AURORA": true,
        "LAS CONCHAS": true,
        "SAN CARLOS": true
      },
      "44467": {
        "RINCÓN DE AGUA AZUL": true
      },
      "44469": {
        "BARRAGÁN Y HERNÁNDEZ": true
      },
      "44470": {
        "EL MANANTIAL": true,
        "HIGUERILLAS 1A SECC": true,
        "HIGUERILLAS 2A SECC": true,
        "LA NOGALERA": true
      },
      "44490": {
        "LÁZARO CÁRDENAS": true,
        "PARQUE INDUSTRIAL EL ÁLAMO": true
      },
      "44493": {
        "LAS JUNTAS": true
      },
      "44500": {
        "ARCOS SUR": true,
        "CAMPO DE POLO CHAPALITA": true,
        "CHAPALITA": true,
        "JARDINES DE LOS ARCOS": true,
        "RESIDENCIAL CHAPALITA": true,
        "VALLARTA SUR": true
      },
      "44509": {
        "VALLARTA CUAUHTÉMOC": true
      },
      "44510": {
        "JARDINES DE PLAZA DEL SOL": true,
        "JUAN DIEGO": true
      },
      "44520": {
        "JARDINES DEL BOSQUE CENTRO": true,
        "JARDINES DEL BOSQUE NORTE": true
      },
      "44530": {
        "COMERCIAL ABASTOS": true,
        "MARGAL": true,
        "MERCADO DE ABASTOS": true,
        "RINCONADA DEL BOSQUE": true
      },
      "44535": {
        "VILLA LA VICTORIA": true
      },
      "44538": {
        "RINCONADA DE LA VICTORIA": true
      },
      "44540": {
        "BOSQUES DE LA VICTORIA": true,
        "BOSQUES DEL VALLE": true,
        "JARDINES DEL VALLE": true,
        "PERLA REAL": true
      },
      "44549": {
        "RINCONADA DE LA ARBOLEDA": true
      },
      "44550": {
        "VERDE VALLE": true
      },
      "44559": {
        "TURQUESA": true
      },
      "44560": {
        "RESIDENCIAL VICTORIA": true
      },
      "44580": {
        "SANTA EDUWIGES": true
      },
      "44600": {
        "LADRÓN DE GUEVARA": true,
        "SANTA TERESITA": true,
        "VILLASEÑOR": true
      },
      "44610": {
        "COUNTRY CLUB": true,
        "LOMAS DEL COUNTRY": true
      },
      "44619": {
        "VILLAS DEL COUNTRY": true
      },
      "44620": {
        "AYUNTAMIENTO": true,
        "CHAPULTEPEC COUNTRY": true
      },
      "44630": {
        "CIRCUNVALACIÓN AMÉRICAS": true,
        "PROVIDENCIA": true
      },
      "44635": {
        "RUBIO Y CORONA": true
      },
      "44638": {
        "PROVIDENCIA 5A SECC": true
      },
      "44639": {
        "PROVIDENCIA 4A SECC": true
      },
      "44647": {
        "LOMAS DE PROVIDENCIA": true
      },
      "44648": {
        "ITALIA PROVIDENCIA": true
      },
      "44650": {
        "LAS AMÉRICAS": true,
        "ROJAS LADRÓN DE GUEVARA": true
      },
      "44656": {
        "JESÚS GARCIA": true
      },
      "44657": {
        "LOMAS DE GUEVARA": true
      },
      "44658": {
        "ITALIA": true,
        "PROVIDENCIA SUR": true
      },
      "44660": {
        "ALDRETE": true,
        "COLINAS DE SAN JAVIER": true,
        "COLOMOS PROVIDENCIA": true,
        "LOS COLOMOS": true,
        "VILLA DE LOS COLOMOS": true
      },
      "44665": {
        "RINCONADA DEL ARROYO": true
      },
      "44667": {
        "AGRARIA": true
      },
      "44668": {
        "VISTA DEL COUNTRY": true
      },
      "44670": {
        "EULOGIO PARRA": true,
        "LOMAS DEL VALLE": true,
        "MONRAZ": true,
        "PRADOS DE PROVIDENCIA": true,
        "TERRAZAS MONRAZ": true
      },
      "44678": {
        "LOMAS SANTA RITA": true
      },
      "44679": {
        "CIRCUNVALACIÓN SARCÓFAGO": true
      },
      "44680": {
        "CIRCUNVALACIÓN GUEVARA": true,
        "CIRCUNVALACIÓN VALLARTA": true,
        "RESIDENCIAL JUAN MANUEL": true
      },
      "44689": {
        "TERRANOVA": true
      },
      "44690": {
        "RINCONADA SANTA RITA": true,
        "VALLARTA NORTE": true,
        "VALLARTA SAN JORGE": true,
        "VALLARTA SAN LUCAS": true,
        "VILLA SANTA RITA": true
      },
      "44700": {
        "GUADALAJARA ORIENTE": true,
        "OBLATOS": true,
        "RÍO VERDE OBLATOS": true,
        "SANTA CECILIA 1A. SECCIÓN": true,
        "SANTA CECILIA 2A. SECCIÓN": true,
        "SANTA CECILIA 3A. SECCIÓN": true,
        "SANTA ROSA": true,
        "UNIDAD RÍO VERDE": true
      },
      "44710": {
        "POPULAR": true,
        "SAN MARTÍN": true,
        "SAN MARTÍN ANEXO": true,
        "SANTOS DEGOLLADO": true
      },
      "44716": {
        "CIRCUNVALACIÓN OBLATOS": true
      },
      "44719": {
        "AMPLIACIÓN TALPITA": true,
        "TALPITA ORIENTE": true,
        "TALPITA PONIENTE": true
      },
      "44720": {
        "ARANDAS": true,
        "BALCONES DE OBLATOS": true,
        "BETHEL": true,
        "HELIODORO HERNÁNDEZ LOZA 1A SECC": true,
        "HELIODORO HERNÁNDEZ LOZA 2A SECC": true,
        "LOMAS DE OBLATOS 1A SECC": true,
        "LOMAS DE OBLATOS 2A SECC": true,
        "LOMAS DE SAN EUGENIO": true,
        "SAN JOSÉ RÍO VERDE 2A. SECCIÓN": true,
        "VILLAS DE GUADALUPE": true
      },
      "44723": {
        "PLUTARCO ELIAS CALLES 1": true
      },
      "44724": {
        "SAN EUGENIO": true
      },
      "44725": {
        "PLUTARCO ELIAS CALLES 2": true
      },
      "44726": {
        "SAN JOSÉ RÍO VERDE 1A. SECCIÓN": true
      },
      "44727": {
        "TETLÁN RIO VERDE": true
      },
      "44730": {
        "ANTIGUA PENAL DE OBLATOS": true,
        "BLANCO Y CUELLAR 1RA.": true,
        "BLANCO Y CUELLAR 2DA.": true,
        "BLANCO Y CUELLAR 3RA.": true,
        "EL PORVENIR UNIDAD HOGAR": true,
        "PROGRESO": true,
        "RINCONADA SAN ANDRES PONIENTE": true,
        "SAN JUAN BOSCO": true
      },
      "44737": {
        "LOS MÁRTIRES": true
      },
      "44740": {
        "INDUSTRIA": true,
        "JARDINES DE GUADALUPE": true,
        "POTRERO ALTO": true,
        "SAN ISIDRO": true
      },
      "44748": {
        "ESTEBAN ALATORRE": true
      },
      "44750": {
        "BARAJAS VILLASEÑOR SAN PABLO": true,
        "CUAUHTÉMOC INFONAVIT": true,
        "CUAUHTÉMOC POPULAR": true,
        "LIBERTAD": true,
        "SANTA MARÍA DE SILO": true
      },
      "44755": {
        "EL PORVENIR ORIENTE": true,
        "RINCONADA SAN ANDRES": true
      },
      "44757": {
        "LOS ROMO": true
      },
      "44765": {
        "AMPLIACIÓN PROVINCIA": true,
        "PABLO VALDEZ": true
      },
      "44770": {
        "BENITO JUÁREZ": true,
        "HERMOSA PROVINCIA": true,
        "INFONAVIT BENITO JUÁREZ": true,
        "LAGOS DE ORIENTE": true,
        "LAGOS DE ORIENTE 2A. SECCIÓN": true,
        "SAN JOAQUÍN": true
      },
      "44780": {
        "SAN MIGUEL DE HUENTITÁN EL ALTO 2A SECC": true
      },
      "44790": {
        "AGUSTÍN YÁÑEZ": true,
        "AMPLIACIÓN LAGOS DE ORIENTE": true,
        "JARDINES DE SAN FRANCISCO": true,
        "LA AURORA": true,
        "LA FLORIDA": true,
        "VERSALLES": true
      },
      "44799": {
        "JAVIER MINA": true
      },
      "44800": {
        "MAGAÑA": true,
        "SAN ANTONIO": true
      },
      "44810": {
        "ELECTRICISTAS": true,
        "EUROPA": true,
        "HORMIGUERO": true,
        "INFONAVIT SAN RAFAEL": true,
        "LOMAS DE REVOLUCIÓN": true,
        "RESIDENCIAL DEL PARQUE": true,
        "RESIDENCIAL SAN ANDRÉS": true,
        "SAN ANDRÉS": true,
        "SAN ANDRÉS 1A. SECCIÓN": true,
        "SAN ANDRÉS 2A. SECCIÓN": true,
        "SAN ANDRÉS GIGANTES": true,
        "SAN RAFAEL": true
      },
      "44815": {
        "JARDINES DE LOS ESCRITORES": true
      },
      "44817": {
        "SAN RAFAEL 2": true
      },
      "44818": {
        "PLAN DE AYALA": true
      },
      "44820": {
        "2001": true,
        "ALDAMA TETLÁN": true,
        "DIOSES DEL NILO": true,
        "INSURGENTES 1A SECC": true,
        "INSURGENTES 2A SECC": true,
        "INSURGENTES 3A SECC": true,
        "INSURGENTES LA PRESA": true,
        "JARDINES DE LOS HISTORIADORES": true,
        "JARDINES DE LOS POETAS": true,
        "LOS OBELISCOS": true,
        "PARQUES DEL NILO": true,
        "TETLÁN": true,
        "TETLÁN I": true,
        "TETLÁN II": true,
        "VILLAS DE LA PRESA": true
      },
      "44824": {
        "FLORENCIA": true,
        "VILLAS DEL NILO": true
      },
      "44825": {
        "PARQUES DE SAN PEDRO": true,
        "POPULAR HORNOS": true
      },
      "44827": {
        "EL BARRO": true
      },
      "44828": {
        "LAS PIEDROTAS": true,
        "VISTAS DEL NILO": true
      },
      "44829": {
        "CANTARRANAS": true
      },
      "44840": {
        "CIUDAD UNIVERSITARIA": true,
        "LOMAS DEL PARADERO": true,
        "PRADOS DEL NILO": true,
        "SUTAJ": true,
        "UNIVERSITARIA": true
      },
      "44860": {
        "JARDINES DE LA PAZ": true,
        "JARDINES DE LA PAZ NORTE": true,
        "JARDINES DEL NILO": true,
        "JARDINES DEL NILO NORTE": true,
        "JARDINES DEL NILO SUR": true,
        "LA PAZ": true,
        "VICENTE GUERRERO": true
      },
      "44870": {
        "ATLAS": true,
        "ATLAS 2A. SECCIÓN": true,
        "ATLAS PONIENTE": true
      },
      "44890": {
        "EL ROSARIO": true,
        "JARDINES DEL ROSARIO": true,
        "RANCHO BLANCO": true,
        "RANCHO BLANCO ÁLAMO": true,
        "REFORMA": true
      },
      "44895": {
        "EL MIRADOR ÁLAMO": true
      },
      "44896": {
        "OROZCO EL MIRADOR": true
      },
      "44897": {
        "LOMAS DE SAN PEDRO": true
      },
      "44898": {
        "EL ROSARIO": true
      },
      "44899": {
        "BOSQUES DEL BOULEVARD": true
      },
      "44900": {
        "DEL FRESNO 1A. SECCIÓN": true,
        "DEL FRESNO 2A. SECCIÓN": true
      },
      "44910": {
        "8 DE JULIO": true,
        "MORELOS": true,
        "TEPOPOTE": true
      },
      "44918": {
        "MARIANO MATAMOROS": true
      },
      "44919": {
        "TEPOPOTE OESTE": true
      },
      "44920": {
        "COLÓN": true,
        "DEL SUR": true,
        "LAS TORRES": true,
        "VILLA LA CRUZ": true
      },
      "44929": {
        "AMPLIACIÓN DEL SUR": true
      },
      "44930": {
        "COLÓN INDUSTRIAL": true
      },
      "44940": {
        "INDUSTRIAL SEGUNDA SECCIÓN": true,
        "ZONA INDUSTRIAL": true
      },
      "44948": {
        "VILLA HERMOSA": true
      },
      "44949": {
        "ZONA INDUSTRIAL 2A SECCIÓN": true
      },
      "44950": {
        "JARDINES DE LA CRUZ 1A. SECCIÓN": true,
        "JARDINES DE LA CRUZ 2A. SECCIÓN": true,
        "JARDINES DE SAN JOSÉ": true,
        "JARDINES DEL SUR": true,
        "RESIDENCIAL LA CRUZ": true
      },
      "44956": {
        "VILLAS DEL SUR 1": true,
        "VILLAS DEL SUR 2": true
      },
      "44959": {
        "VILLAS JARDÍN": true
      },
      "44960": {
        "18 DE MARZO": true,
        "LOMAS DE POLANCO": true,
        "LÓPEZ PORTILLO": true,
        "POLANCO ORIENTE": true
      },
      "44966": {
        "PATRIA NUEVA": true
      },
      "44967": {
        "PATRIA": true
      },
      "44969": {
        "POLANQUITO": true
      },
      "44970": {
        "1 DE MAYO": true,
        "5 DE MAYO": true,
        "ECHEVERRÍA": true,
        "FRANCISCO VILLA": true,
        "INDUSTRIAL PRIMERA SECCIÓN": true,
        "INDUSTRIAL TERCERA SECCIÓN": true,
        "JOSÉ CLEMENTE OROZCO": true
      },
      "44977": {
        "EL ROCÍO": true,
        "VALENTÍN GÓMEZ FARIAS": true,
        "VISTAS DEL SUR": true
      },
      "44978": {
        "LAS PALMAS": true
      },
      "44980": {
        "ARBOLEDAS DEL SUR": true,
        "EL CARMEN": true,
        "EMILIANO ZAPATA": true,
        "LOS COLORINES": true,
        "LÁZARO CÁRDENAS SUR": true,
        "NUEVA ESPAÑA": true,
        "NUEVA SANTA MARÍA": true
      },
      "44984": {
        "BALCONES DEL CUATRO": true
      },
      "44985": {
        "REVOLUCIONARIA": true
      },
      "44986": {
        "LOMA LINDA": true,
        "LOMAS DEL PEDREGAL": true
      },
      "44987": {
        "EL SAUZ INFONAVIT": true,
        "JARDINES EL SAUZ": true,
        "PARQUES DE COLÓN SECCIÓN 2": true,
        "VILLA VICENTE GUERRERO": true
      },
      "44989": {
        "COLÓN C.R.O.C.": true
      },
      "44990": {
        "MIRAVALLE": true
      }
    },
    "SAN PEDRO TLAQUEPAQUE": {
      "45403": {
        "INFONAVIT LA SOLEDAD": true
      },
      "45500": {
        "NIÑOS HÉROES": true,
        "TLAQUEPAQUE CENTRO": true,
        "TLAQUEPAQUE PUEBLITO": true
      },
      "45509": {
        "INFONAVIT REVOLUCIÓN": true
      },
      "45510": {
        "LOS MESEROS": true
      },
      "45519": {
        "JARDINES DE LA PAZ": true
      },
      "45520": {
        "LINDAVISTA": true,
        "LOS ALTOS": true,
        "PATRIA FOVISSSTE": true,
        "TESOROS DEL NILO": true
      },
      "45525": {
        "PARQUE TLAQUEPAQUE": true,
        "REAL PATRIA": true,
        "RESIDENCIAL LA SOLEDAD": true
      },
      "45527": {
        "CAMICHINES ALBORADA 1RA. SECCIÓN": true,
        "CAMICHINES ALBORADA 2 SECCIÓN": true,
        "CAMICHINES ALBORADA 3 SECCIÓN": true,
        "LA ASUNCIÓN": true,
        "RESIDENCIAL CAMICHINES CONDOMIO DEL SOL": true
      },
      "45528": {
        "LOS ALTOS 3A SECC": true
      },
      "45530": {
        "ARROYO DE LAS FLORES": true,
        "FRANCISCO I. MADERO": true,
        "GUAYABITOS": true,
        "LOMAS DEL TEPEYAC": true,
        "NUEVO SANTA MARÍA": true
      },
      "45535": {
        "INDUSTRIAL EL CAMINO": true,
        "LOMAS DE SANTA MARÍA": true
      },
      "45540": {
        "CAMICHINES RESIDENCIAL 1RA. SECCIÓN": true,
        "CAMICHINES RESIDENCIAL 2DA. SECCIÓN": true,
        "HIDALGO": true,
        "RESIDENCIAL LA ASUNCIÓN 1A. SECCIÓN": true
      },
      "45550": {
        "QUINTERO": true
      },
      "45559": {
        "LOMAS DE TLAQUEPAQUE": true,
        "PRADOS TLAQUEPAQUE": true
      },
      "45560": {
        "ALFAREROS": true,
        "EL ÁLAMO": true,
        "JARDINES DEL ÁLAMO": true,
        "LA CAPACHA": true,
        "LOMAS DEL ÁLAMO": true,
        "RANCHO BLANCO": true,
        "ÁLAMO": true,
        "ÁLAMO ORIENTE": true
      },
      "45567": {
        "ÁLAMO SUPER MANZANA": true
      },
      "45570": {
        "COLONIAL TLAQUEPAQUE": true
      },
      "45579": {
        "HACIENDA DE TLAQUEPAQUE": true
      },
      "45580": {
        "AZABACHE": true,
        "CANAL 58": true,
        "EL PALOMO": true,
        "EL PUENTE": true,
        "HACIENDA DE VIDRIOS": true,
        "LA DURAZNERA": true,
        "LOS PORTALES": true,
        "NUEVA CENTRAL CAMIONERA": true,
        "RESIDENCIAL REVOLUCIÓN": true,
        "REVOLUCIÓN": true,
        "SALVADOR PORTILLO LÓPEZ": true,
        "SOLIDARIDAD": true,
        "VILLAS DE LOMA GRANDE": true,
        "VILLAS LOS CANTAROS": true
      },
      "45588": {
        "EL TAPATÍO": true,
        "EL ÓRGANO": true,
        "HACIENDAS SAN PEDRO": true,
        "JARDINES DEL TAPATÍO": true,
        "LAS FLORES": true,
        "PAISAJES DEL TAPATÍO": true,
        "RESIDENCIAL EL TAPATÍO": true
      },
      "45589": {
        "LAS HUERTAS": true,
        "LOMAS DE SAN MIGUEL": true,
        "REVOLUCIÓN JARDÍN": true
      },
      "45590": {
        "BARRIO DE CEMENTO": true,
        "BRISAS DE CHAPALA": true,
        "CANTO DE LUNA": true,
        "CUMBRES DEL PRADO": true,
        "FELIPE ÁNGELES": true,
        "HOGARES DEL ÁLAMO": true,
        "INDÍGENA": true,
        "JUAN DIEGO": true,
        "LAS JUNTAS": true,
        "LAS JUNTITAS": true,
        "LAS VEGAS": true,
        "LÁZARO CÁRDENAS": true,
        "MERIDIANO": true,
        "NUEVA LÁZARO CÁRDENAS": true,
        "PUERTA DEL PRADO": true
      },
      "45593": {
        "ÁLAMO INDUSTRIAL": true
      },
      "45594": {
        "FOVISSSTE MIRAVALLE": true,
        "INFONAVIT MIRAVALLE": true,
        "TERRALTA": true
      },
      "45595": {
        "EL VERGEL 1RA. SECCIÓN": true,
        "EL VERGEL 2DA. SECCIÓN": true,
        "EL VERGELITO": true,
        "MICAELITA": true
      },
      "45596": {
        "LA GUADALUPANA": true
      },
      "45597": {
        "EL CAMPESINO": true
      },
      "45598": {
        "ARTESANOS": true,
        "ARTESANOS ORIENTE": true,
        "COMPOSITORES": true,
        "LA ROMITA": true,
        "SALVADOR VIDRIO": true
      },
      "45599": {
        "CERRO DEL CUATRO": true,
        "EL REFUGIO": true,
        "GUADALUPE EJIDAL": true,
        "HUERTA DE PEÑA": true,
        "LAS TERRAZAS RESIDENCIAL": true,
        "LOMAS DE CURIEL": true,
        "LOMAS DEL CUATRO": true
      },
      "45600": {
        "QUINTANOVA RESIDENCIAL": true
      },
      "45601": {
        "AMANECERES": true,
        "BARRIO DE SAN MIGUEL": true,
        "COTO AREZZO": true,
        "EL REAL": true,
        "GEOVILLAS LOS OLIVOS": true,
        "HACIENDA DEL REAL": true,
        "INDÍGENA SAN SEBASTIANITO": true,
        "JARDINES DE MIRAFLORES": true,
        "LA GIGANTERA": true,
        "LOMA VERDE": true,
        "LOS OLIVOS DE TLAQUEPAQUE": true,
        "PRADOS DE SANTA MARÍA": true,
        "RIVERAS DE SAN SEBASTIANITO": true,
        "SAN SEBASTIANITO": true,
        "SANTA MARÍA TEQUEPEXPAN": true,
        "TULIPANES": true,
        "VALLE DE LAS HERAS": true,
        "VALLE DE SAN SEBASTIANITO": true,
        "VALLE DEL SUR": true
      },
      "45604": {
        "ITESO": true
      },
      "45605": {
        "ANTIGUA SANTA MARÍA": true,
        "MEZQUITERA": true
      },
      "45606": {
        "BALCONES DE SANTA MARÍA": true,
        "BUENOS AIRES": true,
        "JARDINES DE SANTA MARÍA": true,
        "LOMA LINDA": true,
        "VILLAS COLÓN": true
      },
      "45607": {
        "BOSQUE I": true,
        "EL MANTE": true,
        "LOMA BONITA PONIENTE": true,
        "LOMAS DE LA VICTORIA": true
      },
      "45608": {
        "CERRO DEL TESORO": true,
        "EL SÁUZ": true,
        "LOMA BONITA EJIDAL": true,
        "MIRADOR DEL TESORO": true,
        "PAISAJES DEL TESORO": true,
        "PARQUE INDUSTRIAL TECNOLÓGICO": true,
        "PARQUES DE COLON": true
      },
      "45609": {
        "ARROYO SECO": true,
        "HACIENDAS DE SAN JOSÉ": true,
        "LOS CAJETES": true,
        "PARQUES DE SANTA MARÍA": true,
        "PARQUES DEL BOSQUE": true
      },
      "45610": {
        "PEDREGAL DEL BOSQUE": true,
        "REAL TULIPANES": true,
        "TOLUQUILLA": true,
        "TRES PINOS": true
      },
      "45619": {
        "LAS PINTAS DE ABAJO": true,
        "PASEOS DEL LAGO": true
      },
      "45620": {
        "PLAN DE ORIENTE": true,
        "PLAN DE RÍO": true,
        "PLAN DEL SUR": true
      },
      "45623": {
        "EL MANANTIAL": true,
        "IBEROAMERICANO": true,
        "LAS LIEBRES": true,
        "PORTILLO BLANCO": true
      },
      "45625": {
        "LOMAS DE SAN PEDRITO": true,
        "RINCONADAS DE LOS ENCINOS": true,
        "SAN PEDRITO": true,
        "VILLAS DE SAN MIGUEL": true
      },
      "45626": {
        "PARQUE INDUSTRIAL PROLOGISTIC": true
      },
      "45627": {
        "ABADÍA SAN MARTÍN": true,
        "EL ZALATE": true,
        "LOS AMIALES": true,
        "VERDE VALLE": true
      },
      "45628": {
        "ALFREDO BARBA": true,
        "JARDINES DE SAN MARTÍN": true,
        "LOMAS DEL TAPATÍO": true
      },
      "45629": {
        "EL CERRITO": true,
        "EL MORITO": true,
        "JARDINES DEL ÓRGANO": true,
        "LÓPEZ MATEOS": true,
        "MIRADOR DE SAN MARTÍN": true,
        "QUINTAS DE TLAQUEPAQUE": true,
        "SAN MARTÍN DE LAS FLORES DE ABAJO": true,
        "SAN MARTÍN DE LAS FLORES DE ARRIBA": true,
        "VILLAS DEL TAPATÍO": true,
        "ÁLVARO OBREGÓN": true
      },
      "45630": {
        "ALAMEDA": true,
        "CANTERA COLORADA": true,
        "CERRO DEL JAGÜEY": true,
        "LADERITA": true,
        "RESIDENCIAL LAS LOMAS": true,
        "TATEPOSCO": true,
        "TINAJITAS": true
      },
      "45638": {
        "ARBOLEDAS DE SAN MARTÍN": true,
        "BARRIOS UNIDOS DE INTERCOLONIAS": true,
        "CANTARES DEL PARAÍSO": true,
        "EL CANELO": true,
        "EL NOGAL": true,
        "EL SÁUZ": true,
        "EMILIANO ZAPATA": true,
        "FRANCISCO SILVA ROMERO": true,
        "HACIENDAS DE SAN MARTÍN": true,
        "HORIZONTES DE TLAQUEPAQUE": true,
        "LA ARENA": true,
        "LA COFRADÍA": true,
        "LA SEVERIANA": true,
        "LOS HORNOS": true,
        "LOS NARANJOS": true,
        "LOS PUESTOS": true,
        "PARQUES DE LA VICTORIA": true,
        "RESIDENTES DE SAN MARTÍN": true,
        "SAN JUAN": true,
        "SANTIBÁÑEZ": true,
        "SENTIMIENTOS DE LA NACIÓN": true,
        "VALLE DEL PARAÍSO": true
      }
    },
    "TONALÁ": {
      "45400": {
        "ALTAMIRA": true,
        "ARROYOS": true,
        "BAJÍO DE LA MESA": true,
        "BALCONES DEL SOL": true,
        "BELLAVISTA": true,
        "BUENOS AIRES": true,
        "CAÑON": true,
        "CIHUALPILLI": true,
        "COLINAS DE ALTAMIRA": true,
        "COLINAS DE SAN CARLOS": true,
        "COLONIA DEL SUR": true,
        "COLORINES": true,
        "COMOLCA": true,
        "CONCHA": true,
        "CUCHARA": true,
        "EL AMIAL": true,
        "EL MIRADOR": true,
        "EL RECODO": true,
        "EL REMOLINO": true,
        "EL ZAPOTE": true,
        "FIDEL VELÁZQUEZ": true,
        "HIDALGO DE TONALA": true,
        "JARDINES DE SAN RAFAEL": true,
        "JARDINES DE TONALA": true,
        "LA ALBERCA": true,
        "LA CABAÑA": true,
        "LA COMOLEA": true,
        "LA GUADALUPANA": true,
        "LA MESA I": true,
        "LA MESA II": true,
        "LA PROVIDENCIA": true,
        "LAS GABRIELAS": true,
        "LOMA SUR": true,
        "LOMAS DE TONALÁ": true,
        "MIRADOR DE LA REYNA": true,
        "MIRADOR DEL SOL": true,
        "MISIÓN DEL CAMPANARIO": true,
        "PACHAGUILLO": true,
        "PIRUL": true,
        "POTRERITO BECCERROS": true,
        "PRADERAS DEL SOL": true,
        "PRADOS TONALÁ": true,
        "PUEBLITO DEL SOL": true,
        "RICARDO FLORES MAGÓN": true,
        "RINCONADA DE LOS CEREZOS": true,
        "RINCONADA TONALÁ": true,
        "RINCONADAS DEL SOL": true,
        "SAN ELIAS": true,
        "SAN MATEO": true,
        "SILLITA ZAPOTE": true,
        "TENAMAXTLE": true,
        "TONALTECAS": true,
        "TONALTECAS II": true,
        "TONALÁ CENTRO": true,
        "VALLE DEL SOL": true,
        "VISTAS DEL VALLE": true,
        "VISTAS TONALLÁN": true,
        "XICOXOCHITL": true
      },
      "45402": {
        "ALFAREROS": true,
        "ALPINOS": true,
        "AMIALES CIUDAD AZTLÁN": true,
        "BARRIO NUEVO": true,
        "CIUDAD AZTLÁN": true,
        "COLINAS DE TONALÁ": true,
        "COLONOS CIUDAD AZTLÁN": true,
        "EL BARRO": true,
        "EL CERRITO": true,
        "EL CERRO": true,
        "FRANCISCO VILLA": true,
        "FUENTES DEL NILO": true,
        "INDUSTRIAL NUEVA CENTRAL CAMIONERA": true,
        "LADERA": true,
        "LARGUERO": true,
        "LINDA VISTA": true,
        "LOMA DORADA": true,
        "LOMA DORADA EJIDAL": true,
        "LOMAS DE AZTLÁN": true,
        "LOMAS DEL MANANTIAL": true,
        "LOS CUADROS": true,
        "LOS LIBERALES": true,
        "LOS MÚSICOS": true,
        "NUEVO SANTA CRUZ": true,
        "PEDREGAL": true,
        "QUINTANA CATALINA": true,
        "REY XOLOTL": true,
        "SANTA CRUZ DE LAS HUERTAS": true,
        "VILLAS ARTESANOS": true,
        "VISTAS DEL REY": true
      },
      "45403": {
        "AGUA ESCONDIDA": true,
        "CIPRESES": true,
        "COLINAS DE LA CRUZ": true,
        "COLINAS SANTA CRUZ II": true,
        "DEL VALLE": true,
        "EL BAJÍO DE SANTA CRUZ": true,
        "EL DORADITO": true,
        "FLORES MAGÓN": true,
        "FLORES MAGÓN II": true,
        "HACIENDA SAN FRANCISCO": true,
        "INFONAVIT LA SOLEDAD": true,
        "INFONAVIT RÍO NILO": true,
        "LOMAS DE LA SOLEDAD": true,
        "LOMAS DE LOS PÁJAROS": true,
        "LOMAS DEL CAMICHIN": true,
        "LOS CAMICHINES I": true,
        "LOS CAMICHINES II": true,
        "LOS POCITOS": true,
        "MARAVILLAS": true,
        "PASEOS DEL VALLE": true,
        "REAL PATRIA": true,
        "RINCONADA DE LA PRESA": true,
        "RINCONADA DEL ÁRBOL": true,
        "RINCONADA SAN FRANCISCO": true,
        "VILLAS DE ORIENTE": true,
        "VILLAS DE ORIENTE II": true
      },
      "45428": {
        "LA LADRILLERA": true
      }
    },
    "ZAPOPAN": {
      "45010": {
        "BELLAVISTA": true,
        "CHAPALITA INN": true,
        "CIUDAD GRANJA": true,
        "COTO DEL REY": true,
        "CUMBRES": true,
        "EXITMEX": true,
        "GLORIAS DEL COLLI": true,
        "JARDINES DE CHAPALITA": true,
        "LA CASTILLA": true,
        "LOMAS DEL COLLI": true,
        "PASEOS DEL PARQUE": true,
        "RINCONADA DEL PARQUE": true,
        "VISTAS DEL PINAR": true,
        "VOLCÁN DEL COLLI": true
      },
      "45016": {
        "LOMAS UNIVERSIDAD": true,
        "PASEOS UNIVERSIDAD": true,
        "VILLAS DE VALLARTA": true
      },
      "45018": {
        "RESIDENCIAL DEL PARQUE": true,
        "SANTA MARIA DEL PUEBLITO": true
      },
      "45020": {
        "CAMICHINES VALLARTA": true,
        "EUCALIPTO VALLARTA": true,
        "PRADOS VALLARTA": true,
        "REAL VALLARTA": true,
        "VALLARTA LA PATRIA": true
      },
      "45027": {
        "JARDINES VALLARTA": true,
        "RINCONADA DE LOS NOVELISTAS": true
      },
      "45030": {
        "ATLAS CHAPALITA": true,
        "CHAPALITA DE OCCIDENTE": true,
        "CHAPALITA LAS FUENTES": true,
        "EL CARMEN HÁBITAT": true,
        "GUADALUPE JARDÍN": true,
        "JARDINES DE GUADALUPE": true,
        "LA ESTANCIA": true,
        "NUESTRA SEÑORA DE GUADALUPE": true,
        "PARQUE SERENO": true,
        "PRADOS DE GUADALUPE": true,
        "RESIDENCIAL 2000": true,
        "RESIDENCIAL PLAZA GUADALUPE": true,
        "RINCONADA GUADALUPE": true
      },
      "45034": {
        "JARDINES TEPEYAC": true,
        "LOS OLIVOS": true
      },
      "45036": {
        "COLLI SITIO": true,
        "GUADALUPE SUR": true,
        "NUEVA GALICIA 1": true,
        "NUEVA GALICIA 2": true,
        "RESIDENCIAL HACIENDAS GUADALUPE": true
      },
      "45037": {
        "ARCOS DE GUADALUPE": true,
        "GUADALUPE INN": true,
        "PARQUES GUADALUPE": true
      },
      "45038": {
        "LOMAS DE GUADALUPE": true,
        "LOMAS DEL SEMINARIO": true
      },
      "45039": {
        "RESIDENCIAL CORDILLERAS": true
      },
      "45040": {
        "CAMINO REAL": true,
        "CHAPALITA ORIENTE": true,
        "CHAPALITA SUR": true,
        "CIUDAD DE LOS NIÑOS": true,
        "JARDINES DE SAN IGNACIO": true,
        "LAS FLORES": true
      },
      "45047": {
        "GUADALUPE": true,
        "RINCONADA DEL VALLE": true,
        "TEPEYAC CASINO": true
      },
      "45049": {
        "DON BOSCO VALLARTA": true,
        "VALLARTA CUAUHTÉMOC": true
      },
      "45050": {
        "CIUDAD DEL SOL": true,
        "EL ZAPOTE": true,
        "JARDÍNES DEL SOL": true,
        "PRADOS TEPEYAC": true
      },
      "45053": {
        "HACIENDA DEL TEPEYAC": true,
        "PARQUES DEL TEPEYAC": true,
        "RESIDENCIAL TEPEYAC DEL SOL": true
      },
      "45054": {
        "MIRADOR DEL SOL": true
      },
      "45055": {
        "PLAZA DEL SOL": true,
        "RINCONADA DEL SOL": true
      },
      "45056": {
        "COLLI C.T.M.": true
      },
      "45057": {
        "EL COLLI INFONAVIT": true,
        "EL COLLI PRIMAVERA": true
      },
      "45058": {
        "NUEVA PRIMAVERA": true,
        "RINCONADA SANTA CATALINA": true,
        "SANTA CATALINA": true,
        "VILLA PUERTA DEL SOL": true,
        "VILLAS DEL TEPEYAC": true
      },
      "45059": {
        "RESIDENCIAL MOCTEZUMA": true,
        "RESIDENCIAL MOCTEZUMA PONIENTE": true
      },
      "45060": {
        "MIRAMAR": true
      },
      "45066": {
        "ARENALES TAPATÍOS": true,
        "ARRAYANES": true,
        "BOSQUE REAL": true,
        "CITALA": true,
        "COLINAS DE LA PRIMAVERA": true,
        "EL FORTÍN": true,
        "EL TIZATE": true,
        "FORÉT RESIDENCIAL": true,
        "JARDINES DE LA PRIMAVERA": true,
        "LA GRANJA": true,
        "MISIÓN LA FLORESTA": true,
        "MONTE VERDE": true,
        "MONTE VERDE II": true,
        "MONTE VERDE III": true,
        "NATURA BOSQUE RESIDENCIAL": true,
        "OYAMEL": true,
        "PARQUE ARRAYANES": true,
        "PUERTA DEL BOSQUE": true,
        "RESIDENCIAL LA PEÑA": true,
        "VALLE DE SAN NICOLÁS": true,
        "VILLAS DE LA PRIMAVERA": true,
        "VILLAS MARIANO OTERO": true
      },
      "45067": {
        "MARIANO OTERO": true
      },
      "45069": {
        "PARAÍSOS DEL COLLI": true,
        "PARQUE INDUSTRIAL EL COLLI": true
      },
      "45070": {
        "ARBOLEDAS 1A SECC": true,
        "ARBOLEDAS 2A SECC": true,
        "EL COLLI EJIDAL": true,
        "EL COLLI URBANO 1A. SECCIÓN": true,
        "EL COLLI URBANO 2A. SECCIÓN": true,
        "LA CALMA": true,
        "LAS FUENTES": true
      },
      "45076": {
        "UNIDAD CADETE FRANCISCO MÁRQUEZ": true
      },
      "45077": {
        "LAS PIRÁMIDES": true
      },
      "45078": {
        "PERIODISTAS": true
      },
      "45079": {
        "HACIENDA SAN ANTONIO DEL VALLE": true,
        "LAS ALAMEDAS": true,
        "PASEOS DEL SOL": true,
        "RINCONADA DEL SOL POR ZONA ARQUEOLÓGICA IXTEPEC": true
      },
      "45080": {
        "COLINAS DE LAS ÁGUILAS": true,
        "LA CALMA 2A SECC": true,
        "LAS ÁGUILAS": true,
        "PINAR DE LA CALMA": true,
        "RINCONADA DE LA CALMA": true,
        "SIERRA DE TAPALPA": true,
        "UNIDAD DÍAZ ORDAZ": true
      },
      "45085": {
        "LOMA BONITA EJIDAL": true
      },
      "45086": {
        "LOMA BONITA": true,
        "LOMA BONITA SUR": true
      },
      "45087": {
        "NAVÍO": true,
        "RINCONADA LA JOYA": true
      },
      "45088": {
        "LA GIRALDA": true,
        "RESIDENCIAL LOMA BONITA": true
      },
      "45089": {
        "JARDINES VILLAS DEL BOSQUE": true,
        "RESIDENCIAL VICTORIA": true
      },
      "45100": {
        "LA VILLA": true,
        "ZAPOPAN CENTRO": true
      },
      "45110": {
        "COLINAS DE SAN JAVIER": true,
        "COLOMOS PATRIA": true,
        "EL ALCAZAR ORIENTE": true,
        "EL ALCAZAR PONIENTE": true,
        "JACARANDAS": true,
        "JARDINES DE LA PATRIA": true,
        "JARDINES UNIVERSIDAD": true,
        "REAL SAN BERNARDO": true,
        "SAN BERNARDO": true,
        "SAN WENCESLAO": true,
        "SANTA ISABEL": true,
        "VALLARTA UNIVERSIDAD": true,
        "VILLA LA CIMA": true,
        "VILLA UNIVERSITARIA": true,
        "VIRREYES RESIDENCIAL": true
      },
      "45115": {
        "COLINAS VIRREYES": true,
        "ENTRELOMAS RESIDENCIAL": true,
        "LOS CASTAÑOS": true,
        "PUERTA LAS LOMAS": true,
        "RESIDENCIAL PARQUE VIRREYES": true,
        "VILLA VERONA": true,
        "VISTAS DEL TULE I": true,
        "VISTAS DEL TULE II": true
      },
      "45116": {
        "PONTEVEDRA": true,
        "PUERTA AQUA": true,
        "PUERTA DE HIERRO": true,
        "PUERTA DEL BOSQUE": true,
        "PUERTA DEL ROBLE": true,
        "PUERTA PLATA": true,
        "REAL DEL PARQUE": true,
        "ROYAL COUNTRY": true
      },
      "45117": {
        "CALLEJÓN DEL PARQUE": true,
        "EL RINCÓN": true,
        "LA LAJA": true,
        "PARQUE DE LA CASTELLANA": true,
        "PARQUE REGENCY": true,
        "PUERTA DEL SOL": true,
        "VISTA MAGNA": true
      },
      "45118": {
        "ATLAS COLOMOS": true,
        "EL PRADO": true,
        "GUADALAJARITA": true,
        "LOMAS DE LAS PALMAS": true,
        "LOMAS DEL BOSQUE": true,
        "ZOTOGRANDE": true
      },
      "45119": {
        "LA PATRIA UNIVERSIDAD": true
      },
      "45120": {
        "HACIENDA DE LAS LOMAS": true,
        "JUAN MANUEL VALLARTA": true,
        "LOS PINOS": true,
        "RINCONADA SANTA RITA": true,
        "UNIDAD MÉXICO": true,
        "VIGUSA": true,
        "VILLAS DE SAN JAVIER": true
      },
      "45128": {
        "LA FAVORITA": true,
        "LOMAS ALTAS": true
      },
      "45129": {
        "LOMA REAL": true,
        "LOMAS DEL VALLE": true,
        "LOS PALOMOS": true
      },
      "45130": {
        "ALTAGRACIA": true,
        "ARCOS DE ZAPOPAN 1A. SECCIÓN": true,
        "ARCOS DE ZAPOPAN 2A. SECCIÓN": true,
        "ARÁNDANOS CAÑADA RESIDENCIAL": true,
        "BOSQUE VALDEPEÑAS": true,
        "BOSQUES DE ZAPOPAN": true,
        "CASA GRANDE": true,
        "CAÑADAS DE SAN LORENZO": true,
        "COLINAS DEL REY": true,
        "FRANCISCO VILLA": true,
        "HACIENDA DEL SOL": true,
        "LOMAS DE ZAPOPAN": true,
        "MIRADOR DE SAN ISIDRO": true,
        "PUNTA VALDEPEÑAS 1": true,
        "PUNTA VALDEPEÑAS 2": true,
        "REAL DE VALDEPEÑAS": true,
        "REAL DEL BOSQUE": true,
        "REAL DEL CAMICHIN": true,
        "RINCONADAS DE LAS PALMAS": true,
        "SAN FRANCISCO": true,
        "VILLAS DE TORREMOLINOS": true,
        "ZAPOPAN INDUSTRIAL NORTE": true
      },
      "45134": {
        "LA MORALEJA": true
      },
      "45136": {
        "ABADÍA": true,
        "JARDÍN REAL": true,
        "LA CEIBA": true,
        "LA TOSCANA": true,
        "LAS LOMAS CLUB GOLF": true,
        "LOS GIRASOLES": true,
        "LUGANO": true,
        "NOVATERRA": true,
        "PARQUE REAL": true,
        "PUERTA DEL VALLE": true,
        "PUERTA REAL": true,
        "REAL DEL CARMEN": true,
        "REAL DEL CARMEN GRAND": true,
        "RESIDENCIAL DEL VALLE": true,
        "RESIDENCIAL PONIENTE": true,
        "RINCONADAS DEL VALLE": true
      },
      "45138": {
        "ARMONÍA HÁBITAT": true,
        "BASE AÉREA MILITAR NO. 5": true,
        "COLEGIO DEL AIRE": true,
        "EL FRESNO": true,
        "EL OLIVO": true,
        "EL REAL": true,
        "EL SECRETO": true,
        "EL TRIÁNGULO": true,
        "EX HACIENDA DE LA MORA": true,
        "FLORES DEL VALLE": true,
        "GIRASOLES ACUEDUCTO": true,
        "GIRASOLES ELITE": true,
        "HOGARES DE NUEVO MÉXICO": true,
        "HÉROES NACIONALES": true,
        "JARDINES DE NUEVO MÉXICO": true,
        "JARDINES DE SANTA MARGARITA": true,
        "JARDINES DEL VALLE": true,
        "JARDINES SAN FRANCISCO": true,
        "LA CASITA": true,
        "LA NORIA RESIDENCIAL": true,
        "LA TUZANIA": true,
        "LAS BÓVEDAS": true,
        "LOS MANDARINOS": true,
        "LUCERO DEL VALLE": true,
        "LUIS DONALDO COLOSIO": true,
        "MISIÓN DEL VALLE": true,
        "MISIÓN DEL VALLE II": true,
        "MISIÓN JARDINES": true,
        "NUEVO MÉXICO": true,
        "PACÍFICA HABITAT": true,
        "PARQUES DE ZAPOPAN": true,
        "PRADERAS DE SAN ANTONIO": true,
        "PUERTA LAUREL": true,
        "RESIDENCIAL SANTA FE": true,
        "RINCONADA DE LOS FRESNOS": true,
        "RINCONADA DEL AIRE": true,
        "RINCONADAS DE ZAPOPAN": true,
        "SANTA MARGARITA RESIDENCIAL": true,
        "V REGIÓN MILITAR": true,
        "VALLE ESMERALDA": true,
        "VILLAS DE NUEVO MÉXICO": true,
        "VIVEROS DEL VALLE": true
      },
      "45140": {
        "EL VIGÍA": true,
        "LA LOMA": true,
        "RESIDENCIAL LOS FRAILES": true,
        "SAN FRANCISCO": true,
        "SAN JOSÉ DEL BAJÍO": true,
        "SANTA MARGARITA": true,
        "U.A.G.": true,
        "UNIDAD ABASTOS BELENES": true
      },
      "45145": {
        "BELENES NORTE": true
      },
      "45146": {
        "UNIDAD REPÚBLICA": true
      },
      "45147": {
        "SAN ISIDRO EJIDAL": true
      },
      "45148": {
        "LA ARBOLEDA": true
      },
      "45149": {
        "UNIDAD FOVISSSTE": true
      },
      "45150": {
        "ECOLÓGICA SEATTLE": true,
        "EL CAPULLO": true,
        "LA HOJA VERDE": true,
        "LOS MAESTROS": true,
        "SAN MIGUEL DE LA CAÑADA": true,
        "SEATTLE": true,
        "TEPEYAC": true
      },
      "45157": {
        "EL PARAÍSO": true,
        "INDUSTRIAL LOS BELENES": true,
        "LOS PARAÍSOS": true,
        "RINCONADA LOPEZ COTILLA": true,
        "VILLA DE LOS BELENES": true
      },
      "45158": {
        "AVES DEL PARAÍSO": true,
        "CONJUNTO ZAPOPAN": true,
        "LOS ABETOS": true,
        "LOS LAURELES": true,
        "PRADOS DE SAN IGNACIO": true,
        "RINCONADA DE LAS AZALEAS": true,
        "SAN GILBERTO": true
      },
      "45159": {
        "LA AURORA": true
      },
      "45160": {
        "AGRARIA": true,
        "ALTAMIRA": true,
        "JACARANDAS": true,
        "PATRIA": true,
        "PATRIA RAQUET": true,
        "PATRIA ZOQUIPAN": true,
        "PLAZA PATRIA": true,
        "RESIDENCIAL PATRIA": true,
        "SAN MIGUEL DE LA COLINA": true,
        "VILLA SAN JORGE": true,
        "VILLAS DEL BOSQUE": true
      },
      "45167": {
        "LOMA BLANCA": true
      },
      "45168": {
        "SANTA FÉ": true
      },
      "45169": {
        "LINDAVISTA": true,
        "VILLA CORAL": true,
        "VILLA MAGNA": true,
        "VILLA PALMAS": true
      },
      "45170": {
        "COLINAS DE ATEMAJAC": true,
        "CONJUNTO SEATTLE": true,
        "EJIDO DE ZOQUIAPAN": true,
        "GVSA": true,
        "ZOQUIPAN": true
      },
      "45176": {
        "LOMAS DEL CAMINO": true,
        "UNIDAD PATRIA": true
      },
      "45177": {
        "LAGOS DEL COUNTRY": true
      },
      "45178": {
        "LOMAS DE ATEMAJAC": true
      },
      "45179": {
        "SANTA PAULA": true
      },
      "45180": {
        "27 DE SEPTIEMBRE": true,
        "BOSQUE ESCONDIDO": true,
        "COLINAS DE LOS BELENES": true,
        "CONSTITUCIÓN": true,
        "CUCEA UNIVERSIDAD DE GUADALAJARA": true,
        "DEL FEDERALISMO": true,
        "DIVISIÓN DEL NORTE": true,
        "HACIENDA SAN JOAQUÍN": true,
        "HOGAR DE ATEMAJAC": true,
        "JARDINES DE LA CANTERA": true,
        "JARDINES DE LA ESPERANZA": true,
        "JARDINES DEL AUDITORIO": true,
        "JARDINES DEL PORVENIR": true,
        "JARDINES DEL VERGEL": true,
        "JARDINES SEATTLE UNIDAD": true,
        "JOSÉ LÓPEZ PORTILLO": true,
        "LA GRANA": true,
        "LA HUERTA": true,
        "LA JOYA": true,
        "LA PALMITA": true,
        "LAS CABAÑITAS": true,
        "LAS FUENTES": true,
        "LOS CERRITOS": true,
        "NUEVO VERGEL": true,
        "PARQUES DEL AUDITORIO": true,
        "PEDRO MORENO": true,
        "QUINTA DEL FEDERALISMO": true,
        "RINCONADA AUDITORIO": true,
        "RINCONADA SAN ISIDRO": true,
        "UNIDAD AUDITORIO 1A. SECC.": true,
        "UNIDAD AUDITORIO 2A SECC": true,
        "VENUSTIANO CARRANZA": true,
        "VILLAS DEL MARQUES": true
      },
      "45184": {
        "CONSTITUYENTES": true,
        "HERMENEGILDO GALEANA": true
      },
      "45190": {
        "ATEMAJAC DEL VALLE": true,
        "AZALEAS DEL VALLE": true,
        "CONJUNTO RITZ": true,
        "EL BATÁN": true,
        "EL CARRIZAL": true,
        "GONZALEZ ORTEGA": true,
        "HOGARES": true,
        "INDÍGENA DE MEZQUITAN": true,
        "JARDINES DE LOS BELENES": true,
        "LAS PALOMAS": true,
        "LOMAS DEL BATAN": true,
        "LOS CANTEROS": true,
        "VICTOR HUGO": true,
        "VILLA ATEMAJAC": true,
        "VILLAS ALCALDE": true
      },
      "45230": {
        "JARDINES DE SANTA ANA": true,
        "LA HACIENDITA": true,
        "SANTA ANA TEPETITLÁN": true
      },
      "45234": {
        "EL CAMPANARIO": true,
        "LA FLORIDA": true,
        "LA PALMIRA": true,
        "LOS CAJETES": true
      },
      "45235": {
        "AGUA BLANCA": true,
        "AGUA BLANCA INDUSTRIAL": true,
        "AGUA BLANCA SUR": true,
        "EL MANTE": true
      },
      "45236": {
        "AGRÍCOLA": true,
        "ARBOLEDAS RESIDENCIAL": true,
        "EL BRICEÑO": true,
        "EL GARABATO": true,
        "FRANCISCO SARABIA": true,
        "JARDINES DE IXTEPETE": true,
        "LOS MIRASOLES": true,
        "PASEOS DEL BRICEÑO": true,
        "VILLAS DEL IXTEPETE": true,
        "VILLAS PERISUR": true
      },
      "45237": {
        "BUGAMBILIAS COUNTRY": true,
        "CIUDAD BUGAMBILIA": true,
        "CRISTAL": true,
        "RESIDENCIAL EL BOSQUE": true,
        "VISTAS DEL SOL": true
      },
      "45238": {
        "BUGAMBILIAS": true,
        "LA LOMA": true
      },
      "45239": {
        "AZALEAS RESIDENCIAL": true,
        "COTO LA JOYA": true,
        "HACIENDA JACARANDAS": true,
        "LOS PINOS CAMPESTRE": true,
        "MIGUEL DE LA MADRID HURTADO": true,
        "PARAÍSO LOS PINOS": true,
        "RINCONADA DEL IRIS": true,
        "VALLE DE BUGAMBILIAS": true,
        "VILLA SERENA": true,
        "VILLAS ESMERALDA": true,
        "ÉBANO": true
      }
    }
  },
  "MÉXICO": {
    "ALMOLOYA DE JUÁREZ": {
      "50900": {
        "ALMOLOYA DE JUÁREZ CENTRO": true
      },
      "50903": {
        "MINA MÉXICO": true
      },
      "50904": {
        "CERESO ALMOLOYA": true
      },
      "50906": {
        "SAN MIGUEL ALMOLOYÁN": true
      },
      "50907": {
        "SAN PEDRO DE LA HORTALIZA (EJIDO ALMOLOYÁN)": true
      },
      "50910": {
        "BENITO JUÁREZ": true
      },
      "50920": {
        "CONJUNTO URBANO RANCHO SAN JUAN": true
      },
      "50924": {
        "CIENEGUILLAS DE MAÑONES": true
      },
      "50925": {
        "LOMA DEL SALITRE": true
      },
      "50926": {
        "CASA NUEVA (CASA NUEVA YEBUCIVÍ)": true
      },
      "50927": {
        "OCOYOTEPEC (OCOYOTEPEC CENTRO)": true
      },
      "50930": {
        "LA TINAJA": true
      },
      "50933": {
        "CIENEGUILLAS DE GUADALUPE": true
      },
      "50934": {
        "EJIDO SAN DIEGO": true
      },
      "50935": {
        "LOMA BLANCA": true
      },
      "50940": {
        "SAN FRANCISCO TLALCILALCALPAN": true
      },
      "50943": {
        "COLINAS DE SAN FRANCISCO": true
      },
      "50944": {
        "LA LIMA": true
      },
      "50945": {
        "SAN NICOLÁS AMEALCO": true
      },
      "50946": {
        "SAN AGUSTÍN POTEJE CENTRO": true
      }
    },
    "ATIZAPÁN": {
      "52500": {
        "LIBERTAD": true
      },
      "52503": {
        "MAGISTERIAL": true
      },
      "52504": {
        "TEPOZOCO": true
      },
      "52505": {
        "EL TEPIOLOLCO": true
      },
      "52506": {
        "LA REMOLACHA": true
      }
    },
    "ATIZAPÁN DE ZARAGOZA": {
      "52900": {
        "CIUDAD ADOLFO LÓPEZ MATEOS": true
      },
      "52910": {
        "ADOLFO LÓPEZ MATEOS": true,
        "ADOLFO LÓPEZ MATEOS AMPLIACIÓN I": true,
        "ADOLFO LÓPEZ MATEOS AMPLIACIÓN II": true,
        "EX HACIENDA DEL PEDREGAL": true,
        "HOGARES DE ATIZAPÁN": true,
        "LOS ÁLAMOS": true,
        "PRIMERO DE SEPTIEMBRE": true,
        "REAL DEL PEDREGAL": true,
        "RESIDENCIAL SAN MATEO": true
      },
      "52915": {
        "ATIZAPÁN 2000": true,
        "EL CAPULÍN": true,
        "EL MIRADOR": true,
        "JOSÉ MARÍA MORELOS Y PAVÓN": true,
        "LA NUEVA ERA": true,
        "MÉXICO 86": true,
        "VILLA DE LAS TORRES": true
      },
      "52916": {
        "EL TÚNEL (SECCIÓN)": true,
        "LOMA DE MARÍA LUISA": true,
        "LOS OLIVOS": true
      },
      "52918": {
        "AMPLIACIÓN EMILIANO ZAPATA I": true,
        "AMPLIACIÓN EMILIANO ZAPATA II": true,
        "EMILIANO ZAPATA": true,
        "EX-HACIENDA EL PEDREGAL": true,
        "HACIENDA DEL PEDREGAL": true,
        "LOMAS DE LAS TORRES": true,
        "LOMAS DE MONTE MARÍA": true,
        "MIRAFLORES": true,
        "SAGITARIO II": true,
        "VILLA DE LAS PALMAS": true,
        "VILLA DE LAS PALMAS AMPLIACIÓN": true
      },
      "52919": {
        "BOSQUES DE IXTACALA": true,
        "BOSQUES DE PRIMAVERA": true,
        "REVOLUCIÓN": true,
        "UNIVERSIDAD AUTÓNOMA METROPOLITANA": true
      },
      "52920": {
        "AMPLIACIÓN PEÑITAS": true,
        "CERRO GRANDE": true,
        "PEÑITAS": true,
        "SAN ANTONIO POCITOS": true,
        "SAN MATEO TECOLOAPAN": true
      },
      "52923": {
        "VILLA JARDÍN": true
      },
      "52924": {
        "SAN JOSÉ EL JARAL": true,
        "SAN JOSÉ EL JARAL I": true
      },
      "52925": {
        "LOMAS DE LA HACIENDA": true
      },
      "52926": {
        "JARDINES DE MONTERREY": true,
        "MARGARITA MAZA DE JUÁREZ": true,
        "VILLA SAN JOSÉ": true
      },
      "52927": {
        "EL CERRITO": true,
        "SAN MIGUEL XOCHIMANGA": true
      },
      "52928": {
        "CAPULÍN AMPLIACIÓN": true,
        "EJIDOS SAN MIGUEL CHALMA": true,
        "EL CAMPANARIO": true,
        "GENERAL CÁRDENAS DEL RÍO": true,
        "LOMAS DE SAN MIGUEL NORTE": true,
        "LOMAS DE SAN MIGUEL SUR": true,
        "LOMAS DE TEPALCAPA": true,
        "LOMAS DE TEPALCAPA AMPLIACIÓN": true,
        "PRADOS DE IXTACALA I": true,
        "PRADOS DE IXTACALA II": true,
        "SAN JUAN IXTACALA PLANO NORTE": true,
        "SAN JUAN IXTACALA PLANO SUR": true
      },
      "52929": {
        "HACIENDA DE LA LUZ": true,
        "TIERRA DE EN MEDIO": true,
        "VILLAS DE LA HACIENDA": true
      },
      "52930": {
        "BOSQUE ESMERALDA": true,
        "CHILUCA": true,
        "LA ESTADÍA": true,
        "LOMAS DE VALLE ESCONDIDO": true,
        "PLAZAS DEL CONDADO": true,
        "RESIDENCIAL CHILUCA (CLUB DE GOLF CHILUCA)": true
      },
      "52934": {
        "RANCHO BLANCO EJIDO DE ESPÍRITU SANTO": true
      },
      "52936": {
        "PRADO LARGO": true
      },
      "52937": {
        "CLUB DE GOLF VALLESCONDIDO": true,
        "HACIENDA DE VALLE ESCONDIDO": true,
        "VALLE ESCONDIDO": true
      },
      "52938": {
        "CONDADO DE SAYAVEDRA": true,
        "FINCAS DE SAYAVEDRA": true,
        "RANCHO SAN JUAN": true
      },
      "52940": {
        "ALFREDO V. BONFIL": true,
        "AMPLIACIÓN ALFREDO V BONFIL": true,
        "CINCO DE MAYO": true,
        "LUIS DONALDO COLOSIO": true,
        "PROF. CRISTÓBAL HIGUERA": true,
        "PROF. CRISTÓBAL HIGUERA AMPLIACIÓN": true,
        "RINCONADA BONFIL": true
      },
      "52945": {
        "ATIZAPÁN": true,
        "LA EXPLANADA": true,
        "REAL DE ATIZAPÁN": true,
        "RINCONADA DE LAS ARBOLEDAS": true,
        "VERGEL DE ARBOLEDAS": true
      },
      "52946": {
        "SAN JUAN BOSCO": true
      },
      "52947": {
        "LA CIMA": true,
        "LOMAS LINDAS I SECCIÓN": true,
        "LOMAS LINDAS II SECCIÓN": true
      },
      "52948": {
        "BOULEVARES DE ATIZAPÁN": true,
        "CENTRAL DE ABASTOS": true,
        "EL PEDREGAL DE ATIZAPÁN": true,
        "EL RIACHUELO": true
      },
      "52949": {
        "LAS ÁGUILAS": true,
        "SAGITARIO I": true,
        "SEIS DE OCTUBRE": true
      },
      "52950": {
        "LAS ARBOLEDAS": true
      },
      "52953": {
        "AHUEHUETES": true,
        "LAS COLONIAS": true,
        "LAURELES": true,
        "TORRES DE ATIZAPÁN VI": true,
        "TORRES DE ATIZAPÁN VIII": true
      },
      "52957": {
        "CLUB HÍPICO SAN MIGUEL": true,
        "MAYORAZGOS DE LA CONCORDIA": true,
        "MAYORAZGOS DE LOS GIGANTES": true,
        "MAYORAZGOS DEL BOSQUE": true
      },
      "52959": {
        "CLUB DE GOLF HACIENDA": true
      },
      "52960": {
        "BARRIO NORTE": true
      },
      "52965": {
        "LA CONDESA": true
      },
      "52966": {
        "27 DE SEPTIEMBRE": true,
        "MÉXICO NUEVO": true
      },
      "52967": {
        "BOSQUES DE ATIZAPÁN": true,
        "COPORO": true,
        "RINCONADA DE ATIZAPÁN": true,
        "RINCÓN DE LOS BOSQUES": true
      },
      "52968": {
        "FRACCIONAMIENTO INDUSTRIAL EL PEDREGAL": true,
        "ZONA INDUSTRIAL 1 (PROF. CRISTÓBAL HIGUERA)": true,
        "ZONA INDUSTRIAL 2 (MÉXICO NUEVO)": true
      },
      "52970": {
        "LA ERMITA": true,
        "LAS ALAMEDAS": true,
        "SAN JOSÉ": true,
        "VALLE DE MÉXICO": true
      },
      "52975": {
        "EL POTRERO": true,
        "LOMAS DE SAN LORENZO": true,
        "LOMAS DE SAN LORENZO AMPLIACIÓN": true,
        "RINCÓN DE LA MONTAÑA": true
      },
      "52976": {
        "ATIZAPÁN MODERNO": true
      },
      "52977": {
        "14 DE DICIEMBRE": true,
        "LOMAS DE ATIZAPÁN": true,
        "LOMAS DE ATIZAPÁN II": true
      },
      "52978": {
        "JARDINES DE ATIZAPÁN": true,
        "LAS ACACIAS": true
      },
      "52979": {
        "ALBORADA": true,
        "LÁZARO CÁRDENAS": true,
        "PASEOS DE MÉXICO": true
      },
      "52980": {
        "DEMETRIO VALLEJO": true,
        "DEMETRIO VALLEJO AMPLIACIÓN": true,
        "LAS FLORES": true,
        "LOS CAJONES": true,
        "SAN MARTÍN DE PORRES": true,
        "SAN MARTÍN DE PORRES AMPLIACIÓN": true
      },
      "52985": {
        "LA CRUZ": true,
        "LOMAS DE GUADALUPE": true,
        "MORELOS": true,
        "RINCÓN DE LA CHARRERÍA": true
      },
      "52986": {
        "IGNACIO LÓPEZ RAYÓN": true
      },
      "52987": {
        "BOSQUES DE SAN MARTÍN": true,
        "CAPULÍN MONTE SOL": true,
        "CONJUNTO HABITACIONAL VILLA SOL": true,
        "EX EJIDO EL MOSCO": true,
        "LA CAÑADA": true,
        "LOMAS DE CAPISTRANO": true
      },
      "52988": {
        "CASITAS CAPISTRANO": true
      },
      "52989": {
        "NUEVO MADÍN": true,
        "RESIDENCIAL LAGO ESMERALDA": true,
        "VIEJO MADÍN": true
      },
      "52990": {
        "CALACOAYA": true,
        "EL CHAPARRAL": true,
        "EL CHAPARRAL AMPLIACIÓN": true
      },
      "52994": {
        "LOMAS DE BELLAVISTA": true
      },
      "52995": {
        "CLUB DE GOLF BELLAVISTA": true
      },
      "52996": {
        "CALACOAYA RESIDENCIAL": true,
        "CONJUNTO TAXCO": true,
        "EXPLANADA CALACOAYA": true,
        "ISSEMYM": true,
        "PRIVADA DE LAS ARBOLEDAS": true,
        "PRIVADA LAS HUERTAS": true,
        "RINCÓN COLONIAL": true
      },
      "52997": {
        "CINCO DE MAYO": true,
        "EL CALVARIO": true
      },
      "52998": {
        "FUENTES DE SATÉLITE": true,
        "FUENTES DEL SOL": true,
        "MISIÓN DE LA PRESA": true,
        "RANCHO CASTRO": true
      }
    },
    "CALIMAYA": {
      "52200": {
        "CALIMAYA DE DÍAZ GONZÁLEZ": true
      },
      "52203": {
        "LOS ÁNGELES": true
      },
      "52204": {
        "CRUZ VERDE": true
      },
      "52205": {
        "SAUCES": true
      },
      "52210": {
        "ZARAGOZA DE GUADALUPE": true
      },
      "52213": {
        "SAN DIEGO LA HUERTA": true
      },
      "52214": {
        "LA LOMA": true
      },
      "52215": {
        "LAS JARILLAS": true
      },
      "52220": {
        "SAN ANDRÉS OCOTLÁN": true
      },
      "52223": {
        "SAN BARTOLITO TLALTELOLCO": true
      },
      "52224": {
        "LA CONCEPCIÓN COATIPAC (LA CONCHITA)": true
      },
      "52225": {
        "ARBOLEDAS (SAN ANDRÉS)": true
      },
      "52226": {
        "BOSQUE DE LAS FUENTES RESIDENCIAL": true
      },
      "52227": {
        "LOMAS VIRREYES": true
      },
      "52230": {
        "SANTA MARÍA NATIVITAS": true
      },
      "52233": {
        "SAN LORENZO CUAUHTENCO": true
      },
      "52234": {
        "SAN MARCOS DE LA CRUZ": true
      },
      "52235": {
        "SAN CRISTÓBAL": true
      },
      "52236": {
        "EL TARIMORO": true
      }
    },
    "CHALCO": {
      "56600": {
        "BOSQUES DE CHALCO I": true
      },
      "56604": {
        "EJIDAL": true
      },
      "56605": {
        "NUEVA SAN ISIDRO": true
      },
      "56606": {
        "UNIÓN DE GUADALUPE": true
      },
      "56607": {
        "COVADONGA": true
      },
      "56608": {
        "EMILIANO ZAPATA": true
      },
      "56609": {
        "SANTA CRUZ AMALINALCO": true
      },
      "56620": {
        "SAN JOSÉ AXALCO": true
      },
      "56623": {
        "RANCHO SAN MIGUEL": true
      },
      "56624": {
        "PEDREGAL TEZOMPA": true
      },
      "56625": {
        "RESIDENCIAL IZTAC": true
      },
      "56640": {
        "SAN GREGORIO CUAUTZINGO": true
      },
      "56641": {
        "BENITO JUÁREZ": true
      },
      "56642": {
        "SAN LUCAS AMALINALCO": true
      },
      "56643": {
        "EJIDO SAN MARCOS": true
      },
      "56644": {
        "LOS HÉROES CHALCO II": true
      },
      "56646": {
        "GUADALUPE DE LOS TEPETATES": true
      },
      "56647": {
        "SAN MATEO TEZOQUIPAN MIRAFLORES": true
      }
    },
    "CHAPULTEPEC": {
      "52240": {
        "CHAPULTEPEC": true
      },
      "52243": {
        "LAS AMÉRICAS": true
      },
      "52244": {
        "SANTA TERESA": true
      },
      "52250": {
        "LA PRESA (EJIDO DE CHAPULTEPEC)": true
      },
      "52254": {
        "LOS CIRUELOS (RANCHO EL IRIS)": true
      }
    },
    "CHICOLOAPAN": {
      "56370": {
        "SAN VICENTE CHICOLOAPAN DE JUÁREZ CENTRO": true
      },
      "56373": {
        "EL ENCINO": true
      },
      "56375": {
        "EL VERGEL": true,
        "HACIENDA PIEDRAS NEGRAS": true,
        "PRESIDENTES": true
      },
      "56376": {
        "SANTA ROSA": true
      },
      "56377": {
        "SAN JOSÉ": true
      },
      "56380": {
        "REAL DE SAN VICENTE I": true
      },
      "56383": {
        "LOMAS DE CHICOLOAPAN III": true
      },
      "56384": {
        "LOMA SAN PEDRO": true
      },
      "56386": {
        "RANCHO SAN MIGUEL": true
      },
      "56390": {
        "EJÉRCITO DEL TRABAJO": true,
        "EMILIANO ZAPATA": true,
        "FRANCISCO VILLA": true,
        "REVOLUCIÓN": true
      },
      "56395": {
        "MIRADOR TEZALUCA": true
      },
      "56396": {
        "POZO NÚMERO UNO (LA TRINIDAD)": true
      }
    },
    "CHIMALHUACÁN": {
      "56330": {
        "SANTA MARÍA CHIMALHUACÁN": true
      },
      "56334": {
        "ARTESANOS": true,
        "CANASTEROS": true,
        "CARPINTEROS": true,
        "EL MOLINO": true,
        "FUNDIDORES": true,
        "HERREROS": true,
        "LUIS CÓRDOBA REYES": true,
        "MARCO ANTONIO SOSA": true,
        "MELCHOR OCAMPO": true,
        "MINEROS": true,
        "NUEVA TEPALCATES": true,
        "PESCADORES": true,
        "SAN PABLO": true,
        "SAN PABLO PARTE BAJA": true,
        "SAN PEDRO": true,
        "SAN PEDRO PARTE BAJA": true,
        "TEPALCATE": true
      },
      "56335": {
        "4 DE FEBRERO": true,
        "ACUITLAPILCO PRIMERA SECCIÓN": true,
        "ACUITLAPILCO SEGUNDA SECCIÓN": true,
        "ACUITLAPILCO TERCERA SECCIÓN": true,
        "APAPASCO": true,
        "ARBOLEDAS": true,
        "CIUDAD ALEGRE": true,
        "CONSTRUCTORES": true,
        "CORTE PORTEZUELOS": true,
        "CUATRO DE FEBRERO": true,
        "EL LLANO DE SANTA MARÍA": true,
        "GUADALUPE": true,
        "JARDINES DE ACUITLAPILCO": true,
        "JOSÉ MARÍA LUIS MORA": true,
        "LOMAS DE SANTA MARÍA": true,
        "LUIS DONALDO COLOSIO": true,
        "PRIMAVERA": true,
        "RANCHO DE LAS NIEVES": true,
        "SAN MIGUEL": true,
        "SAN MIGUEL ACUITLAPILCO": true,
        "SANTA MARÍA NATIVITAS": true,
        "UNIÓN ANTORCHISTA": true
      },
      "56337": {
        "APELSA": true,
        "ARENITAS": true,
        "COPALERA": true,
        "CORNEJAL": true,
        "EL CAPULÍN": true,
        "EL POCITO": true,
        "LA LADERA": true,
        "LA MINA": true,
        "LADERA": true,
        "LOMAS DE CHIMALHUACÁN": true,
        "LOMAS DE TOTOLCO": true,
        "LOMAS DE TOTOLCO TLATELCO": true,
        "OLMEDO": true,
        "SAN ANDRÉS": true,
        "SAN ISIDRO": true,
        "SAN JUAN ZAPOTLA": true,
        "SANTO DOMINGO": true,
        "TEPENEPANTLA": true,
        "TLAIXCO": true,
        "ZAPOTLA": true
      },
      "56338": {
        "CORTE EL POCITO": true
      },
      "56340": {
        "AMPLIACIÓN SAN LORENZO (PARTE ALTA)": true,
        "CERRO DE LAS PALOMAS": true,
        "SAN LORENZO": true,
        "SAN LORENZO CHIMALCO": true,
        "SAN LORENZO PARTE ALTA": true
      },
      "56343": {
        "ADOLFO LÓPEZ MATEOS": true,
        "AMPLIACIÓN SAN AGUSTÍN": true,
        "AMPLIACIÓN SAN AGUSTÍN ZONA ORIENTE": true,
        "AMPLIACIÓN SAN AGUSTÍN ZONA PONIENTE": true,
        "BALCONES DE SAN AGUSTÍN": true,
        "BUENOS AIRES": true,
        "DIECISIETE DE MARZO": true,
        "ISRAEL": true,
        "JARDINES DE SAN AGUSTÍN (LA ISLA, SANCHO GANADERO)": true,
        "LOS OLIVOS": true,
        "MIRAMAR": true,
        "SAN JOSÉ BUENAVISTA": true,
        "SUTAUR ORIENTE": true,
        "TEQUESQUINÁHUAC": true,
        "TIERRA SANTA (MARAVILLAS)": true,
        "VILLA SAN AGUSTÍN ATLAPULCO": true,
        "ZONA COMUNAL SAN AGUSTÍN": true
      },
      "56344": {
        "EJIDO SAN AGUSTÍN ATLAPULCO": true,
        "VILLA LOS COLORINES": true
      },
      "56346": {
        "FILIBERTO GÓMEZ": true,
        "PROGRESO DE ORIENTE": true,
        "XALTIPAC": true
      },
      "56350": {
        "AMPLIACIÓN XOCHIACA PARTE ALTA": true,
        "DIECISIETE DE SEPTIEMBRE": true,
        "DIECISÉIS DE SEPTIEMBRE": true,
        "LA JOYITA": true,
        "SANTA CECILIA": true,
        "SANTA CECILIA XOCHIACA": true,
        "XOCHIACA": true,
        "XOCHIACA 2A SECCIÓN": true,
        "XOCHITENCO 3A SECCIÓN": true,
        "XOCHITENCO PARTE ALTA": true
      },
      "56353": {
        "ARTURO MONTIEL": true,
        "ORFEBRES": true,
        "SARAPEROS": true,
        "TLATELCO": true
      },
      "56356": {
        "CANTEROS": true,
        "JUGUETEROS": true,
        "NUEVA SANTA CRUZ": true,
        "PLATEROS": true,
        "SANTA CRUZ": true,
        "TALABARTEROS": true,
        "TEJEDORES": true,
        "VIDRIEROS": true
      },
      "56360": {
        "SAN JUAN XOCHITENCO": true,
        "XOCHITENCO 1A SECCIÓN": true,
        "XOCHITENCO 2A SECCIÓN": true
      },
      "56363": {
        "ALFAREROS": true,
        "EBANISTAS": true,
        "LA ROSITA": true,
        "NIÑOS HÉROES": true,
        "NUEVA MARGARITA": true,
        "TRANSPORTISTAS": true
      },
      "56366": {
        "CESTEROS": true,
        "CURTIDORES": true,
        "HOJALATEROS": true,
        "LABRADORES": true,
        "TALLADORES": true,
        "TLATEL XOCHITENCO": true
      }
    },
    "COACALCO DE BERRIOZÁBAL": {
      "55700": {
        "BONITO COACALCO": true,
        "BONITO COACALCO I (LA CRUZ)": true,
        "CHABACANO": true,
        "COLONIAL COACALCO": true,
        "CONJUNTO SALAMANCA": true,
        "EL LAUREL (EL GIGANTE)": true,
        "EL TOLOACHE": true,
        "EL VERGEL": true,
        "FUENTES DE SAN FRANCISCO": true,
        "HACIENDA CRUZTITLA I": true,
        "HACIENDA CRUZTITLA II": true,
        "HACIENDA LAS GARZAS": true,
        "LA CUALAC": true,
        "LAS HIEDRAS": true,
        "PARQUE TAXCO VIEJO": true,
        "PRIVADAS COACALCO": true,
        "REAL DE COACALCO": true,
        "RESIDENCIAL BONITO LA LOMA II": true,
        "RESIDENCIAL HACIENDA CAPULTITLA": true,
        "RESIDENCIAL PARAÍSO I": true,
        "RESIDENCIAL PARAÍSO II": true,
        "RESIDENCIAL SANTANDER": true,
        "RESIDENCIAL SIRAPARK": true,
        "RINCÓN COLONIAL COACALCO": true,
        "SAN FRANCISCO COACALCO": true,
        "VILLA FLORENCIA": true,
        "ZACUAUTITLA": true
      },
      "55705": {
        "REPÚBLICA MEXICANA": true
      },
      "55707": {
        "CALPULLI DEL VALLE": true,
        "EJIDAL CANUTO LUNA": true,
        "EL OBELISCO": true,
        "EX-RANCHO SAN FELIPE": true,
        "LA CIMA": true,
        "LOMAS SAN FELIPE": true
      },
      "55708": {
        "HIDALGO": true
      },
      "55709": {
        "CONJUNTO SAN DIEGO": true,
        "COOR COACALCO": true,
        "EL GIGANTE": true,
        "VILLAS GIGANTE": true
      },
      "55710": {
        "ARCOS LAS TORRES": true,
        "LAS ROSAS": true,
        "RANCHO LA PROVIDENCIA": true,
        "RESIDENCIAL LAS DALIAS I,II,III Y IV": true,
        "SECCIÓN JARDÍN \"LAS PLAZAS\" (UNIDAD COACALCO)": true,
        "VILLA DE LAS FLORES 1A SECCIÓN (UNIDAD COACALCO)": true,
        "VILLA DE LAS FLORES 2A SECCIÓN (UNIDAD COACALCO)": true
      },
      "55712": {
        "DALIAS": true,
        "LOS HÉROES COACALCO": true,
        "SAN FRANCISCO COACALCO (SECCIÓN HACIENDA)": true
      },
      "55713": {
        "AMPLIACIÓN VILLA DE REYES": true,
        "LA FLORESTA": true,
        "RINCONADA COACALCO": true,
        "RINCÓN DE LAS FUENTES": true,
        "VILLA DE REYES": true
      },
      "55714": {
        "HACIENDA SAN PABLO": true,
        "LOS ALMENDROS": true,
        "LOS OLIVOS": true,
        "NIÑOS HÉROES": true,
        "POTRERO II": true,
        "RESIDENCIAL PLAZA COACALCO": true,
        "RINCÓN COAHUILENSE": true,
        "SAN LORENZO TETLIXTAC": true,
        "TETLACOLILI": true
      },
      "55715": {
        "LOS SABINOS II": true,
        "SANTA MARÍA MAGDALENA HUIZACHITLA": true
      },
      "55716": {
        "JARDINES DE SAN JOSÉ 1A SECC": true,
        "JARDINES DE SAN JOSÉ 2A SECC": true,
        "SECCIÓN LAS VILLAS (UNIDAD COACALCO)": true
      },
      "55717": {
        "BOSQUES DEL VALLE 1A SECCIÓN": true,
        "BOSQUES DEL VALLE 2A SECCIÓN": true,
        "EL CHAPARRAL": true,
        "EL LAUREL": true,
        "EX-HACIENDA SAN FELIPE 1A. SECCIÓN": true,
        "EX-HACIENDA SAN FELIPE 2A. SECCIÓN": true,
        "EX-HACIENDA SAN FELIPE 3A. SECCIÓN": true,
        "LAS BUGAMBILIAS": true,
        "LOS PORTALES ORIENTE": true,
        "LOS PORTALES PONIENTE": true,
        "PERIODISTAS REVOLUCIONARIOS": true,
        "RANCHO LA PALMA 1A SECCIÓN": true,
        "RANCHO LA PALMA 2A SECCIÓN": true,
        "RANCHO LA PALMA 3A SECCIÓN": true,
        "RANCHO LA PALMA 4A. SECCIÓN": true
      },
      "55718": {
        "JOSÉ MARÍA MORELOS Y PAVÓN": true,
        "JOYAS DE COACALCO": true,
        "LA GUADALUPANA": true,
        "LAS GARZAS": true,
        "LOS CEDROS I Y II": true,
        "PARQUE INDUSTRIAL ZI-1 Y ZI-2": true,
        "POTRERO I": true,
        "POTRERO LA LAGUNA 1A SECCIÓN": true,
        "POTRERO LA LAGUNA 2A SECCIÓN": true,
        "POTRERO POPULAR I": true,
        "POTRERO POPULAR II": true,
        "PRIVADA LAS GARZAS": true,
        "SANTA MARÍA II": true,
        "SANTA MARÍA III": true
      },
      "55719": {
        "EL PANTANO": true,
        "PLAZA LAS FLORES": true,
        "RINCONADA SAN FELIPE I": true,
        "RINCONADA SAN FELIPE II": true,
        "SAN RAFAEL COACALCO": true,
        "SANTA MARÍA I": true
      },
      "55720": {
        "PARQUE RESIDENCIAL COACALCO 1A SECCIÓN": true,
        "PARQUE RESIDENCIAL COACALCO 2A SECCIÓN": true,
        "PARQUE RESIDENCIAL COACALCO 3A SECCIÓN": true
      },
      "55726": {
        "GRANJAS SAN CRISTÓBAL": true,
        "HACIENDA DEL TERUEL": true,
        "LA VISTA": true,
        "STAR I": true,
        "STAR II": true,
        "VALLE FLORIDO": true,
        "VILLA FLORIDA": true
      },
      "55728": {
        "CAMINO REAL (IMEVIS)": true,
        "COOR GRANJAS": true,
        "EL GRANERO": true,
        "EL OASIS": true,
        "LAS BRISAS": true
      },
      "55729": {
        "LOS SABINOS I": true,
        "SITATYR": true
      },
      "55730": {
        "VILLA LAS MANZANAS": true
      },
      "55736": {
        "BASURERO MUNICIPAL (LA AURORA)": true,
        "LOMAS DE COACALCO 1A. SECCIÓN": true,
        "LOMAS DE COACALCO 2A. SECCIÓN (BOSQUES)": true
      },
      "55737": {
        "JALATLACO": true,
        "MEDITERRANEO": true
      },
      "55738": {
        "ARTE Y PUBLICIDAD MIGUEL HIDALGO": true,
        "ASOCIACIÓN DE COMERCIANTES DE COACALCO": true,
        "EL RANCHITO (IMEVIS)": true,
        "HACIENDA TAXCO VIEJO": true,
        "LOMA BONITA": true,
        "XALATLACO (IMEVIS)": true
      },
      "55739": {
        "LOS ACUALES": true
      }
    },
    "COYOTEPEC": {
      "54660": {
        "COYOTEPEC": true
      },
      "54665": {
        "CALTENCO": true,
        "EL GAVILLERO (BARRIO CALTENCO)": true,
        "LA PLANADA": true,
        "LA RENDA": true,
        "REYES": true,
        "SANTA BÁRBARA": true
      },
      "54666": {
        "CIMAPAN": true,
        "IXTAPACALCO": true,
        "SAN FRANCISCO": true
      },
      "54667": {
        "ACOACALCO": true,
        "CHAUTONCO": true,
        "LA BOLSA": true,
        "SANTIAGO": true
      },
      "54668": {
        "LOMAS DE GUADALUPE": true,
        "PUEBLO NUEVO": true,
        "SAN JUAN": true
      }
    },
    "CUAUTITLÁN": {
      "54800": {
        "CUAUTITLÁN CENTRO": true,
        "EL NOPALITO": true,
        "LOS MORALES 1A SECCIÓN": true,
        "MISIONES II": true,
        "PASEO DE SANTA MARÍA": true,
        "ROMITA": true,
        "SAN JUAN": true
      },
      "54803": {
        "HACIENDA DE CUAUTITLÁN": true,
        "JOYAS DE CUAUTITLÁN": true,
        "LA ALBORADA": true
      },
      "54804": {
        "TECOAC-MONALES": true
      },
      "54805": {
        "EJIDOS DE GUADALUPE": true
      },
      "54807": {
        "EL HUERTO": true,
        "PASEOS DE CUAUTITLÁN": true,
        "SAN FRANCISCO CASCANTITLA": true
      },
      "54830": {
        "EL MACHERO": true,
        "LA ARBOLEDA": true,
        "PARQUE SAN MATEO (HACIENDA SAN MATEO)": true
      },
      "54831": {
        "EL MIRADOR": true,
        "MACOLO": true,
        "SANTA BÁRBARA": true,
        "SANTA MARÍA HUECATITLA": true
      },
      "54834": {
        "SAN JOSÉ PUENTE GRANDE": true
      },
      "54835": {
        "VENECIA": true
      },
      "54836": {
        "EL MECATE": true
      },
      "54840": {
        "DOS RÍOS SEGUNDA SECCIÓN": true,
        "EL CARMEN": true,
        "GALAXIA CUAUTITLÁN": true,
        "JUAN DIEGO": true,
        "LA GUADALUPANA": true,
        "LA LAGUNA": true,
        "LA TOSCANA": true,
        "LOS MORALES 2A SECCIÓN": true,
        "SAN MATEO IXTACALCO": true,
        "SAN ROQUE": true,
        "VILLAS XALTIPA": true
      },
      "54850": {
        "DOS RÍOS PRIMERA SECCIÓN": true,
        "EL TEJOCOTE": true,
        "LA TRINIDAD": true,
        "PASEOS DEL BOSQUE": true,
        "RANCHO SANTA ELENA": true,
        "REAL DE SAN FERNANDO": true,
        "VILLAS XALTIPA II": true
      },
      "54855": {
        "TIZOC": true
      },
      "54857": {
        "VILLAS DE CUAUTITLÁN": true,
        "VILLAS OLIVO": true
      },
      "54858": {
        "CEBADALES PRIMERA SECCIÓN": true
      },
      "54860": {
        "SAN MATEO IXTACALCO FRACCIÓN TLAXCULPAS": true
      },
      "54870": {
        "EL PARAÍSO": true,
        "LÁZARO CÁRDENAS": true,
        "MISIONES I": true,
        "RANCHO SAN BLAS": true,
        "SAN BLAS I": true,
        "SAN BLAS II": true,
        "SAN JOSÉ MILLA": true,
        "SANTA ANA TLALTEPAN": true
      },
      "54875": {
        "CRISTAL": true,
        "FORESTA RESIDENCIAL": true,
        "LAS PATRICIAS I Y II": true,
        "LOS OLIVOS": true,
        "MAYORAZGOS": true
      },
      "54877": {
        "EL PARAÍSO FOVISSSTE": true
      },
      "54878": {
        "EL INFIERNILLO": true
      },
      "54879": {
        "EL CERRITO": true,
        "EL PARTIDOR": true,
        "LA PALMA": true,
        "LOMA BONITA": true,
        "NECAPA": true,
        "NUEVA ESPAÑITA": true,
        "PUENTE JABONERO": true,
        "VILLA JARDÍN": true
      }
    },
    "CUAUTITLÁN IZCALLI": {
      "54700": {
        "CUAUTITLÁN IZCALLI CENTRO URBANO": true,
        "ELITE PLAZA": true
      },
      "54710": {
        "BELLAVISTA": true,
        "EJIDO SANTA MARÍA TIANGUISTENGO": true,
        "EJIDO SANTIAGO CUAUTLALPAN": true,
        "EL CERRITO": true,
        "EL ROSARIO": true,
        "LA ERA": true,
        "LAS TINAJAS": true,
        "LOMAS DE LOS ÁNGELES": true,
        "PRADOS DE CUAUTITLÁN": true,
        "SAN JOSÉ BUENAVISTA": true,
        "SAN JOSÉ HUILANGO": true,
        "SAN PABLO DE LOS GALLOS": true,
        "SANTA MARÍA TIANGUISTENGO": true
      },
      "54712": {
        "BOSQUES DE XHALA": true,
        "LAS ÁNIMAS": true,
        "SAN MATEO IXTACALCO FRACCIÓN LA CAPILLA": true
      },
      "54713": {
        "EL SABINO": true,
        "SAN LORENZO RÍO TENCO": true,
        "SAN MATEO IXTACALCO": true,
        "SANTA BÁRBARA": true
      },
      "54714": {
        "EL SOCORRO": true,
        "PARQUE INDUSTRIAL XHALA": true,
        "SAN SEBASTIÁN XHALA": true
      },
      "54715": {
        "ADOLFO LÓPEZ MATEOS": true,
        "ARBOLEDAS DE SAN MIGUEL": true,
        "BOSQUES DE LA HACIENDA 1A SECCIÓN": true,
        "BOSQUES DE LA HACIENDA 2A SECCIÓN": true,
        "BOSQUES DE LA HACIENDA 3A SECCIÓN": true,
        "COFRADÍA DE SAN MIGUEL": true,
        "COFRADÍA II": true,
        "COFRADÍA III": true,
        "COFRADÍA IV": true,
        "EX-HACIENDA SAN MIGUEL": true,
        "JARDINES DE SAN MIGUEL LLL": true,
        "JARDÍNES DE SAN MIGUEL": true,
        "RINCONADA CUAUTITLÁN": true,
        "VALLE DE LA HACIENDA": true
      },
      "54716": {
        "PARQUE INDUSTRIAL LA LUZ": true,
        "RESIDENCIAL LA LUZ": true
      },
      "54719": {
        "AXOTLÁN": true,
        "CLAUSTROS DE SAN MIGUEL": true,
        "PASEOS DE IZCALLI": true,
        "PASEOS DEL ENCANTO": true,
        "URBI QUINTA MONTECARLO": true
      },
      "54720": {
        "CTM NR1 NÚCLEOS": true,
        "DEL RÍO": true,
        "FERROCARRILERA": true,
        "INFONAVIT NORTE": true,
        "INFONAVIT NORTE CONSORCIO": true,
        "JARDINES DE LA HACIENDA SUR": true,
        "LA PIEDAD": true,
        "LOMAS DE SAN FRANCISCO TEPOJACO": true,
        "MÉXICO": true,
        "SAN MARCOS CUAMATLA": true,
        "SECCIÓN PARQUES": true,
        "VIVEROS II": true
      },
      "54725": {
        "LA AURORA": true,
        "LAS AURORITAS": true,
        "RINCONADA SAN MIGUEL": true,
        "SAN ANTONIO": true
      },
      "54729": {
        "JARDINES DE LA HACIENDA NORTE": true,
        "SAN JUAN ATLAMICA": true
      },
      "54730": {
        "ARCOS DE LA HACIENDA": true,
        "COMPLEJO INDUSTRIAL CUAMATLA": true,
        "EJIDOS DE SAN ISIDRO": true,
        "EL CERRITO": true,
        "PARQUE INDUSTRIAL CUAMATLA": true,
        "PARQUE INDUSTRIAL LA JOYA": true,
        "RINCÓN COLONIAL": true,
        "SAN ISIDRO": true
      },
      "54740": {
        "ATLANTA": true,
        "CUMBRIA": true,
        "ENSUEÑOS": true,
        "LA PERLA": true,
        "RESIDENCIAL LOS LIRIOS": true,
        "SANTA ROSA DE LIMA": true,
        "URBI HACIENDA BALBOA": true
      },
      "54743": {
        "CAMPO 1": true,
        "COLONIAL TAXCO": true,
        "FIDEL VELÁZQUEZ": true,
        "FRANCISCO VILLA": true,
        "FUENTES DEL TEPEYAC": true,
        "INFONAVIT CENTRO": true,
        "INFONAVIT TEPALCAPA": true,
        "PLAZA DORADA": true,
        "SANTA MARÍA GUADALUPE LAS TORRES": true,
        "SANTIAGO TEPALCAPA": true,
        "TULIPANES": true,
        "VALLE DE SAN LUCAS": true
      },
      "54744": {
        "COLINAS DEL LAGO": true,
        "JORGE JIMÉNEZ CANTÚ": true,
        "LA JOYITA": true,
        "NOPALTEPEC": true,
        "VALLE DE LAS FLORES": true
      },
      "54745": {
        "EJIDO DE GUADALUPE": true,
        "LA CONASUPO": true,
        "LOS AILES": true,
        "LOS PINOS": true,
        "SAN FRANCISCO TEPOJACO": true
      },
      "54750": {
        "ARCOS DEL ALBA": true,
        "GENERALÍSIMO JOSÉ MARÍA MORELOS Y PAVÓN SECCIÓN NORTE": true,
        "GENERALÍSIMO JOSÉ MARÍA MORELOS Y PAVÓN SECCIÓN SUR": true,
        "JARDINES DEL ALBA": true,
        "LAS CONCHITAS": true
      },
      "54753": {
        "BOSQUES DEL ALBA I": true,
        "BOSQUES DEL ALBA II": true,
        "FUENTES DEL BOSQUE": true,
        "JOYAS DEL ALBA": true,
        "LUIS ECHEVERRÍA": true,
        "RESIDENCIAL BOSQUES DEL ALBA": true
      },
      "54759": {
        "LOMA BONITA": true
      },
      "54760": {
        "BOSQUES DE MORELOS": true,
        "LAGO DE GUADALUPE": true,
        "PLAN DE GUADALUPE": true,
        "RINCÓN DEL BOSQUE": true,
        "TRES DE MAYO": true
      },
      "54763": {
        "AMPLIACIÓN EJIDAL SAN ISIDRO": true,
        "EJIDAL SAN ISIDRO": true,
        "INFONAVIT SUR \"NIÑOS HÉROES\"": true,
        "LA PRESITA": true,
        "LAS GAVIOTAS": true,
        "LAS HUERTAS": true,
        "LAS MARIPOSAS": true,
        "LOS PÁJAROS": true,
        "RESIDENCIAL LA JOYA": true,
        "SAN MARTÍN OBISPO O TEPETLIXPAN": true,
        "SAN MARTÍN TEPETLIXPA": true,
        "TRES PICOS": true,
        "UNIDAD CÍVICA BACARDI": true,
        "VILLAS DEL SOL": true
      },
      "54764": {
        "SANTA MARÍA DE GUADALUPE LA QUEBRADA": true
      },
      "54765": {
        "EL TIKAL": true,
        "LOMAS DEL BOSQUE": true,
        "MIRADOR SANTA ROSA": true
      },
      "54766": {
        "BOSQUES DEL LAGO": true,
        "CAMPESTRE DEL LAGO": true
      },
      "54767": {
        "GRANJAS LOMAS DE GUADALUPE": true
      },
      "54769": {
        "BOSQUES DEL PERINORTE": true,
        "CUMBRE NORTE": true,
        "HACIENDA DEL PARQUE": true,
        "LA QUEBRADA AMPLIACIÓN": true,
        "LA QUEBRADA CENTRO": true,
        "PARQUE INDUSTRIAL SAN MARTÍN OBISPO": true,
        "PASEO DE LOS JARDINES": true,
        "TORRES ALGIBE": true,
        "VALLE ESMERALDA": true,
        "VILLAS DEL PERINORTE": true
      }
    },
    "ECATEPEC DE MORELOS": {
      "55000": {
        "ECATEPEC CENTRO": true,
        "LA CRUZ DE SAN CRISTÓBAL": true,
        "SAN CRISTÓBAL CENTRO": true
      },
      "55010": {
        "AMPLIACIÓN GUADALUPE VICTORIA": true,
        "BARRIO NUEVO TULTITLÁN": true,
        "BONITO ARBOLEDAS": true,
        "BONITO LAS FLORES": true,
        "CAMINO NACIONAL": true,
        "EL DIAMANTE": true,
        "EL MANCHON": true,
        "EL OBRAJE (DIAMANTE)": true,
        "EL PROGRESO DE GUADALUPE VICTORIA": true,
        "GUADALUPE VICTORIA": true,
        "LAS PIEDRAS": true,
        "LAURELES RESIDENCIAL": true,
        "LOS LIRIOS": true,
        "MATHZI I": true,
        "MATHZI II": true,
        "MATHZI III": true,
        "POZO DE LA PILA": true,
        "PRIVADA DE ECATEPEC": true,
        "RANCHO VICTORIA": true,
        "RANCHO VICTORIA II": true,
        "VILLA ESMERALDA": true
      },
      "55014": {
        "PARQUE RESIDENCIAL COACALCO": true
      },
      "55016": {
        "GUADALUPE VICTORIA": true,
        "LA JOYA": true,
        "MESA DE LOS LEONES": true,
        "TORRES DE ALTAVISTA": true,
        "TÍA JOAQUINA": true,
        "TÍO MARIN": true,
        "VILLAS DE LA JOYA": true
      },
      "55017": {
        "EL TEJOCOTE": true
      },
      "55018": {
        "ECATEPEC 2000": true,
        "EL CAPULÍN": true,
        "FOVISSSTE (JOSÉ MARÍA MORELOS Y PAVÓN)": true,
        "GRANJA EL ROSAL": true,
        "SAN CARLOS": true
      },
      "55020": {
        "10 DE ABRIL": true,
        "BOSQUES DE SAN JAVIER": true,
        "BOULEVARES DE SAN CRISTÓBAL": true,
        "BOULEVARES LA NACIONAL": true,
        "BURSAAB": true,
        "EL CALVARIO": true,
        "EL TERREMOTE": true,
        "EX-HACIENDA JAUREGUI": true,
        "LA MONERA": true,
        "MAGISTERIAL 2000": true,
        "MARTELL": true,
        "MISIÓN DE LOS 40": true,
        "PANITZIN": true,
        "PLAZAS ECATEPEC": true,
        "RESIDENCIAL SAN CRISTÓBAL": true,
        "SERGIO MÉNDEZ ARCEO": true,
        "TIERRA BLANCA": true,
        "TIERRA BLANCA SEGUNDA SECCIÓN (EJIDO ECATEPEC)": true
      },
      "55023": {
        "LOS HÉROES ECATEPEC SECCIÓN I": true,
        "LOS HÉROES ECATEPEC SECCIÓN II": true,
        "LOS HÉROES ECATEPEC SECCIÓN III": true,
        "LOS HÉROES ECATEPEC SECCIÓN IV": true
      },
      "55024": {
        "EJIDAL EMILIANO ZAPATA": true,
        "EJIDOS DE SAN CRISTÓBAL": true,
        "EL CARMEN": true
      },
      "55025": {
        "AMPLIACIÓN EL CARMEN": true,
        "GALAXIA ECATEPEC": true,
        "LOS SAUCES": true,
        "SAN BENJAMIN": true,
        "SANTA ÁGUEDA": true
      },
      "55027": {
        "EL ÁRBOL": true,
        "LA HUERTA": true
      },
      "55028": {
        "VISTA HERMOSA": true
      },
      "55029": {
        "ABEL MARTÍNEZ MONTAÑEZ": true,
        "EHÉCATL (PASEOS DE ECATEPEC)": true,
        "EJIDOS DE SAN ANDRÉS": true,
        "GOLONDRINAS": true,
        "GRANJAS ECATEPEC 1A SECCIÓN": true,
        "GRANJAS ECATEPEC 2A SECCIÓN": true,
        "INDEPENDENCIA": true,
        "LAGUNA DEL REY": true,
        "LUIS DONALDO COLOSIO": true,
        "PLAYA GOLONDRINAS": true,
        "POTRERO DE REY": true,
        "SAN FRANCISCO DE ASÍS": true
      },
      "55030": {
        "AMPLIACIÓN IZCALLI ECATEPEC TATA FÉLIX": true,
        "CHULA VISTA": true,
        "COLINAS DE ECATEPEC": true,
        "DOCE DE DICIEMBRE": true,
        "HOGARES MARLA": true,
        "IZCALLI ECATEPEC": true,
        "LA CURIELA": true,
        "LA MORA": true,
        "TATA FÉLIX": true
      },
      "55036": {
        "LA PANORÁMICA": true
      },
      "55037": {
        "EL CAPULÍN": true
      },
      "55038": {
        "FLORESTA": true
      },
      "55039": {
        "LA PALMA I": true,
        "LA PALMA II": true
      },
      "55040": {
        "BOULEVARES IMPALA": true,
        "CASAS COLONIALES MORELOS": true,
        "FUENTES DE SAN CRISTÓBAL": true,
        "HOGARES MEXICANOS": true,
        "JARDINES DE ECATEPEC": true,
        "LA PROPIEDAD": true,
        "RENOVACIÓN JAJALPA": true,
        "SAN JUAN ALCAHUACAN": true,
        "ÁLAMOS DE SAN CRISTÓBAL": true
      },
      "55050": {
        "ADOLFO RUIZ CORTÍNES": true,
        "AQUILES SERDÁN": true,
        "BOSQUES DE ECATEPEC": true,
        "EL SALADO": true,
        "EX RANCHO JAJALPA": true,
        "GUSTAVO BAZ PRADA": true,
        "HACIENDA SANTA MARÍA": true,
        "IZCALLI JARDINES": true,
        "LA PRADERA": true,
        "NUEVO DIAZ ORDAZ": true,
        "PIRULES DE VILLANCICO 2A SECCIÓN": true,
        "RANCHO JAJALPA": true,
        "RESIDENCIAL FUENTES DE ECATEPEC": true,
        "RINCONADA SAN MARTÍN": true,
        "SAN MARTÍN DE PORRES": true,
        "VIVIENDA DEL TAXISTA": true
      },
      "55055": {
        "AMPLIACIÓN LLANO DE LOS BÁEZ SECCIÓN IZCALLI": true,
        "EL SOL DE ECATEPEC": true,
        "JARDINES DE LOS BÁEZ 1A SECCIÓN": true,
        "JARDINES DE LOS BÁEZ 2A SECCIÓN": true,
        "JARDINES DE LOS BÁEZ 3A SECCIÓN": true,
        "JUBILADOS Y PENSIONADOS": true,
        "LA VELETA": true,
        "LLANO DE LOS BÁEZ": true
      },
      "55056": {
        "VILLAS DE ECATEPEC": true
      },
      "55059": {
        "PIRULES DE VILLANCICO 1A SECCIÓN": true
      },
      "55060": {
        "LA GUADALUPANA": true,
        "LOS HÉROES ECATEPEC SECCIÓN V": true,
        "PRIVADAS DE ECATEPEC": true,
        "VENTA DE CARPIO": true
      },
      "55063": {
        "CIUDAD CUAUHTÉMOC SECCIÓN CHICONAUTLA 3000": true
      },
      "55064": {
        "AMPLIACIÓN SAN ISIDRO ATLAUTENCO": true,
        "CIUDAD CUAUHTÉMOC SECCIÓN NOPALERA I Y II": true,
        "JOYAS DE ATLAUTENCO": true,
        "LA VENTA (LA GUADALUPANA)": true,
        "SAN ISIDRO ATLAUTENCO": true,
        "VISTAS DE ECATEPEC (SECCIÓN A)": true,
        "VISTAS DE ECATEPEC (SECCIÓN B)": true
      },
      "55065": {
        "SANTA CRUZ VENTA DE CARPIO": true
      },
      "55066": {
        "BOSQUES DE SANTO TOMÁS": true,
        "CAMPO SANTO": true,
        "CASAS REALES": true,
        "EL POTRERO": true,
        "JAIME SALVADOR": true,
        "LA CERCA": true,
        "LA PRECIOSA": true,
        "LAS BRISAS": true,
        "LOS ÍDOLOS": true,
        "MÉXICO NUEVO": true,
        "PIRULES DE BAYISCO": true,
        "PORTAL CHICONAUTLA": true,
        "SANTA MARÍA CHICONAUTLA": true,
        "SANTO TOMÁS CHICONAUTLA": true,
        "TERREMOTE": true,
        "ZOPILOCALCO": true
      },
      "55067": {
        "C.T.M. GUADALUPANA": true,
        "CIUDAD CUAUHTÉMOC SECCIÓN CUITLAHUAC": true,
        "CIUDAD CUAUHTÉMOC SECCIÓN EMBAJADA": true,
        "CIUDAD CUAUHTÉMOC SECCIÓN GEO 2000": true,
        "CIUDAD CUAUHTÉMOC SECCIÓN MOCTEZUMA": true,
        "CIUDAD CUAUHTÉMOC SECCIÓN QUETZALCOATL": true,
        "CIUDAD CUAUHTÉMOC SECCIÓN TEPETZINGO": true,
        "CIUDAD CUAUHTÉMOC SECCIÓN TEPOZTLACO": true,
        "CIUDAD CUAUHTÉMOC SECCIÓN TIZOC": true,
        "CIUDAD CUAUHTÉMOC SECCIÓN TLALOC": true,
        "CIUDAD CUAUHTÉMOC SECCIÓN TONATIUH": true,
        "CIUDAD CUAUHTÉMOC SECCIÓN XOCHIQUETZAL": true,
        "COYOMETLA": true,
        "EL HOYO DEL TEPETATE": true,
        "LA FORTALEZA": true,
        "LOS LLANETES": true,
        "MONEDA DE 100 PESOS": true,
        "NIÑOS HÉROES": true,
        "TEPETZINGO EL CHICO": true,
        "TEPOPOTLA": true
      },
      "55068": {
        "EL HOYO": true,
        "EL MIRADOR": true,
        "IGNACIO PICHARDO PAGAZA": true,
        "SANTO TOMÁS CHICONAUTLA": true
      },
      "55069": {
        "LA CERCA": true,
        "LA GARITA": true,
        "LA PRECIOSA": true,
        "LOS PAJARITOS": true
      },
      "55070": {
        "19 DE SEPTIEMBRE": true,
        "AMPLIACIÓN 19 DE SEPTIEMBRE": true,
        "CARLOS SALINAS DE GORTARI": true,
        "COLONIAL ECATEPEC": true,
        "JARDINES DE MORELOS SECCIÓN BOSQUES": true,
        "JARDINES DE MORELOS SECCIÓN CERROS": true,
        "JARDINES DE MORELOS SECCIÓN ELEMENTOS": true,
        "JARDINES DE MORELOS SECCIÓN FLORES": true,
        "JARDINES DE MORELOS SECCIÓN FUENTES": true,
        "JARDINES DE MORELOS SECCIÓN ISLAS": true,
        "JARDINES DE MORELOS SECCIÓN LAGOS": true,
        "JARDINES DE MORELOS SECCIÓN MONTES": true,
        "JARDINES DE MORELOS SECCIÓN PLAYAS": true,
        "JARDINES DE MORELOS SECCIÓN RÍOS": true,
        "JULIA MARIN": true,
        "LLANOS DE MORELOS I": true,
        "LLANOS DE MORELOS II": true,
        "PLAN DE ARROYO": true,
        "PROFOPEC (POLÍGONOS VII)": true,
        "SOL II": true,
        "VILLAS DEL SOL": true
      },
      "55074": {
        "AMPLIACIÓN 19 DE SEPTIEMBRE 1A SECCIÓN": true,
        "EJIDO DE ATLAUTENCO": true,
        "LA PURÍSIMA": true,
        "LOS ALCATRACES": true,
        "LOS CORDELES": true,
        "LOS PINOS": true,
        "MEXICANOS UNIDOS I": true,
        "MEXICANOS UNIDOS II": true,
        "PLAYAS DE SAN JUAN": true,
        "UPROVI": true,
        "VIENTO NUEVO": true
      },
      "55075": {
        "JARDINES DE MORELOS 5A SECCIÓN": true
      },
      "55076": {
        "LAS AMÉRICAS": true
      },
      "55080": {
        "ARBOLEDAS DE SAN CARLOS": true,
        "EL BOSQUE": true,
        "FRANCISCO VILLA": true,
        "JESÚS SÁNCHEZ": true,
        "LOMAS DE ATZOLCO": true,
        "LOMAS DE ECATEPEC": true,
        "NUEVO LAREDO": true,
        "SAN CARLOS": true,
        "XOCHICUAC I": true,
        "XOCHICUAC II": true
      },
      "55084": {
        "EL RANCHITO": true
      },
      "55085": {
        "VIVEROS TULPETLAC": true
      },
      "55087": {
        "LOMAS DE SAN CARLOS ZONA COMUNAL": true
      },
      "55090": {
        "BONITO ECATEPEC": true,
        "ECATEPEC 40 CASAS": true,
        "EL ARBOLITO JAJALPA": true,
        "EL JAGÜEY": true,
        "EL POCITO": true,
        "EL POTRERO": true,
        "JAJALPA": true,
        "JAJALPA OLÍMPICA": true,
        "LAS PALMAS ECATEPEC": true,
        "LOS LAURELES": true,
        "OBRERA JAJALPA": true,
        "RÍO PIEDRAS": true,
        "SAN JOSÉ JAJALPA": true
      },
      "55094": {
        "VILLAS JAJALPA": true
      },
      "55095": {
        "JAJALPA": true
      },
      "55100": {
        "FRANCISCO I. MADERO": true,
        "INDUSTRIAS ECATEPEC": true,
        "JARDINES DE CERRO GORDO": true,
        "LOS REYES ECATEPEC": true,
        "PATRIMONIO SOCIAL": true,
        "PRIMERO DE MAYO": true,
        "PRO REVOLUCIÓN": true,
        "RÍO DE LUZ": true,
        "TULPETLAC": true,
        "VILLA 1O DE MAYO": true,
        "VILLAS 1O DE AGOSTO": true,
        "VIVIENDAS VENTA DE CARPIO": true
      },
      "55104": {
        "GRANJAS POPULARES GUADALUPE TULPETLAC": true
      },
      "55105": {
        "EL PARAÍSO": true,
        "IGNACIO L. VALLARTA": true
      },
      "55107": {
        "INDUSTRIAS TULPETLAC": true
      },
      "55114": {
        "TOLOTZIN I": true
      },
      "55115": {
        "JOSÉ MARÍA MORELOS Y PAVÓN SAGITARIO X": true
      },
      "55117": {
        "JOSEFA ORTIZ DE DOMÍNGUEZ SAGITARIO VII": true
      },
      "55118": {
        "ALFREDO DEL MAZO": true,
        "AMPLIACIÓN JOYAS DE ECATEPEC": true,
        "COLONOS DE MÉXICO (ALFREDO TORRES MARTÍNEZ)": true,
        "CUCHILLA DE LA DRAGA": true,
        "JOYAS DE ECATEPEC": true,
        "JUAN DE LA BARRERA": true,
        "PROGRESO DE LA UNIÓN": true,
        "SOSA ECATEPEC": true
      },
      "55119": {
        "EL DIQUE": true,
        "POTRERO CHICO": true,
        "VALLE DE ECATEPEC ESTADO DE MÉXICO CTM XIII": true
      },
      "55120": {
        "CIUDAD AZTECA SECCIÓN ORIENTE": true,
        "CIUDAD AZTECA SECCIÓN PONIENTE": true
      },
      "55125": {
        "ALDEAS DE ARAGÓN I": true,
        "ALDEAS DE ARAGÓN II": true
      },
      "55126": {
        "PROFOPEC (POLÍGONO I)": true
      },
      "55127": {
        "PROFOPEC IV (POLÍGONO IV EL CEGOR)": true
      },
      "55128": {
        "JOSÉ ANTONIO TORRES": true
      },
      "55129": {
        "JOSEFA ORTIZ DE DOMÍNGUEZ": true,
        "LA FLORIDA (CIUDAD AZTECA)": true
      },
      "55130": {
        "CIUDAD Y PUERTO": true,
        "NUEVO PASEO DE SAN AGUSTÍN": true,
        "NUEVO PASEO DE SAN AGUSTÍN 2A SECC": true,
        "NUEVO PASEO DE SAN AGUSTÍN 3A SECCIÓN": true,
        "NUEVO PASEO SAN AGUSTÍN 3A B": true,
        "OLÍMPICA 68 I": true,
        "PLAZA DE SANTA CLARA": true,
        "VICENTE COSS RAMÍREZ": true
      },
      "55135": {
        "LADERAS DEL PEÑÓN": true
      },
      "55137": {
        "INDECO SANTA CLARA (CAMPIÑAS DE ARAGÓN)": true
      },
      "55138": {
        "VALLE DE SANTIAGO": true
      },
      "55139": {
        "CAMPIÑAS DE ARAGÓN": true
      },
      "55140": {
        "JARDINES DE ARAGÓN": true,
        "RINCONADA DE ARAGÓN": true
      },
      "55146": {
        "TOLOTZIN II": true
      },
      "55147": {
        "LOS ÁLAMOS": true
      },
      "55148": {
        "ALBORADA DE ARAGÓN": true,
        "VILLAS DE ARAGÓN": true
      },
      "55149": {
        "IGNACIO ALLENDE": true
      },
      "55158": {
        "PROFOPEC (POLÍGONO II)": true
      },
      "55170": {
        "16 DE SEPTIEMBRE": true,
        "CENTRAL MICHOACANA": true,
        "SAGITARIO IV": true
      },
      "55176": {
        "PROFOPEC (POLÍGONO V)": true
      },
      "55180": {
        "MÉXICO COLONIAL II": true
      },
      "55187": {
        "PROFOPEC (POLÍGONO III)": true
      },
      "55188": {
        "MÉXICO COLONIAL I": true
      },
      "55189": {
        "NOVELA MEXICANA I": true
      },
      "55190": {
        "LÁZARO CÁRDENAS V ZONA": true
      },
      "55200": {
        "DIVISIÓN DEL NORTE": true,
        "EMILIANO ZAPATA 1A SECCIÓN": true,
        "GRANJAS VALLE DE GUADALUPE SECCIÓN B": true,
        "GUSTAVO DÍAZ ORDAZ": true
      },
      "55210": {
        "LA ESTRELLA": true,
        "LA POPULAR": true,
        "VALLE DE ANÁHUAC SECCIÓN A": true
      },
      "55218": {
        "CUCHILLA A. ROSALES": true
      },
      "55220": {
        "EMILIANO ZAPATA 1A SECCIÓN A": true,
        "JARDINES DE SAN GABRIEL": true,
        "JARDINES DEL TEPEYAC": true,
        "VICENTE GUERRERO": true
      },
      "55230": {
        "LA MEDIA LUNA": true
      },
      "55234": {
        "LA GLORIETA": true
      },
      "55235": {
        "UNIDAD OBRERO CTM XIV": true
      },
      "55236": {
        "AMPLIACIÓN CÓDICE MENDOCINO": true,
        "CÓDICE MENDOCINO I": true,
        "CÓDICE MENDOCINO II": true,
        "SAGITARIO V": true
      },
      "55237": {
        "ESTRELLA DE ORIENTE": true
      },
      "55238": {
        "EJERCITO DEL TRABAJO II": true,
        "FELIPE ÁNGELES (ANTES SAGITARIO II)": true,
        "IZCALLI SANTA CLARA": true,
        "SAGITARIO I": true,
        "SAGITARIO III": true
      },
      "55240": {
        "ALBORADA": true,
        "LA FLORIDA": true,
        "MELCHOR MUZQUIZ": true
      },
      "55242": {
        "VILLAS COSMOS": true
      },
      "55243": {
        "HACIENDAS DE ARAGÓN": true
      },
      "55244": {
        "CASTILLOS DE ARAGÓN": true,
        "PARQUES DE ARAGÓN": true,
        "PASEOS DE ARAGÓN": true
      },
      "55245": {
        "MÉXICO INDEPENDIENTE": true
      },
      "55246": {
        "PETROQUÍMICA ECATEPEC": true
      },
      "55247": {
        "CIUDAD ORIENTE": true,
        "CROC ARAGÓN": true
      },
      "55248": {
        "FUENTES DE ARAGÓN": true
      },
      "55249": {
        "ECATEPEC FEDERACIÓN (MÁRTIRES DE RÍO BLANCO)": true,
        "POESÍA MEXICANA": true
      },
      "55260": {
        "NUEVA ARAGÓN": true
      },
      "55264": {
        "FERNANDO DE ALBA NEZAHUALPILLI": true,
        "PRIZO I": true,
        "PRIZO II": true,
        "PRIZO III": true
      },
      "55266": {
        "MÉXICO INSURGENTE": true,
        "MÉXICO REVOLUCIONARIO": true
      },
      "55267": {
        "CIUDAD AMANECER": true,
        "QUINTO SOL": true,
        "SAUCES II": true,
        "SAUCES V": true
      },
      "55268": {
        "NOVELA MEXICANA II": true,
        "SAUCES COALICIÓN": true,
        "SAUCES VI": true
      },
      "55269": {
        "MÉXICO PREHISPÁNICO I": true,
        "MÉXICO PREHISPÁNICO II": true,
        "SAUCES I": true,
        "SAUCES P.R.I.": true
      },
      "55270": {
        "EL CHAMIZAL": true,
        "EMILIANO ZAPATA 2A SECC": true,
        "GRANJAS VALLE DE GUADALUPE SECCIÓN A": true,
        "GRANJAS VALLE DE GUADALUPE SECCIÓN C": true
      },
      "55280": {
        "AMPLIACIÓN VALLE DE ARAGÓN SECCIÓN A": true,
        "NUEVO VALLE DE ARAGÓN": true,
        "RENACIMIENTO DE ARAGÓN": true,
        "VALLE DE ARAGÓN 3RA SECCIÓN ORIENTE": true,
        "VALLE DE ARAGÓN 3RA SECCIÓN PONIENTE": true,
        "VALLE DE ARAGÓN 3RA. SECCIÓN ORIENTE": true,
        "VALLE DE ARAGÓN 3RA. SECCIÓN PONIENTE": true
      },
      "55284": {
        "RENACIMIENTO CHICO": true
      },
      "55287": {
        "FERNANDO ALBA IXTLAXÓCHITL": true
      },
      "55288": {
        "NEZAHUALPILLI": true
      },
      "55289": {
        "BUGAMBILIAS DE ARAGÓN": true
      },
      "55290": {
        "ARBOLEDAS DE ARAGÓN": true,
        "GRANJAS INDEPENDENCIA": true,
        "GRANJAS INDEPENDENCIA SECCIÓN A": true,
        "GRANJAS INDEPENDENCIA SECCIÓN B": true,
        "GRANJAS INDEPENDENCIA SECCIÓN C": true,
        "SOLIDARIDAD 90 (MÁRTIRES DE RÍO BLANCO)": true
      },
      "55294": {
        "AV. CENTRAL CROC": true
      },
      "55295": {
        "AMPLIACIÓN NICOLÁS BRAVO": true,
        "AMPLIACIÓN PEDRO OJEDA PAULLADA": true,
        "FRANJA VALLE DE GUADALUPE": true,
        "LIC. PEDRO OJEDA PAULLADA": true,
        "LICENCIADO PEDRO OJEDA PAULLADA": true
      },
      "55296": {
        "A.S.A.": true,
        "LAS FLORES DE ARAGÓN": true,
        "NICOLÁS BRAVO": true
      },
      "55297": {
        "HÉROES DE GRANADITAS": true
      },
      "55298": {
        "EJERCITO DEL TRABAJO III": true
      },
      "55299": {
        "EJERCITO DEL TRABAJO I": true
      },
      "55300": {
        "PIEDRA GRANDE": true
      },
      "55308": {
        "BENITO JUÁREZ LA MESA": true,
        "BENITO JUÁREZ XALOSTOC NORTE": true
      },
      "55310": {
        "CUAUHTÉMOC XALOSTOC": true,
        "SAN PEDRO XALOSTOC": true
      },
      "55316": {
        "AMPLIACIÓN SAN PEDRO XALOSTOC": true
      },
      "55317": {
        "EL ARBOLITO XALOSTOC": true
      },
      "55320": {
        "EL CARDONAL XALOSTOC": true,
        "EL NARDO": true,
        "ESFUERZO NACIONAL": true,
        "SANTA MARÍA XALOSTOC": true
      },
      "55330": {
        "5 DE SEPTIEMBRE": true,
        "AMPLIACIÓN SAN FRANCISCO XALOSTOC": true,
        "JARDINES DE XALOSTOC": true,
        "LA LAGUNA 21": true,
        "LAS VEGAS XALOSTOC": true,
        "PRADOS DE XALOSTOC": true,
        "SAN FRANCISCO XALOSTOC": true,
        "TOLOTZIN V": true
      },
      "55338": {
        "MELCHOR OCAMPO": true
      },
      "55339": {
        "VILLAS DE GUADALUPE XALOSTOC": true
      },
      "55340": {
        "BENITO JUÁREZ XALOSTOC": true,
        "RUSTICA XALOSTOC": true,
        "VIVEROS DE XALOSTOC": true
      },
      "55347": {
        "AMPLIACIÓN SAN JOSÉ XALOSTOC": true
      },
      "55348": {
        "PARQUE INDUSTRIAL XALOSTOC": true
      },
      "55349": {
        "URBANA IXHUATEPEC": true
      },
      "55360": {
        "EL SALADO": true,
        "SAN JOSÉ XALOSTOC": true
      },
      "55369": {
        "AMPLIACIÓN SAN MIGUEL XALOSTOC": true
      },
      "55390": {
        "ALTAVILLA": true,
        "SAN MIGUEL XALOSTOC": true
      },
      "55400": {
        "ALDEAS I": true,
        "ALDEAS II": true,
        "ISSEMYM": true,
        "NIEVES": true,
        "SANTA MARÍA TULPETLAC": true
      },
      "55404": {
        "ECATEPEC LAS FUENTES": true,
        "EJIDO DE SANTA MARÍA TULPETLAC": true,
        "EL CHAMIZALITO": true,
        "EL CHARCO": true,
        "EL CHARCO II": true,
        "SANTA MARÍA TULPETLAC": true
      },
      "55405": {
        "LA PURÍSIMA": true
      },
      "55407": {
        "CUCHILLA LÁZARO CÁRDENAS": true,
        "TALLERES GRÁFICOS": true
      },
      "55410": {
        "EL OSTOR": true,
        "LOMAS DE SAN CARLOS CANTERA": true,
        "TECUESCOMAC": true
      },
      "55414": {
        "EL PARQUE": true,
        "LA NOPALERA 2A. SECCIÓN TULPETLAC": true,
        "LOMAS VERDES TLALJUYACA": true,
        "MARGARITA MAZA DE JUÁREZ": true,
        "NUEVA RUFINO TAMAYO": true,
        "TEPETLAC TEXALPA": true,
        "XOCHITENCO": true
      },
      "55415": {
        "AMPLIACIÓN ALMARCIGO": true,
        "BUENOS AIRES": true,
        "EL ALMARCIGO NORTE": true,
        "EL ALMARCIGO SUR": true,
        "EL ROSAL": true,
        "MEXIHUILOYA": true
      },
      "55416": {
        "BENITO JUÁREZ 1RA SECCIÓN": true,
        "BENITO JUÁREZ 1RA. SECCIÓN": true,
        "BENITO JUÁREZ 2DA SECCIÓN": true,
        "BENITO JUÁREZ 2DA. SECCIÓN": true,
        "BENITO JUÁREZ 3RA SECCIÓN": true,
        "BENITO JUÁREZ 3RA. SECCIÓN": true,
        "LA VIRGEN": true,
        "PROGRESO TLAJOYUCA": true,
        "TEXALPA": true
      },
      "55417": {
        "GUADALUPE COATZOCHICO": true
      },
      "55418": {
        "AMPLIACIÓN SANTA MARÍA TULPETLAC": true,
        "CUAUHTÉMOC": true,
        "EL CALLEJÓN": true,
        "MEXICALCO I": true,
        "MEXICALCO II Y IV": true,
        "MEXICALCO III": true,
        "PROGRESO CHICO TULPETLAC": true,
        "RUFINO TAMAYO": true,
        "VILLAS TULPETLAC": true
      },
      "55419": {
        "EL CORTIJO": true,
        "TLATEMPA": true
      },
      "55420": {
        "CERRO GORDO": true
      },
      "55425": {
        "CERRO GORDO": true
      },
      "55429": {
        "BELLAVISTA": true,
        "LA CUESTA SANTA CLARA": true,
        "TEPETZICASCO": true
      },
      "55430": {
        "CONJUNTO EJECUTIVO": true,
        "JARDINES DE CASA NUEVA": true,
        "JOSÉ MARIA PINO SUÁREZ": true,
        "JUNTA DE SAN JUAN": true
      },
      "55450": {
        "JARDINES DE SANTA CLARA": true,
        "PRADOS DE SANTA CLARA": true
      },
      "55458": {
        "CONJUNTO GUANAJUATO": true
      },
      "55459": {
        "AMÉRICA SANTA CLARA": true
      },
      "55490": {
        "FAJA DE ORO": true,
        "FINCA SAN MIGUEL": true,
        "MIGUEL HIDALGO": true
      },
      "55498": {
        "HÉROES DE LA INDEPENDENCIA": true
      },
      "55500": {
        "CONJUNTO TEPEYAC HIDALGO": true
      },
      "55506": {
        "BUENAVISTA": true
      },
      "55507": {
        "LA PALMA": true
      },
      "55508": {
        "AMPLIACIÓN COANALCO": true,
        "COANALCO BUENAVISTA": true
      },
      "55509": {
        "LA PRESA": true,
        "PLAN DE AYALA": true
      },
      "55510": {
        "EL POZO": true,
        "TABLAS DEL POZO": true,
        "TEPEOLULCO": true
      },
      "55515": {
        "LA TEJA": true,
        "LOS BORDOS": true
      },
      "55516": {
        "BOCA BARRANCA": true
      },
      "55517": {
        "EL MIRADOR": true
      },
      "55518": {
        "ARBOLEDAS DE XALOSTOC": true,
        "LA AGÜITA": true,
        "LA LOMITA": true
      },
      "55519": {
        "LA ESPERANZA": true,
        "SAN ANDRÉS DE LA CAÑADA": true
      },
      "55520": {
        "CARLOS HANK GONZÁLEZ": true
      },
      "55530": {
        "EL GALLITO": true,
        "SAN JACO (EL GALLITO)": true,
        "SANTA CLARA": true
      },
      "55540": {
        "REAL DE SANTA CLARA": true,
        "RINCONADA DE SANTA CLARA": true,
        "SANTA CLARA COATITLA": true
      },
      "55547": {
        "SANTA CLARA": true
      },
      "55548": {
        "CANTERA GUADALUPANA": true,
        "DOS DE OCTUBRE": true,
        "ÁREA ZAPOTECAS": true
      },
      "55549": {
        "ÁREA SANTA CRUZ": true
      }
    },
    "HUEHUETOCA": {
      "54683": {
        "EX-HACIENDA DE XALPA": true,
        "SAN BARTOLO": true,
        "SAN PEDRO XALPA": true
      },
      "54684": {
        "JARDINES DE HUEHUETOCA": true,
        "PUENTE GRANDE": true,
        "REAL DE HUEHUETOCA": true
      },
      "54685": {
        "ARBOLEDAS DE HUEHUETOCA": true,
        "CASA NUEVA": true,
        "GALAXIA HUEHUETOCA": true,
        "HUEHUETOCA DEL MAUREL": true,
        "LA CAÑADA": true,
        "PASEOS DEL PRADO": true,
        "PORTAL DEL SOL": true,
        "SALITRILLO": true
      }
    },
    "HUIXQUILUCAN": {
      "52760": {
        "EL CERRITO": true
      },
      "52763": {
        "HACIENDA DE LAS PALMAS": true,
        "VILLA FLORENCE": true,
        "VISTA HORIZONTE": true
      },
      "52764": {
        "JESÚS DEL MONTE": true,
        "LA RETAMA": true
      },
      "52765": {
        "ESFUERZO OBRERO": true,
        "INDUSTRIA MILITAR Y COVE": true,
        "SAN FERNANDO": true
      },
      "52766": {
        "SAN JACINTO": true
      },
      "52767": {
        "IGNACIO ALLENDE": true
      },
      "52768": {
        "SAN JUAN YAUTEPEC": true
      },
      "52769": {
        "LA CAÑADA": true
      },
      "52770": {
        "LAS CANTERAS": true,
        "PASEOS DEL BOSQUE": true
      },
      "52773": {
        "DEL RÍO": true,
        "EL ESCOBAL": true,
        "EL MANZANO": true,
        "LA CAPILLA": true,
        "LA MANZANA (LA RINCONADA)": true,
        "MAGDALENA CHICHICASPA": true,
        "MAGDALENA CHICHICASPA (LAS CAMPANITAS)": true
      },
      "52774": {
        "ARENAL": true,
        "BOSQUE REAL": true,
        "EL PEDREGAL": true
      },
      "52775": {
        "CONSTITUYENTES DE 1917": true,
        "TIERRA Y LIBERTAD": true
      },
      "52776": {
        "LA UNIDAD": true,
        "LOMA DEL CARMEN": true
      },
      "52777": {
        "EL BOSQUE": true,
        "FEDERAL BUROCRÁTICA": true,
        "PARADICE": true
      },
      "52778": {
        "AMPLIACIÓN PALO SOLO": true,
        "PALO SOLO": true
      },
      "52779": {
        "CONJUNTO URBANO GREEN HOUSE": true,
        "LOMAS COUNTRY CLUB": true,
        "MONTÓN CUARTELES": true,
        "PIRULES": true
      },
      "52780": {
        "BOSQUES DE LAS LOMAS": true,
        "LOMAS DE TECAMACHALCO SECCIÓN BOSQUES I Y II": true,
        "LOMAS DE TECAMACHALCO SECCIÓN CUMBRES": true
      },
      "52783": {
        "BOSQUES DE LA HERRADURA": true,
        "RINCONADA DE LA HERRADURA": true
      },
      "52784": {
        "LA HERRADURA": true,
        "LA HERRADURA SECCIÓN I": true,
        "LA HERRADURA SECCIÓN II": true,
        "LA HERRADURA SECCIÓN III": true
      },
      "52785": {
        "BALCONES DE LA HERRADURA": true,
        "GALARDÓN": true,
        "JARDINES DE LA HERRADURA": true,
        "LOMAS DE LA HERRADURA": true
      },
      "52786": {
        "LOMAS ANÁHUAC": true,
        "MAGNOCENTRO": true,
        "PARQUES DE LA HERRADURA": true
      },
      "52787": {
        "BOSQUES DE LAS PALMAS": true,
        "INTERLOMAS": true,
        "PALMAS ALTAS RESIDENCIAL": true,
        "PASEO DE LAS PALMAS": true,
        "VALLE DE LAS PALMAS": true,
        "VILLA DE LAS LOMAS": true
      },
      "52788": {
        "FRONDOSO TORRES": true,
        "LOMAS DE LAS PALMAS": true,
        "LOMAS DEL OLIVO": true,
        "PRIVADA DEL BOSQUE": true
      },
      "52789": {
        "EL OLIVO": true,
        "LOMAS DEL SOL": true
      },
      "52790": {
        "SAN FRANCISCO DOS RÍOS": true
      },
      "52793": {
        "EL OBRAJE": true,
        "PARAJE EL MIRADOR": true,
        "PARAJE TREJO (EL CHAPARRAL)": true,
        "SAN BARTOLOMÉ COATEPEC": true
      },
      "52794": {
        "LA CUMBRE": true
      },
      "52795": {
        "SANTA CRUZ AYOTUXCO": true
      },
      "52796": {
        "SAN CRISTÓBAL TEXCALUCAN": true
      },
      "52797": {
        "HUILOTEAPAN (SAN JOSÉ HUILOTEAPAN)": true
      },
      "52798": {
        "CERRO DE SAN FRANCISCO": true
      },
      "52799": {
        "AGUA BENDITA": true
      }
    },
    "IXTAPALUCA": {
      "56530": {
        "CAPILLA I": true
      },
      "56535": {
        "EL JARAL (EL CAPULÍN)": true
      },
      "56536": {
        "SAN JOSÉ DE LA PALMA": true
      },
      "56537": {
        "CAPILLA II": true
      },
      "56538": {
        "SANTA BÁRBARA": true
      },
      "56539": {
        "LA MAGDALENA": true
      },
      "56540": {
        "CITLALMINA": true
      },
      "56550": {
        "EMILIANO ZAPATA": true
      },
      "56553": {
        "EL MOLINO": true
      },
      "56555": {
        "RESIDENCIAL AYOTLA": true
      },
      "56556": {
        "JOSÉ DE LA MORA": true
      },
      "56558": {
        "AMPLIACIÓN EMILIANO ZAPATA": true
      },
      "56560": {
        "AYOTLA": true
      },
      "56563": {
        "LOMA BONITA": true
      },
      "56564": {
        "EL MIRADOR": true
      },
      "56565": {
        "LINDA VISTA": true
      },
      "56566": {
        "GEOVILLAS DE AYOTLA": true
      },
      "56567": {
        "MELCHOR OCAMPO I, II, III, IV Y V": true
      },
      "56568": {
        "UNIÓN ANTORCHISTA": true
      },
      "56569": {
        "RINCÓN DEL BOSQUE": true
      },
      "56570": {
        "ARBOLADA": true
      },
      "56576": {
        "ESTADO DE MÉXICO": true
      },
      "56577": {
        "HORNOS SANTA BÁRBARA": true
      },
      "56579": {
        "20 DE NOVIEMBRE": true
      },
      "56580": {
        "PASEOS DE COATEPEC": true
      },
      "56584": {
        "PUEBLO NUEVO (SAN ISIDRO LABRADOR)": true
      },
      "56585": {
        "LOS HÉROES": true
      },
      "56586": {
        "TLAYEHUALE": true
      },
      "56587": {
        "SANTA ANA": true
      },
      "56588": {
        "TEJALPA": true
      },
      "56589": {
        "JORGE JIMÉNEZ CANTÚ": true
      },
      "56590": {
        "RÍO FRÍO DE JUÁREZ": true
      },
      "56599": {
        "MANUEL ÁVILA CAMACHO": true
      }
    },
    "JALTENCO": {
      "55783": {
        "ALBORADA JALTENCO CTM XI": true,
        "BAHÍAS DE JALTENCO": true,
        "PRIVADAS DEL SOL": true,
        "PRO VIVIENDA": true
      }
    },
    "LA PAZ": {
      "56400": {
        "AMPLIACIÓN LOS REYES": true,
        "JARDÍN DE LOS REYES": true,
        "LOS REYES ACAQUILPAN CENTRO": true
      },
      "56410": {
        "ANCÓN DE LOS REYES": true,
        "RINCÓN DE LOS REYES": true
      },
      "56420": {
        "FLORESTA": true,
        "VALLE DE LOS PINOS": true
      },
      "56428": {
        "TEPOZANES": true
      },
      "56429": {
        "UNIDAD FLORESTA": true
      },
      "56430": {
        "VALLE DE LOS REYES": true
      },
      "56440": {
        "COAXUSCO": true,
        "MAGDALENA DE LOS REYES": true
      },
      "56490": {
        "EMILIANO ZAPATA": true,
        "LAS TORRES III": true
      },
      "56495": {
        "LOMA ENCANTADA": true,
        "VILLAS DEL SOL": true
      },
      "56500": {
        "AMPLIACIÓN TECAMACHALCO": true,
        "SAN SALVADOR TECAMACHALCO": true
      },
      "56505": {
        "2 DE MARZO": true
      },
      "56507": {
        "EL PINO": true
      },
      "56508": {
        "LA JOYITA": true
      },
      "56509": {
        "CONJUNTO LA PAZ": true,
        "FERROCARRIL": true,
        "JALPA": true,
        "LAS CRUCES": true,
        "PARCELAS": true,
        "VILLAS DE LA PAZ": true
      },
      "56510": {
        "PROFESOR CARLOS HANK GONZÁLEZ": true,
        "UNIDAD ACAQUILPAN": true
      },
      "56512": {
        "LOS PIRULES (EL POTRERO)": true
      },
      "56513": {
        "AMPLIACIÓN DR. JORGE JIMÉNEZ CANTÚ": true
      },
      "56514": {
        "PASO DE MINAS": true
      },
      "56515": {
        "DR. JORGE JIMÉNEZ CANTÚ": true
      },
      "56516": {
        "RÍOS DE SAN ISIDRO": true
      },
      "56520": {
        "AMPLIACIÓN SAN SEBASTIÁN": true,
        "PRESIDENTES": true,
        "SALITRERÍA": true,
        "SAN SEBASTIÁN CHIMALPA": true
      },
      "56524": {
        "C.E.A.S.": true,
        "CUCHILLA DE LA ANCÓN": true,
        "EL SALADO": true,
        "RICARDO FLORES MAGÓN": true
      },
      "56525": {
        "LA MAGDALENA ATLICPAC": true,
        "MAGISTERIAL": true
      },
      "56526": {
        "ALAMEDAS": true
      },
      "56527": {
        "AMPLIACIÓN ARENAL": true,
        "ANÁHUAC": true,
        "ARENAL": true
      },
      "56528": {
        "ADOLFO LÓPEZ MATEOS": true,
        "AHUAXTLA": true,
        "UNIDAD ANÁHUAC TEPETATES": true
      },
      "56529": {
        "LA CERCA": true,
        "TLAZALA": true
      }
    },
    "LERMA": {
      "52000": {
        "LERMA DE VILLADA CENTRO": true
      },
      "52004": {
        "AURIS": true,
        "BOSQUES DE LERMA": true,
        "CIDECO": true,
        "CORREDOR INDUSTRIAL TOLUCA LERMA": true,
        "EJIDAL EMILIANO ZAPATA": true,
        "EL PORVENIR LL": true,
        "GUADALUPE LA CIÉNEGA": true,
        "HACIENDA SANTA CLARA": true,
        "INFONAVIT": true,
        "ISIDRO FABELA": true,
        "LA BOMBA": true,
        "LA MOTA": true,
        "LOS CEDROS 400": true,
        "NUEVA AMEYALCO": true,
        "PARQUE INDUSTRIAL CERRILLO I": true,
        "PARQUE INDUSTRIAL CERRILLO II": true,
        "SAN ISIDRO": true,
        "SANTA CLARA": true,
        "VALLE DE LERMA": true
      },
      "52005": {
        "LOS OLIVOS": true
      },
      "52006": {
        "HACIENDA LERMA": true
      },
      "52010": {
        "EL ÁRBOL": true
      },
      "52020": {
        "EL ESPINO PERALTA": true
      },
      "52030": {
        "EL CARACOL": true
      },
      "52040": {
        "EL TIRADERO": true
      },
      "52043": {
        "SANTIAGO ANALCO": true
      },
      "52044": {
        "SAN MATEO ATARASQUILLO": true
      },
      "52045": {
        "CAÑADA DE ALFERES": true
      },
      "52046": {
        "SANTA CRUZ CHIGNAHUAPAN": true
      },
      "52047": {
        "AGRÍCOLA ANALCO": true
      },
      "52050": {
        "DOLORES (RANCHERÍA DOLORES)": true
      },
      "52054": {
        "SAN FRANCISCO XOCHICUAUTLA": true
      },
      "52055": {
        "BARRANCA GRANDE": true
      },
      "52059": {
        "LA UNIDAD HUITZIZILAPAN": true
      }
    },
    "MELCHOR OCAMPO": {
      "54880": {
        "EDUCACIÓN": true,
        "EL MIRADOR": true,
        "MELCHOR OCAMPO CENTRO": true,
        "RANCHO EL BAÑADERO": true,
        "SAN ANTONIO": true,
        "SAN ISIDRO": true,
        "TORRESCO": true,
        "XACOPINCA": true
      },
      "54882": {
        "SAN FRANCISCO TENOPALCO": true
      },
      "54883": {
        "EDUCACIÓN": true
      },
      "54884": {
        "SEÑOR DE LOS MILAGROS": true,
        "TEPETONGO": true
      },
      "54890": {
        "2 DE SEPTIEMBRE": true,
        "BICENTENARIO": true,
        "CAÑADITAS": true,
        "LA CAÑADA": true,
        "LA FLORIDA": true,
        "LA PALMA DE VISITACIÓN": true,
        "LOMAS DE TENOPALCO": true,
        "LOS ÁLAMOS": true,
        "LOS ÁLAMOS II": true,
        "REVOLUCIONARIA": true,
        "SAN FRANCISCO TENOPALCO": true,
        "VILLAS DEL FRESNO": true,
        "VISITACIÓN": true,
        "XOCHIMIQUÍA": true,
        "ÁLAMOS III": true
      },
      "54893": {
        "REVOLUCIONARIA": true
      },
      "54894": {
        "LA FLORIDA": true
      }
    },
    "METEPEC": {
      "52140": {
        "CASA DEL PEDREGAL": true,
        "COAXUSTENCO": true,
        "EL CAMPANARIO": true,
        "ESPÍRITU SANTO": true,
        "GUERRERO": true,
        "LA HERRADURA I": true,
        "LA HERRADURA III": true,
        "LOS MORILLOS": true,
        "LOS ROBLES": true,
        "LOS SANTOS": true,
        "LOS SAUCES II": true,
        "MAPLE": true,
        "MAYORAZGO": true,
        "METEPEC CENTRO": true,
        "PUERTA DE HIERRO": true,
        "QUINTA DEL SOL": true,
        "QUINTAS LAS MANZANAS": true,
        "RESIDENCIAL ALBORADA": true,
        "RESIDENCIAL CAMPESTRE METEPEC": true,
        "RESIDENCIAL LOS CEREZOS": true,
        "RINCÓN VIEJO": true,
        "SAN AGUSTÍN": true,
        "SAN LORENZO COACALCO (SAN LORENZO)": true,
        "SAN MATEO": true,
        "SAN MIGUEL": true,
        "SANTA CRUZ": true,
        "SANTA TERESA": true,
        "SANTIAGUITO": true,
        "VILLA ROMANA": true,
        "VILLAS AMOZOC": true,
        "VILLAS DEL SOL": true
      },
      "52143": {
        "DE LA ASUNCIÓN": true
      },
      "52144": {
        "CONDADO DEL VALLE": true
      },
      "52145": {
        "SAN LUCAS TUNCO": true
      },
      "52146": {
        "SAN SEBASTIÁN": true
      },
      "52147": {
        "SAN GASPAR TLAHUELILPAN": true
      },
      "52148": {
        "AGRÍCOLA LÁZARO CÁRDENAS": true,
        "FINCA REAL": true,
        "HACIENDA SAN ANTONIO": true,
        "LLANO GRANDE (EL SALITRE)": true,
        "LOS SAUCES": true
      },
      "52149": {
        "ANDRÉS MOLINA ENRÍQUEZ": true,
        "HACIENDA DEL BOSQUE": true,
        "LA VIRGEN": true,
        "LAS MAGNOLIAS": true,
        "LAS MITRAS": true,
        "LOMAS DE SAN ISIDRO": true,
        "LOS VITRALES": true,
        "LOS ÁLAMOS": true,
        "RESIDENCIAL LA LOMA": true,
        "RINCÓN DE SAN ISIDRO": true,
        "SAN ISIDRO RESIDENCIAL": true,
        "SAN JOSÉ LA PILITA": true,
        "VALLE DEL CRISTAL": true,
        "VILLAS DANTE": true,
        "VILLAS MAGDALENA": true,
        "VILLAS SAN AGUSTÍN": true
      },
      "52150": {
        "CASA MAGNA": true,
        "EL CASTAÑO": true,
        "EL MANANTIAL": true,
        "LA ANTIGUA": true,
        "LA JOYA": true,
        "LOMA REAL": true,
        "RESIDENCIAL BALMORAL": true,
        "SAN ÁNGEL": true,
        "SOLAR": true,
        "VILLA DORADA": true,
        "VILLAS CHAPULTEPEC": true,
        "VILLAS ESPERANZA": true,
        "VILLAS II RESIDENCIAL": true,
        "VILLAS III": true,
        "VILLAS KENT SECC SAUCES": true
      },
      "52154": {
        "LOS CEDROS": true
      },
      "52155": {
        "VIRREYES": true
      },
      "52156": {
        "CHOPOS": true,
        "EL HIPICO": true,
        "EL PORTÓN I, II, III": true,
        "HÍPICO": true,
        "LOS GIRASOLES": true,
        "OLMOS": true,
        "VILLAS METEPEC": true
      },
      "52157": {
        "EL RODEO": true,
        "LAS HACIENDAS": true
      },
      "52158": {
        "LOS FRESNOS": true,
        "PLAZUELAS DE SAN FRANCISCO": true,
        "RINCONADA SAN CARLOS": true,
        "RINCÓN DE SAN GABRIEL": true,
        "SAN FRANCISCO COAXUSCO": true,
        "SAN MARINO": true
      },
      "52159": {
        "FORTANET": true,
        "RESIDENCIAL COUNTRY CLUB": true,
        "SAN CARLOS": true,
        "SAN GABRIEL": true
      },
      "52160": {
        "EL ARENAL": true,
        "SAN BARTOLOMÉ TLALTELULCO": true,
        "SANTIAGUITO": true,
        "URBANO BONANZA": true
      },
      "52161": {
        "SANTA MARÍA MAGDALENA OCOTITLÁN": true
      },
      "52164": {
        "CASA DEL VALLE": true,
        "RESIDENCIAL LAS PALMAS": true,
        "SAN JORGE PUEBLO NUEVO": true,
        "UNIÓN": true
      },
      "52165": {
        "AGRIPÍN GARCÍA ESTRADA": true,
        "LAS MARGARITAS": true,
        "SANTA CRUZ OCOTITLÁN": true
      },
      "52166": {
        "DR. JORGE JIMÉNEZ CANTÚ": true,
        "LA MICHOACANA": true,
        "LUISA ISABEL CAMPOS DE JIMÉNEZ CANTÚ": true
      },
      "52167": {
        "ALTEZA RESIDENCIAL METEPEC": true,
        "BOSQUES SAN JUAN": true,
        "EL CIPRÉS": true,
        "ESTORIL": true,
        "ISIDRO FABELA": true,
        "JESÚS JIMÉNEZ GALLARDO": true,
        "JUAN FERNÁNDEZ ALBARRÁN": true,
        "LAS JARAS": true,
        "MUNICIPAL": true,
        "RESIDENCIAL LAS AMÉRICAS": true,
        "VILLAS SAN GREGORIO": true
      },
      "52168": {
        "PRADOS DE CEBORUCO": true,
        "RESIDENCIAL VERANDA": true,
        "SOLIDARIDAD DE LOS ELECTRICISTAS": true,
        "VALLE DE SAN JAVIER": true,
        "VILLAS ALTEZA": true
      },
      "52169": {
        "JUAN FERNÁNDEZ ALBARRÁN": true,
        "LAS GLORIAS": true,
        "LOS NOGALES": true,
        "PURÍSIMA": true,
        "REAL DE SAN JAVIER": true,
        "XINANTÉCATL": true
      },
      "52170": {
        "EL CARMEN": true,
        "EL NOGAL": true,
        "LOS ARBOLES I": true,
        "LOS ARBOLES II": true,
        "PUERTA DEL SOL": true,
        "QUINTAS DE SAN JERÓNIMO": true,
        "REAL DE SAN JERÓNIMO": true,
        "RINCONADA SAN JERÓNIMO": true,
        "SAN JERÓNIMO": true,
        "SAN JERÓNIMO CHICAHUALCO": true,
        "SAN JOSÉ": true
      },
      "52172": {
        "AGRÍCOLA FRANCISCO I. MADERO": true,
        "ALSACIA": true,
        "ALTAVISTA": true,
        "AMARENA RESIDENCIAL": true,
        "AQUITANIA": true,
        "BELLAVISTA": true,
        "BOSQUES DE LA ASUNCIÓN": true,
        "CASA REAL": true,
        "EL BALDAQUIN RESIDENCIAL": true,
        "EL PIRUL": true,
        "EL PUEBLITO": true,
        "ESPERANZA LÓPEZ MATEOS": true,
        "ESTRELLA": true,
        "EXPLANADA DEL PARQUE": true,
        "GALÁPAGOS": true,
        "HACIENDAS DE GUADALUPE": true,
        "HÁBITAT METEPEC": true,
        "IBIZA RESIDENCIAL": true,
        "ISSEMYM LA PROVIDENCIA": true,
        "LA ASUNCIÓN": true,
        "LA CAPILLA": true,
        "LA CONCORDIA": true,
        "LOMAS DE LA ASUNCIÓN": true,
        "LORENA": true,
        "LOS ALMENDROS": true,
        "LOS CISNES": true,
        "LOS SAUCES": true,
        "MISIÓN VIEJO": true,
        "PALMA REAL": true,
        "PASEO NORMANDÍA": true,
        "PASEO SANTA ELENA": true,
        "PORTOFINO ROYAL COUNTRY CLUB": true,
        "QUINTA LAS AZALEAS": true,
        "RANCHO EL SILENCIO": true,
        "RANCHO SAN LUCAS": true,
        "REAL DE AZALEAS": true,
        "REAL DE AZALEAS I": true,
        "REAL DE AZALEAS II": true,
        "REAL DE AZALEAS III": true,
        "RESIDENCIAL ARIA": true,
        "RESIDENCIAL BOSQUES DE CIRUELOS": true,
        "RESIDENCIAL LA JOYA DIAMANTE": true,
        "RESIDENCIAL SAN SALVADOR": true,
        "RINCONADA SAN LUIS": true,
        "SAN ANTONIO REGLA": true,
        "SAN MIGUEL": true,
        "SAN MIGUEL REGLA": true,
        "SAN SALVADOR TIZATLALLI": true,
        "SANTA CECILIA": true,
        "SANTA MARÍA REGLA": true,
        "SANTA RITA": true,
        "SUR DE LA HACIENDA": true,
        "VILLAS KENT SECCIÓN EL NEVADO": true,
        "VILLAS KENT SECCIÓN GUADALUPE": true,
        "VILLAS LOS ARRAYANES": true,
        "VILLAS SANTA TERESA": true,
        "VILLAS TIZATLALLI": true,
        "ÁRBOL DE LA VIDA": true
      },
      "52175": {
        "CASA BLANCA": true,
        "LA NORIA": true,
        "LOS ARCOS": true,
        "RENACIMIENTO": true,
        "VILLAS CASA BLANCA": true
      },
      "52176": {
        "ARBOLEDAS I": true,
        "IZCALLI CUAUHTÉMOC I": true,
        "IZCALLI CUAUHTÉMOC II": true,
        "IZCALLI CUAUHTÉMOC III": true,
        "IZCALLI CUAUHTÉMOC IV": true,
        "IZCALLI CUAUHTÉMOC V": true,
        "IZCALLI CUAUHTÉMOC VI": true,
        "LA CAMPESINA": true,
        "LAS MARINAS": true,
        "RANCHO SAN FRANCISCO": true
      },
      "52177": {
        "CAMPESTRE DEL VALLE": true,
        "EL ALCÁZAR": true,
        "LA HORTALIZA": true,
        "LA PROVIDENCIA": true,
        "LAS BARCENAS RESIDENCIAL": true,
        "LÁZARO CÁRDENAS": true,
        "RANCHO LA PROVIDENCIA": true,
        "RESIDENCIAL CITLALLI": true,
        "RESIDENCIAL LA GAVIA": true,
        "RESIDENCIAL LA PROVIDENCIA": true,
        "RINCONADA MEXICANA": true,
        "VILLAS COUNTRY": true
      },
      "52178": {
        "CAMPESTRE DEL VIRREY": true,
        "LAS VIANDAS": true,
        "VILLAS CAMPESTRE DE METEPEC": true
      },
      "52179": {
        "ARBOLEDAS II": true,
        "ARCOS I Y II": true,
        "DIAMANTE": true,
        "EL ENSUEÑO": true,
        "LOS PILARES": true,
        "PILARES": true,
        "TOLLOCAN II": true
      }
    },
    "MEXICALTZINGO": {
      "52180": {
        "SAN MATEO MEXICALTZINGO CENTRO": true
      },
      "52182": {
        "SAN JOSÉ": true
      },
      "52183": {
        "AZCAPOTZALCO": true
      },
      "52185": {
        "LA ESTACIÓN": true
      },
      "52189": {
        "SAN ISIDRO": true
      }
    },
    "NAUCALPAN DE JUÁREZ": {
      "53000": {
        "SAN BARTOLO NAUCALPAN (NAUCALPAN CENTRO)": true,
        "UNIDAD MORELOS": true
      },
      "53010": {
        "CONJUNTO SAN MIGUEL": true
      },
      "53030": {
        "BOSQUE DE LOS REMEDIOS": true
      },
      "53040": {
        "LAS AMÉRICAS": true
      },
      "53050": {
        "EL MIRADOR": true
      },
      "53060": {
        "LOMA TAURINA": true
      },
      "53070": {
        "ADOLFO LÓPEZ MATEOS": true
      },
      "53100": {
        "CIUDAD SATÉLITE": true,
        "CLUB CUICACALLI": true
      },
      "53110": {
        "BUGAMBILIAS": true,
        "FONTANA RESIDENCIAL": true,
        "SANTA CRUZ DEL MONTE": true
      },
      "53115": {
        "LOMAS DE LAS FUENTES": true
      },
      "53116": {
        "LA ALTEZA": true
      },
      "53117": {
        "CRISTÓBAL COLÓN": true,
        "EL SAUZALITO": true
      },
      "53119": {
        "COLONIAL SATÉLITE": true
      },
      "53120": {
        "LOMAS VERDES (CONJUNTO LOMAS VERDES)": true,
        "LOMAS VERDES 1A SECCIÓN": true
      },
      "53124": {
        "BOSQUE ALTO": true,
        "LA CÚSPIDE": true,
        "PETROQUÍMICA LOMAS VERDES": true
      },
      "53125": {
        "LOMAS VERDES 3A SECCIÓN": true,
        "LOMAS VERDES 4A SECCIÓN": true
      },
      "53126": {
        "EL CRISTO": true,
        "LOMAS VERDES 5A SECCIÓN (LA CONCORDIA)": true,
        "LOMAS VERDES 6A SECCIÓN": true
      },
      "53127": {
        "LA ALTEÑA I": true,
        "LA ALTEÑA II": true,
        "LA ALTEÑA III": true,
        "LOMAS DE SANTA CRUZ": true
      },
      "53128": {
        "CONJUNTO LA RONDA": true,
        "RESIDENCIAL SANTA CRUZ": true
      },
      "53129": {
        "JARDINES DE SATÉLITE": true,
        "TELEFONISTAS": true
      },
      "53130": {
        "JARDINES DE LA FLORIDA": true
      },
      "53138": {
        "HACIENDA DE CRISTO (EXHACIENDA DE CRISTO)": true
      },
      "53140": {
        "AMPLIACIÓN MISIONES": true,
        "BOULEVARES": true,
        "JARDINES DE BOULEVARES": true,
        "MISIONES": true
      },
      "53150": {
        "SANTA CRUZ ACATLÁN": true
      },
      "53160": {
        "LA FLORIDA": true
      },
      "53170": {
        "LOMA DE CRISTY": true
      },
      "53177": {
        "RINCONADA DILIGENCIAS": true
      },
      "53178": {
        "LA SOLEDAD": true
      },
      "53179": {
        "LOMAS VERDES INFONAVIT": true
      },
      "53200": {
        "LA ATALAYA": true,
        "LOMAS DE SAN MATEO": true
      },
      "53215": {
        "CASAS VIEJAS (LA ERA)": true,
        "LA BARRANQUILLA": true,
        "LA HUERTA SAN MATEO": true
      },
      "53216": {
        "SANTIAGO TEPATLAXCO": true
      },
      "53217": {
        "LA PRESA (TEJOCOTE)": true
      },
      "53218": {
        "COLINAS DE SAN MATEO": true,
        "RANCHO COLORADO": true
      },
      "53219": {
        "RINCÓN VERDE": true
      },
      "53220": {
        "LA JOYA I": true,
        "LA JOYA II": true,
        "LA JOYITA": true,
        "REAL SAN MATEO": true,
        "RINCONADA DE LOS PARQUES": true,
        "RINCÓN DE LAS FUENTES": true,
        "SAN MATEO NOPALA": true
      },
      "53224": {
        "SAN MATEO NOPALA ZONA NORTE": true
      },
      "53227": {
        "CUMBRES DE SAN MATEO": true,
        "IZCALLI SAN MATEO": true,
        "PEDREGAL DE SAN MATEO": true,
        "RINCONADA SAN MATEO": true,
        "SAN MATEO NOPALA ZONA SUR": true
      },
      "53228": {
        "EL RISCO": true,
        "LA LUNA (SAN MATEO NOPALA)": true,
        "LADERAS DE LA COLMENA": true,
        "LOS EMPERADORES": true,
        "PRADERAS DE SAN MATEO": true,
        "SANTA ROSA": true
      },
      "53229": {
        "AGUA BUENA": true,
        "CIPRESES (LAS JULIANAS)": true,
        "CÓRDOBA": true,
        "EL CHABACANO": true,
        "EL COBRADERO": true,
        "EL PUERTO": true,
        "JARDINES DEL OJO DE AGUA": true,
        "JUAN GÓMEZ": true,
        "LA CUESTA": true,
        "LA HIEDRA": true,
        "LA ROSA": true,
        "LAS ARENILLAS": true,
        "LAS PEÑITAS": true,
        "LAS ÁNIMAS (EX-HACIENDA LAS ÁNIMAS)": true,
        "PINOS II": true,
        "PUENTE DE PIEDRA": true,
        "RANCHO VIEJO": true,
        "SAN MATEO NOPALA (BELLAVISTA)": true,
        "TITO": true
      },
      "53230": {
        "LOS ÁLAMOS": true
      },
      "53237": {
        "LOS FRESNOS": true
      },
      "53239": {
        "AMPLIACIÓN LOS FRESNOS": true
      },
      "53240": {
        "ALCANFORES": true,
        "ANEXO JARDINES DE SAN MATEO": true,
        "JARDINES DE SAN MATEO": true,
        "JARDINES DE SAN MATEO SECCIÓN COLINAS": true,
        "PRADO SAN MATEO": true,
        "VALLE DE SAN MATEO": true
      },
      "53247": {
        "LOMAS DE OCCIPACO": true
      },
      "53248": {
        "LADERAS DE SAN MATEO": true
      },
      "53250": {
        "LA PALMA": true,
        "SANTIAGO OCCIPACO": true
      },
      "53260": {
        "MÉXICO 68": true
      },
      "53270": {
        "LAS PAPAS": true,
        "SAN JUAN TOTOLTEPEC": true
      },
      "53278": {
        "IZCALLI DEL BOSQUE": true
      },
      "53279": {
        "BOSQUES DE MOCTEZUMA": true,
        "TERCER MUNDO": true
      },
      "53280": {
        "CIUDAD BRISA": true
      },
      "53283": {
        "PEDREGAL DE ECHEGARAY": true,
        "TIAHUI": true
      },
      "53290": {
        "BALCONES DE SAN MATEO": true,
        "VISTA DEL VALLE SECCIÓN ELECTRICISTAS": true
      },
      "53296": {
        "VISTA DEL VALLE II, III, IV Y IX": true,
        "VISTA DEL VALLE SECCIÓN BOSQUES": true,
        "XALPA DE LA HUERTA": true
      },
      "53297": {
        "EX-EJIDO SANTIAGO OCCIPACO": true,
        "PASEOS DEL BOSQUE": true
      },
      "53298": {
        "CUMBRES DE HIMALAYA": true
      },
      "53300": {
        "COLÓN ECHEGARAY": true,
        "HACIENDA DE ECHEGARAY": true
      },
      "53309": {
        "RINCÓN ECHEGARAY": true
      },
      "53310": {
        "BOSQUE DE ECHEGARAY": true,
        "BOSQUE DE ECHEGARAY SECCIÓN ELECTRICISTAS": true
      },
      "53320": {
        "DIEZ DE ABRIL": true
      },
      "53329": {
        "RIVERA DE ECHEGARAY": true
      },
      "53330": {
        "CERVECERA MODELO": true
      },
      "53338": {
        "CONJUNTO LA HUERTA": true,
        "SANTA MARÍA NATIVITAS": true
      },
      "53339": {
        "RINCÓN DEL BOSQUE DE ECHEGARAY": true
      },
      "53340": {
        "LA PERLA": true,
        "LOS PASTORES": true
      },
      "53348": {
        "INDUSTRIAL LA PERLA": true
      },
      "53350": {
        "RANCHO ATENCO": true
      },
      "53370": {
        "INDUSTRIAL ALCE BLANCO": true,
        "NAUCALPAN": true
      },
      "53378": {
        "AHUIZOTLA (SANTIAGO AHUIZOTLA)": true
      },
      "53390": {
        "LOMAS DE SOTELO": true
      },
      "53398": {
        "EL PARQUE": true
      },
      "53400": {
        "LOS REMEDIOS": true
      },
      "53410": {
        "AMPLIACIÓN LOS REMEDIOS (EL BEATO)": true,
        "PADRE FIGUEROA": true,
        "UNIÓN POPULAR": true
      },
      "53420": {
        "LOMA COLORADA 1RA. SECCIÓN": true
      },
      "53425": {
        "EL CORRALITO": true,
        "LA UNIVERSAL": true
      },
      "53426": {
        "CASA BLANCA": true,
        "CUARTOS II 1A SECCIÓN": true,
        "CUARTOS III": true,
        "EMILIANO ZAPATA": true,
        "LA CAÑADA - SAN LORENZO TOTOLINGA": true,
        "LA RAQUELITO": true,
        "LOS CUARTOS II": true,
        "SAN LORENZO TOTOLINGA": true,
        "SAN LORENZO TOTOLINGA 1A SECCIÓN": true,
        "SAN LORENZO TOTOLINGA 2A SECCIÓN": true
      },
      "53427": {
        "EL PORVENIR": true,
        "LAS CABALLERIZAS": true,
        "LAS HUERTAS 1A SECC": true,
        "LAS HUERTAS 2A SECCIÓN": true,
        "LAS HUERTAS 3A SECCIÓN": true,
        "LOMA COLORADA 2DA. SECCIÓN": true,
        "LOMAS DE LOS REMEDIOS": true,
        "LUISA ISABEL CAMPOS DE JIMÉNEZ CANTÚ (CUARTOS I)": true
      },
      "53428": {
        "MÉXICO 86 (LA CHACONA)": true
      },
      "53430": {
        "LOS ARCOS": true,
        "REUBICACIÓN EL TORITO": true
      },
      "53440": {
        "PREDIO EL ZAPOTE": true,
        "SIERRA NEVADA": true,
        "UNIÓN POPULAR": true
      },
      "53450": {
        "CIUDAD DE LOS NIÑOS": true
      },
      "53458": {
        "BOSQUE DE LOS REMEDIOS": true
      },
      "53459": {
        "AMPLIACIÓN CIUDAD DE LOS NIÑOS": true
      },
      "53460": {
        "BARRIO EL TORITO": true,
        "LA RIVERA": true,
        "LOS ARCOS": true
      },
      "53470": {
        "LOMA DE CANTERAS (LOMAS DE CANTERA)": true
      },
      "53489": {
        "PARQUE INDUSTRIAL NAUCALPAN": true
      },
      "53490": {
        "LA MONERA": true,
        "LAS TINAJAS (PREDIO LAS TINAJAS)": true,
        "LOMAS DE SAN AGUSTÍN": true,
        "SANTA LILIA CHAMAPA": true
      },
      "53500": {
        "EL CONDE": true,
        "SAN ANDRÉS ATOTO": true
      },
      "53519": {
        "INDUSTRIAL ATOTO": true
      },
      "53520": {
        "EL OLIVAR": true,
        "ROSA DE CASTILLA": true
      },
      "53529": {
        "INDUSTRIAL TLATILCO": true
      },
      "53530": {
        "EL MOLINITO": true,
        "JARDINES DEL MOLINITO": true,
        "NUEVO MOLINITO": true
      },
      "53533": {
        "CAMPO MILITAR 1": true
      },
      "53550": {
        "AMPLIACIÓN SAN ESTEBAN": true,
        "SAN ESTEBAN HUITZILACASCO": true,
        "UNIDAD SAN ESTEBAN": true
      },
      "53560": {
        "LÁZARO CÁRDENAS": true
      },
      "53569": {
        "SAN FRANCISCO CUAUTLALPAN": true
      },
      "53570": {
        "LA CAÑADA": true,
        "LOMAS DE LA CAÑADA": true,
        "SAN ANTONIO ZOMEYUCAN": true,
        "SAN ANTONIO ZOMEYUCAN (ZONA URBANA)": true
      },
      "53580": {
        "AMPLIACIÓN LOMA LINDA": true,
        "LA ESPERANZA": true,
        "LOMA LINDA": true,
        "PIEDRAS NEGRAS": true,
        "REFORMA SAN LUÍS": true,
        "SAN LUÍS TLATILCO": true
      },
      "53598": {
        "ESTADO DE MÉXICO (EL TAMBOR)": true,
        "HIDALGO": true
      },
      "53640": {
        "BOSQUES DE CHAMAPA": true,
        "NUEVA SAN RAFAEL": true
      },
      "53650": {
        "SAN MIGUEL DEXTHA": true
      },
      "53658": {
        "EL CASTILLO": true,
        "LA CEBADA (BARRIO LA CEBADA)": true,
        "LA MAGNOLIA": true,
        "LA PALMA (PIE DE LA PALMA)": true,
        "LA VIGA (CERRO LOCO)": true,
        "LAS TORRES": true,
        "LLANO DE LAS FLORES (BARRIO DEL HUESO)": true,
        "MINAS DEL TECOLOTE": true,
        "PARAJE LAS ROSAS": true
      },
      "53659": {
        "VILLA ALPINA": true
      },
      "53660": {
        "LA PRESA CHAMAPA": true,
        "SAN RAFAEL CHAMAPA": true
      },
      "53664": {
        "CUARTOS CONSTITUCIÓN (SAN RAFAEL CHAMAPA I)": true,
        "SAN RAFAEL CHAMAPA (TABIQUERA 2)": true,
        "SAN RAFAEL CHAMAPA (TABIQUERA 3)": true,
        "SAN RAFAEL CHAMAPA (TABIQUERA 4)": true,
        "SAN RAFAEL CHAMAPA (TABIQUERA 5)": true,
        "SAN RAFAEL CHAMAPA (TABIQUERA 6)": true,
        "SAN RAFAEL CHAMAPA (TABIQUERA 7)": true,
        "SAN RAFAEL CHAMAPA (TABIQUERA 8)": true,
        "SAN RAFAEL CHAMAPA I": true,
        "SAN RAFAEL CHAMAPA II": true
      },
      "53670": {
        "LOS CUARTOS (SAN RAFAEL CHAMAPA I)": true
      },
      "53680": {
        "LA MORA": true,
        "SAN RAFAEL CHAMAPA (TABIQUERA 9)": true,
        "SAN RAFAEL CHAMAPA IV": true
      },
      "53687": {
        "POETAS MEXIQUENSES ( TABIQUERA 10 )": true,
        "SAN RAFAEL CHAMAPA (TABIQUERA 1)": true
      },
      "53688": {
        "LAS COLONIAS (PREDIO LAS COLONIAS)": true
      },
      "53689": {
        "ISIDRO FABELA (TABIQUERAS 11 Y 12)": true,
        "IZCALLI CHAMAPA": true
      },
      "53690": {
        "AMPLIACIÓN OLÍMPICA (SAN RAFAEL CHAMAPA VII)": true,
        "LOMAS DE CHAMAPA": true,
        "OLIMPIADA 68 (SAN RAFAEL CHAMAPA III)": true,
        "OLÍMPICA (SAN RAFAEL CHAMAPA V)": true,
        "VALLE DORADO (SAN RAFAEL CHAMAPA VI)": true
      },
      "53694": {
        "MINAS EL COYOTE": true
      },
      "53695": {
        "LA PALMA": true,
        "MINAS SAN MARTÍN": true
      },
      "53696": {
        "MINA PALACIOS (MINAS PALACIO)": true
      },
      "53697": {
        "3 DE MAYO": true,
        "EL CAPULÍN": true,
        "JARDINES DE SAN JOSÉ": true,
        "MINAS EL TECOLOTE": true
      },
      "53698": {
        "OLÍMPICA RADIO 1A SECCIÓN (SAN RAFAEL CHAMAPA)": true,
        "OLÍMPICA RADIO 2A SECCIÓN (EL CARACOL)": true,
        "SAN JOSÉ POZA HONDA": true
      },
      "53700": {
        "ALTAMIRA": true,
        "AMPLIACIÓN ALTAMIRA": true,
        "TORRES ZOMEYUCAN (SAN ANTONIO ZOMEYUCAN)": true
      },
      "53708": {
        "BALCONES DE CHAMAPA": true,
        "TIERRA Y LIBERTAD": true
      },
      "53710": {
        "PLAN DE AYALA": true
      },
      "53713": {
        "VICENTE GUERRERO": true
      },
      "53714": {
        "LA MANCHA III": true
      },
      "53716": {
        "ALFREDO DEL MAZO VÉLEZ": true,
        "LA PUNTA": true
      },
      "53717": {
        "LA MANCHA I": true,
        "LA MANCHA II": true
      },
      "53718": {
        "ALFREDO V. BONFIL": true
      },
      "53719": {
        "LOMAS DEL CADETE": true
      },
      "53730": {
        "CAPULÍN SOLEDAD": true,
        "UNIDAD Y PROGRESO": true
      },
      "53760": {
        "SAN JOSÉ DE LOS LEONES 1A SECCIÓN": true,
        "SAN JOSÉ DE LOS LEONES 2A SECCIÓN": true,
        "SAN JOSÉ DE LOS LEONES 3A SECCIÓN": true
      },
      "53770": {
        "EL CHAMIZAL": true
      },
      "53780": {
        "MÁRTIRES DE RÍO BLANCO": true
      },
      "53787": {
        "AMPLIACIÓN MÁRTIRES DE RÍO BLANCO": true
      },
      "53788": {
        "LA TOLVA": true
      },
      "53790": {
        "BENITO JUÁREZ": true
      },
      "53798": {
        "LA RADIO BENITO JUÁREZ": true
      },
      "53799": {
        "AMPLIACIÓN BENITO JUÁREZ": true
      },
      "53800": {
        "BUENAVISTA": true,
        "LOMAS DEL RÍO": true
      },
      "53809": {
        "MIRAMAR": true
      },
      "53810": {
        "SAN JOSÉ RÍO HONDO (RÍO HONDO)": true
      },
      "53819": {
        "PROGRESO": true
      },
      "53820": {
        "RICARDO FLORES MAGÓN": true
      },
      "53830": {
        "INDEPENDENCIA": true,
        "LA GUADALUPANA": true
      },
      "53839": {
        "RINCONES DEL BOSQUE": true
      },
      "53840": {
        "LOMAS DEL HUIZACHAL": true
      },
      "53900": {
        "LOMAS HIPÓDROMO": true
      },
      "53909": {
        "EXPLANADA DE LAS FUENTES": true
      },
      "53910": {
        "LOMAS MANUEL ÁVILA CAMACHO": true
      },
      "53930": {
        "COUNTRY CLUB": true
      },
      "53940": {
        "RÍO ESCONDIDO": true
      },
      "53950": {
        "LOMAS DE TECAMACHALCO": true
      },
      "53960": {
        "REFORMA SOCIAL (LOMAS DE SAN ISIDRO)": true
      },
      "53970": {
        "SAN MIGUEL TECAMACHALCO": true
      }
    },
    "NEXTLALPAN": {
      "55795": {
        "COMPUERTA ORIENTE": true,
        "LAGUNA": true,
        "LOS PASTALES": true
      },
      "55796": {
        "EX-HACIENDA SANTA INÉS": true,
        "LOS AGUILUCHOS": true,
        "PASEOS DEL VALLE": true,
        "POZOS Y VÍAS (FRACCIÓN DIECISIETE A)": true,
        "PRADOS SAN FRANCISCO": true,
        "SAN ANTONIO (EL OASIS)": true,
        "TIERRA DE SANTA INÉS": true,
        "VILLAS DE NEXTLALPAN": true
      },
      "55797": {
        "SAN JUAN ATENANCO": true,
        "SANTIAGO ATOCAN": true
      }
    },
    "NEZAHUALCÓYOTL": {
      "57000": {
        "BENITO JUÁREZ (LA AURORA)": true
      },
      "57100": {
        "VALLE DE ARAGÓN": true
      },
      "57103": {
        "POLÍGONO DEL BORDO DE XOCHIACA": true
      },
      "57120": {
        "CAMPESTRE GUADALUPANA": true
      },
      "57129": {
        "AMPLIACIÓN CAMPESTRE GUADALUPANA": true
      },
      "57130": {
        "IMPULSORA POPULAR AVÍCOLA": true,
        "LAS ANTENAS O CLAUSTRO DE SOR JUANA INÉS DE LA C.": true
      },
      "57138": {
        "BOSQUES DE VIENA": true,
        "CANAL DE SALES": true,
        "EMILIANO ZAPATA": true
      },
      "57139": {
        "PLAZAS DE ARAGÓN": true
      },
      "57140": {
        "JARDINES DE GUADALUPE": true
      },
      "57150": {
        "VERGEL DE GUADALUPE": true
      },
      "57158": {
        "JOYAS DE ARAGÓN": true
      },
      "57170": {
        "BOSQUES DE ARAGÓN": true
      },
      "57171": {
        "ESCUELA NACIONAL DE ESTUDIOS PROFESIONALES ARAGÓN": true
      },
      "57178": {
        "LAS ARMAS": true
      },
      "57179": {
        "PRADOS DE ARAGÓN": true
      },
      "57180": {
        "CIUDAD LAGO": true
      },
      "57185": {
        "AMPLIACIÓN CIUDAD LAGO": true,
        "AMPLIACIÓN CIUDAD LAGO EL TRIANGULO": true,
        "CUCHILLA DEL TESORO": true
      },
      "57188": {
        "AMPLIACIÓN CIUDAD LAGO ASA (ANTONIO ALZATE)": true
      },
      "57189": {
        "AMPLIACIÓN CIUDAD LAGO COMUNICACIONES": true
      },
      "57200": {
        "EL SOL": true
      },
      "57205": {
        "CIUDAD JARDÍN": true
      },
      "57210": {
        "ESTADO DE MÉXICO": true
      },
      "57300": {
        "TAMAULIPAS": true,
        "TAMAULIPAS SECCIÓN VIRGENCITAS": true
      },
      "57310": {
        "TAMAULIPAS SECCIÓN LAS FLORES": true,
        "TAMAULIPAS SECCIÓN PALMAR": true
      },
      "57400": {
        "EL BARCO PRIMERA SECCIÓN": true,
        "EL BARCO SEGUNDA SECCIÓN": true,
        "EL BARCO TERCERA SECCIÓN": true
      },
      "57410": {
        "MARAVILLAS": true
      },
      "57420": {
        "NEZAHUALCÓYOTL PRIMERA SECCIÓN": true,
        "NEZAHUALCÓYOTL SEGUNDA SECCIÓN": true,
        "NEZAHUALCÓYOTL TERCERA SECCIÓN": true
      },
      "57430": {
        "PORVENIR": true
      },
      "57440": {
        "LAS PALMAS": true,
        "MARTÍNEZ DEL LLANO": true,
        "XOCHITENCO": true
      },
      "57450": {
        "VOLCANES": true
      },
      "57460": {
        "JUÁREZ PANTITLÁN": true
      },
      "57500": {
        "AGUA AZUL GRUPO A SUPER 4": true,
        "AGUA AZUL GRUPO B SUPER 23": true,
        "AGUA AZUL GRUPO B SUPER 4": true,
        "AGUA AZUL GRUPO C SÚPER 4 Y SÚPER 23": true,
        "CENTRAL": true
      },
      "57510": {
        "AGUA AZUL SECCIÓN PIRULES": true
      },
      "57520": {
        "PORFIRIO DÍAZ": true
      },
      "57530": {
        "MODELO": true
      },
      "57600": {
        "AMPLIACIÓN ROMERO SECCIÓN LAS FUENTES": true
      },
      "57610": {
        "PAVÓN SECCIÓN SILVIA": true
      },
      "57620": {
        "MÉXICO PRIMERA SECCIÓN": true,
        "MÉXICO SEGUNDA SECCIÓN": true
      },
      "57630": {
        "ROMERO": true
      },
      "57700": {
        "EVOLUCIÓN": true,
        "EVOLUCIÓN SÚPER 22": true,
        "EVOLUCIÓN SÚPER 24": true,
        "EVOLUCIÓN SÚPER 43": true
      },
      "57708": {
        "EVOLUCIÓN PONIENTE": true
      },
      "57709": {
        "AMPLIACIÓN EVOLUCIÓN": true
      },
      "57710": {
        "GENERAL JOSÉ VICENTE VILLADA": true
      },
      "57718": {
        "AMPLIACIÓN GENERAL JOSÉ VICENTE VILLADA ORIENTE": true,
        "AMPLIACIÓN GENERAL JOSÉ VICENTE VILLADA SÚPER 44": true
      },
      "57719": {
        "AMPLIACIÓN GENERAL JOSÉ VICENTE VILLADA PONIENTE": true
      },
      "57720": {
        "ATLACOMULCO": true
      },
      "57730": {
        "METROPOLITANA PRIMERA SECCIÓN": true
      },
      "57739": {
        "SAN LORENZO": true
      },
      "57740": {
        "METROPOLITANA SEGUNDA SECCIÓN": true
      },
      "57750": {
        "METROPOLITANA TERCERA SECCIÓN": true
      },
      "57760": {
        "AMPLIACIÓN GENERAL JOSÉ VICENTE VILLADA SÚPER 43": true
      },
      "57800": {
        "ESPERANZA": true
      },
      "57809": {
        "REY NEZAHUALCÓYOTL": true
      },
      "57810": {
        "IZCALLI NEZAHUALCÓYOTL": true
      },
      "57819": {
        "PARQUE INDUSTRIAL NEZAHUALCÓYOTL": true
      },
      "57820": {
        "LA PERLA": true
      },
      "57830": {
        "AMPLIACIÓN LA PERLA REFORMA": true
      },
      "57840": {
        "REFORMA": true
      },
      "57849": {
        "REFORMA A SECCIÓN 1": true
      },
      "57900": {
        "LAS ÁGUILAS": true
      },
      "57910": {
        "CONSTITUCIÓN DE 1857": true
      },
      "57920": {
        "SANTA MARTHA": true
      },
      "57930": {
        "MANANTIALES": true
      },
      "57940": {
        "LOMA BONITA": true
      },
      "57950": {
        "AMPLIACIÓN LAS ÁGUILAS": true
      }
    },
    "NICOLÁS ROMERO": {
      "54400": {
        "BENITO JUÁREZ 1A. SECCIÓN (CABECERA MUNICIPAL)": true
      },
      "54402": {
        "BARRÓN": true
      },
      "54405": {
        "BENITO JUÁREZ": true
      },
      "54407": {
        "AMPLIACIÓN EL ROSARIO": true,
        "AQUILES CÓRDOVA MORÁN": true,
        "LIBERTAD 1A. SECCIÓN": true,
        "LIBERTAD 2A SECCIÓN": true
      },
      "54408": {
        "JORGE JIMÉNEZ CANTÚ": true
      },
      "54409": {
        "INDEPENDENCIA 1A. SECCIÓN": true,
        "INDEPENDENCIA 2A. SECCIÓN": true,
        "SAN MARCOS": true,
        "TORRES PEREGRINA": true
      },
      "54410": {
        "EL GLOBO": true
      },
      "54413": {
        "CINCO DE FEBRERO": true,
        "GUADALUPE SAN ILDEFONSO": true,
        "SAN JUAN": true
      },
      "54414": {
        "AMPLIACIÓN VISTA HERMOSA": true,
        "BUENAVISTA": true,
        "VISTA HERMOSA 1A. SECCIÓN": true,
        "VISTA HERMOSA 2A. SECCIÓN": true
      },
      "54416": {
        "CANTAROS III": true,
        "CUMBRES": true,
        "RINCONADA LAGO DE GUADALUPE": true,
        "SANTA ANITA LA BOLSA": true
      },
      "54417": {
        "AZOTLÁN PARTE ALTA": true,
        "AZOTLÁN PARTE BAJA": true,
        "LOMAS DE GUADALUPE": true
      },
      "54420": {
        "LOS MANANTIALES": true
      },
      "54424": {
        "SAN MIGUEL HILA": true
      },
      "54425": {
        "VICENTE GUERRERO 1A. SECCIÓN": true,
        "VICENTE GUERRERO 2A. SECCIÓN": true
      },
      "54426": {
        "VICENTE GUERRERO BARRÓN": true
      },
      "54434": {
        "HIDALGO": true,
        "IGNACIO CAPETILLO": true,
        "SANTA ANITA": true
      },
      "54435": {
        "CIUDAD CAMPESTRE": true,
        "EL TRAFICO": true,
        "HIMNO NACIONAL": true,
        "LLANO GRANDE ATZACAPUTZALTONGO": true,
        "VEINTIDÓS DE FEBRERO": true
      },
      "54449": {
        "BOSQUES DE SAN NICOLÁS": true,
        "LOMA DE GUADALUPE (LA BIZNAGA)": true,
        "SAN JOSÉ EL VIDRIO": true,
        "SAN MIGUEL": true
      },
      "54455": {
        "LOMA DE SAN JOSÉ": true,
        "MORELOS": true
      },
      "54457": {
        "IGNACIO ZARAGOZA": true
      },
      "54459": {
        "EL GAVILLERO": true,
        "LOMA LARGA": true
      },
      "54460": {
        "\"Y\" GRIEGA": true,
        "CAJA DE AGUA": true,
        "JOYA DEL TEJOCOTE": true,
        "LA CONCEPCIÓN": true,
        "LOS TUBOS": true,
        "PROGRESO INDUSTRIAL": true,
        "SAN PABLO DE LA CRUZ": true,
        "VILLAS DEL BOSQUE": true
      },
      "54463": {
        "EL TANQUE": true,
        "LLANO GRANDE (NUEVO EJIDO)": true,
        "LOMA DEL RÍO": true
      },
      "54466": {
        "CANTAROS I": true,
        "CANTAROS II": true,
        "FUENTES DE SAN JOSÉ": true,
        "PASEO DE SAN CARLOS": true,
        "SAN CARLOS": true,
        "SAN JUAN TLIHUACA": true,
        "UNIDAD MAGISTERIAL": true
      },
      "54467": {
        "ARCOIRIS": true,
        "ELSA CÓRDOVA MORÁN": true,
        "FRANCISCO I. MADERO 1A. SECCIÓN": true,
        "FRANCISCO I. MADERO SECCIÓN 20": true,
        "MIRADOR DEL CONDE": true
      },
      "54469": {
        "BENITO JUÁREZ BARRÓN": true
      },
      "54470": {
        "SAN ILDEFONSO": true
      },
      "54473": {
        "BULEVARES DEL LAGO": true,
        "CAMPESTRE LIBERACIÓN": true,
        "FRANCISCO SARABIA 1A. SECCIÓN": true,
        "FRANCISCO SARABIA 2A. SECCIÓN": true
      },
      "54474": {
        "AMPLIACIÓN GRANJAS DE GUADALUPE": true,
        "CLARA CÓRDOVA MORÁN": true,
        "GRANJAS DE GUADALUPE 1A. SECCIÓN": true,
        "VISTA VERDE": true
      },
      "54475": {
        "LA COLMENA": true,
        "LOMA DE LA CRUZ 1A. SECCIÓN": true
      },
      "54476": {
        "BOSQUES DE LA COLMENA": true,
        "COLONIAL DEL LAGO": true,
        "HACIENDA SANTO TOMAS": true,
        "LOMAS DEL LAGO": true,
        "PUEBLO VIEJO": true,
        "RICARDO FLORES MAGÓN": true,
        "SITIO 217": true
      },
      "54477": {
        "SAN ISIDRO LA PAZ 1A. SECCIÓN": true,
        "SAN ISIDRO LA PAZ 2A. SECCIÓN": true,
        "SAN ISIDRO LA PAZ 3A. SECCIÓN": true
      }
    },
    "OCOYOACAC": {
      "52740": {
        "CENTRO OCOYOACAC": true,
        "COAPANOAYA": true,
        "EJIDO LA CAMPANA": true,
        "SAN MIGUEL": true,
        "SANTA MARÍA": true
      }
    },
    "SAN MATEO ATENCO": {
      "52100": {
        "SAN MATEO ATENCO CENTRO": true
      },
      "52104": {
        "400 UNO RESIDENCIAL": true,
        "CARLOS HANK GONZÁLEZ": true,
        "CUAUHTÉMOC": true,
        "EL FORTÍN": true,
        "ESPACIO UNO RESIDECIAL": true,
        "FÉNIX RESIDENCIAL": true,
        "GRAFITO": true,
        "HACIENDA EL DORADO": true,
        "HACIENDA EL DORADO II": true,
        "HACIENDA REAL RESIDENCIAL": true,
        "HACIENDA SANTA MARÍA": true,
        "LA MAGDALENA": true,
        "RESIDENCIAL SAN ÁNGEL": true,
        "RINCONADA SAN CARLOS": true,
        "SAN FRANCISCO": true,
        "SAN JUAN": true,
        "SAN MIGUEL": true,
        "SAN NICOLÁS": true,
        "SANTA MARÍA": true,
        "SANTIAGO": true,
        "TEZONTLE": true,
        "VILLAS DE METEPEC SAN MATEO": true,
        "VISTA VERDE": true,
        "VITALIA SAN MATEO": true
      },
      "52105": {
        "BUENAVISTA": true,
        "LA CONCEPCIÓN": true,
        "SAN ISIDRO": true,
        "SAN PEDRO": true,
        "SANTA ELENA": true,
        "ÁLVARO OBREGÓN": true
      },
      "52110": {
        "EMILIANO ZAPATA": true
      },
      "52120": {
        "REFORMA": true
      }
    },
    "TECÁMAC": {
      "55740": {
        "TECÁMAC DE FELIPE VILLANUEVA CENTRO": true
      },
      "55743": {
        "REAL GRANADA": true
      },
      "55744": {
        "SAN PEDRO POTZOHUACAN": true
      },
      "55745": {
        "REAL GRANADA IV": true
      },
      "55746": {
        "EX HACIENDA SAN MIGUEL TENOPALA": true
      },
      "55747": {
        "SAN PABLO TECALCO": true
      },
      "55748": {
        "JEMA": true
      },
      "55749": {
        "MONTECARLO": true
      },
      "55750": {
        "EL TANQUE": true
      },
      "55752": {
        "SAN JUAN PUEBLO NUEVO": true
      },
      "55754": {
        "SANTO DOMINGO AJOLOAPAN": true
      },
      "55755": {
        "LOS REYES ACOZAC": true
      },
      "55757": {
        "SAN LUCAS XOLOX": true
      },
      "55758": {
        "AMPLIACIÓN LA PALMA (ZONA INDUSTRIAL)": true
      },
      "55760": {
        "SAN FRANCISCO CUAUTLIQUIXCA": true
      },
      "55763": {
        "VITALIA": true
      },
      "55764": {
        "LOS HÉROES OZUMBILLA": true,
        "LOS HÉROES TECÁMAC II": true,
        "MARGARITO F. AYALA": true,
        "NUEVO PARAÍSO": true
      },
      "55765": {
        "LOS HÉROES SAN PABLO": true
      },
      "55766": {
        "AMPLIACIÓN OZUMBILLA": true
      },
      "55767": {
        "ALCÁZAR": true,
        "BOSQUES DE LOS HÉROES": true,
        "CONJUNTO URBANO REAL VERONA": true,
        "LOMA BONITA": true,
        "LOS ARCOS": true,
        "PASEOS DEL BOSQUE": true,
        "PUNTA PALERMO": true,
        "QUINTA VERSALLES": true,
        "REAL ALCALÁ": true,
        "REAL CARRARA": true,
        "REAL CASTELL": true,
        "REAL DEL CID": true,
        "REAL DEL SOL": true,
        "REAL FIRENZE": true,
        "REAL TOSCANA": true,
        "REAL VIZCAYA": true,
        "SANTA CRUZ": true,
        "VALLE SAN PEDRO URBI VILLA DEL CAMPO": true
      },
      "55768": {
        "CUAUHTÉMOC": true
      },
      "55770": {
        "SAN PEDRO (EL TERREMOTO)": true
      },
      "55773": {
        "HACIENDA PROVENZAL": true
      },
      "55776": {
        "LOMAS DE SAN PEDRO ATZOMPA": true
      },
      "55778": {
        "AMPLIACIÓN DE LA CONCEPCIÓN": true
      }
    },
    "TEOLOYUCAN": {
      "54770": {
        "HACIENDA BEATRIZ": true,
        "MISIONES TEOLOYUCAN": true,
        "TLATENCO": true,
        "TLATILCO": true,
        "VILLAS TEOLOYUCAN": true
      },
      "54783": {
        "ANALCO": true,
        "FRESNO 2000": true,
        "LA PROVIDENCIA": true,
        "SAN JUAN": true,
        "SANTA CRUZ": true,
        "SANTA MARÍA CALIACAC": true,
        "SANTO TOMÁS": true,
        "TEPANQUIAHUAC": true
      },
      "54784": {
        "ATZACOALCO": true,
        "SAGITARIO": true,
        "SAN BARTOLO": true,
        "SANTIAGO": true
      },
      "54785": {
        "EX-HACIENDA SAN JOSÉ PUENTE GRANDE": true,
        "LA VICTORIA": true,
        "LOS OLIVOS": true,
        "SAN JOSÉ": true
      },
      "54786": {
        "ACOLCO": true,
        "AXALPA": true,
        "CUAXOXOCA": true,
        "GUADALUPE": true,
        "LA ERA": true,
        "SAN SEBASTIÁN": true,
        "SANTA CRUZ DEL MONTE": true,
        "ZIMAPAN": true
      }
    },
    "TEPOTZOTLÁN": {
      "54600": {
        "SAN MARTÍN": true,
        "SAN MATEO XOLOC": true,
        "TEPOTZOTLÁN CENTRO": true
      },
      "54602": {
        "EL REFUGIO": true,
        "EL TEJOCOTE": true,
        "GUADALUPE": true,
        "LA PALMITA": true,
        "SAN JOSÉ": true
      },
      "54603": {
        "CAPULA": true
      },
      "54604": {
        "EJIDO SANTIAGO": true,
        "SANTA CRUZ": true
      },
      "54605": {
        "PARQUE INDUSTRIAL CEDROS": true,
        "TEXCACOA": true,
        "TLACATECO": true,
        "VILLAS DEL CONVENTO": true
      },
      "54607": {
        "AMPLIACIÓN LOS POTROS (TRES PIEDRAS)": true,
        "EL ARROYO": true,
        "LA LUMBRERA": true,
        "LOMA BONITA": true,
        "RICARDO FLORES MAGÓN": true,
        "SAN JOSÉ LA TEJA": true
      },
      "54608": {
        "LOS ÁLAMOS": true,
        "PASEO LOS VIRREYES": true
      },
      "54610": {
        "INDUSTRIAL EL TRÉBOL": true,
        "PARQUE INDUSTRIAL EL CONVENTO": true,
        "PUENTE GRANDE": true,
        "RESERVA ECOLÓGICA XOCHITLA": true
      },
      "54614": {
        "EL TRÉBOL": true
      },
      "54615": {
        "AXOTLÁN II": true,
        "LA TECLA": true,
        "LUMBRERA II": true,
        "SAN SEBASTIÁN": true
      },
      "54616": {
        "ARBOLEDA": true,
        "LAS ÁNIMAS": true
      },
      "54650": {
        "CAÑADA DE CISNEROS": true,
        "CLUB VIRREYES": true,
        "DE LA LUZ": true,
        "EL MIRADOR": true,
        "GRANJAS HOGAR Y PETROHUERTOS DELEGACIÓN": true,
        "HACIENDA LA CONCEPCIÓN": true,
        "HACIENDA LA CONCEPCIÓN (EX-RANCHO LA JOYA)": true,
        "LA LUZ": true,
        "LANZAROTE": true,
        "LAS LECHUGUILLAS": true,
        "SAN BARTOLO": true,
        "SAN JOSÉ": true,
        "SAN VICENTE": true,
        "SANTA RITA": true,
        "SANTIAGO": true,
        "SANTIAGO CUAUTLALPAN CENTRO": true,
        "SANTIAGO EL ALTO": true,
        "TIERRAS BLANCAS DEL SUR": true,
        "TITINI": true
      }
    },
    "TEXCOCO": {
      "56100": {
        "TEXCOCO DE MORA CENTRO": true
      },
      "56105": {
        "SAN PEDRO": true
      },
      "56106": {
        "LAS SALINAS": true
      },
      "56110": {
        "JOYAS DE SAN MATEO": true
      },
      "56120": {
        "INFONAVIT": true
      },
      "56130": {
        "LA CONCHITA": true
      },
      "56140": {
        "AHUEHUETES": true
      },
      "56150": {
        "LAS VEGAS": true
      },
      "56160": {
        "NIÑOS HÉROES": true
      },
      "56170": {
        "SAN MATEO": true
      },
      "56200": {
        "VICENTE RIVA PALACIO": true
      },
      "56203": {
        "LA MAGDALENA PANOAYA": true
      },
      "56204": {
        "EMILIANO ZAPATA": true
      },
      "56205": {
        "SAN FELIPE": true
      },
      "56207": {
        "LÁZARO CÁRDENAS": true
      },
      "56208": {
        "SAN MIGUEL TOCUILA": true
      },
      "56210": {
        "SAN SIMÓN": true
      },
      "56213": {
        "SAN JOSÉ TEXOPA": true
      },
      "56214": {
        "LOS REYES SAN SALVADOR": true
      },
      "56215": {
        "PENTECOSTÉS": true
      },
      "56216": {
        "LA RESURRECCIÓN": true
      },
      "56217": {
        "SANTIAGUITO": true
      },
      "56220": {
        "SAN LUIS HUEXOTLA": true
      },
      "56223": {
        "BELLAVISTA": true
      },
      "56224": {
        "BUENAVISTA": true
      },
      "56225": {
        "LOMAS DE CRISTO": true
      },
      "56226": {
        "SAN MATEO HUEXOTLA": true
      },
      "56227": {
        "EL CAPULÍN SUR": true
      },
      "56230": {
        "SAN DIEGO": true
      },
      "56233": {
        "SUTEYN": true
      },
      "56235": {
        "EL MOLINO DE FLORES": true
      },
      "56236": {
        "XOCOTLÁN": true
      },
      "56237": {
        "EL BATÁN": true
      },
      "56240": {
        "LA PURIFICACIÓN TEPETITLA": true
      },
      "56243": {
        "EJIDO SAN JUAN TEZONTLA": true
      },
      "56244": {
        "SAN AGUSTÍN": true
      },
      "56245": {
        "SAN PABLO IXAYOC": true
      },
      "56246": {
        "SANTA MARÍA NATIVITAS": true
      },
      "56247": {
        "SAN NICOLÁS TLAMINCA": true
      },
      "56250": {
        "SAN MIGUEL COATLINCHÁN": true
      },
      "56253": {
        "VALLE DE TLÁLOC": true
      },
      "56254": {
        "TEPETITLÁN": true
      },
      "56255": {
        "EL ARENAL": true,
        "EL TRABAJO": true,
        "QUINTAS DEL VALLE": true,
        "SAN JOSÉ (EL PARAÍSO)": true,
        "SAN PEDRO CUAUTLANPAN": true,
        "SANTIAGO CUAUTLALPAN": true,
        "VILLAS DE SANTIAGO": true
      },
      "56256": {
        "SAN FELIPE DE JESÚS": true,
        "SANTA LUCÍA": true
      },
      "56257": {
        "LOMAS DE LA CRUZ": true
      },
      "56260": {
        "SAN ANDRÉS (LA ALCANFORERA)": true
      },
      "56263": {
        "SANTA IRENE": true
      },
      "56264": {
        "COLEGIO DE POSTGRADUADOS": true,
        "EJIDOS DE BELTRÁN CUAUTLALPAN": true,
        "MONTECILLO": true,
        "WENCESLAO VICTORIA": true
      },
      "56265": {
        "EL TEJOCOTE": true,
        "LÁZARO CÁRDENAS": true
      },
      "56266": {
        "SANTA MARTHA": true
      },
      "56267": {
        "GUADALUPE VICTORIA": true
      },
      "56268": {
        "BORDO PONIENTE": true
      }
    },
    "TLALNEPANTLA DE BAZ": {
      "54000": {
        "ALTA VISTA": true,
        "TLALNEPANTLA CENTRO": true
      },
      "54009": {
        "LA RIVIERA": true
      },
      "54010": {
        "21 DE MARZO": true,
        "BARRIENTOS GUSTAVO BAZ": true,
        "LA AZTECA": true,
        "LA PROVIDENCIA": true,
        "SAN PEDRO BARRIENTOS": true,
        "VALLE HERMOSO": true
      },
      "54015": {
        "BARRIENTOS": true,
        "CONJUNTO URBANO TERRAZE": true
      },
      "54016": {
        "JOSÉ MARÍA VELASCO": true
      },
      "54017": {
        "COMUNIDAD BETANIA": true,
        "NIÑOS HÉROES": true
      },
      "54020": {
        "BENITO JUÁREZ (TEQUEX.)": true,
        "CONDOMINIO TEQUEXQUINÁHUAC": true,
        "EL DORADO": true,
        "EL GRAN DORADO": true,
        "LA JOYA CHICA": true,
        "LOMAS BOULEVARES": true,
        "TEQUEXQUINAHUAC PARTE ALTA": true,
        "TEQUEXQUINÁHUAC": true,
        "VALLE DORADO": true
      },
      "54021": {
        "LOMA AZUL": true
      },
      "54022": {
        "ROBLES PATERA": true
      },
      "54023": {
        "LOMAS DE ATLACO": true,
        "LOMAS DE VALLE DORADO": true,
        "LOMAS TULPAN": true,
        "LOS PIRULES AMPLIACIÓN": true
      },
      "54025": {
        "CUMBRES DEL VALLE": true
      },
      "54026": {
        "LAS ARBOLEDAS": true
      },
      "54028": {
        "LADERAS DE SAN JAVIER": true
      },
      "54030": {
        "AMPLIACIÓN SAN JAVIER": true,
        "CENTRO INDUSTRIAL TLALNEPANTLA": true,
        "IMSS TLALNEPANTLA": true,
        "JESÚS GARCIA CORONA": true,
        "LA NUEVA FERROCARRILERA": true,
        "LA ROMANA": true,
        "SAN JAVIER": true,
        "SAN NICOLÁS": true,
        "TLAXCOPAN": true
      },
      "54033": {
        "LA FERROCARRILERA EL HOYO": true,
        "SAN LORENZO": true
      },
      "54037": {
        "EL TRIÁNGULO": true
      },
      "54038": {
        "RIVERA DEL BOSQUE": true
      },
      "54040": {
        "LEANDRO VALLE": true,
        "LOMAS DE SAN ANDRÉS ATENCO": true,
        "LOMAS DE SAN ANDRÉS ATENCO AMPLIACIÓN": true,
        "LOS PIRULES": true,
        "RINCÓN DEL VALLE": true,
        "SAN ANDRÉS ATENCO": true,
        "SAN ANDRÉS ATENCO AMPLIACIÓN": true,
        "VALLE DE LOS PINOS 1RA SECCIÓN": true,
        "VALLE VERDE": true
      },
      "54049": {
        "BALCONES DEL VALLE": true
      },
      "54050": {
        "BOSQUES DE MÉXICO": true,
        "EX-HACIENDA DE SANTA MÓNICA": true,
        "JACARANDAS": true,
        "JACARANDAS AMPLIACIÓN": true,
        "JARDINES DE SANTA MÓNICA": true,
        "LAS MARGARITAS": true,
        "MAGISTERIAL VISTA BELLA": true,
        "MARGARITAS AMPLIACIÓN": true
      },
      "54054": {
        "BELLAVISTA SATÉLITE": true,
        "CLUB DE GOLF BELLAVISTA": true,
        "JARDINES BELLAVISTA": true,
        "RESIDENCIAL PRIVANZA": true,
        "RINCÓN DE BELLA VISTA": true
      },
      "54055": {
        "SAN LUCAS TEPETLACALCO": true,
        "SAN LUCAS TEPETLACALCO AMPLIACIÓN": true
      },
      "54057": {
        "VALLE DE SANTA MÓNICA": true
      },
      "54059": {
        "FRANCISCO VILLA": true
      },
      "54060": {
        "ARCOS ELECTRA": true,
        "ELECTRA": true,
        "LA LOMA": true,
        "MIGUEL HIDALGO": true,
        "VALLE DE LOS PINOS 2DA. SECCIÓN": true,
        "VALLE DEL PARAÍSO": true,
        "VALLE SOL": true,
        "VIVEROS DEL RÍO": true,
        "VIVEROS DEL VALLE": true
      },
      "54063": {
        "RINCONADA DEL PARAÍSO": true
      },
      "54067": {
        "TLALCALLI": true
      },
      "54068": {
        "BENITO JUÁREZ CENTRO": true
      },
      "54069": {
        "LAS ROSAS": true,
        "PLAZA DE LAS ROSAS": true
      },
      "54070": {
        "ADOLFO LÓPEZ MATEOS": true,
        "EL CORTIJO": true,
        "LA COMUNIDAD": true,
        "RANCHO SAN ANTONIO": true,
        "SAN JOSÉ PUENTE DE VIGAS": true,
        "TLALNEMEX": true
      },
      "54073": {
        "LOS REYES": true
      },
      "54075": {
        "LOS REYES": true,
        "LOS REYES IXTACALA 2DA. SECCIÓN": true
      },
      "54076": {
        "LOS TEJAVANES": true
      },
      "54080": {
        "AMPLIACIÓN VISTA HERMOSA": true,
        "BELLAVISTA PUENTE DE VIGAS": true,
        "CONDOMINIOS VILLAS SATÉLITE": true,
        "CONJUNTO PINTORES": true,
        "EL MIRADOR": true,
        "LAS ARMAS": true,
        "NATURA": true,
        "PLAZAS DE LA COLINA": true,
        "REAL DEL OCHO": true,
        "RESIDENCIAS DEL PARQUE": true,
        "TEPETLACALCO A. C.": true,
        "VISTA HERMOSA": true,
        "VIVEROS DE LA LOMA": true,
        "XOCOYAHUALCO": true
      },
      "54090": {
        "HOGARES FERROCARRILEROS": true,
        "LA ESCUELA": true,
        "LA MORA": true,
        "LOS CEDROS": true,
        "LOS REYES IXTACALA 1RA. SECCIÓN": true,
        "PUENTE DE VIGAS": true,
        "ROSARIO 1 SECTOR CROC II": true,
        "ROSARIO 1 SECTOR CROC III-A": true,
        "ROSARIO 1 SECTOR CROC VII": true,
        "ROSARIO 1 SECTOR II-CA": true,
        "ROSARIO 1 SECTOR II-CB": true,
        "ROSARIO 1 SECTOR II-CD": true,
        "ROSARIO 1 SECTOR III-A": true,
        "ROSARIO 1 SECTOR III-B": true,
        "ROSARIO 1 SECTOR III-C": true,
        "ROSARIO I SECTOR CROC III B": true,
        "ROSARIO II SECTOR I": true,
        "ROSARIO II SECTOR II": true,
        "ROSARIO II SECTOR III": true,
        "SAN JERÓNIMO TEPETLACALCO": true,
        "SAN JOSÉ PUENTE DE VIGAS": true,
        "SAN PABLO XALPA": true,
        "SEDENA": true
      },
      "54092": {
        "ROSARIO 1 SECTOR CROC V BUGAMBILIAS": true,
        "ROSARIO CEYLÁN": true
      },
      "54093": {
        "ROSARIO II GASERA": true
      },
      "54094": {
        "ROSARIO II HIPÓDROMO TEXTIL": true
      },
      "54098": {
        "GUSTAVO BAZ PRADA LOS REYES IXTACALA": true
      },
      "54100": {
        "LAS PALOMAS": true,
        "SAN LUCAS PATONI": true,
        "UNBIDAD CROC SOLIDARIDAD": true
      },
      "54108": {
        "AMPLIACIÓN LA ARBOLEDA": true,
        "LA SIDERAL": true
      },
      "54109": {
        "LA ARBOLEDA": true
      },
      "54110": {
        "COOPERATIVA LA ROMANA": true,
        "EL OLIVO I": true,
        "FRANJA MUNICIPAL": true,
        "HOGAR OBRERO": true,
        "ISIDRO FABELA": true,
        "LA BLANCA": true,
        "LOMAS DEL CALVARIO": true,
        "NUEVO MÉXICO": true,
        "REFORMA URBANA": true,
        "SANTA MARÍA TLAYACAMPA": true,
        "UNIDAD BARRIENTOS": true
      },
      "54118": {
        "FRANJA FÉRREA": true
      },
      "54119": {
        "EL OLIVO II PARTE ALTA CARLOS PICHARDO CRUZ": true,
        "EL OLIVO II PARTE BAJA": true
      },
      "54120": {
        "GUSTAVO BAZ PRADA": true,
        "GUSTAVO BAZ PRADA AMPLIACIÓN": true,
        "LA CAÑADA": true,
        "LOMA BONITA": true,
        "LOS PARAJES": true,
        "RANCHO SAN RAFAEL AMATES": true,
        "SAN RAFAEL": true,
        "TLAYAPA": true
      },
      "54124": {
        "CUAUHTÉMOC": true
      },
      "54126": {
        "RÍO SAN JAVIER": true,
        "TABLA HONDA": true
      },
      "54127": {
        "FERROCARRILERA SAN RAFAEL": true
      },
      "54128": {
        "CONDOMINIOS SAN RAFAEL": true
      },
      "54130": {
        "EL ROSAL": true,
        "EX EJIDO DE SANTA CECILIA": true,
        "INDEPENDENCIA": true,
        "INDEPENDENCIA AMPLIACIÓN": true,
        "IZCALLI DEL RÍO": true,
        "JARDINES DE LA CAÑADA": true,
        "JARDINES SANTA CECILIA INFONAVIT": true,
        "LOS ÁNGELES": true,
        "MEDIA LUNA": true,
        "SANTA CECILIA": true,
        "SANTA CECILIA ACATITLÁN": true,
        "VALLE DE LAS PIRÁMIDES": true
      },
      "54134": {
        "JARDINES DE SANTA CECILIA": true
      },
      "54135": {
        "SAN BUENAVENTURA": true
      },
      "54136": {
        "SAN BUENAVENTURA": true
      },
      "54140": {
        "EL PUERTO": true,
        "EL TENAYO CENTRO": true,
        "EL TENAYO NORTE": true,
        "EL TENAYO SUR": true,
        "EX-EJIDO DE SAN LUCAS PATONI": true,
        "FFCC CECILIA MORA VIUDA DE GÓMEZ": true,
        "IZCALLI ACATITLÁN": true,
        "IZCALLI PIRÁMIDE": true,
        "IZCALLI PIRÁMIDE II": true,
        "LA CANTERA": true,
        "SAN MIGUEL CHALMA": true
      },
      "54142": {
        "CHALMA LA UNIÓN": true
      },
      "54143": {
        "CHALMA LA BARRANCA": true
      },
      "54145": {
        "TABLA HONDA": true
      },
      "54146": {
        "LA CUCHILLA": true
      },
      "54147": {
        "EL TENAYO": true,
        "VALLE DEL TENAYO": true
      },
      "54149": {
        "HUGO CERVANTES DEL RÍO": true
      },
      "54150": {
        "ACUEDUCTO TENAYUCA": true,
        "AHUEHUETES": true,
        "AMPLIACIÓN VALLE CEYLÁN": true,
        "ARENAL TENAYUCA": true,
        "LOMA ESCONDIDA": true,
        "SAN BARTOLO TENAYUCA": true,
        "VALLE CEYLÁN": true
      },
      "54152": {
        "LA PURÍSIMA": true
      },
      "54158": {
        "PODER DE DIOS": true
      },
      "54160": {
        "ARTEMISA": true,
        "EL TEJOCOTE": true,
        "LA JOYA IXTACALA": true,
        "MIRAFLORES": true,
        "NUEVA IXTACALA": true,
        "P.I.P.S.A.": true,
        "PRADO IXTACALA": true,
        "SAN ANTONIO IXTACALA": true,
        "SAN FELIPE IXTACALA": true,
        "SAN JUAN IXTACALA": true
      },
      "54162": {
        "CEYLÁN IXTACALA": true
      },
      "54168": {
        "SAN JUAN IXTACALA AMPLIACIÓN NORTE": true
      },
      "54170": {
        "BOSQUES DE CEYLÁN": true,
        "PARQUE INDUSTRIAL SAN PABLO XALPA": true,
        "PRADO VALLEJO": true,
        "PRENSA NACIONAL": true,
        "SAN PABLO XALPA": true,
        "VENUSTIANO CARRANZA": true
      },
      "54172": {
        "EX HACIENDA DE EN MEDIO": true
      },
      "54173": {
        "MARAVILLAS CEYLÁN": true
      },
      "54180": {
        "ATRÁS DEL TEQUIQUIL": true,
        "LOMAS DE SAN JUAN IXHUATEPEC": true,
        "SAN JOSÉ IXHUATEPEC": true,
        "SAN JUAN IXHUATEPEC": true
      },
      "54187": {
        "ECUESTRE RESIDENCIAL SAN JOSÉ": true,
        "LA PRESA": true,
        "MAGISTERIAL SIGLO XXI": true
      },
      "54189": {
        "LÁZARO CÁRDENAS 1RA. SECCIÓN": true,
        "LÁZARO CÁRDENAS 2DA. SECCIÓN": true,
        "LÁZARO CÁRDENAS 3RA. SECCIÓN": true
      },
      "54190": {
        "CONSTITUCIÓN DE 1917": true,
        "CONSTITUYENTES DE 1857": true,
        "DIVISIÓN DEL NORTE": true,
        "DR. JORGE JIMÉNEZ CANTÚ": true,
        "FFCC CONCEPCIÓN ZEPEDA VIUDA DE GÓMEZ Z.": true,
        "LA LAGUNA": true,
        "LA PETROLERA": true,
        "MARINA NACIONAL": true
      },
      "54193": {
        "EX-EJIDO DE TEPEOLULCO": true
      },
      "54195": {
        "COLINAS DE SAN JOSÉ": true,
        "SANTA VIRGINIA": true
      },
      "54196": {
        "ANGELES SAN JOSÉ": true,
        "BAHÍA DEL COPAL": true
      },
      "54197": {
        "SAN ISIDRO IXHUATEPEC": true
      },
      "54198": {
        "LOMAS DE LINDAVISTA EL COPAL": true,
        "LOS ÁNGELES": true
      }
    },
    "TOLUCA": {
      "50000": {
        "TOLUCA DE LERDO CENTRO": true
      },
      "50010": {
        "CELANESE": true,
        "CLUB JARDÍN": true,
        "DEL PANTEÓN": true,
        "EL BALCÓN": true,
        "EL TEJOCOTE": true,
        "GALAXIAS DE SAN LORENZO": true,
        "GRAN MORADA": true,
        "GUADALUPE": true,
        "HACIENDA SAN AGUSTÍN": true,
        "LA CRUZ COMALCO": true,
        "LA LOMA": true,
        "LA MAGDALENA": true,
        "LAS FLORES": true,
        "LOS GIRASOLES": true,
        "LOS GIRASOLES I": true,
        "LOS GIRASOLES II": true,
        "LOS GIRASOLES III": true,
        "LOS GIRASOLES IV": true,
        "SAN ANGELÍN": true,
        "SAN JUAN DE LA CRUZ": true,
        "SAN LORENZO TEPALTITLÁN CENTRO": true,
        "TLACOPA": true,
        "UNIVERSIDAD": true,
        "VILLAS TEPALTITLÁN": true
      },
      "50016": {
        "DE LA CRESPA": true,
        "JARDINES DE LA CRESPA": true,
        "PARQUE INDUSTRIAL SAN ANTONIO": true
      },
      "50017": {
        "LAS BRISAS": true
      },
      "50018": {
        "SAN ANTONIO": true
      },
      "50019": {
        "SAN RAFAEL": true
      },
      "50020": {
        "3 CAMINOS": true,
        "BOSQUES DE LA MORA": true,
        "LOS FRAILES": true,
        "LOS ÁNGELES": true,
        "RANCHO LA MORA": true,
        "RINCONADA DE LA MORA": true,
        "SANTIAGO MILTEPEC": true,
        "VALLE DE SANTIAGO RESIDENCIAL": true
      },
      "50026": {
        "CARLOS HANK GONZÁLEZ": true
      },
      "50030": {
        "SANTA CRUZ AZCAPOTZALTONGO": true
      },
      "50039": {
        "LA LEGA": true
      },
      "50040": {
        "ELECTRICISTAS LOCALES": true,
        "LA RETAMA": true,
        "LA TERESONA": true,
        "SAN LUIS OBISPO": true,
        "SAN MIGUEL APINAHUIZCO": true,
        "SECTOR POPULAR": true,
        "SOR JUANA INÉS DE LA CRUZ": true,
        "UNIÓN": true
      },
      "50050": {
        "EL CÓPORO": true,
        "SANTA BÁRBARA": true,
        "ZOPILOCALCO NORTE": true,
        "ZOPILOCALCO SUR": true
      },
      "50060": {
        "DOCTORES": true,
        "HUITZILA": true,
        "LOMAS ALTAS": true,
        "NIÑOS HÉROES (PENSIONES)": true,
        "SAN JUAN BUENAVISTA": true
      },
      "50069": {
        "CENTRO SCT MEXICO": true
      },
      "50070": {
        "FIDEL VELÁZQUEZ": true,
        "INDEPENDENCIA": true,
        "METEORO": true,
        "REFORMA Y FERROCARRILES NACIONALES": true,
        "VILLAS FONTANA I": true,
        "VILLAS FONTANA II": true
      },
      "50071": {
        "TOLUCA": true
      },
      "50075": {
        "CIENTÍFICOS": true,
        "LAS TORRES": true
      },
      "50076": {
        "RESIDENCIAL LAS TORRES": true
      },
      "50080": {
        "LA MERCED (ALAMEDA)": true,
        "SAN BERNARDINO": true
      },
      "50090": {
        "5 DE MAYO": true,
        "SANTA CLARA": true
      },
      "50100": {
        "14 DE DICIEMBRE": true,
        "BOSQUES DE SAN MATEO": true,
        "EL TRIGO": true,
        "EX-HACIENDA SAN JORGE": true,
        "LA JOYA": true,
        "LA RIBERA I": true,
        "LA RIBERA II": true,
        "LA RIBERA III": true,
        "LA RIBERA IV": true,
        "LOMAS DE SAN MATEO": true,
        "MIGUEL HIDALGO (CORRALITOS)": true,
        "NIÑOS HÉROES": true,
        "NUEVA OXTOTITLÁN": true,
        "PARQUE DE SAN MATEO": true,
        "PARQUES NACIONALES": true,
        "PROTINBOS": true,
        "RINCÓN DEL PARQUE": true,
        "SAN MATEO OXTOTITLÁN": true
      },
      "50103": {
        "ATOTONILCO": true,
        "TLANEPANTLA": true,
        "TLAYACA": true
      },
      "50110": {
        "CULTURAL": true,
        "DEL DEPORTE": true,
        "GUADALUPE SAN BUENAVENTURA": true,
        "PLAZAS DE SAN BUENAVENTURA": true,
        "REAL DEL BOSQUE": true,
        "SAN BUENAVENTURA": true,
        "VICENTE GUERRERO": true,
        "VILLAS DE SAN BUENAVENTURA": true
      },
      "50115": {
        "LOMA BONITA": true
      },
      "50120": {
        "CIPRÉS": true,
        "FEDERAL (ADOLFO LÓPEZ MATEOS)": true,
        "GRANJAS": true,
        "MORELOS 1A SECCIÓN": true,
        "MORELOS 2A SECC": true,
        "RESIDENCIAL COLÓN": true,
        "TOLLOCAN INFONAVIT": true
      },
      "50122": {
        "ZONA MILITAR": true
      },
      "50123": {
        "PASEO TOLLOCAN INFONAVIT": true
      },
      "50130": {
        "ALTAMIRANO": true,
        "AMÉRICAS": true,
        "CUAUHTÉMOC": true,
        "FRANCISCO MURGUÍA EL RANCHITO": true,
        "UNIVERSIDAD": true
      },
      "50140": {
        "NUEVA SANTA MARÍA": true,
        "NUEVA SANTA MARÍA DE LAS ROSAS": true,
        "SANTA MARÍA DE LAS ROSAS": true,
        "TERMINAL": true,
        "VALLE DON CAMILO": true,
        "VALLE VERDE": true,
        "VILLAS FLORENCIA": true
      },
      "50150": {
        "COMISIÓN FEDERAL DE ELECTRICIDAD": true,
        "IZCALLI IPIEM": true,
        "IZCALLI TOLUCA": true,
        "JUAN BELTRÁN": true,
        "PROGRESO": true,
        "SALVADOR SÁNCHEZ COLÍN": true,
        "SAN SEBASTIÁN": true,
        "VÉRTICE": true
      },
      "50160": {
        "SANTA ANA TLAPALTITLÁN": true,
        "VILLAS DE SANTA ANA": true,
        "VILLAS DE SANTA ANA I": true,
        "VILLAS DE SANTA ANA II": true,
        "VILLAS DE SANTA ANA III": true,
        "VILLAS DE SANTA ANA IV": true,
        "VILLAS DE SANTA ANA V": true,
        "VILLAS DE SANTA ANA VI": true,
        "VILLAS DE SANTA ANA VII": true
      },
      "50168": {
        "LA MACHINCUEPA": true,
        "SANTA MARÍA ZOZOQUILPAN": true
      },
      "50170": {
        "EL SEMINARIO 1A SECCIÓN": true,
        "EL SEMINARIO 2A SECCIÓN": true,
        "EL SEMINARIO 3A SECCIÓN": true,
        "EL SEMINARIO 4A SECCIÓN": true,
        "EL SEMINARIO 5A SECCIÓN": true,
        "HÉROES DEL 5 DE MAYO": true,
        "ISIDRO FABELA 1A SECCIÓN": true,
        "ISIDRO FABELA 2A SECCIÓN": true,
        "LAS HACIENDAS": true,
        "OCHO CEDROS": true,
        "OCHO CEDROS 2A SECCIÓN": true,
        "VILLA HOGAR": true
      },
      "50180": {
        "AMPLIACIÓN LÁZARO CÁRDENAS": true,
        "AZTECA": true,
        "BOSQUES DE COLÓN": true,
        "DEL PARQUE": true,
        "HERMANOS DE LA VEGA": true,
        "LÁZARO CÁRDENAS": true,
        "MODERNA DE LA CRUZ": true
      },
      "50190": {
        "BENITO JUÁREZ": true,
        "EMILIANO ZAPATA": true,
        "EVA SÁMANO DE LÓPEZ MATEOS": true,
        "LA MAGDALENA": true,
        "UNIDAD VICTORIA": true
      },
      "50200": {
        "ARMANDO NEYRA CHAVEZ": true,
        "BARRIO SAN GABRIEL": true,
        "LA CONCEPCIÓN": true,
        "LA TRINIDAD": true,
        "NATIVIDAD": true,
        "PASEOS DEL PILAR": true,
        "SAN ANDRÉS CUEXCONTITLÁN": true,
        "SAN CRISTÓBAL HUICHOCHITLÁN": true,
        "SAN JOSÉ GUADALUPE": true,
        "SAN SALVADOR": true,
        "SANTA ROSA": true
      },
      "50203": {
        "PASEO TOLLOCAN INFONAVIT": true
      },
      "50205": {
        "JICALTEPEC CUEXCONTITLÁN": true,
        "SAN DIEGO DE LOS PADRES CUEXCONTITLÁN": true,
        "SAN DIEGO DE LOS PADRES OTZACATIPAN": true
      },
      "50206": {
        "LA LOMA CUEXCONTITLÁN": true,
        "SAN DIEGO LINARES": true
      },
      "50209": {
        "TOLUCA (LIC. ADOLFO LÓPEZ MATEOS)": true
      },
      "50210": {
        "BOSQUES DE CANTABRIA": true,
        "EX HACIENDA SAN JOSÉ": true,
        "FUENTES DE SAN JOSÉ": true,
        "HACIENDA DEL VALLE I": true,
        "HACIENDA DEL VALLE II": true,
        "LA MAGDALENA OTZACATIPAN": true,
        "LOS SAUCES I": true,
        "LOS SAUCES II": true,
        "LOS SAUCES III": true,
        "LOS SAUCES IV": true,
        "LOS SAUCES V": true,
        "PASEO ARBOLEDA": true,
        "SANTA CRUZ OTZACATIPAN": true,
        "VALLE DE LA HACIENDA": true,
        "VALLE DE SAN JOSÉ": true,
        "VILLA MANE": true
      },
      "50214": {
        "BALCONES SANTÍN": true,
        "PASEOS SANTÍN": true,
        "VILLAS SANTÍN": true
      },
      "50220": {
        "DE CANALEJA": true,
        "SAN MATEO OTZACATIPAN": true,
        "VILLA TULIPANES": true,
        "VILLAS DE SAN MATEO": true
      },
      "50223": {
        "PARQUE INDUSTRIAL EXPORTEC II": true
      },
      "50225": {
        "BORDO DE LAS CANASTAS": true,
        "GEOVILLAS CENTENARIO": true,
        "NUEVA SAN FRANCISCO": true,
        "SAN MIGUEL TOTOLTEPEC": true
      },
      "50226": {
        "LA ARBOLEDA II": true,
        "LA ARBOLEDA III": true,
        "SAN PEDRO TOTOLTEPEC": true,
        "VILLAS SANTA MARÍA (GALAXIA)": true
      },
      "50227": {
        "GEOVILLAS DE SAN MATEO": true,
        "LA FLORESTA": true,
        "MISIONES DE SANTA ESPERANZA": true,
        "PASEOS DE TOLUCA": true,
        "RINCONADAS DEL PILAR": true,
        "VILLAS DE SANTA MÓNICA": true
      },
      "50228": {
        "GEO VILLAS DE LA IND": true,
        "GEO VILLAS DE LA IND. II": true,
        "GEOVILLAS LOS CEDROS": true,
        "LA ARBOLEDA": true,
        "LA ARBOLEDA IV": true,
        "LA ARBOLEDA V": true,
        "LA CRESPA": true,
        "LA PERLA": true,
        "LAS FUENTES": true,
        "LAS FUENTES DEL ORDAL": true,
        "LAS FUENTES IND.": true,
        "LOS SABINOS": true,
        "VILLA DE SAN ANDRÉS": true
      },
      "50230": {
        "LAS MISIONES": true
      },
      "50233": {
        "PARQUE INDUSTRIAL TOLUCA 2000": true
      },
      "50235": {
        "SAN FRANCISCO TOTOLTEPEC": true
      },
      "50236": {
        "LA CONSTITUCIÓN TOTOLTEPEC": true
      },
      "50240": {
        "EL CARMEN TOTOLTEPEC": true,
        "EL OLIMPO": true,
        "LOS AHUEHUETES": true,
        "PRADOS DE TOLLOCAN": true
      },
      "50245": {
        "CAMPO REAL": true,
        "CAMPO REAL I": true,
        "CAMPO REAL II": true,
        "CAMPO REAL III": true,
        "HACIENDA LA GALIA": true,
        "JESÚS GARCÍA LOVERA \"EL PILAR\"": true,
        "LA ALAMEDA": true,
        "LAS BUGAMBILIAS": true,
        "LOS HÉROES I": true,
        "MARÍA BONITA": true,
        "RESIDENCIAL LA JOYA": true,
        "SAN ANTONIO ABAD": true,
        "SAN JERÓNIMO": true,
        "SANTA MARÍA TOTOLTEPEC": true,
        "SOR JUANA INÉS DE LA CRUZ": true
      },
      "50246": {
        "EL COECILLO": true,
        "LOS HÉROES II": true,
        "LOS HÉROES III": true
      },
      "50250": {
        "LA CAÑADA": true,
        "LA CURVA": true,
        "LA LOMA RESIDENCIAL": true,
        "LAS MARGARITAS": true,
        "LAS PALOMAS": true,
        "RANCHO DE MAYA": true,
        "SAN FELIPE TLALMIMILOLPAN": true,
        "SANTA JUANITA": true
      },
      "50253": {
        "DOS RÍOS": true,
        "EL CALVARIO": true,
        "JARDINES DE SAN PEDRO": true,
        "LA COMUNIDAD": true,
        "LOS ÁLAMOS": true
      },
      "50254": {
        "BALCONES DE SAN FELIPE": true,
        "DEL PANTEÓN": true,
        "EL FRONTÓN": true,
        "EL MIRADOR": true,
        "EL MOGOTE": true,
        "LA VENTA": true,
        "LOMA BONITA": true,
        "TLALA": true
      },
      "50255": {
        "EL REFUGIO": true
      },
      "50256": {
        "LAS PALMAS": true
      },
      "50257": {
        "LA JOYA": true
      },
      "50258": {
        "ACUXTITLA": true
      },
      "50260": {
        "ALEJANDRÍA": true,
        "ATENEA": true,
        "CAPULTITLÁN CENTRO": true,
        "EL PACÍFICO": true,
        "LA ERA": true,
        "LA RIVERA": true,
        "MIRAMONTE": true,
        "PASEOS DEL VALLE": true,
        "VILLAS FONTANA": true,
        "VILLAS SANTA ESTHER": true
      },
      "50263": {
        "DE CRISTO REY": true,
        "DE LA CRUZ": true,
        "DEL ESPÍRITU SANTO": true,
        "LA SANTÍSIMA TRINIDAD": true,
        "LA VIRGEN DE GUADALUPE": true,
        "LOS PINOS": true,
        "SAN ISIDRO LABRADOR": true,
        "SAN JUAN APÓSTOL": true
      },
      "50264": {
        "LA SOLEDAD": true,
        "LAS PALMAS": true,
        "SAN FELIPE DE JESÚS": true,
        "SAN JOSÉ": true,
        "SAN JUDAS TADEO": true,
        "SAN PABLO": true
      },
      "50265": {
        "CACALOMACÁN CENTRO": true,
        "DEL CAMPO": true,
        "DEL PANTEÓN": true,
        "EL CHORRITO": true,
        "GUADALUPE": true,
        "LA CAPILLA": true,
        "LA LOMA": true,
        "LA PALMA": true,
        "LAS PALOMAS": true,
        "SAGRADO CORAZÓN DE JESÚS": true,
        "SAN MIGUEL ZACANGO": true,
        "SAN PEDRO": true,
        "SIXTO NOGUEZ": true,
        "SOR JUANA INÉS DE LA CRUZ": true,
        "TIERRA COLORADAS": true,
        "VILLAS SANTA ISABEL": true
      },
      "50266": {
        "SAN ANTONIO BUENAVISTA": true
      },
      "50270": {
        "TECAXIC": true
      },
      "50273": {
        "SAN PABLO": true
      },
      "50274": {
        "TLALNEPANTLA": true
      },
      "50280": {
        "SANTIAGO TLAXOMULCO CENTRO": true
      },
      "50283": {
        "EL POZO BLANCO": true
      },
      "50284": {
        "LOS POCITOS": true
      },
      "50285": {
        "LAS BUGAMBILIAS": true
      },
      "50286": {
        "EL TEPETATE": true
      },
      "50290": {
        "ALCALTUNCO": true,
        "BORDO NUEVO": true,
        "CHICHIPICAS": true,
        "CHUPASCLIYA": true,
        "DE JESÚS 1DA. SECCIÓN": true,
        "DE JESÚS 2DA. SECCIÓN": true,
        "DEL POZO": true,
        "EJIDO SANTA CRUZ ATZCAPOTZALTONGO": true,
        "EL CERRITO": true,
        "EL CERRO DEL PERICO": true,
        "JICALTEPEC AUTOPAN": true,
        "LA GRANJA": true,
        "LA VEGA": true,
        "SAN PABLO AUTOPAN": true,
        "SANTA CRUZ ATZCAPOTZALTONGO": true,
        "TANAMATO": true,
        "TEJOCOTE": true
      },
      "50293": {
        "PARQUE INDUSTRIAL TOLUCA": true
      },
      "50294": {
        "DE JESÚS 3A. SECCIÓN": true,
        "DE PUEBLO NUEVO": true,
        "DE SANTA CRUZ": true,
        "DE SANTA MARÍA": true,
        "TLACHALOYA": true,
        "VILLAS LOS ÁNGELES": true
      },
      "50295": {
        "PARQUE INDUSTRIAL SAN CAYETANO": true
      }
    },
    "TULTEPEC": {
      "54960": {
        "EL CARMEN": true,
        "SAN JUAN XOCOTLA": true,
        "SAN RAFAEL IXTLAHUACA": true,
        "TULTEPEC CENTRO": true
      },
      "54962": {
        "PARAJE TRIGO TENCO": true,
        "SAN PABLO OTLICA": true,
        "TLAMELACA": true,
        "XACOPINCA": true
      },
      "54963": {
        "ANTIGUA": true,
        "EJIDO EL QUEMADO": true,
        "EL CUQUÍO": true,
        "NODÍN": true,
        "SAN ANTONIO EL CUADRO": true,
        "SAN JOAQUÍN": true,
        "SAN MARTÍN": true,
        "SAN MARTÍN EL CALVARIO": true
      },
      "54964": {
        "LA CANTERA": true,
        "OXTOC": true,
        "SAN MIGUEL OTLICA": true,
        "SANTA ISABEL NEPANTLA": true
      },
      "54965": {
        "AMPLIACIÓN LA PIEDAD": true,
        "EMIQUÍA": true,
        "JARDINES DE SANTA CRUZ": true,
        "LA CAÑADA": true,
        "LA MORITA": true,
        "LA PIEDAD": true,
        "MÉXICO": true,
        "SANTA RITA": true,
        "TEPETLIXCO": true
      },
      "54966": {
        "GUADALUPE TLAZINTLA": true
      },
      "54967": {
        "EL MIRADOR": true,
        "LA PALMA": true
      },
      "54970": {
        "FRESNOS": true,
        "LAS BRISAS": true,
        "LOMAS DE TULTEPEC": true,
        "SAN MARCOS": true,
        "VICENTE SUÁREZ": true
      },
      "54972": {
        "CAJIGA (EJIDO DE TULTEPEC)": true,
        "EL PROGRESO (VILLA ESMERALDA)": true,
        "LA AURORA": true,
        "LA JOYA": true
      },
      "54974": {
        "ADOBERAS": true,
        "LA RINCONADA": true
      },
      "54975": {
        "AMADO NERVO": true
      },
      "54976": {
        "SAN ANTONIO XAHUENTO": true
      },
      "54977": {
        "LA SAUCERA": true
      },
      "54980": {
        "HACIENDA DEL JARDÍN": true,
        "LA MANZANA": true,
        "SANTIAGO TEYAHUALCO": true,
        "VILLAS DE LORETO": true
      },
      "54983": {
        "SAN PABLITO (PARAJE SAN PABLITO)": true
      },
      "54984": {
        "EL BOSQUE TULTEPEC": true,
        "EL DORADO": true,
        "EL TECOMPA": true,
        "LA MITRA": true,
        "PASEOS DE TULTEPEC I": true,
        "PASEOS DE TULTEPEC II": true
      },
      "54985": {
        "INFONAVIT C.T.M. SAN PABLO TULTEPEC": true
      },
      "54986": {
        "DIEZ DE JUNIO": true
      },
      "54987": {
        "ARCOS TULTEPEC": true,
        "HACIENDA REAL DE TULTEPEC": true
      },
      "54990": {
        "TEYAHUALCO": true
      }
    },
    "TULTITLÁN": {
      "54900": {
        "BELÉM": true
      },
      "54910": {
        "CENTRAL DE ABASTOS": true,
        "EJIDO LA REYNA (LA REYNA)": true,
        "EX HACIENDA CASCO LA MARISCALA": true,
        "FUENTES DEL VALLE": true,
        "JARDINES DE TULTITLÁN": true,
        "LA PONDEROSA": true,
        "LOS AGAVES TULTITLÁN": true,
        "LOS PORTALES": true,
        "UNIVERSIDAD POLITÉCNICA DEL VALLE DE MÉXICO": true,
        "VILLA ESMERALDA": true,
        "VILLAS DE SAN JOSÉ": true
      },
      "54913": {
        "AMPLIACIÓN COCEM": true,
        "BOSQUES DE TULTITLÁN": true,
        "COCEM": true,
        "PRIVADA SAN MARCOS": true,
        "QUINTA EL ÁNGEL": true,
        "RECURSOS HIDRÁULICOS": true,
        "RESIDENCIAL SOL DE TULTITLÁN": true,
        "VILLAS JARDÍN": true
      },
      "54914": {
        "UNIDAD ELECTRICISTAS": true
      },
      "54915": {
        "EL OBELISCO": true,
        "INDEPENDENCIA": true,
        "LOS REYES": true,
        "PORTO ALEGRE": true
      },
      "54916": {
        "LÁZARO CÁRDENAS (ZONA HORNOS)": true
      },
      "54918": {
        "EL CUEYAMIL": true,
        "PARQUE INDUSTRIAL CARTAGENA": true,
        "PARQUE INDUSTRIAL TULTITLÁN": true
      },
      "54920": {
        "HOGARES DE CASTERA": true,
        "JARDINES DE LOS CLAUSTROS III": true,
        "SAN PABLO CASTERA": true
      },
      "54924": {
        "CONJUNTO CRISTAL": true,
        "EL KIOSCO": true,
        "LAS LLANURAS": true,
        "LLANURAS": true,
        "LOTE 104 (TEHUANTEPEC)": true
      },
      "54925": {
        "HACIENDA SAN PABLO": true,
        "PRADOS SECCIÓN B": true
      },
      "54926": {
        "ESTEPAS": true,
        "GALAXIAS TULTITLÁN": true,
        "LAS ESTEPAS": true,
        "LOS AGAVES (LOTE 71)": true,
        "LOTE 55 (LOS TEJADOS)": true,
        "SUSTITUCIÓN ARISTA": true
      },
      "54927": {
        "EMILIO CHUAYFFET CHEMOR": true,
        "HOGARES DE CASTERA LOTE 73": true,
        "LAS TÓRTOLAS": true,
        "LOTE 41 (EL CARMEN)": true,
        "MARIANO ESCOBEDO (LOS FAROLES)": true
      },
      "54929": {
        "ALBORADA I": true,
        "EL CREPÚSCULO (LOTE 12)": true,
        "JARDINES DE LOS CLAUSTROS VI": true,
        "LA ALBORADA VALLAS": true,
        "NUEVO INFONAVIT": true,
        "UNIDAD MORELOS 3RA. SECCIÓN INFONAVIT": true,
        "VILLAS LORETO": true
      },
      "54930": {
        "GRANJAS SAN PABLO": true
      },
      "54932": {
        "CONJUNTO FORTUNA": true,
        "CONJUNTO HABITACIONAL MAGNOLIAS (LOTE 117-B)": true,
        "IMMEX II": true,
        "ISIDRO FABELA": true,
        "LOTE 105 (ÉBANO)": true,
        "MAGNOLIAS": true,
        "MAGNOLIAS 2000": true,
        "RESIDENCIAL MAGNOLIAS": true,
        "RESIDENCIAL SAN PABLO II": true,
        "SAN PABLO III-A": true,
        "SAN PABLO III-B": true,
        "VILLAS DE SAN PABLO": true,
        "VILLAS SAN PABLO (LOTE 117 SUR)": true
      },
      "54933": {
        "AZUL CIELO": true,
        "COYOLI MARTÍNEZ": true,
        "EL CAMPANARIO": true,
        "IZCALLI SAN PABLO": true,
        "JARDINES DE SAN PABLO": true,
        "LOTE 93 (AMALIA)": true,
        "PARQUE SAN PABLO": true,
        "PLAZA JARDINES": true,
        "RESIDENCIAL LA ESPERANZA": true,
        "VERDE CLARO": true
      },
      "54934": {
        "EL ROCÍO": true,
        "GUSTAVO BAZ": true,
        "PRADOS SECCIÓN A": true
      },
      "54935": {
        "ALBORADA II": true,
        "CASAS ALFA": true,
        "CASITAS SAN PABLO": true,
        "EL FARO (LOTE 3 PTE.)": true,
        "JARDINES DE LOS CLAUSTROS I": true,
        "JARDINES DE LOS CLAUSTROS II": true,
        "LA CHINAMPA": true,
        "LA ISLA": true,
        "LAS ALMENAS": true,
        "LAS CALDERAS": true,
        "LAS CRUCES": true,
        "LAS FUENTES": true,
        "LAVA 46": true,
        "LOTE 52 (TORRES TULTITLÁN)": true,
        "LOTE 82 (GUILLERMO GONZÁLEZ C.)": true,
        "LOTE 84 (LAS ADELAS)": true,
        "PORTAL SAN PABLO": true,
        "PORTAL SAN PABLO II": true,
        "RESIDENCIAL MORELOS": true,
        "UNIDAD MORELOS 3RA. SECCIÓN": true
      },
      "54938": {
        "AMPLIACIÓN SAN PABLO DE LAS SALINAS": true,
        "ARCOS I": true,
        "ARCOS II": true,
        "ARCOS III": true,
        "ARCOS IV": true,
        "ARCOS V": true,
        "BONITO TULTITLÁN (LOTE 60)": true,
        "EL ALCÁZAR": true,
        "EL LAUREL": true,
        "LOTE 46 (EL RELOJ VILLAS)": true,
        "LOTE 47 (EL RELOJ RESIDENCIAL)": true,
        "LOTE 48 (EL RELOJ CRONOS)": true,
        "LOTE 49 (LAS ARBOLEDAS)": true,
        "LOTE 50 A": true,
        "LOTE 50 B (LAS LADERAS)": true,
        "LOTE 50 C (REAL DE TULTITLÁN)": true,
        "LOTE 50 D": true,
        "LOTE 59 (TORRES DEL RELOJ)": true,
        "LOTE 62 ORIENTE (JUAN RULFO)": true,
        "LOTE 63": true,
        "LOTE 64 (OCTAVIO PAZ)": true,
        "LOTE 76 (EL RELOJ)": true,
        "VILLAS SANTA TERESITA": true,
        "VILLAS TULTITLÁN": true
      },
      "54939": {
        "PARAJE SAN PABLITO": true
      },
      "54940": {
        "CORREDOR LECHERÍA-CUAUTITLÁN": true,
        "LECHERÍA": true
      },
      "54942": {
        "AMPLIACIÓN LAS TORRES SEGUNDA SECCIÓN": true,
        "BENITO JUÁREZ": true,
        "LA LIBERTAD": true,
        "LAS TORRES": true
      },
      "54943": {
        "CIUDAD LABOR": true,
        "OJO DE AGUA PRIMERA SECCIÓN": true,
        "OJO DE AGUA SEGUNDA SECCIÓN": true
      },
      "54944": {
        "SAN FRANCISCO CHILPAN": true
      },
      "54945": {
        "ESTADO DE MÉXICO": true,
        "IZCALLI DEL VALLE": true,
        "NUEVA TULTITLÁN": true,
        "VALLE DE TULES": true,
        "VALLE VERDE": true
      },
      "54946": {
        "FERROCARRILERA": true,
        "MARIANO ESCOBEDO": true
      },
      "54947": {
        "EJIDO DE SAN ANTONIO TULTITLÁN": true
      },
      "54948": {
        "BELLO HORIZONTE": true,
        "REAL DEL BOSQUE": true,
        "SAN MATEO CUAUTEPEC": true,
        "SOLIDARIDAD 1RA. SECCIÓN": true,
        "SOLIDARIDAD 2DA. SECCIÓN": true,
        "SOLIDARIDAD 3RA. SECCIÓN": true
      },
      "54949": {
        "CONJUNTO BRILLANTE": true,
        "EJIDO SANTA MARÍA CUAUTEPEC": true,
        "LAS TERRAZAS": true,
        "LOS SAUCES": true,
        "MAYORAZGO DE TULTITLÁN": true,
        "RESIDENCIAL DURAZNOS": true,
        "SANTA MARÍA CUAUTEPEC": true
      },
      "54950": {
        "LA SARDAÑA": true
      },
      "54954": {
        "AMPLIACIÓN SAN MARCOS": true,
        "RINCONADA SAN MARCOS": true
      },
      "54955": {
        "AMPLIACIÓN BUENAVISTA": true,
        "AMPLIACIÓN BUENAVISTA 1RA. SECCIÓN": true,
        "AMPLIACIÓN BUENAVISTA 2DA. SECCIÓN": true
      },
      "54957": {
        "AMPLIACIÓN EL TESORO": true,
        "EL TESORO": true,
        "SIERRA DE GUADALUPE": true
      },
      "54958": {
        "AMPLIACIÓN LA SARDAÑA": true,
        "JARDINES DE LA CAÑADA": true,
        "LOMAS DE CARTAGENA": true,
        "LOMAS DEL PARQUE": true,
        "LOMAS DEL PARQUE II": true,
        "LOMAS DEL PARQUE III": true,
        "LOS TULIPANES": true
      },
      "54959": {
        "CORREDOR LÓPEZ PORTILLO": true,
        "EL PARAJE": true,
        "EL PARAJE SAN FRANCISCO CHILPAN": true,
        "FIMESA I": true
      }
    },
    "VALLE DE CHALCO SOLIDARIDAD": {
      "56610": {
        "ALFREDO BARANDA": true
      },
      "56613": {
        "SAN MIGUEL XICO": true
      },
      "56614": {
        "PODER POPULAR": true
      },
      "56615": {
        "CONCEPCIÓN": true
      },
      "56616": {
        "GUADALUPANA": true
      },
      "56617": {
        "EL TRIUNFO": true
      },
      "56618": {
        "AVÁNDARO": true,
        "CARLOS SALINAS DE GORTARI": true,
        "DARÍO MARTÍNEZ II SECCIÓN": true,
        "EMILIANO ZAPATA": true,
        "GEOVILLAS LA ASUNCIÓN": true,
        "SAN GREGORIO": true,
        "SAN JUAN TLALPIZAHUAC": true
      },
      "56619": {
        "LA PUNTA": true
      }
    },
    "ZINACANTEPEC": {
      "51350": {
        "SAN MIGUEL ZINACANTEPEC": true
      },
      "51354": {
        "LA JOYA": true
      },
      "51355": {
        "SAN VALENTÍN": true
      },
      "51356": {
        "DE LA VERACRUZ": true,
        "DEPORTIVA": true,
        "IRMA PATRICIA GALINDO DE REZ": true,
        "LINDAVISTA": true,
        "SAN GREGORIO": true
      },
      "51357": {
        "SAN MATÍAS TRANSFIGURACIÓN": true
      },
      "51360": {
        "SANTA MARÍA DEL MONTE": true
      },
      "51364": {
        "EL CÓPORO": true
      },
      "51366": {
        "SAN BARTOLO DEL LLANO (SAN ISIDRO)": true
      },
      "51367": {
        "LOMA DEL KIOSCO": true
      },
      "51370": {
        "BOSQUES DEL NEVADO": true
      },
      "51373": {
        "RECIBITAS (EL REMOLINO)": true
      },
      "51374": {
        "OJO DE AGUA": true
      },
      "51375": {
        "TEJALPA": true
      },
      "51380": {
        "SAN ANTONIO ACAHUALCO": true
      },
      "51383": {
        "CUAUHTÉMOC": true
      },
      "51384": {
        "EL CONTADERO DE MATAMOROS (SAN JOSÉ)": true
      },
      "51385": {
        "CIENDABAJO (HACIENDA DE ABAJO)": true
      },
      "51386": {
        "LA CAÑADA (CAÑADA GRANDE)": true
      },
      "51390": {
        "LA PUERTA DEL MONTE": true
      },
      "51393": {
        "LOMA ALTA": true
      }
    },
    "ZUMPANGO": {
      "55620": {
        "EL COLORADO": true,
        "LA SOLEDAD": true,
        "SAN JOSÉ DE LA LOMA": true
      },
      "55628": {
        "SAN LORENZO (ZITLALTEPEC)": true,
        "SAN MIGUEL (ZITLALTEPEC)": true,
        "SAN PEDRO (ZITLALTEPEC)": true,
        "SANTA MARÍA (ZITLALTEPEC)": true,
        "SANTA MARÍA DE GUADALUPE": true
      }
    }
  },
  "NUEVO LEON": {
    "APODACA": {
      "66600": {
        "CIUDAD APODACA CENTRO": true,
        "FUTURO APODACA": true,
        "HOMERO SEPÚLVEDA": true,
        "MANUEL VILLARREAL": true,
        "MODERNO APODACA": true,
        "SAN FRANCISCO": true,
        "SANTA ROSA II": true
      },
      "66603": {
        "GDS BUSINESS PARK": true,
        "KALOS APODACA": true,
        "PARQUE INDUSTRIAL APODACA": true,
        "PARQUE INDUSTRIAL ELICÁN": true,
        "PARQUE INDUSTRIAL KRONOS": true,
        "PARQUE INDUSTRIAL MONTERREY": true,
        "PIMSA ORIENTE": true,
        "PLAZA SENDERO LA FE": true,
        "PROLOGIS MONTERREY INDUSTRIAL CENTER": true,
        "RESIDENCIAL SAN FRANCISCO": true,
        "VALLE DE SAN FRANCISCO": true
      },
      "66604": {
        "ALTABRISA": true,
        "ALTABRISA PREMIER": true,
        "BOSQUE DE AGUA": true,
        "BOSQUEALTO": true,
        "BURÓCRATAS MUNICIPALES": true,
        "CAPELLANÍA RESIDENCIAL": true,
        "CASAS REALES": true,
        "CRYSTAL LAGOONS": true,
        "GÉVORA RESIDENCIAL": true,
        "LOS CASTAÑOS PRIVADA RESIDENCIAL": true,
        "LOS MOLINOS SAN FRANCISCO": true,
        "PARQUE INDUSTRIAL KUADRUM": true,
        "PRIVADA SANTA MARTHA": true,
        "RESERVA SAN FRANCISCO": true,
        "RESERVA SAN FRANCISCO SECTOR NORTE": true,
        "RESERVA VALLE": true,
        "SANTA ROSA": true,
        "TORENTO": true
      },
      "66605": {
        "BENITO JUÁREZ": true,
        "LA CONDESA RESIDENCIAS": true,
        "NOVA APODACA": true,
        "PARQUE INDUSTRIAL MILENIUM CENTER": true,
        "PEDREGAL DE APODACA": true,
        "RESIDENCIAL APODACA": true,
        "TERESITA": true
      },
      "66606": {
        "ALVENTO": true,
        "CERRADAS DE RINCONADA": true,
        "KATAVIA RESIDENCIAL": true,
        "PRIVADAS DE RINCONADA": true,
        "RINCONADA COLONIAL": true,
        "RINCONADA NORTE": true,
        "SIERRA LA ESPERANZA": true,
        "VILLAS COLONIALES": true
      },
      "66607": {
        "HACIENDA LOS GUAJARDO": true,
        "LOS ASTURES": true,
        "PARAJE SANTA ROSA": true,
        "PARAJE SANTA ROSA SECTOR NORTE": true,
        "PARQUE INDUSTRIAL AVANTE APODACA": true,
        "PARQUE INDUSTRIAL SANTO TOMÁS": true,
        "PASEO DE LOS NOGALES SANTA ROSA": true,
        "PRIVADA TIARA": true,
        "PRIVENZA QUINTA REAL": true,
        "QUINTA REAL": true,
        "SANTA ROSA": true,
        "VALLE DE SALDUERO": true,
        "VALLE LA RIOJA": true
      },
      "66609": {
        "CERRADAS CONCORDIA": true,
        "ESTANCIAS VALLE DE PLATA": true,
        "KUATRO": true,
        "MISIÓN DE LOS ÁNGELES": true,
        "MONETTA": true,
        "PRIVALIA CONCORDIA": true,
        "RADICA": true
      },
      "66610": {
        "AMBERES RESIDENCIAL": true,
        "ANTIGUA SANTA ROSA": true,
        "ARBADO CASTAÑARES": true,
        "ARBADO MONARCA": true,
        "BALCONES DE SANTA ROSA": true,
        "BONATERRA": true,
        "BOSQUES DE SANTA ROSA": true,
        "EX-HACIENDA SANTA ROSA": true,
        "JARDINES DE SANTA ROSA": true,
        "LOS LIENZOS": true,
        "LOS MURALES": true,
        "LOS SOLES": true,
        "LOS ÉBANOS DOCEAVO SECTOR": true,
        "LOS ÉBANOS DÉCIMO SECTOR": true,
        "LOS ÉBANOS NOVENO SECTOR": true,
        "LOS ÉBANOS OCTAVO SECTOR": true,
        "LOS ÉBANOS ONCEAVO SECTOR": true,
        "LOS ÉBANOS SÉPTIMO SECTOR": true,
        "PEDREGAL DEL VALLE": true,
        "PRADOS DE SANTA ROSA": true,
        "PRIVADAS DE SANTA ROSA": true,
        "PRIVADAS DE SANTA ROSA SECTOR DOS": true,
        "QUINTA COLONIAL APODACA": true,
        "RINCÓN DE SANTA ROSA": true,
        "VALLE DE LOS NOGALES": true,
        "VALLE DE LOS NOGALES RESIDENCIAL": true,
        "VILLAS DE SANTA ROSA": true
      },
      "66612": {
        "ANDALUCÍA": true,
        "ARIA RESIDENCIAL": true,
        "BOSQUE REAL": true,
        "CORTIJO LAS PALMAS": true,
        "EL MOLINO": true,
        "HACIENDA LAS YUCAS": true,
        "HACIENDA SANTA ISABEL": true,
        "INSURGENTES": true,
        "JARDINES DE LAS PALMAS": true,
        "JARDINES DE SAN ANDRÉS": true,
        "LAS ESTANCIAS": true,
        "LAS HUERTAS": true,
        "LOMBARDÍA RESIDENCIAL": true,
        "LOS ENCINOS": true,
        "LOS ÉBANOS": true,
        "MANANTIAL": true,
        "METROPLEX": true,
        "MISIÓN DE FUNDADORES": true,
        "MISIÓN DE SAN JOSÉ PRIVADAS": true,
        "MISIÓN DE SAN JOSÉ RESIDENCIAS": true,
        "MISIÓN DEL PARQUE": true,
        "MURAN RESIDENCIAL": true,
        "NUEVO LAS PUENTES PRIMER SECTOR": true,
        "NUEVO LAS PUENTES SEGUNDO SECTOR": true,
        "NUEVO LAS PUENTES TERCER SECTOR": true,
        "PRADOS DE LOS PINOS": true,
        "PRADOS DEL VIRREY": true,
        "PRIVADA LUMENA": true,
        "PRIVADA SUNDARA": true,
        "PRIVADAS DEL REY": true,
        "REAL DE SAN ANDRES": true,
        "SANTA ALICIA": true,
        "VALLE DE APODACA": true,
        "VALLE DE LAS BUGAMBILIAS": true,
        "VALLE DE LAS PALMAS CUARTO SECTOR": true,
        "VALLE DE LAS PALMAS QUINTO SECTOR": true,
        "VALLE DE LAS PALMAS SEGUNDO SECTOR": true,
        "VALLE DE LAS PALMAS SEXTO SECTOR": true,
        "VALLE DE LAS PALMAS TERCER SECTOR": true,
        "VALLE DE SAN ANDRÉS": true,
        "VILLA LAS PUENTES": true,
        "VILLAS PREMIER": true,
        "ÉBANOS NORTE": true
      },
      "66613": {
        "BALCONES DEL NORTE III": true,
        "FUNDADORES": true,
        "JARDINES DE MONTERREY I": true,
        "JARDINES DE MONTERREY II": true,
        "JARDINES DE MONTERREY III": true,
        "LOS ALTOS": true,
        "LOS AMARANTOS": true,
        "LOS LIRIOS": true,
        "LOS NUEVOS VERGELES": true,
        "MOISÉS SÁENZ": true,
        "PARQUE INDUSTRIAL DEL NORTE": true,
        "PARQUE INDUSTRIAL JARDÍNES DE MONTERREY": true,
        "PARQUE INDUSTRIAL LAMAR": true,
        "PASEO DE APODACA": true,
        "PRIVADAS DEL REY II": true,
        "RESIDENCIAL MOISÉS SÁENZ": true,
        "SANTA ELENA": true
      },
      "66614": {
        "ARBOLEDAS DE SANTA ROSA": true,
        "COSMÓPOLIS": true,
        "COSMÓPOLIS OCTAVO SECTOR": true,
        "INDUSTRIAL APODACA": true,
        "KALOS SANTA ROSA": true,
        "LAS MERCEDES": true,
        "MILIMEX SANTA ROSA": true,
        "MISIÓN DE LOS OLIVOS": true,
        "PARQUE INDUSTRIAL AZTECA": true,
        "PASEO DE SANTA ROSA": true,
        "PORTAL DE SANTA ROSA": true,
        "RENACERES": true,
        "VENTURA DE SANTA ROSA": true
      },
      "66630": {
        "ANDANA RESIDENCIAL": true,
        "ARBADO FLORESTA": true,
        "ARBOLEDAS DEL MEZQUITAL": true,
        "CALABRIA RESIDENCIAL": true,
        "CANTIZALES": true,
        "CORINTO RESIDENCIAL": true,
        "EJIDO MEZQUITAL": true,
        "EL MEZQUITAL": true,
        "FRANCISCO ELIZONDO": true,
        "FRANCISCO MARTINEZ": true,
        "GARCIA MIRELES": true,
        "HACIENDA DEL MORO": true,
        "HACIENDA LOS NOGALES": true,
        "LAS AMÉRICAS": true,
        "PRIVADA 103": true,
        "PRIVADA LOS OLMOS": true,
        "VELLANÍA RESIDENCIAL": true,
        "VIEJO MEZQUITAL": true
      },
      "66632": {
        "BALCONES DEL MEZQUITAL": true,
        "CANTÚ": true,
        "CERRADAS AMBAR": true,
        "CERRADAS DE SANTA ROSA": true,
        "CERRADAS DEL PARQUE": true,
        "CERRADAS MAGENTA": true,
        "DESARROLLO INDUSTRIAL GP APODACA 2": true,
        "EX HACIENDA SAN FRANCISCO": true,
        "HACIENDA DEL MEZQUITAL": true,
        "JOSÉ MARÍA GARCÍA PONCE": true,
        "NUEVO MEZQUITAL": true,
        "PRIVADAS BORNEO": true,
        "RECOVA RESIDENCIAL": true,
        "RINCÓN DE LA MORALEJA": true,
        "VALLE DEL MEZQUITAL": true,
        "VILLAS DEL MEZQUITAL": true
      },
      "66633": {
        "ALIANZA": true,
        "DEPORTIVO HUINALÁ": true,
        "DEPORTIVO HUINALÁ MUNDIALISTA": true,
        "FRESNOS DEL LAGO": true,
        "HACIENDA SANTA FE": true,
        "JARDINES DE SAN JORGE": true,
        "KALOS MIGUEL ALEMÁN": true,
        "LA ENCARNACIÓN": true,
        "LOS ARRECIFES": true,
        "LOS ÁLAMOS": true,
        "MIRADOR HUINALÁ": true,
        "MONTERREY BUSINESS PARK": true,
        "NORIA NORTE": true,
        "NORIA SUR": true,
        "ORION RESIDENCIAL": true,
        "PARQUE INDUSTRIAL JM": true,
        "PARQUE INDUSTRIAL KALOS ENCARNACIÓN": true,
        "PARQUE INDUSTRIAL MULTIPARK": true,
        "PARQUE INDUSTRIAL MÉXICO": true,
        "PARQUE INDUSTRIAL OMOLAP": true,
        "PARQUE INDUSTRIAL TITAN": true,
        "PRIVADA ANTIGUA HUINALÁ": true,
        "PRIVADAS DEL PARQUE": true,
        "REGIO PARQUE INDUSTRIAL": true,
        "RESIDENCIAL JOYAS DE HUINALÁ": true,
        "RINCÓN DE LA GLORIA": true,
        "SAN IGNACIO": true,
        "TORRE DE CAMPO": true,
        "VALLE DE LOS ÁLAMOS": true,
        "VENTURA DE ASÍS PRIMER SECTOR": true,
        "VENTURA DE ASÍS SEGUNDO SECTOR": true,
        "ÁLAMOS DEL PARQUE": true
      },
      "66634": {
        "AXIS MTY": true,
        "CAMPESTRE CTM": true,
        "EL MILAGRO": true,
        "ENCINOS RESIDENCIAL": true,
        "ILTAMARINDO": true,
        "INDEPENDENCIA": true,
        "JACARANDAS": true,
        "MISIÓN DE SAN PATRICIO": true,
        "MONTALTO RESIDENCIAL": true,
        "PRIVADA LA CASTAÑA": true,
        "PRIVADAS PREMIER": true,
        "PRIVADAS SANTA FE": true,
        "RESIDENCIAL LAS PROVINCIAS": true,
        "VALLE DE HUINALÁ": true,
        "VILLAS DE HUINALÁ": true
      },
      "66635": {
        "HACIENDA LAS PALMAS": true,
        "HACIENDA LAS PALMAS II": true,
        "HACIENDA LOS ENCINOS": true,
        "JARDINES DE APODACA": true,
        "JARDINES DE LA ENRAMADA": true,
        "KEBANA": true,
        "LA ENRAMADA I": true,
        "LA ENRAMADA II": true,
        "LA ENRAMADA III": true,
        "LA ENRAMADA IV": true,
        "LA ENRAMADA V": true,
        "LA ENRAMADA VI": true,
        "LA ENRAMADA VII": true,
        "LAS PRADERAS I": true,
        "LAS PRADERAS II": true,
        "LOS FRESNOS PRIMER SECTOR": true,
        "LOS FRESNOS SEGUNDO SECTOR": true,
        "LOS FRESNOS TERCER SECTOR": true,
        "LOS PINOS CUARTO SECTOR": true,
        "LOS PINOS QUINTO SECTOR": true,
        "LOS PINOS TERCER SECTOR": true,
        "MAGNOLIAS": true,
        "MUJERES ILUSTRES": true,
        "NUEVA DEMOCRACIA": true,
        "PASEO LAS PALMAS I": true,
        "PASEO LAS PALMAS II": true,
        "PASEO LAS PALMAS III": true,
        "PASEO LAS PALMAS IV": true,
        "PORTAL ANÁHUAC": true,
        "PRADRERAS DE LA ENRAMADA": true,
        "VALLE DE LAS PALMAS PRIMER SECTOR": true,
        "VILLA LUZ": true,
        "VILLA SOL": true
      },
      "66636": {
        "ALTAMURA RESIDENCIAL": true,
        "ARBADO": true,
        "ARBOLEDAS DEL VIRREY": true,
        "CERRADA PROVIDENCIA": true,
        "FRESNOS NORTE": true,
        "HACIENDA LOS PINOS PRIMER SECTOR": true,
        "HACIENDA LOS PINOS SEGUNDO SECTOR": true,
        "JARDINES DE LOS PINOS PRIMER SECTOR": true,
        "JARDINES DE LOS PINOS SEGUNDO SECTOR": true,
        "LA HACIENDA": true,
        "LA MORADA RESIDENCIAL": true,
        "LOS FRESNOS CUARTO SECTOR": true,
        "LOS FRESNOS DÉCIMO SECTOR": true,
        "LOS FRESNOS NOVENO SECTOR": true,
        "LOS FRESNOS OCTAVO SECTOR": true,
        "LOS PINOS PRIMER SECTOR": true,
        "LOS PINOS SEGUNDO SECTOR": true,
        "LOS ROBLES": true,
        "NUEVO AMANECER PRIMER SECTOR": true,
        "NUEVO AMANECER SEGUNDO SECTOR": true,
        "PASEO DE LOS NOGALES": true,
        "PASEO DE LOS PINOS II": true,
        "PRADERAS DE APODACA": true,
        "PRADOS DE LA CIENEGUITA": true,
        "RESIDENCIAL PALMAS": true,
        "SANTA CECILIA": true
      },
      "66637": {
        "ALMACENTRO": true,
        "INDUSTRIAL MARTEL": true,
        "PARQUE INDUSTRIAL MILIMEX": true
      },
      "66640": {
        "ALBERTA ESCAMILLA": true,
        "BALCONES DE HUINALÁ": true,
        "COLONIAL DE HUINALÁ": true,
        "ESTANCIA CASTAÑO": true,
        "FRACCIONAMIENTO INDUSTRIAL SAN ANDRÉS": true,
        "HACIENDA SAN GERARDO": true,
        "HUINALÁ": true,
        "JARDINES DE HUINALÁ": true,
        "LOMAS DE HUINALÁ II": true,
        "MISIÓN REAL": true,
        "PRADOS RESIDENCIAL": true,
        "REAL DE APODACA": true,
        "REFORMA": true,
        "SAN ANDRÉS": true,
        "SAN MIGUEL GOLONDRINAS": true
      },
      "66643": {
        "HACIENDA EL CAMPANARIO": true,
        "HUERTAS SAN JAVIER": true,
        "MISIÓN SAN PABLO": true,
        "MODENA": true,
        "PARQUE INDUSTRIAL AVANTE AEROPUERTO": true,
        "PARQUE INDUSTRIAL LA SILLA APODACA": true,
        "PARQUE INDUSTRIAL NEXXUS AEROPUERTO": true,
        "PASEO DE LAS FLORES": true,
        "PORTAL DEL VALLE": true,
        "PRIVADA CEREZO": true,
        "PROTEXA": true,
        "RESIDENCIAL ACCADIA": true,
        "SANTA ANITA": true
      },
      "66644": {
        "BUGAMBILIAS HUINALÁ": true,
        "CÉNTRIKA HUINALÁ": true,
        "FRACCIONAMIENTO INDUSTRIAL SAN CARLOS": true,
        "REAL HACIENDA DE HUINALÁ": true,
        "RINCÓN DE HUINALÁ": true,
        "SANTA MÓNICA": true,
        "TREVIÑO ELIZONDO": true,
        "VILLAS DE SAN CARLOS": true
      },
      "66645": {
        "AMERICAN INDUSTRIES": true,
        "BOSQUES DE HUINALÁ": true,
        "HACIENDA DEL CARMEN": true,
        "JARDINES DEL VIRREY": true,
        "PADILLA": true,
        "PARQUE INDUSTRIAL EL SABINAL": true,
        "PARQUE INDUSTRIAL HUINALÁ": true,
        "PIRSA": true
      },
      "66646": {
        "LOMAS DE SAN ISIDRO": true,
        "LOS COLIBRIES": true,
        "MILENIUM RESIDENCIAL": true,
        "MISIÓN DE HUINALÁ": true,
        "MISIÓN DE SAN JAVIER": true,
        "MONTEBELLO HUINALÁ": true,
        "PORTAL DE HUINALÁ": true,
        "PRIVADA DOMINIO": true,
        "PRIVADAS CANTERAS": true,
        "PRIVALIA HUINALÁ": true,
        "PUEBLO NUEVO": true,
        "RESIDENCIAL SAN BENITO": true,
        "RIVERAS DE HUINALÁ": true,
        "SAN ISIDRO": true,
        "SAN JAVIER": true,
        "SANTA SOFÍA RESIDENCIAL": true,
        "TERRANOVA ELITE": true,
        "TRÉBOLES": true
      },
      "66647": {
        "AMERICAN INDUSTRIES APODACA": true,
        "ARBOLADA": true,
        "BOSQUE BOREAL": true,
        "BOSQUES DE SAN MIGUEL": true,
        "BOSQUES DEL SOL": true,
        "CAMPESTRE HUINALÁ": true,
        "CAOBA RESIDENCIAL": true,
        "DAVISA INDUSTRIAL PARK APODACA": true,
        "EL ROSARIO": true,
        "FUENTES DE SANTA LUCIA": true,
        "FÁTIMA": true,
        "HACIENDA LAS MARGARITAS": true,
        "JARDINES DE SAN PATRICIO": true,
        "LOMA LA PAZ": true,
        "LOS CANDILES": true,
        "LOS OLIVOS RESIDENCIAL": true,
        "LOS PINCELES": true,
        "LOS PUERTOS (BIF) [RASTRO]": true,
        "LOS VITRALES": true,
        "MIRASOL RESIDENCIAL": true,
        "PASEO DE LA LOMA": true,
        "PASEO DE LAS FUENTES": true,
        "PECARI DULCES NOMBRES INDUSTRIAL PARK": true,
        "PRADERAS DE HUINALÁ": true,
        "RESERVA ACANTO": true,
        "RESERVA ACANTO SECTOR OLMO": true,
        "RIVIERAS DE APODACA": true,
        "TOSCANA RESIDENCIAL": true,
        "VESTA PARK APODACA": true,
        "VIVIENDA DIGNA": true
      },
      "66648": {
        "CERRADA LA TOSCANA": true,
        "COLINAS DE SAN MIGUEL": true,
        "EL CAMPANARIO": true,
        "JOYAS DEL PEDREGAL": true,
        "LOMAS DE HUINALÁ I": true,
        "LOMAS DEL PEDREGAL": true,
        "LOS TRES NOGALES": true,
        "MADEIRA RESIDENCIAL": true,
        "MISIÓN DE LAS FLORES": true,
        "MISIÓN DE SAN MIGUEL": true,
        "MONTE ALBAN II": true,
        "PRIVADA SAN AGUSTÍN": true,
        "RINCÓN DE SAN MIGUEL": true,
        "ROBERTO ESPINOZA": true,
        "SANTA FÉ": true,
        "VALLE DE SAN MIGUEL": true,
        "VALLE DEL PEDREGAL": true,
        "VALTERRA RESIDENCIAL": true
      },
      "66649": {
        "ALTARIA RESIDENCIAL": true,
        "GOLONDRINAS": true,
        "MIGUEL HIDALGO": true,
        "MIXCOAC": true,
        "MONTE ALBÁN": true,
        "NUEVA MIXCOAC": true,
        "PRIVADA SAN MIGUELITO": true,
        "QUINTA SAN MIGUEL": true,
        "REAL DE SAN MIGUEL": true,
        "RINCÓN DE LOS CRISTALES": true,
        "RIVERAS DE LORETO": true,
        "SAN MIGUEL": true,
        "SAN MIGUELITO": true,
        "SEBASTIÁN ELIZONDO": true,
        "VILLAS DE LORETO": true
      }
    },
    "GARCIA": {
      "66023": {
        "ARCO VIAL": true,
        "AVANTE MONTERREY INDUSTRIAL PARK": true,
        "EX-HACIENDA SAN JOSÉ": true,
        "LAS PALMAS": true,
        "LOMAS DE GARCÍA": true,
        "LOS PARQUES": true,
        "MANDARA": true,
        "MISIÓN SAN JUAN": true,
        "MITRAS BICENTENARIO": true,
        "MITRAS PONIENTE": true,
        "PARAJE DE LAS GRUTAS": true,
        "PARAJE SAN FRANCISCO": true,
        "PARAJE SAN JOSÉ": true,
        "PARAJE SAN JOSÉ SECTOR PECES": true,
        "PARQUE INDUSTRIAL CIUDAD MITRAS": true,
        "PARQUES DIAMANTE": true,
        "PORTAL DEL PARQUE": true,
        "RANCHO DE ENMEDIO (LAS MITRAS)": true,
        "REAL DE SAN MARTÍN": true,
        "SAN JOSÉ": true,
        "VALLE DE LAS GRUTAS": true,
        "VALLE DE LINCOLN SAN AGUSTÍN": true,
        "VALLE DE LINCOLN SAN JOSÉ": true,
        "VERANDA PASEO RESIDENCIAL": true,
        "VILLAS DE SAN MARTÍN": true,
        "VILLAS DEL PONIENTE": true
      },
      "66024": {
        "ALTRYSA": true,
        "CERRADAS SOLÉ": true,
        "LAS LOMAS": true,
        "LOMAS DEL SUR": true,
        "LOMAS PALMEIRA": true,
        "MONTENOVA": true,
        "RESIDENCIAL SANTUARIO": true
      }
    },
    "GENERAL ESCOBEDO": {
      "66050": {
        "CIUDAD GENERAL ESCOBEDO CENTRO": true,
        "DEL VALLE": true,
        "DON LALO": true,
        "GUADALUPE VICTORIA": true,
        "INFONAVIT RICARDO FLORES MAGÓN": true,
        "JARDINES DE ESCOBEDO II": true,
        "JARDINES DEL CANADÁ": true,
        "LA CUCHILLA": true,
        "LAS ENCINAS": true,
        "LAS PALOMAS": true,
        "LAS QUINTAS II": true,
        "LAS QUINTAS III": true,
        "LOS ELIZONDO": true,
        "LOS EUCALIPTOS": true,
        "LOS SALDAÑAS": true,
        "MIRAVISTA": true,
        "PRIVADA CANTERAS": true,
        "PRIVADA SAN JORGE": true,
        "PRIVADAS DIAMANTE": true,
        "RESIDENCIAL LAS QUINTAS": true,
        "RINCÓN DE MIRAVISTA": true,
        "SHALOM": true,
        "TORRES DIAMANTE": true,
        "VILLA ALTA": true
      },
      "66051": {
        "JARDINES DE ESCOBEDO I": true,
        "PLAZA SOL": true
      },
      "66052": {
        "ARBOLEDAS DE ESCOBEDO": true,
        "BALCONES DEL NORTE": true,
        "CAMPIÑAS DE CASTILLA": true,
        "DESARROLLO INDUSTRIAL GP TECNOCENTRO": true,
        "EMILIANO ZAPATA": true,
        "FERNANDO AMILPA PREDIO": true,
        "JARDINES DE LA REINA": true,
        "LOS ALTOS": true,
        "LOS OLIVOS": true,
        "NIÑOS HÉROES": true,
        "NUEVA CASTILLA": true,
        "PUERTA DE ANÁHUAC": true,
        "RIO PESQUERÍA": true,
        "RIO PESQUERÍA NORTE": true,
        "RIO PESQUERÍA NUEVAS PUENTES": true,
        "RIO PESQUERÍA PONIENTE": true,
        "SÓCRATES RIZZO UNIÓN DE COMERCIANTES": true,
        "UNIÓN DE ALFAREROS": true,
        "ÉBANOS Y NUEVA ESPERANZA": true
      },
      "66053": {
        "BELISARIO DOMÍNGUEZ": true,
        "CENTRO INDUSTRIAL IGS ESCOBEDO": true,
        "CHAMIZAL": true,
        "LOS GIRASOLES II": true,
        "LOS NOGALES": true,
        "LÁZARO CÁRDENAS AGROPECUARIA SUR": true,
        "PARQUE LOGÍSTICO PUERTA DEL NORTE": true,
        "PRIVADAS DE SAN JOSÉ": true,
        "PRIVADAS DEL LOS SAUCES": true,
        "RESERVA ESCOBEDO": true,
        "RINCÓN DE LAS ENCINAS": true,
        "SAN JOSÉ DE LOS SAUCES": true,
        "VALLE DE ESCOBEDO": true,
        "VILLA CASTELLO": true,
        "VYNMSA ESCOBEDO INDUSTRIAL PARK": true
      },
      "66054": {
        "ANÁHUAC CAMPOAMOR": true,
        "ANÁHUAC LA PERGOLA": true,
        "CPA LOGISTICS CENTER ESCOBEDO": true,
        "EX-HACIENDA EL CANADÁ": true,
        "HACIENDAS DEL CANADA": true,
        "LA ENCOMIENDA": true,
        "LA ENCOMIENDA II": true,
        "PUERTA DEL NORTE RESIDENCIAL": true
      },
      "66055": {
        "CALIFORNIA RESIDENCIAL": true,
        "CELESTINO GASCA": true,
        "HACIENDAS DE ANÁHUAC": true,
        "INFONAVIT FELIPE CARRILLO PUERTO": true,
        "INFONAVIT INSURGENTES": true,
        "INFONAVIT TOPO GRANDE": true,
        "JOYAS DE ANÁHUAC": true,
        "NEXXUS RESIDENCIAL SECTOR CRISTAL": true,
        "NEXXUS RESIDENCIAL SECTOR DIAMANTE": true,
        "NEXXUS RESIDENCIAL SECTOR ESMERALDA": true,
        "NEXXUS RESIDENCIAL SECTOR PLATINO": true,
        "NEXXUS RESIDENCIAL SECTOR RUBÍ": true,
        "NEXXUS RESIDENCIAL SECTOR ZAFIRO": true,
        "PARQUE INDUSTRIAL NEXXUS XXI": true,
        "PORTAL DE ESCOBEDO": true,
        "PRIVADAS BOUGAMBILIAS": true,
        "PRIVADAS DEL ÁNGEL": true,
        "RESIDENCIAL PINOS": true,
        "ROBLE NUEVO": true,
        "VALLE NORD": true,
        "VILLAS DE ESCOBEDO II": true,
        "VILLAS DEL PARQUE": true
      },
      "66056": {
        "BALCONES DE ANÁHUAC": true,
        "BOSQUES DE QUEBÉC": true,
        "HILARIO AYALA PREDIO": true,
        "INFONAVIT MONTERREAL": true,
        "LOMAS DE ESCOBEDO": true,
        "LOS GIRASOLES I": true,
        "PRADERAS DE GIRASOLES": true,
        "RIBERAS DE GIRASOLES": true,
        "TOPO GRANDE": true,
        "VALLE DE GIRASOLES": true,
        "VILLAS DE ESCOBEDO": true
      },
      "66057": {
        "FUENTES DE ESCOBEDO": true,
        "HACIENDA ESCOBEDO": true,
        "LOS RINCONES RESIDENCIAL": true,
        "NOVUS SENDERO": true,
        "NUESTRA SEÑORA DE FÁTIMA": true,
        "PRIVADA RESIDENCIAL AVIANA": true,
        "RESIDENCIAL ESCOBEDO": true,
        "VENETO RESIDENCIAL": true
      },
      "66058": {
        "16 DE SEPTIEMBRE": true,
        "AMPLIACIÓN LÁZARO CÁRDENAS": true,
        "ANÁHUAC SAN PATRICIO": true,
        "DIRONA ADUANA INTERIOR": true,
        "INFONAVIT EX-HACIENDA EL CANADÁ": true,
        "JARDINES DE ESCOBEDO III": true,
        "LA LOMA": true,
        "LAS HADAS": true,
        "LAS MALVINAS": true,
        "LOS GIRASOLES III": true,
        "LÁZARO CÁRDENAS": true,
        "MÁRTIRES DEL 36": true,
        "PARQUE INDUSTRIAL NEXXUS ESCOBEDO CENTER": true,
        "PRADERAS DE TOPO GRANDE": true,
        "SALVATERRA": true,
        "SOLIDARIDAD": true,
        "UCAM": true
      },
      "66059": {
        "ANÁHUAC MADEIRA": true,
        "CALZADAS ANÁHUAC": true,
        "CERRADAS DE ANÁHUAC": true,
        "CERRADAS DE ANÁHUAC SECTOR CONTEMPORÁNEO": true,
        "CERRADAS DE ANÁHUAC SECTOR PREMIER": true,
        "EL CENTENARIO": true,
        "HACIENDA LOS CANTÚ": true,
        "LA CANTERA PRIVADA RESIDENCIAL": true,
        "MISIÓN DE ANÁHUAC": true,
        "NEXXUS RESIDENCIAL SECTOR DORADO": true,
        "PARAJE ANÁHUAC": true,
        "PRIVADAS DE ANÁHUAC SECTOR ESPAÑOL": true,
        "PRIVADAS DE ANÁHUAC SECTOR FRANCÉS": true,
        "PRIVADAS DE ANÁHUAC SECTOR HIMALAYA": true,
        "PRIVADAS DE ANÁHUAC SECTOR INGLÉS": true,
        "PRIVADAS DE ANÁHUAC SECTOR IRLANDES": true,
        "PRIVADAS DE ANÁHUAC SECTOR MEDITERRÁNEO": true,
        "PRIVADAS DE ANÁHUAC SECTOR NIZA": true,
        "PRIVADAS DE ANÁHUAC SECTOR TÍBET": true,
        "PRIVADAS DE LINDORA": true,
        "PRIVADAS DEL CANADÁ": true,
        "QUINTAS DE ANÁHUAC": true,
        "VALLE DEL CANADÁ": true,
        "VILLAS DE ANÁHUAC": true,
        "VILLAS DE ANÁHUAC SECTOR ALPES": true
      },
      "66061": {
        "JARDINES DE SAN MARTÍN": true,
        "PEDREGAL DE ESCOBEDO": true,
        "PEDREGAL DEL TOPO CHICO (FOMERREY 52)": true,
        "SAN MARTÍN": true
      },
      "66062": {
        "GLORIA MENDIOLA": true,
        "HACIENDA LA PROVIDENCIA": true,
        "LA ISLA": true,
        "LAS VILLAS": true,
        "PARQUE INDUSTRIAL ESCOBEDO": true,
        "PARQUE INDUSTRIAL PERIFÉRICO": true,
        "PASO CUCHARAS": true,
        "VALLE DE SAN MIGUEL RESIDENCIAL": true,
        "VILLAS DE SAN FRANCISCO": true
      },
      "66064": {
        "18 DE OCTUBRE": true,
        "CENTRO LOGÍSTICO LIBRAMIENTO": true,
        "CIUDAD SAN MARCOS": true,
        "CIUDAD SAN MARCOS SECTOR PIONERO": true,
        "LA CONCORDIA": true,
        "LA UNIDAD (FOMERREY)": true,
        "LAS FLORES": true,
        "LOS VERGELES": true,
        "NUEVA ESPERANZA (FOMERREY 193)": true,
        "NUEVO ESCOBEDO": true,
        "PORTAL DEL FRAILE": true,
        "PRIVADAS DE CAMINO REAL": true,
        "RIVERAS DE LOS NARANJOS": true,
        "SAN MARCOS": true,
        "SANTA MARTHA (FOMERREY 191)": true,
        "VALLE DE SAN FRANCISCO": true,
        "VIDA": true,
        "VILLAS DE SAN MARTÍN": true
      },
      "66070": {
        "BRIANZZAS RESIDENCIAL SEGUNDO SECTOR": true,
        "BRIANZZAS RESIDENCIAL TERCER SECTOR": true,
        "LOMAS DE SAN GENARO": true,
        "MONTE HOREB": true,
        "MURIEL RESIDENCIAL": true,
        "PROVILEON": true,
        "PUERTA DEL SOL": true,
        "SANTALUZ": true,
        "VILLA DE LOS AYALA": true,
        "VILLAS MIRASUR": true
      },
      "66072": {
        "BOSQUES DE ESCOBEDO": true,
        "BRIANZZAS RESIDENCIAL": true,
        "CORTIJO LOS AYALA": true,
        "HACIENDA DEL TOPO": true,
        "HACIENDA LOS AYALA": true,
        "HACIENDA LOS VERGELES": true,
        "LA PROVIDENCIA": true,
        "LOS AGAVES": true,
        "MIRADOR DEL VALLE": true,
        "MIRASUR II": true,
        "PARQUE INDUSTRIAL LIBRAMIENTO": true,
        "PASEO REAL": true,
        "PROGRESO PASO CUCHARAS": true,
        "QUINTO CENTENARIO": true,
        "RENACIMIENTO": true
      },
      "66073": {
        "ADELITAS DE VILLA": true,
        "COLINAS DE ANÁHUAC": true,
        "INFONAVIT SAN GENARO": true,
        "LAS LOMAS": true,
        "LOMAS DE AZTLÁN (FOMERREY 153)": true,
        "LOS GIRASOLES IV": true,
        "SANTA JULIA": true,
        "SOLIDARIDAD SOCIAL (FOMERREY 9)": true
      }
    },
    "GUADALUPE": {
      "67100": {
        "GUADALUPE CENTRO": true
      },
      "67110": {
        "ARBOLEDAS DE SAN MIGUEL": true,
        "BOSQUES DEL ORIENTE": true,
        "JARDINES LA VICTORIA": true,
        "LA AMISTAD": true,
        "LA VICTORIA": true,
        "LOS OLIVOS": true,
        "PASEO SAN MIGUEL": true,
        "PEDREGAL DE LINDAVISTA": true,
        "PLAZA SAN ANTONIO": true,
        "RINCÓN LINDAVISTA": true,
        "SAN RAFAEL": true,
        "TALABERNA": true,
        "VILLA DE SAN MIGUEL": true,
        "VILLA SAN ANTONIO": true
      },
      "67112": {
        "ALMENDROS": true,
        "HACIENDA LOS ENCINOS": true,
        "LAS DALIAS": true,
        "PEDREGAL DE LINDAVISTA II": true,
        "PRIVADAS DE LINDAVISTA": true,
        "PROVIVIENDA": true,
        "PROVIVIENDA LA ESPERANZA": true,
        "RESIDENCIAL SAN ANTONIO": true,
        "RESIDENCIAL SANTA FE": true,
        "VALLE DE SAN ANTONIO": true,
        "VILLAS DEL RÍO": true
      },
      "67113": {
        "ARBOLEDAS DE ACAPULCO": true,
        "BALCONES DE SAN MIGUEL": true,
        "COLONIAL DE SAN MIGUEL": true,
        "COLONIALES SAN MIGUEL SECTOR UNO": true,
        "FUENTES DE SAN MIGUEL": true,
        "HACIENDA SAN MIGUEL": true,
        "INFONAVIT BENITO JUÁREZ": true,
        "LOMAS DE SAN MIGUEL": true,
        "MIXCOAC": true,
        "POLICÍA AUXILIAR": true,
        "PRIVADA SAN FERNANDO": true,
        "REAL DE SAN MIGUEL SECTOR CUATRO": true,
        "REAL DE SAN MIGUEL SECTOR DOS": true,
        "REAL DE SAN MIGUEL SECTOR TRES": true,
        "REAL DE SAN MIGUEL SECTOR UNO": true,
        "RESIDENCIAL AVANTE": true,
        "TORRES DE SAN MIGUEL": true,
        "VALLE SAN MIGUEL": true
      },
      "67115": {
        "MAYA": true,
        "NUEVO MILENIO": true,
        "PARQUE INDUSTRIAL VIGA": true,
        "PEDREGAL DE ORIENTE": true,
        "PROMOFISA": true,
        "SAN MIGUEL": true,
        "SEBASTIÁN ELIZONDO": true
      },
      "67116": {
        "BENITO JUÁREZ": true,
        "JARDINES DE CASA BLANCA": true,
        "JARDINES DEL RÍO": true,
        "JARDINES GUADALUPE": true,
        "JARDÍNES DE SAN MIGUEL": true,
        "NUEVO SAN MIGUEL": true,
        "RIVERAS DE LA SILLA (FOMERREY 31)": true,
        "SIETE COLINAS SECTOR PALATINO": true
      },
      "67117": {
        "ARBOLEDAS DEL ORIENTE": true,
        "CAÑADA BLANCA": true,
        "CENTROAMÉRICA": true,
        "EDUARDO CABALLERO": true,
        "JOSEFA ZOZAYA": true,
        "LOS CRISTALES": true,
        "LOS CRISTALES TERCER SECTOR": true,
        "MISIÓN DE GUADALUPE": true,
        "RAÚL CABALLERO": true,
        "RESIDENCIAL TORREMOLINOS": true,
        "SANTA FE LIVING": true,
        "TORREMOLINOS LA FE": true,
        "VALLE TORREMOLINOS": true,
        "ZOZAYITA": true
      },
      "67118": {
        "EMILIANO ZAPATA (FOMERREY 18)": true,
        "HACIENDA LA ESPAÑOLA": true,
        "LA FLORESTA": true,
        "MISIÓN DEL VALLE": true,
        "NUEVO SAN RAFAEL": true,
        "VALLE SAN RAFAEL": true,
        "VILLA ESPAÑOLA": true
      },
      "67119": {
        "INDUSTRIAL JARDINES SAN RAFAEL": true,
        "JARDINES DE SAN RAFAEL": true,
        "PRADERAS DE SAN RAFAEL": true,
        "SAN RAFAEL": true
      },
      "67120": {
        "ADOLFO PRIETO": true,
        "ADOLFO PRIETO SECTOR 2": true,
        "ADOLFO PRIETO SECTOR 3": true,
        "AMÉRICA OBRERA": true,
        "HÉRCULES": true,
        "LA LUZ": true,
        "LEÓN XIII": true,
        "NUEVA LIBERTAD": true,
        "RESIDENCIAL MINERVA": true
      },
      "67123": {
        "10 DE MAYO": true,
        "ARBOLEDAS DE CORREGIDORA": true,
        "JARDINES DE LINDAVISTA": true,
        "LIBERTAD": true,
        "LINDA VISTA": true
      },
      "67124": {
        "ADOLFO PRIETO SECTOR 4": true,
        "ARAGONÉS": true,
        "ESCAMILLA": true,
        "REAL DE MINAS": true
      },
      "67125": {
        "ALBANA LINDA VISTA": true,
        "AMÉRICA": true,
        "CERRADAS DE LINDAVISTA": true,
        "CONDOCASA LINDAVISTA": true,
        "LOLYTA": true,
        "PRIVADA PURÍSIMA": true,
        "VALLE DE LINDAVISTA": true,
        "VISTA SOL": true
      },
      "67126": {
        "18 DE MARZO": true,
        "DOCTOR ÁNGEL MARTÍNEZ VILLARREAL": true,
        "RIVERA DE LINDA VISTA": true,
        "RIVERAS DE LA PURÍSIMA": true,
        "TORRES LINDAVISTA": true
      },
      "67128": {
        "PARQUE INDUSTRIAL LAS AMÉRICAS": true
      },
      "67129": {
        "ARBOLEDAS NUEVA LINDAVISTA": true,
        "CENTRAL DE CARGA": true,
        "JARDINES NUEVA LINDAVISTA": true,
        "LA PURÍSIMA": true,
        "LA TALAVERNA MÓDULO SOCIAL FOVISSSTE": true,
        "NUEVA LINDA VISTA": true,
        "RINCÓN DE LA PURÍSIMA": true,
        "SERENA": true
      },
      "67130": {
        "BOSQUES DEL SOL": true,
        "CERRADA MÉXICO": true,
        "LA CONDESA": true,
        "PARQUE INDUSTRIAL NEXXUS": true,
        "PASEO AMBERES": true,
        "PRIVADAS DE SAN MIGUEL": true,
        "VALLE DE LAS FLORES": true,
        "VALLE SOLEADO": true
      },
      "67132": {
        "BELLO AMANECER": true,
        "FÁTIMA": true,
        "PARQUE INDUSTRIAL FINSA MONTERREY-GUADALUPE": true,
        "REGIO PARQUE INDUSTRIAL GUADALUPE": true,
        "RIVIERA DE GUADALUPE": true
      },
      "67133": {
        "KALOS GUADALUPE AEROPUERTO": true,
        "LAS ESCOBAS": true
      },
      "67134": {
        "ARBOLEDAS DE SANTA CECILIA": true,
        "CONSTANZA": true,
        "DOS RÍOS": true,
        "FONTANA RESIDENCIAL": true,
        "PENÍNSULA RESIDENCIAL": true,
        "PRIVADA SAN CARLOS": true,
        "RESIDENCIAL PRIVADA LAS PLAZAS": true,
        "RIBERAS DE DOS RÍOS": true,
        "SANTA CLARA": true
      },
      "67140": {
        "CENTRAL DE ABASTOS": true,
        "CHINAMECA": true,
        "CÓNDOR": true,
        "DEL MAESTRO": true,
        "ESMERALDA": true,
        "IGNACIO ALTAMIRANO": true,
        "JARDINES LA PASTORA": true,
        "JUAN ÁLVAREZ": true,
        "LA HERRADURA": true,
        "LA PASTORA": true,
        "LAS PLAZAS DOS": true,
        "LAS PLAZAS TRES": true,
        "LAS PLAZAS UNO": true,
        "LOS SAUCES": true,
        "PARAÍSO": true,
        "POLANCO": true,
        "POLANCO ORIENTE": true,
        "RESIDENCIAL CERRO DE LA SILLA": true,
        "REVOLUCIÓN": true,
        "RIVERA DE LA PASTORA": true,
        "SANTA MARGARITA": true,
        "VALLE DE CHAPULTEPEC": true
      },
      "67144": {
        "BENITO JUÁREZ": true,
        "EL BAJÍO": true,
        "GUERRA": true,
        "LA HUERTA": true,
        "MARTE": true,
        "RIVIERA DEL CONTRY": true,
        "VENUS": true
      },
      "67150": {
        "AZTECA": true,
        "INFONAVIT AZTECA": true,
        "JOSÉ MARÍA MORELOS": true,
        "LAS CANTERAS": true,
        "NUEVA EXPOSICIÓN": true,
        "RESIDENCIAL AZTECA": true,
        "RINCÓN DE LA AZTECA": true
      },
      "67153": {
        "PRIVADA CHAPULTEPEC": true,
        "PRIVADA LAURA": true
      },
      "67154": {
        "EL SABINO": true,
        "EXPOSICIÓN MODELO": true,
        "LA FUENTE": true,
        "SAN DIEGO": true
      },
      "67155": {
        "ALAMEDAS DE LA HACIENDA": true,
        "EXPO GANADERA": true,
        "EXPOSICIÓN": true,
        "GUADALUPE ZITOON": true,
        "LA HACIENDA": true
      },
      "67160": {
        "INFONAVIT LA JOYA": true,
        "RIBERAS DEL RÍO": true,
        "VALLE HERMOSO SECTOR UNO": true
      },
      "67163": {
        "IGNACIO ZARAGOZA": true,
        "SAN AGUSTÍN": true,
        "VICENTE GUERRERO": true
      },
      "67164": {
        "21 DE ENERO": true,
        "RÍO": true,
        "UNIÓN": true,
        "VALLE HERMOSO SECTOR DOS": true
      },
      "67165": {
        "LOS ENCINOS": true,
        "RESIDENCIAL LAS QUINTAS": true,
        "UNIÓN MODELO": true
      },
      "67167": {
        "INFONAVIT LA JOYA CUARTO SECTOR": true,
        "INFONAVIT LA JOYA QUINTO SECTOR": true,
        "LA JOYITA": true,
        "ORIZABA": true,
        "ROSITA": true
      },
      "67168": {
        "HACIENDA DE LOS ARCÁNGELES": true,
        "HACIENDA LOS LERMAS": true,
        "LAS SABINAS (SOLIDARIDAD FOMERREY)": true,
        "MARSELLA RESIDENCIAL": true,
        "NUEVA JOYA": true,
        "PORTAL DE LA HACIENDA": true,
        "RINCÓN DE LA HACIENDA": true,
        "SIMUPLADE": true,
        "VALLE DE LAS SABINAS": true
      },
      "67169": {
        "EL QUETZAL": true,
        "EVANTE RESIDENCIAL": true,
        "FAISANES SUR": true,
        "LIBERTADORES DE AMÉRICA": true,
        "LOS FAISANES": true,
        "LOS FAISANES SECTOR EL DORADO": true,
        "LOS FAISANES SECTOR PLATINO": true,
        "SABINITAS": true
      },
      "67170": {
        "15 DE MAYO": true,
        "20 DE NOVIEMBRE": true,
        "CAMINO REAL": true,
        "MIRASOL": true,
        "PROGRESO": true
      },
      "67173": {
        "CONTRY LA COSTA": true,
        "CONTRY LA ESCONDIDA": true,
        "CONTRY LA SILLA": true,
        "CONTRY LOS NOGALES": true,
        "PEDREGAL CONTRY": true,
        "PUNTA CONTRY": true,
        "RINCÓN COLONIAL LA SILLA": true,
        "RINCÓN DE LA PRIMAVERA": true
      },
      "67174": {
        "25 DE NOVIEMBRE": true,
        "ATOYAC DE ÁLVAREZ": true,
        "BOSQUES DE LA PASTORA": true,
        "BOSQUES DEL CONTRY": true,
        "CONTRY SOL": true,
        "LAS ÁGUILAS": true,
        "PUESTA DEL SOL": true,
        "RIBERAS DEL CONTRY": true,
        "RINCÓN DEL CONTRY": true,
        "VALLE DEL CONTRY": true,
        "VILLA PASTORA": true
      },
      "67175": {
        "FELIPE ÁNGELES": true,
        "LA QUINTA": true,
        "LAS VILLAS": true,
        "PLAN DEL RÍO": true,
        "TOLTECA": true
      },
      "67176": {
        "FRESNOS LA SILLA": true,
        "MIRADOR DE LA SILLA": true,
        "RUIZ CORTÍNES": true,
        "VIVIENDA POPULAR": true
      },
      "67177": {
        "ALTOS SAN ROQUE (FOMERREY 26)": true,
        "CERRO DE LA SILLA": true,
        "FOVISSSTE CAMINO REAL": true,
        "GALERÍAS DEL CAMINO REAL PRIMER SECTOR": true,
        "GALERÍAS DEL CAMINO REAL SEGUNDO SECTOR": true,
        "LOMAS DE LA SILLA (FOMERREY 14)": true,
        "RESIDENCIAL REAL DE LA SILLA": true,
        "VALLE DE GUADALUPE": true
      },
      "67178": {
        "ALFONSO MARTÍNEZ DOMÍNGUEZ": true,
        "CONTRY LOS ENCINOS": true,
        "GRANJITAS LA SILLA": true,
        "JARDINES DE TOLTECA": true,
        "LOMAS DE TOLTECA": true,
        "LOS CANELOS": true,
        "PRIVADAS DE CONTRY": true
      },
      "67179": {
        "IGNACIO ALLENDE": true,
        "PRIVADA LOS SABINOS": true,
        "RESIDENCIAL MIRA LOMA": true
      },
      "67180": {
        "BURÓCRATAS MUNICIPALES": true,
        "DÍAZ ORDAZ": true,
        "FOMERREY 20 (2 DE MAYO)": true,
        "LA PLAYA": true,
        "LA PLAYITA": true,
        "MIGUEL HIDALGO (FOMERREY 19)": true,
        "PARQUE SAN ANDRÉS": true,
        "VALLES DE LA SILLA": true,
        "VILLA DE LOS REYES": true,
        "ZERTUCHE SEGUNDO SECTOR": true
      },
      "67182": {
        "23 DE NOVIEMBRE": true,
        "ALMAGUER": true,
        "ARBOLEDAS DE LA SILLA": true,
        "CAÑÓN DE LA SILLA": true,
        "COLINAS DE GUADALUPE": true,
        "COLINAS DE LA SILLA": true,
        "EL PEÑÓN": true,
        "ENCINO DE LA SILLA": true,
        "GUADALUPE CHÁVEZ": true,
        "MORENITA GUAJARDO": true,
        "PRIVADA VICENTE FERRER": true
      },
      "67183": {
        "AMPLIACIÓN MÉXICO NUEVO": true,
        "BOSQUES DE LA SILLA": true,
        "CAMPESTRE LA SILLA": true,
        "GARZA MELO": true,
        "GUAJARDO": true,
        "LA ALIANZA DE RUTEROS": true,
        "LOS DELFINES": true,
        "LUIS DONALDO COLOSIO": true,
        "MIGUEL DE LA MADRID": true,
        "NUEVO MÉXICO": true,
        "VILLA OLÍMPICA": true
      },
      "67184": {
        "COLIBRÍ TRES": true,
        "CONDADO DE SANTA LUCÍA": true,
        "INSURGENTES": true,
        "JARDINES DE SANTA CLARA": true,
        "LA COMEDIA": true,
        "PABLO LIVAS": true,
        "SAN CRISTÓBAL": true,
        "SAN SEBASTIÁN": true,
        "SANTA ISABEL": true,
        "TACUBAYA": true,
        "VALLE DE SAN ANDRÉS": true,
        "VALLE SAN ROQUE": true,
        "VESTA PARK GUADALUPE": true,
        "VILLA SAN SEBASTIÁN": true,
        "ZERTUCHE PRIMER SECTOR": true
      },
      "67185": {
        "13 DE MAYO": true,
        "AGUA NUEVA": true,
        "CERRADAS DE LA SILLA": true,
        "EL MILAGRO": true,
        "FOMERREY 32": true,
        "GUADALUPE VICTORIA": true,
        "JOSÉ LUIS MORA": true,
        "LA ROCA": true,
        "LAS AVENIDAS": true,
        "PARQUES DE GUADALUPE": true,
        "RAFAEL RAMÍREZ SECTOR I": true,
        "RAFAEL RAMÍREZ SECTOR II": true,
        "SANTA CLARA": true
      },
      "67186": {
        "COLLADOS DE GUADALUPE PRIMER SECTOR": true,
        "COLLADOS DE GUADALUPE SEGUNDO SECTOR": true,
        "COLLADOS DE GUADALUPE TERCER SECTOR": true,
        "CUESTA VERDE": true,
        "GLORIA MENDIOLA": true,
        "JOSEFA ORTIZ DE DOMÍNGUEZ": true,
        "LAS TERRASSAS": true,
        "LOMA VERDE": true,
        "LOMAS DE SAN ROQUE": true,
        "LUCIO BLANCO": true,
        "NUEVO ALMAGUER": true,
        "PRADERAS DE LA SILLA": true,
        "PRIVADA EL MIRADOR": true,
        "SAN EDUARDO": true,
        "UNIDAD PILOTO": true,
        "VALLE LA SILLA": true,
        "VICENTE FERRER": true
      },
      "67188": {
        "CERRADAS DE BUGAMBILIAS": true,
        "CHULA VISTA": true,
        "LOS LERMAS": true,
        "MELCHOR OCAMPO": true,
        "NUEVO SAN SEBASTIÁN": true,
        "ROSALINDA": true,
        "VIA ANTIGUA": true
      },
      "67189": {
        "2 DE JUNIO": true,
        "COLIBRÍ DOS": true,
        "LOS ÁNGELES": true,
        "RESIDENCIAL COLIBRÍ": true,
        "SANTA ELENA": true,
        "SOLIDARIDAD": true
      },
      "67190": {
        "3 CAMINOS": true,
        "3 CAMINOS NORTE": true,
        "CERRO AZUL": true,
        "CERRO DE LA SILLA UC": true,
        "DIVISIÓN DEL NORTE": true,
        "GUADALUPE LA SILLA": true,
        "LANTANA PRIVADAS RESIDENCIAL": true,
        "LAS FLORES": true,
        "NIÑOS HÉROES": true,
        "PARQUE INDUSTRIAL GUADALUPE": true,
        "RESIDENCIAL GUADALUPE": true,
        "REYNOSA": true,
        "ROBLE SANTA MARÍA": true
      },
      "67192": {
        "BUGAMBILIAS DE LA SIERRA": true,
        "LAS COLINAS": true,
        "LAS PALMAS": true,
        "NUEVA AURORA": true,
        "RANCHO VIEJO SECTOR DOS": true,
        "RANCHO VIEJO SECTOR UNO": true,
        "VALLE DE SAN ROQUE": true
      },
      "67193": {
        "ACUEDUCTO GUADALUPE": true,
        "JARDINES DE ANDALUCÍA": true,
        "MISIÓN SANTA FE": true,
        "PARQUE INDUSTRIAL ACUEDUCTO": true,
        "SIERRA MORENA": true
      },
      "67194": {
        "BOSQUES DEL REY": true,
        "COLINAS DEL REY": true,
        "LA ESCONDIDA RESIDENCIAL": true,
        "LOMAS DEL REY": true,
        "MOLINO DEL REY": true,
        "MÉXICO 86": true,
        "NOSARA RESIDENCIAL": true,
        "PORTALES DE LA SILLA": true,
        "PORTALES DE LA SILLA SEGUNDO SECTOR": true,
        "PRIVADAS DEL REY": true,
        "RINCÓN DE LA SIERRA": true
      },
      "67195": {
        "CIUDAD CROC": true,
        "PARQUE INDUSTRIAL LA SILLA": true,
        "PEDREGAL DE GUADALUPE": true,
        "VALLES DE GUADALUPE": true,
        "VILLA ALEGRE": true
      },
      "67196": {
        "JARDINES DE XOCHIMILCO": true,
        "LAS ESCOBAS": true,
        "PORTAL DE XOCHIMILCO": true,
        "PRIVADAS DE LA SILLA": true,
        "RINCÓN LA SILLA": true,
        "VALLE DEL SOL": true,
        "XOCHIMILCO": true
      },
      "67197": {
        "CORTIJO LA SILLA": true,
        "HACIENDA DE GUADALUPE": true,
        "MISIÓN DE LA SILLA": true,
        "TIERRA PROPIA SECTOR DOS": true,
        "TIERRA PROPIA SECTOR UNO": true,
        "VALLE DE LOS ENCINOS": true
      },
      "67198": {
        "ACAPULCO": true,
        "CARMEN SERDÁN": true,
        "FOMERREY TRES": true,
        "NUEVO SANTA MARÍA": true,
        "RINCÓN DE GUADALUPE": true,
        "SANTA MARÍA": true,
        "SCOP": true
      },
      "67199": {
        "HACIENDA LA SILLA": true,
        "LOS INDEPENDIENTES": true,
        "PASEO DE GUADALUPE": true,
        "SCT": true
      },
      "67200": {
        "31 DE DICIEMBRE": true,
        "CIUDAD CNOP": true,
        "EVOLUCIÓN": true,
        "NUEVO TAMAULIPAS": true,
        "PUERTA DEL SOL": true,
        "TAMAULIPAS": true
      },
      "67202": {
        "5 DE ENERO": true,
        "LA TRINIDAD": true,
        "MIGUEL HIDALGO": true,
        "NUEVO LEÓN": true,
        "RESIDENCIAL SANTA MARÍA": true,
        "SANDRA SAAVEDRA": true
      },
      "67203": {
        "HACIENDA SAN SEBASTIÁN": true,
        "MARÍA TERESA": true,
        "OASIS RESIDENCIAL": true,
        "PRADERAS DE GUADALUPE": true,
        "VAQUERÍAS": true
      },
      "67204": {
        "CRISPÍN TREVIÑO": true,
        "DAVID CAVAZOS": true,
        "HUERTA DE GUADALUPE": true,
        "INDUSTRIAL LA SILLA": true,
        "LOS MANANTIALES": true,
        "PRIVADA VILLAS DEL RÍO": true,
        "VILLAS DEL RÍO": true
      },
      "67205": {
        "29 DE JULIO": true,
        "FUENTES DE GUADALUPE": true,
        "KALOS GUADALUPE": true,
        "MISIÓN SANTA CRUZ": true,
        "PRIVADAS MASAI": true,
        "RINCÓN DE LOS SABINOS": true,
        "SANTA CRUZ": true
      }
    },
    "JUÁREZ": {
      "67258": {
        "ANZURES": true,
        "ANZURES VENTURA": true,
        "LA TOSCANA": true,
        "LOMAS ANZURES": true,
        "LOMAS DE FÁTIMA": true,
        "LOS PUERTOS": true,
        "LOS PUERTOS CUARTO SECTOR": true,
        "LOS PUERTOS TERCER SECTOR": true,
        "NÁPOLES": true,
        "VALPARAÍSO": true,
        "VILLAS ANZURES": true
      },
      "67287": {
        "JARDINES DE LA SILLA (JARDINES)": true,
        "PRIVADA JARDÍN RESIDENCIAL": true,
        "RICARDO FLORES MAGÓN": true
      },
      "67288": {
        "EX HACIENDA EL ROSARIO": true,
        "EX HACIENDA EL ROSARIO SECTOR DIAMANTE": true,
        "HÉROE DE NACOZARI": true,
        "LA QUERENCIA RESIDENCIAL": true,
        "LOMAS DE LOS NARANJOS": true,
        "LOS NARANJOS": true,
        "MONTE ALTO": true,
        "PASEO DE ACUEDUCTO JUÁREZ": true,
        "RANCHO VIEJO": true,
        "SANTA ISABEL": true,
        "SIERRA VISTA": true,
        "VILLA LOS NARANJOS": true,
        "VILLAS DE LA HACIENDA": true
      },
      "67289": {
        "PORTOFINO RESIDENCIAL": true,
        "PRIVADA VÍA SIETE": true,
        "PUNTA ESMERALDA SUR": true,
        "VALLE DE JUÁREZ": true
      }
    },
    "MONTERREY": {
      "64000": {
        "LA FINCA": true,
        "MONTERREY CENTRO": true
      },
      "64010": {
        "OBRERA": true
      },
      "64018": {
        "DESARROLLO URBANO REFORMA": true,
        "NUEVO CENTRO DE MONTERREY": true
      },
      "64019": {
        "CONDOMINIOS CONSTITUCIÓN": true
      },
      "64020": {
        "GONZALITOS": true,
        "MITRAS SUR": true
      },
      "64030": {
        "CHEPEVERA": true,
        "LOMAS": true
      },
      "64040": {
        "DEPORTIVO OBISPADO": true,
        "MARÍA LUISA": true,
        "UNIDAD ALDAMA": true
      },
      "64049": {
        "EXSEMINARIO": true
      },
      "64050": {
        "JARDINES DEL CERRO": true,
        "JARDÍN": true
      },
      "64060": {
        "OBISPADO": true
      },
      "64070": {
        "MIRADOR": true
      },
      "64100": {
        "SAN BERNABÉ": true
      },
      "64102": {
        "ARCOS DEL SOL": true,
        "ARCOS DEL SOL ELITE": true,
        "BARRIO ACERO": true,
        "BARRIO ALAMEDA": true,
        "BARRIO ANTIGUO CIUDAD SOLIDARIDAD": true,
        "BARRIO AZTLÁN": true,
        "BARRIO CHAPULTEPEC": true,
        "BARRIO DE LA INDUSTRIA": true,
        "BARRIO DE MARGARITAS": true,
        "BARRIO DEL PARQUE": true,
        "BARRIO DEL PRADO": true,
        "BARRIO ESTRELLA": true,
        "BARRIO LA MODERNA": true,
        "BARRIO PUERTA DEL SOL": true,
        "BARRIO SAN CARLOS": true,
        "BARRIO SAN LUIS": true,
        "BARRIO SAN PEDRO": true,
        "BARRIO SANTA ISABEL": true,
        "BARRIO TOPO CHICO": true,
        "JARDINES DEL REY": true,
        "LAS ESTACIONES": true,
        "LAS PLAZAS": true,
        "MIRASOL": true,
        "MIRASOL SECTOR 3 (SAN FELIPE)": true,
        "PRIVADAS DE LINCOLN": true,
        "RESERVA CUMBRES": true,
        "URBI VILLA BONITA": true,
        "URBI VILLA DEL CEDRO PRIMER SECTOR": true,
        "URBI VILLA DEL CEDRO SEGUNDO SECTOR": true,
        "URBI VILLA DEL REY": true,
        "VILLAS DE SAN BERNABÉ": true
      },
      "64103": {
        "2 DE OCTUBRE": true,
        "ALFONSO REYES (P-38)": true,
        "AMPLIACIÓN NOGALES (P-87)": true,
        "ANICETO CORPUS": true,
        "ARBOLEDAS DE ESCOBEDO (P-44)": true,
        "ARBOLEDAS DE SAN BERNABE": true,
        "BALCONES DE SAN BERNABÉ": true,
        "CERRADAS DEL PONIENTE": true,
        "COLONIAL SAN BERNABÉ": true,
        "COMERCIAL LINCOLN PONIENTE": true,
        "CUAUHTÉMOC": true,
        "DIEGO DE MONTEMAYOR": true,
        "DIEGO DE MONTEMAYOR (SECTOR P ALIANZA)": true,
        "EL PALMAR (P-96, 141)": true,
        "EUGENIO GARZA SADA (SECTOR D ALIANZA)": true,
        "FRANCISCO I MADERO (SECTOR I ALIANZA)": true,
        "FRAY S TERESA DE MIER (SECTOR V ALIANZA)": true,
        "HACIENDA DE SAN BERNABÉ": true,
        "HERMENEGILDO GALEANA (SECTOR E ALIANZA)": true,
        "HOMERO LÓPEZ ORTIZ": true,
        "IGNACIO M ALTAMIRANO (SECTOR J ALIANZA)": true,
        "INGENIERO JOSÉ MARÍA MALDONADO TIJERINA": true,
        "JARDINES DE LA ALIANZA": true,
        "JERÓNIMO TREVIÑO (P-35)": true,
        "JOSEFA ORTIZ DE DOMÍNGUEZ (SECTOR B ALIANZA)": true,
        "JOSÉ MA PINO SUÁREZ (SECTOR H ALIANZA)": true,
        "JOSÉ MARÍA MORELOS": true,
        "LA ALIANZA SECTOR F": true,
        "LA ALIANZA SECTOR L": true,
        "LA ALIANZA SECTOR N": true,
        "LA REALIDAD": true,
        "LAS FUENTES (P-53, 54, 134)": true,
        "LAS TORRES": true,
        "LORENZO GARZA (P-1)": true,
        "LOS NARANJOS": true,
        "LOS NOGALES I": true,
        "LOS NOGALES II": true,
        "LOS NOGALES III": true,
        "LOS ÁNGELES (P-49, 50, 133)": true,
        "MARTÍN DE ZAVALA (P-34)": true,
        "MARÍA LEIJA BRIONES": true,
        "MISIÓN SAN BERNABÉ": true,
        "PASEO DE SAN BERNABÉ": true,
        "PERIODISTAS": true,
        "PERIODISTAS DE MÉXICO PRIMERA ETAPA": true,
        "PORTAL DEL VALLE": true,
        "PORTALES DE SAN BERNABÉ": true,
        "PRADOS SAN BERNABÉ": true,
        "PROFESOR MIGUEL RAMOS ARIZPE (SECTOR O ALIANZA)": true,
        "PROFESOR MOISÉS SAENZ (SECTOR Q ALIANZA)": true,
        "PUERTA DEL SOL LA ALIANZA": true,
        "REAL DE SAN BERNABÉ": true,
        "RINCÓN DE SAN BERNABÉ": true,
        "RIVERAS DEL RÍO": true,
        "RÓMULO LOZANO (SECTOR K ALIANZA)": true,
        "SAN ANTONIO (P-37)": true,
        "SAN BERNABÉ TOPO CHICO": true,
        "SAN DAVID I (P-33)": true,
        "SAN GABRIEL": true,
        "SAN ISIDRO": true,
        "SAN JUAN DE GUADALUPE": true,
        "SAN PEDRO (P-72, 76, 736)": true,
        "SAN RODOLFO UNO (P-89, 139)": true,
        "SANTA ANA (P-63)": true,
        "TRAZO BARRÓN (SECTOR ALIANZA)": true,
        "TRAZO MAO (SECTOR ALIANZA)": true,
        "TRAZO MARCELINO (SECTOR ALIANZA)": true,
        "TRAZO MARCO (SECTOR M ALIANZA)": true,
        "TRAZO ROSARIO (SECTOR ALIANZA)": true,
        "UNIÓN ANTORCHISTA": true,
        "URBI VILLA COLONIAL": true,
        "VALLE DE LA ESPERANZA": true,
        "VALLES DE SAN BERNABÉ I": true,
        "VALLES DE SAN BERNABÉ II": true,
        "VALLES DE SAN BERNABÉ III": true,
        "VENUSTIANO CARRANZA SECTOR LA ALIANZA": true,
        "VICENTE SUÁREZ (SECTOR T ALIANZA)": true,
        "VILLAS DE LA ALIANZA": true,
        "VILLAS DE SAN SEBASTIÁN": true,
        "VILLAS DEL CARMEN": true
      },
      "64104": {
        "SAN BERNABÉ II (F-120)": true,
        "SAN BERNABÉ III": true,
        "SAN BERNABÉ IV (F-124)": true
      },
      "64105": {
        "SAN BERNABÉ IX (F-112)": true,
        "SAN BERNABÉ X (F-113)": true,
        "SAN BERNABÉ XI (F-114)": true,
        "SAN BERNABÉ XII (F-115)": true
      },
      "64106": {
        "SAN BERNABÉ XIII (F-116)": true,
        "SAN BERNABÉ XIV (F-109)": true,
        "SAN BERNABÉ XV (F-119)": true
      },
      "64107": {
        "COLINA DE SAN BERNABÉ (F-25)": true
      },
      "64108": {
        "PLUTARCO ELÍAS CALLES": true
      },
      "64109": {
        "3 DE FEBRERO": true,
        "SAN BERNABÉ (F-105)": true,
        "SAN BERNABÉ (F-51)": true
      },
      "64110": {
        "MADRE SELVA": true,
        "MISIÓN LINCOLN": true
      },
      "64116": {
        "CUMBRE ALTA": true,
        "LOMAS DE CUMBRES": true,
        "VILLA CUMBRES": true
      },
      "64117": {
        "BALCONES DE LAS MITRAS": true,
        "COLINAS DE VALLE VERDE": true,
        "TORRES MONARCAS": true,
        "VALLE VERDE SEGUNDO SECTOR": true
      },
      "64118": {
        "PASEO DE LAS MITRAS": true
      },
      "64119": {
        "FIDEL VELÁZQUEZ (SNAT)": true
      },
      "64120": {
        "LOMA LINDA": true
      },
      "64130": {
        "LOMAS DE VILLA ALEGRE": true,
        "VILLA ALEGRE": true
      },
      "64140": {
        "LOMAS MODELO": true,
        "UNIDAD MODELO": true,
        "VALLE DE SANTA LUCÍA (GRANJA SANITARIA)": true
      },
      "64145": {
        "PASO DEL ÁGUILA": true
      },
      "64148": {
        "GENARO ROJAS VÁZQUEZ": true
      },
      "64150": {
        "SANTA CECILIA": true,
        "VILLA SANTA CECILIA": true,
        "ÁLVARO OBREGÓN": true
      },
      "64157": {
        "RINCÓN SANTA CECILIA": true,
        "VALLE SANTA CECILIA": true
      },
      "64158": {
        "LOMAS DE SANTA CECILIA": true
      },
      "64159": {
        "CERRITOS MODELO (F-76)": true,
        "LOMAS MODELO NORTE": true,
        "MITRA DORADA": true
      },
      "64160": {
        "15 DE MARZO": true,
        "16 DE SEPTIEMBRE": true,
        "ESPERANZA O PEÑA ELIZONDO": true,
        "JARDÍN MODELO": true,
        "NUEVA GALICIA": true,
        "NUEVA MODELO (F-8)": true,
        "SANTA CRUZ (F- 10)": true
      },
      "64165": {
        "RESIDENCIAL RAÚL RANGEL FRÍAS": true,
        "UNIÓN DE FIERREROS": true
      },
      "64167": {
        "LOMAS DE LA UNIDAD MODELO": true
      },
      "64168": {
        "ABELARDO ZAPATA": true
      },
      "64170": {
        "CONDOCASA MITRAS": true,
        "FELIPE ÁNGELES": true,
        "SAN FRANCISCO DE ASÍS": true,
        "VILLA MITRAS": true
      },
      "64178": {
        "BORTONÍ": true
      },
      "64180": {
        "DEL MAESTRO": true,
        "MORELOS": true,
        "NUEVA MORELOS": true,
        "PRIVADA CUMBRES": true,
        "TORRES PRAVIA": true,
        "VALLE MORELOS": true
      },
      "64186": {
        "5 DE MAYO": true
      },
      "64190": {
        "CENTRAL": true
      },
      "64200": {
        "CROC": true
      },
      "64204": {
        "VALLE DE SAN MARTÍN (F-24)": true
      },
      "64205": {
        "LOMAS DE TOPO CHICO": true
      },
      "64206": {
        "EL PORVENIR": true,
        "LADERAS DEL TOPO CHICO (F-23)": true
      },
      "64208": {
        "CONQUISTADORES": true
      },
      "64209": {
        "CONQUISTADORES": true,
        "TIERRA PROPIA (F-35)": true
      },
      "64210": {
        "7 DE NOVIEMBRE (F-82)": true,
        "ARTICULO 27 (F-96)": true,
        "DIF (F-15)": true,
        "FOMERREY": true,
        "SAN MARTÍN": true
      },
      "64215": {
        "23 DE MARZO": true,
        "BALCONES DE AZTLÁN": true,
        "LIBERTADORES DE AMÉRICA": true,
        "RENÉ ÁLVAREZ": true
      },
      "64217": {
        "MUNICIPAL (POPULAR MUNICIPAL)": true,
        "POPULAR": true,
        "PROVILEON SAN BERNABÉ": true,
        "SAN BERNABÉ VIII (F-125)": true
      },
      "64218": {
        "BENITO JUÁREZ (TIRADEROS DE BASURA)": true,
        "MUNICIPAL AMPLIACIÓN": true
      },
      "64219": {
        "FELIPE ZAMBRANO": true,
        "GLORIA MENDIOLA (TIERRA PROPIA)": true
      },
      "64220": {
        "1 DE MAYO (F-97)": true,
        "LOMAS DE SAN MARTÍN": true
      },
      "64226": {
        "LA AMISTAD": true
      },
      "64228": {
        "FRANCISCO VILLA": true
      },
      "64230": {
        "SAN ÁNGEL (F-78)": true
      },
      "64233": {
        "FRAY SERVANDO TERESA DE MIER (F-6)": true
      },
      "64234": {
        "18 DE FEBRERO": true
      },
      "64235": {
        "LAS PEDRERAS": true,
        "SALVADOR ALLENDE": true,
        "UNIDAD DEL PUEBLO": true
      },
      "64236": {
        "TIERRA Y LIBERTAD SECTOR HERÓICO": true
      },
      "64238": {
        "PREDIO ZAPATA": true
      },
      "64240": {
        "21 DE MARZO 2 SECTOR": true,
        "FRANCISCO GONZÁLEZ BOCANEGRA": true,
        "LOS DORADOS": true,
        "MOCTEZUMA": true,
        "MÁRTIRES DE SAN COSME": true,
        "RAFAEL BUELNA": true
      },
      "64244": {
        "TIERRA Y LIBERTAD SECTOR SUR": true
      },
      "64245": {
        "CNOP": true
      },
      "64246": {
        "TIERRA Y LIBERTAD SECTOR CENTRO": true
      },
      "64247": {
        "PLAN DE SAN LUIS": true
      },
      "64250": {
        "FERROCARRILERA": true,
        "FLORES MAGÓN 3 SECTOR": true,
        "JOSEFA ORTIZ DE DOMÍNGUEZ": true,
        "LOMA BONITA": true,
        "PABLO GONZÁLEZ": true,
        "RESIDENCIAL AZTLÁN": true,
        "UNIÓN BENITO GARZA CANTÚ": true,
        "VALLE DEL TOPO CHICO SEXTO SECTOR": true
      },
      "64259": {
        "VALLE DEL TOPO CHICO": true
      },
      "64260": {
        "CONSTITUYENTES DEL 57": true,
        "HOGARES FERROCARRILEROS": true,
        "HÉROE DE NACOZARI": true,
        "INFONAVIT HOGARES FERROCARRILEROS": true,
        "KENNEDY": true,
        "LOMAS DE ANÁHUAC": true,
        "LUIS ECHEVERRÍA (F-75)": true,
        "MONTERREY CONJUNTO HABITACIONAL": true,
        "NOGALES TOPO CHICO": true,
        "TOPO CHICO": true
      },
      "64264": {
        "LA MESETA": true
      },
      "64265": {
        "CÁNDIDO DÍAZ": true,
        "UNIÓN BENITO JUÁREZ": true,
        "ÁVILA CAMACHO": true
      },
      "64266": {
        "BELISARIO DOMÍNGUEZ": true,
        "NUEVA TOPO CHICO": true
      },
      "64268": {
        "10 DE JUNIO": true,
        "4 DE DICIEMBRE": true,
        "DIVISIÓN DEL NORTE": true,
        "PRIMERO DE JUNIO": true,
        "UNIÓN CUAUHTÉMOC": true
      },
      "64269": {
        "LÁZARO CÁRDENAS": true
      },
      "64270": {
        "PLAZA INSURGENTES": true,
        "SAN JOSÉ": true,
        "SANTA FE NOR PONIENTE": true,
        "SIMÓN BOLÍVAR": true
      },
      "64280": {
        "BERNARDO REYES": true,
        "NARCISO MENDOZA": true,
        "NIÑO ARTILLERO": true,
        "PUEBLO QUIETO": true
      },
      "64290": {
        "HIDALGO": true,
        "POPULAR": true,
        "REGINA": true
      },
      "64299": {
        "AKRA": true,
        "INDUSTRIAL": true,
        "PREDIO ESTRELLA": true
      },
      "64300": {
        "JARDÍN DE LAS MITRAS": true,
        "VALLE DE LAS MITRAS": true
      },
      "64310": {
        "INDUSTRIAL ABRAHAM LINCOLN": true,
        "PREMIER LINCOLN": true,
        "RESIDENCIAL ABRAHAM LINCOLN": true,
        "TORRES LINCOLN": true
      },
      "64320": {
        "MITRAS NORTE": true
      },
      "64330": {
        "FRANCISCO GARCÍA NARANJO (INDECO)": true,
        "FRANCISCO GARCÍA NARANJO (PROVILEON)": true,
        "SAN JORGE": true
      },
      "64339": {
        "VALLE VERDE TERCER SECTOR": true
      },
      "64340": {
        "CUMBRES ELITE SECTOR VILLAS": true,
        "HACIENDA MITRAS": true,
        "PRIVADAS DE CUMBRES": true
      },
      "64344": {
        "PEDREGAL CUMBRES": true
      },
      "64345": {
        "CUMBRE ALLEGRO": true,
        "CUMBRES ELITE PREMIER PRIVADA APENINOS": true,
        "CUMBRES ELITE PREMIER PRIVADA SANTA HELENA": true,
        "CUMBRES ELITE PREMIER PRIVADAS ALPES Y EVEREST": true
      },
      "64346": {
        "CUMBRES JADE": true,
        "CUMBRES LE FONTAINE": true,
        "CUMBRES PLATINO": true,
        "CUMBRES PROVIDENCIA": true,
        "CUMBRES RENACIMIENTO": true,
        "CUMBRES RODEO": true,
        "CUMBRES SAN ÁNGEL": true,
        "HACIENDA SANTA CLARA": true,
        "PASEO DE CUMBRES": true,
        "PRIVADAS CUMBRES DIAMANTE": true,
        "REAL DE CUMBRES": true
      },
      "64347": {
        "CUMBRES ORO RESIDENCIAL": true,
        "CUMBRES ORO SECTOR REGENCY": true,
        "CUMBRES QUINTA REAL": true,
        "JARDINES DE LAS CUMBRES": true,
        "MISIÓN CUMBRES 2 SECTOR": true,
        "VALLE DE LAS CUMBRES PRIMER SECTOR": true,
        "VALLE DE LAS CUMBRES SEGUNDO SECTOR": true
      },
      "64348": {
        "MIRADOR DE LAS MITRAS": true,
        "MISIÓN DE LAS CUMBRES": true,
        "PORTAL DE CUMBRES": true
      },
      "64349": {
        "CERRADAS DE CUMBRES": true,
        "CIMA DE LA MONTAÑA": true,
        "CIMA DEL BOSQUE": true,
        "COLONIAL CUMBRES": true,
        "CUMBRES ANTARES": true,
        "CUMBRES CALLEJUELAS": true,
        "CUMBRES DEL SOL": true,
        "CUMBRES ELITE": true,
        "CUMBRES ELITE SECTOR LA HACIENDA": true,
        "CUMBRES GRAN VÍA": true,
        "CUMBRES LAS PALMAS": true,
        "CUMBRES MADEIRA": true,
        "CUMBRES MADEIRA FRANCÉS": true,
        "CUMBRES PLATINUM": true,
        "CUMBRES SAN AGUSTÍN": true,
        "CUMBRES SANTA CLARA": true,
        "ESPACIO CUMBRES": true,
        "GRAN RESERVA CUMBRES": true,
        "PRIVADAS CUMBRES ELITE": true,
        "PUERTA DE HIERRO": true,
        "RESIDENCIAL CUMBRES LA JOYA": true
      },
      "64350": {
        "VALLE DEL INFONAVIT": true
      },
      "64360": {
        "CUMBRES CAMPANARIO": true,
        "VALLE VERDE PRIMER SECTOR": true,
        "VILLA DORADA": true
      },
      "64365": {
        "PATRONATO CRUZ VERDE": true
      },
      "64366": {
        "CIMA DE LAS CUMBRES": true,
        "CONDOCASAS CUMBRES": true,
        "CUMBRESCONDIDO": true
      },
      "64367": {
        "CUMBRES SECTOR LA ESPERANZA": true,
        "LA ESCONDIDA CENTRO URBANO": true,
        "LA ESPERANZA": true
      },
      "64368": {
        "RINCÓN DE LAS CUMBRES": true
      },
      "64369": {
        "VALLE DE LOS CEDROS": true
      },
      "64370": {
        "LOS ALTOS": true,
        "LOS CEDROS": true
      },
      "64380": {
        "BURÓCRATAS DEL ESTADO": true,
        "BURÓCRATAS FEDERALES": true
      },
      "64390": {
        "ANTONIO I VILLARREAL": true,
        "EMILIANO ZAPATA": true,
        "UH.LÁZARO CÁRDENAS": true
      },
      "64400": {
        "ESTRELLA": true
      },
      "64410": {
        "BELLA VISTA": true,
        "DEL PRADO": true
      },
      "64420": {
        "BENITO JUÁREZ": true,
        "GARZA NIETO": true,
        "PEDRO LOZANO": true,
        "PROGRESO": true
      },
      "64430": {
        "URDIALES": true
      },
      "64440": {
        "FERROCARRILERO (PREDIO 21)": true,
        "INDUSTRIAL": true
      },
      "64450": {
        "15 DE MAYO (LARRALDE)": true
      },
      "64460": {
        "MITRAS CENTRO": true,
        "TIJERINA": true
      },
      "64470": {
        "OBRERISTA": true
      },
      "64480": {
        "TALLERES": true
      },
      "64488": {
        "10 DE MARZO": true
      },
      "64489": {
        "RUBÉN JARAMILLO": true
      },
      "64490": {
        "SARABIA": true
      },
      "64500": {
        "DEL NORTE": true
      },
      "64508": {
        "RESIDENCIAL VIDRIERA": true
      },
      "64510": {
        "COYOACÁN": true,
        "JUANA DE ARCO": true,
        "MARIANO ESCOBEDO": true
      },
      "64517": {
        "INDUSTRIAL BENITO JUÁREZ": true
      },
      "64520": {
        "CEMENTOS": true,
        "CÉNTRIKA": true,
        "CÉNTRIKA CRISOLES": true,
        "CÉNTRIKA DEL LAGO": true,
        "CÉNTRIKA VICTORIA": true,
        "CÉNTRIKA VICTORIA ELITE": true,
        "VICTORIA": true,
        "VIDRIERA": true
      },
      "64530": {
        "LAS FLORES": true,
        "MADERO NORTE": true,
        "MODERNA": true
      },
      "64536": {
        "JARDINES DE LA MODERNA": true
      },
      "64540": {
        "FONTANARES CHURUBUSCO SUR": true,
        "LOS FRESNOS": true,
        "PARQUE INDUSTRIAL REGIOMONTANO": true,
        "SANTA FÉ": true,
        "VILLAS DE LINDA VISTA": true
      },
      "64549": {
        "INDUSTRIAS DEL VIDRIO": true
      },
      "64550": {
        "ARGENTINA": true,
        "ASARCO": true,
        "CANTÚ": true,
        "FABRILES": true,
        "MARTÍNEZ": true,
        "PRIVADA PINOS": true,
        "REFORMA": true,
        "TAMPICO": true
      },
      "64560": {
        "FRANCISCO I MADERO": true,
        "NUEVA MADERO": true,
        "VENUSTIANO CARRANZA": true
      },
      "64568": {
        "ALMAGUER": true
      },
      "64570": {
        "TREVIÑO": true
      },
      "64580": {
        "ACERO": true,
        "MODELO": true,
        "PABLO A DE LA GARZA": true,
        "TERMINAL": true
      },
      "64590": {
        "AGRÍCOLA": true,
        "AGRÍCOLA ACERO": true,
        "CHURUBUSCO": true,
        "FIERRO": true,
        "ÁLAMOS CORREGIDORA": true
      },
      "64600": {
        "LEONES": true
      },
      "64610": {
        "LAS CUMBRES": true
      },
      "64618": {
        "LLAVE DE ORO": true
      },
      "64619": {
        "BOSQUES DE LAS CUMBRES": true,
        "COLINAS DE LAS CUMBRES": true,
        "CUMBRES MAGNOLIA": true,
        "CUMBRES MEDITERRÁNEO": true,
        "CUMBRES PARAÍSO": true,
        "RESIDENCIAL CUMBRES": true
      },
      "64620": {
        "VISTA HERMOSA": true
      },
      "64623": {
        "BALCONES DE GALERÍAS": true
      },
      "64630": {
        "COLINAS DE SAN JERÓNIMO": true,
        "LA ESCONDIDA": true,
        "RINCÓN DE SAN JEMO": true,
        "SAN JEMO": true,
        "VILLAS DE SAN JERÓNIMO": true
      },
      "64632": {
        "JARDINES DE SAN JERÓNIMO": true
      },
      "64633": {
        "RINCÓN DE LAS COLINAS": true
      },
      "64634": {
        "COLINAS DE LIVERPOOL": true,
        "COLINAS DE SAN JERÓNIMO": true,
        "COLONIAL SAN FRANCISCO": true,
        "COLONIAL SAN JERÓNIMO": true,
        "LA VEREDA PRIVADA RESIDENCIAL": true,
        "LOMAS DE SAN JERÓNIMO": true,
        "PRADOS DE SAN JERÓNIMO": true,
        "REAL DE SAN JERÓNIMO": true,
        "VALLE DE SAN JERÓNIMO": true,
        "VILLAS DE SAN JERÓNIMO": true
      },
      "64635": {
        "COLINAS DIAMANTE": true,
        "RESIDENCIAL SAN JERÓNIMO II": true
      },
      "64636": {
        "MISIÓN DE SAN JERÓNIMO": true
      },
      "64637": {
        "HACIENDA SAN JERÓNIMO": true,
        "RINCÓN DE SAN JERÓNIMO": true
      },
      "64638": {
        "BALCONES DE COLINAS DE SAN JERÓNIMO": true,
        "CANTERA": true,
        "COLINAS DE SAN GERARDO": true,
        "LAS LAJAS": true
      },
      "64639": {
        "MONTELEÓN": true,
        "RESIDENCIAL DINASTÍA": true,
        "RESIDENCIAL LAS COLINAS": true,
        "SAN JEMO TERCER SECTOR": true
      },
      "64640": {
        "SAN JERÓNIMO": true
      },
      "64649": {
        "RESIDENCIAL GALERÍAS": true
      },
      "64650": {
        "COLINAS DEL VALLE": true,
        "COOPERATIVA CUAUHTÉMOC": true,
        "CUMBRES DEL VALLE": true,
        "RINCÓN DE SANTA MARÍA": true,
        "SANTA MARÍA": true
      },
      "64659": {
        "SENDERO SAN JERÓNIMO": true
      },
      "64660": {
        "MIRAVALLE": true,
        "RINCÓN DEL VALLE": true
      },
      "64700": {
        "NUEVO REPUEBLO": true,
        "ROMA": true,
        "ROMA SUR": true,
        "TECNOLÓGICO": true
      },
      "64710": {
        "BALCONES DEL CARMEN": true,
        "COMERCIAL AMPLIACIÓN DOCTORES": true,
        "DEL CARMEN": true,
        "EL MAGUEY": true,
        "HACIENDA SAN FRANCISCO": true,
        "LOMA LARGA": true,
        "LOMAS DE SAN FRANCISCO": true,
        "LOS DOCTORES": true,
        "NUEVAS COLONIAS": true,
        "PÍO X": true,
        "UNIÓN FRANCISCO I MADERO": true
      },
      "64715": {
        "LOMA LARGA": true,
        "LOS MAGUEYES": true
      },
      "64718": {
        "SERTOMA": true
      },
      "64720": {
        "ANCIRA": true,
        "BENITO JUÁREZ (F-96)": true,
        "CENTRO": true,
        "INDEPENDENCIA": true,
        "UNIÓN MIGUEL BARRERA": true
      },
      "64730": {
        "ALFONSO REYES": true,
        "AMÉRICA NÚMERO DOS": true,
        "ARTURO B DE LA GARZA": true,
        "HERIBERTO JARA": true,
        "LA PEDRERA": true,
        "TANQUE DE GUADALUPE": true
      },
      "64740": {
        "ALTAVISTA SUR": true,
        "ARROYO SECO": true,
        "JARDINES ROMA": true,
        "LAS RETAMAS": true,
        "MÉXICO": true,
        "ROMA PRIVADA": true
      },
      "64750": {
        "ALTAMIRA": true,
        "ALTAMIRA (MANZ 20)": true,
        "HACIENDAS DE LA SIERRA": true,
        "LAS CANTERAS": true,
        "LUIS ECHEVERRÍA SUR": true,
        "ROMA": true,
        "VALLE DEL MIRADOR": true
      },
      "64753": {
        "ALFAREROS": true,
        "LAS PRIVANZAS MALLORCA": true,
        "LOS ÁNGELES BOSQUE RESIDENCIAL": true,
        "PRIVANZAS QUINTO SECTOR": true
      },
      "64754": {
        "JARDÍN DE LAS TORRES": true
      },
      "64760": {
        "15 DE SEPTIEMBRE": true,
        "CERRO DE LA CAMPANA": true,
        "DESARROLLO LAS TORRES 91": true,
        "MARTÍNEZ DOMÍNGUEZ A UNIÓN (LA CAMPANA)": true,
        "RUIZ CORTÍNES": true,
        "UNIÓN EL RINCONCITO": true
      },
      "64764": {
        "LOS ROSALES": true,
        "VALPARAÍSO": true
      },
      "64765": {
        "ANTIGUA": true,
        "LADERAS DEL MIRADOR (F-XXI)": true
      },
      "64770": {
        "ALTAVISTA INVERNADERO": true,
        "ALTAVISTA SECTOR LOMAS": true,
        "BALCONES DE ALTAVISTA": true,
        "VILLA LOS PINOS": true
      },
      "64780": {
        "13 DE JUNIO": true,
        "18 DE MARZO": true,
        "BRISAS DIAMANTE": true,
        "LAS BRISAS": true,
        "LAS BRISAS SECTOR LA PUNTA": true,
        "MÁRTIRES DE TLATELOLCO": true,
        "MÁS PALOMAS (VALLE DE SANTIAGO)": true,
        "SIERRA VENTANA": true
      },
      "64783": {
        "25 DE MARZO (SIERRA VENTANA)": true
      },
      "64788": {
        "SIERRA VENTANA (REVOLUCIÓN PROLETARIA)": true
      },
      "64790": {
        "BALCONES DEL MIRADOR": true,
        "TORRES BRISAS": true,
        "VALLE DE LAS BRISAS": true,
        "VALLE DEL MARQUEZ": true
      },
      "64798": {
        "PASEOS DEL MARQUEZ": true
      },
      "64800": {
        "BUENOS AIRES": true
      },
      "64810": {
        "CARACOL": true,
        "CERRO DE LA SILLA": true,
        "ESPAÑA": true,
        "LA FLORIDA": true,
        "PLAZA REVOLUCIÓN": true,
        "RESIDENCIAL LA FLORIDA": true,
        "VILLA FLORIDA": true
      },
      "64820": {
        "ANCÓN DEL HUAJUCO": true,
        "EL REALITO": true,
        "EX HACIENDA EL ANCÓN": true,
        "JARDÍN ESPAÑOL": true,
        "NUEVA ESPAÑOLA": true,
        "PLAZA CHAPULTEPEC": true,
        "RESIDENCIAL LA ESPAÑOLA": true,
        "VALLE DE CHAPULTEPEC": true,
        "VALLE DEL HUAJUCO": true
      },
      "64830": {
        "ESTADIO": true,
        "LA PRIMAVERA": true,
        "LADRILLERA": true,
        "LTH": true,
        "NARVARTE": true,
        "VALLE PRIMAVERA": true
      },
      "64833": {
        "VALLE PRIMAVERA": true
      },
      "64834": {
        "RINCÓN DE LA PRIMAVERA": true
      },
      "64836": {
        "INDUSTRIAL Y COMERCIAL": true
      },
      "64840": {
        "ALTAVISTA": true,
        "JARDINES DE ALTAVISTA": true,
        "NUEVA ESPAÑA": true
      },
      "64844": {
        "COLONIA RINCON": true
      },
      "64845": {
        "CONTRY LUX": true
      },
      "64849": {
        "EQUIPAMIENTO INSTITUTO TECNOLÓGICO DE ESTUDIOS SUPERIORES DE MONTERREY": true
      },
      "64850": {
        "CONTRY TESORO": true,
        "TORREMOLINOS": true,
        "VILLA DEL RÍO": true
      },
      "64858": {
        "BALCONES DE SATÉLITE": true,
        "CONTRY LOS NARANJOS": true
      },
      "64859": {
        "CONTRY SAN JUANITO": true
      },
      "64860": {
        "COLONIAL LA SILLA": true,
        "CONTRY": true,
        "CONTRY LOS ESTANQUES": true,
        "EL PIRUL": true,
        "JARDINES DEL CONTRY": true,
        "PASEO DEL CONTRY": true,
        "RINCÓN DEL CONTRY": true,
        "VILLAS DE LUX": true
      },
      "64865": {
        "CONTRY LOS NOGALES": true
      },
      "64878": {
        "LOS REMATES": true,
        "SAN ÁNGEL": true,
        "UNIÓN CANOAS ÁNGEL SUR": true
      },
      "64880": {
        "LA CONDESA": true
      },
      "64890": {
        "ALTANA": true,
        "CORTIJO DEL RÍO": true,
        "ESTANZA": true,
        "LAGOS DEL BOSQUE": true,
        "PRIVADA CASTAÑA": true,
        "PRIVADAS DE LA SILLA": true,
        "PRIVADAS DEL SUR": true,
        "RESIDENCIAL LA HACIENDA": true,
        "RESIDENCIAL Y CLUB DE GOLF LA HERRADURA": true,
        "VILLA LAS FUENTES": true
      },
      "64893": {
        "PRIVADAS DEL PEDREGAL": true
      },
      "64898": {
        "PEDREGAL DE LA SILLA": true,
        "PRADOS DE LA SILLA": true,
        "PRIVADAS DEL RÍO": true,
        "RESIDENCIAL VISTALTA": true,
        "SANTA SOFIA": true,
        "VILLAS DE LA HACIENDA": true
      },
      "64900": {
        "JARDINES DEL PASEO": true,
        "LA REPÚBLICA": true,
        "PRIVADA FUNDADORES SEGUNDA SECCIÓN": true
      },
      "64909": {
        "EMPLEADOS SFEO": true,
        "LOMAS DE MONTECRISTO": true
      },
      "64910": {
        "MIRADOR RESIDENCIAL": true
      },
      "64920": {
        "DEL PASEO RESIDENCIAL": true
      },
      "64926": {
        "PRIVADA FUNDADORES": true
      },
      "64930": {
        "LAS TORRES": true
      },
      "64940": {
        "EDUARDO A ELIZONDO": true
      },
      "64949": {
        "VILLA SOL": true
      },
      "64950": {
        "MEDEROS": true,
        "TORRES DE SATÉLITE": true
      },
      "64960": {
        "CIUDAD SATÉLITE": true
      },
      "64968": {
        "COLINAS DEL SUR": true,
        "SATÉLITE ACUEDUCTO SEXTO SECTOR": true,
        "SATÉLITE MIRADORES": true
      },
      "64969": {
        "CONTRY SUR": true,
        "LOMAS DE SATÉLITE": true
      },
      "64970": {
        "BOSQUES DE SATÉLITE": true,
        "CAMPESTRE MEDEROS": true,
        "RINCÓN COLONIAL MEDEROS": true
      },
      "64978": {
        "LOMAS MEDEROS": true,
        "PRIVADA VILLA ALTA RESIDENCIAL": true
      },
      "64983": {
        "ANTARA": true,
        "LA TOSCANA": true,
        "LAS ESTANCIAS": true,
        "PALMARES RESIDENCIAL": true,
        "RINCÓN DEL VERGEL": true,
        "SANTA LUCÍA": true,
        "ÉBANOS": true
      },
      "64984": {
        "BRISAS DE VALLE ALTO": true,
        "CERRADAS DE VALLE ALTO RESIDENCIAL": true,
        "EL SABINO CERRADA RESIDENCIAL": true,
        "LA ESTANZUELA VIEJA": true,
        "MISIÓN CANTERÍAS": true,
        "PRIVADA LOS ENCINOS": true,
        "RESIDENCIAL LA LÁGRIMA": true,
        "SAN PABLO": true,
        "VILLAS DE LA HERRADURA": true,
        "VILLAS LA RIOJA": true,
        "VISTANCIAS": true
      },
      "64985": {
        "AIRES DEL VERGEL": true,
        "ALMENDROS DE LADERAS": true,
        "CANTABRIA RESIDENCIAL": true,
        "CASTAÑOS DEL VERGEL": true,
        "CEREZOS RESIDENCIAL": true,
        "EL URO ORIENTE": true,
        "GRANADAS": true,
        "LA JOYA PRIVADA RESIDENCIAL": true,
        "LADERAS ABEDUL": true,
        "LADERAS CARANDAY": true,
        "LOS CRISTALES": true,
        "PEDREGAL DE LA MONTAÑA": true,
        "SIENNA RESIDENCIAL": true,
        "VILLA MURANO": true,
        "VILLA SANTA ISABEL": true,
        "VILLA TOLEDO": true
      },
      "64986": {
        "EL REFUGIO": true,
        "EL URO": true,
        "L ANDANA RESIDENCIAL": true,
        "MONTEALBÁN RESIDENCIAL": true,
        "PRIVADA RESIDENCIAL VILLAS DEL URO": true,
        "RANCHO LA BOLA": true,
        "SORIA": true
      },
      "64987": {
        "BOSQUES DEL VERGEL": true,
        "CATUJANES": true,
        "EL ENCINO": true,
        "EL VERGEL": true,
        "ENCINOS DEL VERGEL": true,
        "LAS DILIGENCIAS": true,
        "PRIVADA LA HERRADURA": true
      },
      "64988": {
        "AMPLIACIÓN LOS NOGALES": true,
        "BOSQUES DE LA ESTANZUELA": true,
        "BOSQUES DE LA SILLA": true,
        "COLINAS DEL HUAJUCO": true,
        "EL ENCANTO": true,
        "EL ENCANTO II": true,
        "EL FORTÍN DEL HUAJUCO": true,
        "EL MILAGRO": true,
        "ENCINO REAL": true,
        "ESTANZUELA NUEVA": true,
        "GRANJA POSTAL": true,
        "HOROTINA": true,
        "IGNACIO ALTAMIRANO": true,
        "JARDINES DE LA ESTANZUELA": true,
        "LA ALHAMBRA": true,
        "LA ESTANZUELA": true,
        "LA ESTANZUELA (F-45)": true,
        "LA PERLA": true,
        "LA RIOJA PRIVADA RESIDENCIAL": true,
        "LAS CALLEJAS RESIDENCIAL": true,
        "LAS RIVERAS": true,
        "LOMAS DEL VERGEL": true,
        "LOS SANTOS": true,
        "LOS ÁLAMOS": true,
        "LÁGRIMA DE LOS NIÑOS": true,
        "MISIÓN SILLA": true,
        "NEREA RESIDENCIAL": true,
        "NOGALES DE LA SIERRA": true,
        "PARAÍSO RESIDENCIAL": true,
        "PASEO DEL VERGEL": true,
        "PRIVADA DEL BOSQUE": true,
        "PRIVADA DEL VERGEL": true,
        "PRIVADA VILLA REAL": true,
        "PRIVADAS DE LA FUENTE RESIDENCIAL": true,
        "RESIDENCIAL AMURA": true,
        "RESIDENCIAL DE LA SIERRA": true,
        "RESIDENCIAL LA ESCONDIDA": true,
        "RINCÓN DE LA ESCONDIDA": true,
        "RINCÓN DE LA SIERRA": true,
        "SIERRA ESCONDIDA": true,
        "THESSALIA": true,
        "UNIDAD LA ESTANZUELA": true
      },
      "64989": {
        "BALCONES DE VALLE ALTO": true,
        "BIOMA RESIDENCIAL": true,
        "BOSQUES DE VALLE ALTO": true,
        "CAMPESTRE BUGAMBILIAS": true,
        "EL PORTÓN DE VALLE ALTO": true,
        "FLOR DE PIEDRA": true,
        "HACIENDA CODORNICES": true,
        "HACIENDA LOS ENCINOS": true,
        "LAGOS DEL VERGEL": true,
        "LAS JACARANDAS PRIVADA RESIDENCIAL": true,
        "LOMAS DE VALLE ALTO": true,
        "LOMAS DEL HÍPICO": true,
        "LOS AZULEJOS": true,
        "LOS MILAGROS DE VALLE ALTO": true,
        "MAESTRANZAS VILLAS DE PROVIDENCIA": true,
        "NATURA": true,
        "PEDREGAL DE VALLE ALTO": true,
        "PLAZA RINCÓN DE LA SIERRA ALTA": true,
        "PLAZA RINCÓN DE LA VIRGEN": true,
        "PORTAL DE VALLE ALTO": true,
        "PORTAL DEL HUAJUCO": true,
        "PRIVADA VALLE ALTO": true,
        "REAL DE VALLE ALTO": true,
        "RESIDENCIAL CANTERÍAS": true,
        "RINCÓN DE LAS MONTAÑAS": true,
        "RINCÓN DE LOS AHUEHUETES": true,
        "RINCÓN DE LOS ENCINOS": true,
        "RINCÓN DE VALLE ALTO": true,
        "SAN GABRIEL": true,
        "SAN MICHELLE": true,
        "SIERRA ALTA": true,
        "VALLE ALTO": true,
        "VALLE DEL VERGEL": true,
        "VILLAS DE CANTERÍAS": true,
        "ÁUREA RESIDENCIAL": true
      },
      "64990": {
        "ANTIGUA HACIENDA SANTA ANITA": true,
        "CAMPESTRE LOS CRISTALES": true,
        "CAMPESTRE SERTOMA": true,
        "CANTEREL": true,
        "EL MIRADOR": true,
        "LAS JARAS": true,
        "LAS MARGARITAS": true,
        "LOS CRISTALES CAMPESTRE": true,
        "SANTA ISABEL": true,
        "VALLE DE CRISTAL": true
      },
      "64996": {
        "CAROLCO": true,
        "EL EDÉN": true
      }
    },
    "SAN NICOLÁS DE LOS GARZA": {
      "66400": {
        "SAN NICOLÁS DE LOS GARZA CENTRO": true
      },
      "66410": {
        "BENITO JUÁREZ": true,
        "CONSTITUYENTES DEL 17": true,
        "IGNACIO RAMIREZ": true,
        "LA ENRAMADA": true,
        "LAS ALAMEDAS": true,
        "MIRAFLORES": true,
        "MÉXICO LINDO": true,
        "NICOLÁS BRAVO": true,
        "PRIVADA SENDERO ANÁHUAC": true
      },
      "66413": {
        "BOSQUES DEL ROBLE": true,
        "EL NARANJAL": true,
        "RINCÓN DEL ROBLE": true,
        "SAN BARTOLO": true,
        "SAN ISIDRO": true
      },
      "66414": {
        "EL FUNDADOR": true,
        "JARDINES DE SAN NICOLÁS": true,
        "RESIDENCIAL EL ROBLE": true,
        "RESIDENCIAL ROBLE CUARTO SECTOR": true,
        "RESIDENCIAL ROBLE SECTOR TRES": true,
        "RESIDENCIAL SAN NICOLÁS": true,
        "ROBLE SAN NICOLÁS": true,
        "ROBLE SAN NICOLÁS SECTOR 2": true,
        "ROBLE SAN NICOLÁS SECTOR 3": true,
        "ROBLE SAN NICOLÁS SECTOR SIETE": true
      },
      "66415": {
        "FOMERREY 4 MUJERES ILUSTRES": true,
        "HÉROES DE MÉXICO": true,
        "VILLA LUZ": true
      },
      "66417": {
        "ANÁHUAC SENDERO": true,
        "BORANA RESIDENCIAL": true,
        "HACIENDA DEL ROBLE": true,
        "LA NOGALERA": true,
        "PORTAL DEL ROBLE": true,
        "RESIDENCIAL ROBLE SECTOR SEIS": true,
        "VALLE DE LAS ALAMEDAS": true,
        "VALLE DEL ROBLE": true,
        "VILLAS DEL ROBLE": true
      },
      "66418": {
        "CENTENARIO II": true,
        "RESIDENCIAL ROBLE SECTOR 2": true,
        "VALLE DORADO": true,
        "VALLE SOL": true,
        "VIEJO ROBLE": true
      },
      "66420": {
        "CERRADAS DEL ROBLE": true,
        "ITURBIDE": true,
        "LAS VILLAS": true,
        "RESIDENCIAL PERIFÉRICO": true,
        "VILLA UNIVERSIDAD": true,
        "VILLAZUL": true
      },
      "66422": {
        "BALCONES DE ANÁHUAC": true,
        "EL MIRADOR DE SAN NICOLÁS (FOMERREY 129)": true,
        "PARAÍSO DE ANÁHUAC": true,
        "RESERVA DE ANAHUAC": true,
        "RESIDENCIAL ANÁHUAC ZONA NORTE": true,
        "RINCÓN DE ANÁHUAC": true,
        "VILLAS DE ANÁHUAC": true
      },
      "66425": {
        "COLINAS DE ANÁHUAC": true,
        "ESTACIÓN RAMON TREVIÑO": true,
        "GETSEMANI": true,
        "PARQUE INDUSTRIAL STIVA BARRAGÁN": true,
        "PRIVADA RESIDENCIA HACIENDA ANÁHUAC": true,
        "TABACHINES": true,
        "ZONA INDUSTRIAL": true
      },
      "66427": {
        "VILLARREAL": true
      },
      "66428": {
        "CASA BELLA": true,
        "LAS MISIONES": true,
        "PRIVADA CASA BELLA": true
      },
      "66430": {
        "BETEL": true,
        "CONGREGACIÓN MARIANO ESCOBEDO": true,
        "EL REFUGIO SECTOR 1": true,
        "EL REFUGIO SECTOR 2": true,
        "FRANCISCO VILLA": true,
        "LA GLORIA": true,
        "LOS NOGALES": true,
        "LOS ÁLAMOS": true,
        "RINCÓN DE LOS ÁLAMOS": true,
        "SAN ANTONIO": true,
        "SAN IGNACIO": true,
        "SANTA MARÍA": true
      },
      "66435": {
        "RINCÓN DE LOS CEDROS": true
      },
      "66436": {
        "LAS NUEVAS PUENTE": true,
        "PRADERAS DE SANTO DOMINGO": true
      },
      "66437": {
        "POBLADO DE SANTO DOMINGO": true,
        "VALLE DE SAN CARLOS": true,
        "VICENTE GUERRERO (FOMERREY 46)": true,
        "VILLAS DE SANTO DOMINGO": true
      },
      "66438": {
        "VALLE DE LAS FLORES": true,
        "VALLE DE SANTO DOMINGO": true
      },
      "66440": {
        "LOS MORALES": true,
        "LOS NOGALES (FOMERREY 44)": true,
        "NUEVO MEZQUITAL": true,
        "TORRES DE SANTO DOMINGO": true,
        "UNIDAD LABORAL": true
      },
      "66444": {
        "CARMEN ROMANO DE LOPEZ PORTILLO (FOMERREY 27)": true,
        "ECOCENTRO INDUSTRIAL": true,
        "FUENTES DE ANÁHUAC": true,
        "PASEO DE LOS ANDES": true,
        "PEDREGAL DE SANTO DOMINGO": true,
        "PRADOS DE SANTO DOMINGO": true,
        "PRIVADA SANTO DOMINGO": true
      },
      "66445": {
        "ALBATERRA RESIDENCIAL": true,
        "FRACCIONAMIENTO INDUSTRIAL LOS PARQUES": true,
        "JARDINES DEL MEZQUITAL": true,
        "VALLE DEL MEZQUITAL (FOMERREY 30)": true
      },
      "66446": {
        "ANÁHUAC LA ESCONDIDA": true,
        "BALCONES DE SANTO DOMINGO": true,
        "PASEO SAN NICOLÁS": true,
        "REAL ANÁHUAC": true
      },
      "66447": {
        "SANTO DOMINGO (FOM. 34)": true
      },
      "66448": {
        "ARBOLEDAS DE SANTO DOMINGO": true,
        "LOS NARANJOS": true,
        "RESIDENCIAL SANTO DOMINGO": true
      },
      "66449": {
        "AQUILES SERDÁN (FOMERREY 33)": true,
        "ARBOLEDAS DEL MEZQUITAL": true,
        "FOMERREY 119": true,
        "HACIENDA DE SANTO DOMINGO": true,
        "PARQUES DE SANTO DOMINGO": true,
        "RESIDENCIAL SANTO DOMINGO SECTOR 2": true,
        "TORRES DE SANTO DOMINGO (FOMERREY 118)": true
      },
      "66450": {
        "ANÁHUAC": true,
        "AVITA ANÁHUAC": true,
        "CHAPULTEPEC": true,
        "CUAUHTÉMOC": true,
        "EL ROBLE": true,
        "LOMAS DEL ROBLE": true,
        "PEDREGAL DE ANÁHUAC": true,
        "PRIVAL DE ANAHUAC": true,
        "ROYAL": true,
        "VALLE DE ANÁHUAC": true,
        "VIEJO ANÁHUAC": true
      },
      "66455": {
        "CIUDAD UNIVERSITARIA": true
      },
      "66456": {
        "ANCESTRA": true,
        "PARQUE ANÁHUAC": true,
        "POTRERO ANÁHUAC": true
      },
      "66457": {
        "RESIDENCIAL ANÁHUAC": true
      },
      "66458": {
        "ROBLE NORTE": true
      },
      "66460": {
        "ANÁHUAC 11": true,
        "AÑO DE JUÁREZ (FOMERREY 86)": true,
        "JARDÍN DE LAS PUENTES": true,
        "LAS PUENTES SECTOR 1": true,
        "LAS PUENTES SECTOR 10": true,
        "LAS PUENTES SECTOR 11": true,
        "LAS PUENTES SECTOR 12": true,
        "LAS PUENTES SECTOR 14": true,
        "LAS PUENTES SECTOR 15": true,
        "LAS PUENTES SECTOR 2": true,
        "LAS PUENTES SECTOR 3": true,
        "LAS PUENTES SECTOR 4": true,
        "LAS PUENTES SECTOR 5": true,
        "LAS PUENTES SECTOR 6": true,
        "LAS PUENTES SECTOR 7": true,
        "LAS PUENTES SECTOR 8": true,
        "LAS PUENTES SECTOR 9": true,
        "PASEO DE LAS PUENTES": true,
        "RESIDENCIAL LAS PUENTES": true,
        "RINCÓN DE LAS PUENTES": true,
        "RINCÓN DE LOS ANDES": true,
        "VALLE DE LAS PUENTES": true,
        "VILLA LAS PUENTES": true
      },
      "66463": {
        "BOSQUES DE ANÁHUAC": true,
        "JARDINES DE ANÁHUAC": true
      },
      "66465": {
        "ARBOLEDAS DE SAN JORGE": true,
        "COLONIAL LAS PUENTES": true,
        "HACIENDA LAS PUENTES": true,
        "RESIDENCIAL LAS PALMAS": true,
        "RIVERAS DE LAS PUENTES": true
      },
      "66466": {
        "BALCONES DE LAS PUENTES": true
      },
      "66468": {
        "JARDINES DE SANTO DOMINGO": true
      },
      "66469": {
        "JULIO CAMELO TREVIÑO": true,
        "VILLA ESPERANZA": true
      },
      "66470": {
        "ALCATRACES RESIDENCIAL": true,
        "ANDALUCÍA": true,
        "COSTA DEL SOL": true,
        "INDUSTRIAS DEL VIDRIO AMPLIACIÓN ORIENTE": true,
        "LOS LAURELES": true,
        "MIGUEL ALEMÁN": true,
        "RESIDENCIAL LOS MORALES": true,
        "RESIDENCIAL PASEO DE LOS ÁNGELES": true,
        "RINCÓN DEL ORIENTE": true,
        "SAN BENITO DEL LAGO": true,
        "TACUBA": true,
        "VILLAS DE ORIENTE": true,
        "VIVENZA": true
      },
      "66473": {
        "BLAS CHUMACERO CTM": true,
        "BOSQUES DE LINDAVISTA": true,
        "BOSQUES DE LINDAVISTA SECTOR DIAMANTE": true,
        "LA TALAVERNA": true,
        "LA TALAVERNA CROC": true,
        "LOS CIPRESES": true,
        "PARQUE LA TALAVERNA": true,
        "VILLAS DE SAN MIGUEL": true
      },
      "66475": {
        "CASA BLANCA": true,
        "INFONAVIT LOS ÁNGELES SECTOR OCHO": true,
        "INFONAVIT LOS ÁNGELES SECTOR SIETE": true,
        "JARDINES DE CASA BLANCA": true,
        "SAN ÁNGEL CASA BLANCA": true,
        "VILLAS DE CASA BLANCA": true
      },
      "66476": {
        "LA ESTANCIA": true,
        "LOS REALES": true,
        "VILLA LUIS": true
      },
      "66477": {
        "DEL LAGO": true,
        "HACIENDA LAS FUENTES": true,
        "HACIENDA LOS ANGELES": true,
        "LA FE": true,
        "RESIDENCIAL SANTA FE": true
      },
      "66478": {
        "ARBOLEDAS DE SAN CRISTÓBAL": true,
        "CERRADAS DE CASA BLANCA": true,
        "FRESNOS DEL LAGO": true,
        "INFONAVIT LOS ÁNGELES SECTOR CINCO": true,
        "INFONAVIT LOS ÁNGELES SECTOR CUATRO": true,
        "INFONAVIT LOS ÁNGELES SECTOR DOS": true,
        "INFONAVIT LOS ÁNGELES SECTOR TRES": true,
        "INFONAVIT LOS ÁNGELES SECTOR UNO": true,
        "LOS PINOS": true,
        "MISIÓN DE CASA BLANCA": true,
        "MISIÓN DE SAN CRISTÓBAL": true,
        "PALMAS DIAMANTE": true,
        "PRIVADAS DE CASA BLANCA": true,
        "QUINTA MONTECARLO": true,
        "RESIDENCIAL SAN CRISTÓBAL": true,
        "RESIDENCIAL SAN CRISTÓBAL SECTOR TRES": true,
        "RINCÓN DE CASA BLANCA 1ER SECTOR": true,
        "RINCÓN DE CASA BLANCA SECTOR 2": true,
        "RINCÓN DE LOS ÁNGELES": true,
        "VALLE CASA BLANCA": true,
        "VILLAS DE SAN CRISTÓBAL": true
      },
      "66479": {
        "MARGARITA SALAZAR": true
      },
      "66480": {
        "AZTECA (FOMERREY 11)": true,
        "BOSQUES DEL NOGALAR": true,
        "DEPORTIVO LAGRANGE": true,
        "DÍAZ ORDAZ": true,
        "GARZA CANTU": true,
        "JOSÉ LÓPEZ PORTILLO": true,
        "LIVING SAN NICOLÁS": true,
        "PASEO DEL NOGALAR": true,
        "PRIVADAS SAN NICOLÁS": true,
        "RESIDENCIAL NOGALAR": true,
        "VALLE AZTECA (FOMERREY 12)": true,
        "VALLE DE LAS GRANJAS (FOMERREY 13)": true,
        "VALLE DEL NOGALAR": true
      },
      "66482": {
        "MERCADO DE ABASTOS ESTRELLA": true,
        "PREDIO ALDAPE": true
      },
      "66484": {
        "ANTIGUO NOGALAR": true,
        "FUTURO NOGALAR": true,
        "INDUSTRIAL NOGALAR": true
      },
      "66485": {
        "BOSQUES DE SANTO DOMINGO (FOMERREY 92)": true,
        "RINCÓN DEL NOGALAR": true
      },
      "66486": {
        "4 DE OCTUBRE FOMERREY 72": true,
        "HACIENDA NOGALAR": true,
        "JARDINES DEL NOGALAR (FOMERREY 28)": true,
        "LA MORENA (FOMERREY 65)": true,
        "PRIVADA NOGALAR": true,
        "SALVADOR ALLENDE": true
      },
      "66488": {
        "FLORIDOS BOSQUES DEL NOGALAR (FOMERREY 90)": true
      },
      "66489": {
        "LAGOS DE CHAPULTEPEC (FOMERREY 69)": true
      },
      "66490": {
        "ANTIGUO CORRAL DE PIEDRA": true,
        "CIUDAD IDEAL": true,
        "COLONIAL LAGRANGE": true,
        "CONSTITUYENTES DE QUERÉTARO SECTOR 1": true,
        "CONSTITUYENTES DE QUERÉTARO SECTOR 2": true,
        "CONSTITUYENTES DE QUERÉTARO SECTOR 3": true,
        "CONSTITUYENTES DE QUERÉTARO SECTOR 4": true,
        "CONSTITUYENTES DE QUERÉTARO SECTOR 5": true,
        "CONSTITUYENTES DE QUERÉTARO SECTOR 6": true,
        "FRANCISCO GARZA SADA": true,
        "INDUSTRIAS DEL VIDRIO AMPLIACIÓN NORTE SECTOR 1": true,
        "INDUSTRIAS DEL VIDRIO AMPLIACIÓN NORTE SECTOR 2": true,
        "INDUSTRIAS DEL VIDRIO AMPLIACIÓN NORTE SECTOR 3": true,
        "INDUSTRIAS DEL VIDRIO AMPLIACIÓN NORTE SECTOR 4": true,
        "INFONAVIT VALLE DE LAGRANGE": true,
        "NUEVO MUNDO": true,
        "PEÑA GUERRA": true,
        "RESIDENCIAL RIVIERA": true
      },
      "66494": {
        "CENTRAL DE CARGA": true
      },
      "66495": {
        "HACIENDA LOS MORALES": true
      },
      "66496": {
        "ALEJANDRÍA": true,
        "FIDEL VELÁZQUEZ SÁNCHEZ": true,
        "VALLE DE LOS MORALES": true
      },
      "66499": {
        "HACIENDA LAGRANGE": true,
        "LOS MEZQUITES": true,
        "PARQUE INDUSTRIAL MONTERREY": true,
        "RESIDENCIAL SAN FELIPE": true
      }
    },
    "SAN PEDRO GARZA GARCÍA": {
      "66200": {
        "LOS ENCINOS": true,
        "SAN PEDRO GARZA GARCÍA CENTRO": true
      },
      "66210": {
        "SAN PEDRO 400": true
      },
      "66214": {
        "VILLA DEL OBISPO": true
      },
      "66215": {
        "SAN PEDRO": true
      },
      "66216": {
        "EL OBISPO": true,
        "VISTA MONTAÑA": true,
        "ZONA CLOUHTIER": true
      },
      "66217": {
        "PLAN DE AYALA": true,
        "ZONA INDUSTRIAL": true
      },
      "66218": {
        "ECHEVERRÍA": true,
        "LUCIO BLANCO 1ER SECTOR": true,
        "LUCIO BLANCO 2DO SECTOR": true,
        "VALLE DEL SEMINARIO": true
      },
      "66219": {
        "REVOLUCIÓN": true,
        "ZONA REVOLUCIÓN": true
      },
      "66220": {
        "DEL VALLE": true,
        "JARDINES DEL VALLE": true
      },
      "66224": {
        "FUENTES DEL DAVID": true,
        "FUENTES DEL VALLE": true,
        "FUENTES DEL VALLE SECTOR COLINAS": true,
        "RESIDENCIAL SANTA BÁRBARA LA CRIPTA": true,
        "ZONA FUENTES DEL VALLE": true,
        "ZONA LOS SABINOS": true,
        "ZONA SANTA BÁRBARA PONIENTE": true
      },
      "66225": {
        "LA JOYA": true,
        "ZONA DEL VALLE": true
      },
      "66226": {
        "CONJUNTO HABITACIONAL BUGAMBILIAS": true,
        "VALLE DEL MEZQUITE": true
      },
      "66227": {
        "LAS CAPILLAS": true,
        "LOS OLIVOS": true,
        "SAN FRANCISCO": true
      },
      "66228": {
        "RESIDENCIAL SAN CARLOS": true,
        "ZONA DE LOS CALLEJONES": true
      },
      "66230": {
        "CODORNICES ALDAMA": true,
        "CONJUNTO HABITACIONAL MORELOS": true,
        "JARDINES COLONIALES": true,
        "LA CIMA": true,
        "LA CÚSPIDE": true,
        "LA FINCA": true,
        "LA TOSCANA": true,
        "LA VENTANA": true,
        "LAS CODORNICES": true,
        "LAS UVAS": true,
        "LAS VERANDAS": true,
        "MISIÓN DEL VALLE": true,
        "PRADOS DE LA SIERRA": true,
        "PRIVADA VERSALLES": true,
        "RESIDENCIAL LOS CUBOS": true,
        "RINCÓN COLONIAL": true,
        "SAN GABRIEL": true,
        "SAN JOSÉ": true,
        "SAN PEDRO": true,
        "VILLA CAMPANARIO": true,
        "ZONA HACIENDA SAN FRANCISCO": true,
        "ZONA LA CIMA": true,
        "ZONA PALO BLANCO": true,
        "ZONA ROSARIO": true
      },
      "66233": {
        "LAS SENDAS GALICIAS": true,
        "MISIÓN DEL VALLE 3": true,
        "SANTA ELENA": true,
        "VILLA DE LOS PATOS": true,
        "ZONA VALLE PONIENTE": true
      },
      "66235": {
        "LOS OLMOS": true,
        "VILLA MONTAÑA": true
      },
      "66236": {
        "JARDINES DE MIRASIERRA": true,
        "PALO BLANCO": true,
        "PALO BLANCO SECTOR EL EDÉN": true,
        "RESIDENCIAL PALO BLANCO": true,
        "VILLAS DE SANTA BÁRBARA": true
      },
      "66237": {
        "LOS SAUCES 1ER SECTOR": true,
        "LOS SAUCES 2 SECTOR": true
      },
      "66238": {
        "JESÚS M GARZA": true,
        "LINDAVISTA": true,
        "LUCIO BLANCO 3ER SECTOR": true,
        "LÁZARO GARZA AYALA": true,
        "MIRADOR DE VASCONCELOS": true,
        "RINCÓN DE SAN FRANCISCO": true,
        "VALLE DE VASCONCELOS": true,
        "ZONA LOS SAUCES": true,
        "ZONA MIRADOR VAZCONCELOS": true
      },
      "66239": {
        "HACIENDA DE LOS CALLEJONES": true,
        "LOS PINOS": true,
        "NEMESIO GARCIA NARANJO": true,
        "RESIDENCIAL LAS AMAPAS": true,
        "RINCÓN DE CORREGIDORA": true,
        "VOLKSWAGEN": true
      },
      "66240": {
        "LA BARRANCA": true,
        "LA MONTAÑA": true,
        "LOMAS DE TAMPIQUITO": true,
        "MIRASIERRA": true,
        "OLÍMPICO": true,
        "PRIVADA SAN ANDRÉS": true,
        "PRO VIVIENDA POPULAR": true,
        "RINCÓN DE LA MONTAÑA": true,
        "TAMPIQUITO": true,
        "ZONA MIRASIERRA": true,
        "ZONA VALLE DEL MEZQUITE": true
      },
      "66244": {
        "CAPISTRANO": true,
        "LOMAS DEL BOSQUE": true,
        "LOMAS VALLE SECTOR CONVENTO": true,
        "LOS FRESNOS": true,
        "PRIVADA 20 DE NOVIEMBRE": true
      },
      "66245": {
        "BARRANCA DEL PEDREGAL": true
      },
      "66247": {
        "HACIENDA EL ROSARIO": true,
        "HACIENDA LAS CAMPANAS": true,
        "LA PARVADA ANGELITOS": true,
        "MANSIÓN DEL ROSARIO": true
      },
      "66249": {
        "CERRADA MORALILLO": true,
        "MORALILLO": true,
        "VILLAS DE TERRASOL": true
      },
      "66250": {
        "BOSQUES DEL VALLE": true,
        "FÁTIMA": true,
        "JERÓNIMO SILLER": true,
        "PRIVADA RÍO EBRO": true,
        "PRIVADA SIERRA MADRE": true,
        "VALLE DE CHIPINQUE": true,
        "ZONA JERÓNIMO SILLER": true,
        "ZONA PRIVADA RÍO TAMAZUNCHALE": true
      },
      "66254": {
        "CARRIZALEJO": true
      },
      "66256": {
        "LOMAS DEL VALLE": true
      },
      "66257": {
        "DEL VALLE SECTOR FÁTIMA": true,
        "ZONA FÁTIMA": true
      },
      "66259": {
        "CORTIJO DEL VALLE": true,
        "GÓMEZ MORIN": true,
        "LA CAÑADA": true,
        "RINCÓN DE CARRIZALEJO": true,
        "ZONA ANTIGUA EXHACIENDA CARRIZALEJO": true,
        "ZONA CARRIZALEJO": true,
        "ZONA LA ALIANZA": true
      },
      "66260": {
        "AMPLIACIÓN CANTERAS": true,
        "AMPLIACIÓN VALLE DEL MIRADOR": true,
        "CORPORATIVO PROSER": true,
        "DEL VALLE ORIENTE": true,
        "HACIENDA DE LA SIERRA": true,
        "JARDINES DE CAMPESTRE": true,
        "PORTAL DE SANTA ENGRACIA": true,
        "RESIDENCIAL CANTERAS": true,
        "RESIDENCIAL SAN AGUSTÍN PRIMER SECTOR": true,
        "RESIDENCIAL SAN AGUSTÍN SEGUNDO SECTOR": true,
        "RESIDENCIAL SAN MATEO": true,
        "ZONA SAN AGUSTÍN": true
      },
      "66263": {
        "ZONA CAMPESTRE": true,
        "ZONA SANTA ENGRACIA": true
      },
      "66265": {
        "VALLE DEL CAMPESTRE": true,
        "ZONA LA DIANA": true
      },
      "66266": {
        "CONJUNTO HABITACIONAL RENZO": true,
        "LA ADMIRANZA": true,
        "LA DIANA": true,
        "LOS ARCÁNGELES": true,
        "MIRADOR DEL CAMPESTRE": true,
        "PRIVADA RESIDENCIAL FRIDA KAHLO": true,
        "RESIDENCIAL SANTA BÁRBARA": true,
        "VERONA": true,
        "VILLAS DE SAN AGUSTIN": true,
        "VISTA REAL": true,
        "ZONA LOMA BLANCA PONIENTE": true,
        "ZONA LOMA LARGA ORIENTE": true,
        "ZONA VALLE ORIENTE NORTE": true
      },
      "66267": {
        "SANTA ENGRACIA": true
      },
      "66268": {
        "DEL VALLE SECT NORTE": true,
        "PRIVADA SANTA ENGRACIA": true,
        "VALLE DE SANTA ENGRACIA": true,
        "VILLAS DE SANTA ENGRACIA": true,
        "ZONA VALLE SANTA ENGRACIA": true
      },
      "66270": {
        "COLINAS DE SAN AGUSTIN": true,
        "LOS COLORINES": true,
        "MISIÓN SAN PATRICIO": true,
        "PRIVADA VEREDALTA": true,
        "RESIDENCIAL GALEANA": true,
        "SAN AGUSTIN CAMPESTRE": true,
        "SAN PATRICIO": true,
        "VEREDALTA": true,
        "ZONA LOMAS DE SAN AGUSTÍN": true,
        "ZONA TAMPIQUITO": true
      },
      "66273": {
        "CORPORATIVO SANTA ENGRACIA": true,
        "PRIVADA GRUTA": true,
        "VILLAS DE ARAGÓN": true,
        "ZONA MONTEBELLO": true
      },
      "66276": {
        "HACIENDA SAN AGUSTÍN": true,
        "VILLA LAS PALMAS": true,
        "ZONA HACIENDA SAN AGUSTÍN": true,
        "ZONA LOMAS DEL CAMPESTRE": true
      },
      "66277": {
        "LA ENCANTADA": true,
        "LAS CEIBAS": true,
        "PRIVADA REAL DE SAN AGUSTÍN": true,
        "PRIVADA SAN ROBERTO": true,
        "SANTA CRUZ": true,
        "TURQUESA": true
      },
      "66280": {
        "BALCONES DEL VALLE": true,
        "BOSQUES DE LA SIERRA 1ER SECTOR": true,
        "COLINAS DE LA SIERRA MADRE": true,
        "PEDREGAL DEL VALLE": true,
        "VILLA DEL PEDREGAL": true,
        "VILLAS CRISANTEMO": true,
        "ZONA BOSQUES DE LA SIERRA": true
      },
      "66285": {
        "SIERRA NEVADA": true,
        "VILLAS DEL VALLE": true,
        "ZONA BOSQUES DEL VALLE": true,
        "ZONA COLINAS SIERRA MADRE": true,
        "ZONA VALLE SAN ÁNGEL": true
      },
      "66287": {
        "LOMAS DEL ROSARIO": true,
        "ZONA PEDREGAL DEL VALLE": true
      },
      "66295": {
        "COMERCIAL ALPINO CHIPINQUE": true,
        "HACIENDA DE CARRIZALEJO": true,
        "JOYA DEL VENADO": true,
        "LA JOYA DE LA CORONA": true,
        "LOMAS DE SAN ÁNGEL": true,
        "MESA DE LA CORONA": true,
        "ZONA ALPINO": true
      },
      "66297": {
        "LAS ALONDRAS": true,
        "LOS ENCINOS": true,
        "RESIDENCIAL CHIPINQUE": true,
        "VILLA CHIPINQUE": true,
        "VILLAS LA RIVERA": true,
        "ZONA LOMA BLANCA": true,
        "ZONA RESIDENCIAL CHIPINQUE": true
      }
    },
    "SANTA CATARINA": {
      "66100": {
        "LA FAMA": true,
        "PRIVADA ACUEDUCTO": true,
        "PRIVADA ANTIGUA": true,
        "PRIVADA LA BOLITA": true
      },
      "66110": {
        "CIMAS DEL PONIENTE": true
      },
      "66114": {
        "CERRO DE LAS MITRAS": true,
        "CIMA DE LAS MITRAS": true
      },
      "66115": {
        "JARDÍN DE LAS MITRAS": true
      },
      "66116": {
        "FAMA II": true,
        "FAMA IV": true,
        "FAMA V": true
      },
      "66117": {
        "LA FAMA 1": true
      },
      "66118": {
        "EUGENIO CANAVATI CTM": true,
        "FAMA III": true
      },
      "66119": {
        "ARBOLEDAS DE LAS MITRAS": true,
        "CAÑADA BRASIL": true,
        "LOMAS DE LA FAMA": true,
        "LOMAS DEL MIRADOR": true
      },
      "66120": {
        "LOS PORTALES": true,
        "SAN HUMBERTO": true,
        "VILLAS DE SAN HUMBERTO": true,
        "VILLAS LOS PORTALES": true
      },
      "66129": {
        "ALTICA": true,
        "COOPERATIVA LA UNIÓN": true,
        "LA ERMITA": true,
        "PRADOS DE SAN JORGE": true,
        "PRIVADAS DEL PONIENTE": true,
        "PROVIVIENDA DEL PONIENTE SECTOR DOS": true,
        "PROVIVIENDA DEL PONIENTE SECTOR TRES": true,
        "PROVIVIENDA DEL PONIENTE SECTOR UNO": true,
        "VÉRTICE": true
      },
      "66139": {
        "RINCÓN DE LAS MITRAS (FOMERREY 2)": true
      },
      "66140": {
        "JOSÉ LÓPEZ PORTILLO": true
      },
      "66145": {
        "HACIENDA LOS PORTALES": true
      },
      "66147": {
        "SANTA MAGDALENA": true
      },
      "66149": {
        "TRABAJADORES": true
      },
      "66150": {
        "LAS VIVENZIAS": true,
        "LOS TREVIÑO": true,
        "PARQUES LA FAMA": true,
        "PRIVADA TREVIÑO": true
      },
      "66160": {
        "BENITO JUÁREZ": true
      },
      "66165": {
        "JARDINES DE LA FAMA": true,
        "PRIVADAS ONDARA": true,
        "VALLE DE LA SIERRA": true
      },
      "66166": {
        "CAMPANIA": true
      },
      "66167": {
        "HUASTECA DEL VALLE II": true,
        "LA ESPAÑOLA": true
      },
      "66168": {
        "LA CONCORDIA": true
      },
      "66169": {
        "EFIMEX": true
      },
      "66170": {
        "PROTEXA": true
      },
      "66179": {
        "MONTENEGRO": true
      },
      "66180": {
        "JESÚS M GARZA": true
      },
      "66187": {
        "LAS PALMAS": true
      },
      "66188": {
        "CANTIZAL": true,
        "LA FRATERNIDAD": true,
        "LAS ALMENAS": true,
        "LAS FINCAS": true,
        "LAS FINCAS II": true,
        "MONTALIA": true,
        "RESIDENCIAL OLINCA": true
      },
      "66189": {
        "LA BARRICA": true
      },
      "66190": {
        "SAN ISIDRO": true
      },
      "66195": {
        "NUEVA FORTALEZA": true
      },
      "66196": {
        "LA BANDA": true,
        "LOS CENIZOS": true,
        "MIGUEL HIDALGO": true,
        "RESIDENCIAL CORDILLERA": true,
        "VALLE PONIENTE SECTOR OLINCA": true,
        "VÍA CORDILLERA": true
      },
      "66197": {
        "CONSULADO GENERAL DE LOS ESTADOS UNIDOS DE AMÉRICA": true,
        "EL AGUACATAL": true,
        "HUASTECA REAL": true,
        "HUASTECA REAL II": true,
        "JARDÍN SECRETO": true,
        "LAS MONTAÑAS": true,
        "LOMA BLANCA": true
      },
      "66198": {
        "LA FORTALEZA": true
      },
      "66199": {
        "IDELFONSO VÁZQUEZ": true
      },
      "66350": {
        "CERRADA DEL VALLE": true,
        "CERRADA DEL VALLE PLUS": true,
        "CIUDAD SANTA CATARINA CENTRO": true,
        "LÁZARO CÁRDENAS": true,
        "MIRADOR DE SANTA CATARINA": true,
        "NUEVA SANTA CATARINA": true,
        "PRIVADA LAS FLORES": true,
        "PRIVADA OLIVOS": true,
        "PRIVADA ROBLE": true,
        "REAL DEL VALLE": true,
        "RESIDENCIAL EL CASTILLO": true,
        "RESIDENCIAL PANORÁMICA": true,
        "SANTA MARTHA I": true,
        "SANTA MARTHA II": true
      },
      "66353": {
        "EL PARAÍSO": true,
        "PRIVADA SAN PATRICIO": true,
        "PRIVADA VALLE PONIENTE": true,
        "RESIDENCIAL LA HUASTECA": true,
        "VILLAS DE LA HUASTECA": true
      },
      "66354": {
        "EL HORREO": true,
        "ENRIQUE RANGEL": true,
        "INFONAVIT LA HUASTECA": true,
        "INFONAVIT SANTA CATARINA": true,
        "LOMA PELONA": true,
        "LOS VITRALES": true,
        "MIRADOR DE LA HUASTECA": true,
        "MISIÓN DE LA HUASTECA": true,
        "PEDREGAL LA HUASTECA": true,
        "PRIVADAS LA HUASTECA": true,
        "PRIVADAS SIERRA MADRE RESIDENCIAL": true,
        "VENTANAS DE LA HUASTECA": true
      },
      "66356": {
        "ALFONSO MARTÍNEZ DOMÍNGUEZ": true,
        "EL CASTILLO": true,
        "PRADERAS DEL CASTILLO": true,
        "PRIVADA 10 DE MAYO": true
      },
      "66357": {
        "BALCONES DE SANTA CATARINA (FOMERREY 134)": true,
        "HACIENDA DE SANTA CATARINA": true,
        "PASEO DE LA SIERRA": true
      },
      "66358": {
        "ANTIGUA SANTA CATARINA": true,
        "CORDILLERAS DEL VIRREY": true,
        "CUMBRES DE SANTA CATARINA": true,
        "GENERAL FRANCISCO NARANJO": true,
        "LAS CATARINAS": true,
        "LUIS ECHEVERRÍA ALVAREZ": true,
        "PEDREGAL DE SANTA CATARINA": true,
        "PRIVADA ENCINOS": true,
        "PUERTA DEL SOL": true,
        "RESIDENCIAL DE LA SIERRA": true,
        "ZIMIX": true,
        "ZIMIX LEONES": true,
        "ZIMIX NORTE": true,
        "ZIMIX SUR": true
      },
      "66360": {
        "ADOLFO LÓPEZ MATEOS": true,
        "COLINAS DE SANTA CATARINA": true,
        "EL OBISPO JOMYCO": true,
        "HACIENDA SAN JOSÉ": true,
        "INDUSTRIAL MONTE DE LOS OLIVOS": true,
        "INDUSTRIAL UNIDAD NACIONAL": true,
        "INFONAVIT ADOLFO LÓPEZ MATEOS": true,
        "INFONAVIT CUAUHTÉMOC": true,
        "LA JOYA": true,
        "MISIÓN SANTA CATARINA": true,
        "RESIDENCIAL CUAUHTÉMOC": true
      },
      "66362": {
        "BOSQUES DEL PONIENTE": true,
        "EL MOLINO": true,
        "JARDINES DE SANTA CATARINA": true,
        "LAS MARGARITAS": true,
        "MERCADO DE ABASTOS PONIENTE": true,
        "PASEO DEL PRADO": true,
        "PIO XII": true,
        "PRIVADA 5 DE MAYO": true,
        "RESIDENCIAL ARVORE": true,
        "RINCÓN DE LAS HUERTAS": true,
        "VALLE DE SANTA CRUZ": true,
        "VILLAS DE LAS HUERTAS": true,
        "VILLAS DEL PONIENTE LAS GRANADAS": true
      },
      "66363": {
        "EL ESCORIAL": true,
        "LABORES NUEVAS": true,
        "SENDEROS": true
      },
      "66364": {
        "UNIÓN DEL NORESTE": true
      },
      "66365": {
        "MÁRTIRES DE CANANEA": true,
        "PRADOS DEL REY": true,
        "PRADOS DEL SOL": true,
        "RINCÓN DE LA HUASTECA": true,
        "VILLAS DEL MIRADOR": true,
        "ÁPICE": true,
        "ÁPICE CUATRO": true,
        "ÁPICE DOS": true,
        "ÁPICE TRES": true
      },
      "66366": {
        "TEPEYAC": true
      },
      "66367": {
        "BOSQUES LA HUASTECA": true,
        "EL FRUTAL": true,
        "EL OBISPO": true,
        "FORZA PARK": true,
        "HACIENDA EL PALMAR": true,
        "HUASTECA DEL VALLE I": true,
        "INDUSTRIAL SANTA CATARINA": true,
        "INDUSTRIAL UNIDAD NACIONAL II": true,
        "LOS VIÑEDOS": true,
        "METRO ALIANZA SANTA CATARINA": true,
        "NORBERTO AGUIRRE": true,
        "PARQUE INDUSTRIAL AVIA": true,
        "PARQUE INDUSTRIAL DEL PONIENTE KALOS": true,
        "PARQUE INDUSTRIAL DIAMANTE": true,
        "PARQUE INDUSTRIAL GONHER": true,
        "PARQUE INDUSTRIAL LA CONCORDIA": true,
        "PARQUE INDUSTRIAL LA ESPERANZA": true,
        "PARQUE INDUSTRIAL LA PUERTA": true,
        "PARQUE INDUSTRIAL LAS TORRES": true,
        "PARQUE INDUSTRIAL LOS NOGALES": true,
        "PARQUE INDUSTRIAL MARFER": true,
        "PARQUE INDUSTRIAL MARTEL DE SANTA CATARINA": true,
        "PARQUE INDUSTRIAL MILENIUM": true,
        "PARQUE INDUSTRIAL MULTITECH": true,
        "PARQUE INDUSTRIAL PEDRERAS": true,
        "PARQUE INDUSTRIAL STIVA SANTA CATARINA": true,
        "PRIVADA SAN PEDRO RESIDENCIAL": true,
        "PRIVADAS DE SANTA CATARINA": true,
        "PRIVADAS DE SANTA CATARINA SECTOR ELITE": true,
        "PUERTA DE LAS MITRAS": true,
        "REGIO PARQUE INDUSTRIAL SANTA CATARINA": true,
        "RESIDENCIAL DE SANTA CATARINA": true,
        "SANTA CATARINA INDUSTRIAL PARK": true,
        "T.A.D. PEMEX REFINERIA": true,
        "TERRA PARK SANTA CATARINA": true,
        "TERRA PARK SANTA CATARINA II": true,
        "TERRA PARK SANTA CATARINA IV": true
      },
      "66368": {
        "MICRO EMPRESARIOS": true,
        "PARQUE 100": true,
        "PARQUE 200": true,
        "PARQUE 300": true,
        "PARQUE INDUSTRIAL LAS PALMAS": true,
        "REAL DE SANTA CATARINA": true,
        "RINCÓN DE LAS PALMAS": true,
        "RINCÓN DEL PONIENTE": true,
        "SAN FRANCISCO": true,
        "TERRA PARK COLOSIO": true
      },
      "66369": {
        "LA CONQUISTA": true,
        "LAS SOMBRILLAS": true,
        "LOMAS DEL PONIENTE": true,
        "MISIÓN DE LAS VILLAS": true,
        "SAN GILBERTO": true,
        "VISIÓN DE LA HUASTECA": true
      },
      "66370": {
        "INDUSTRIAS DEL PONIENTE": true
      },
      "66373": {
        "27 DE MAYO": true,
        "AMPLIACIÓN SAN GREGORIO": true
      },
      "66374": {
        "ALBIA RESIDENCIAL": true,
        "PRIVADA SAN MIGUEL LA HUASTECA": true,
        "VIRGINIA TAFICH": true
      },
      "66375": {
        "29 DE JULIO": true,
        "VISTA A LA SIERRA": true
      },
      "66376": {
        "EL LECHUGAL": true,
        "SANTA CATALINA": true,
        "SANTA JULIA": true
      },
      "66377": {
        "LAS SIERRAS": true,
        "SAN GREGORIO": true
      },
      "66378": {
        "AURORA": true,
        "AURORITA": true
      }
    }
  },
  "PUEBLA": {
    "CORONANGO": {
      "72670": {
        "ANALCO": true,
        "LAS BARRANCAS": true,
        "SAN ANTONIO MIHUACAN": true,
        "SANTA MARÍA CORONANGO": true
      },
      "72680": {
        "SAN FRANCISCO OCOTLÁN (OCOTLÁN)": true
      },
      "72683": {
        "CAMPESTRE EL PILAR": true,
        "DOLCE BIANCA": true,
        "SAN CARLOS": true,
        "SAN FERNANDO": true,
        "TRES CANTOS RESIDENCIAL": true
      },
      "72685": {
        "SAN MARTÍN ZOQUIAPAN": true
      }
    },
    "CUAUTLANCINGO": {
      "72700": {
        "EL SAUZAL RESIDENCIAL": true,
        "FUENTES DEL MOLINO": true,
        "FUENTES DEL MOLINO SECCIÓN ARBOLEDAS": true,
        "JOSÉ MIGUEL": true,
        "LA JOYA": true,
        "LA NORIA": true,
        "LA QUINTA": true,
        "LOS FRAILES": true,
        "MÉXICO-PUEBLA": true,
        "QUECHOLANTLA": true,
        "RESIDENCIAL ANTURIOS": true,
        "RESIDENCIAL LOS COLORINES": true,
        "SAN JUAN CUAUTLANCINGO": true,
        "SAN MIGUEL": true,
        "VILLAS DE LA HACIENDA": true,
        "VILLAS DE SAN FACUNDO": true,
        "VILLAS EL MARQUÉS": true,
        "VILLAS LA ESCONDIDA": true,
        "VILLAS SAN JUAN": true,
        "VIRREYES": true,
        "XALATLA": true,
        "ÁNGELES": true
      },
      "72702": {
        "EL CARMEN": true,
        "ESTRELLA DEL MAR": true,
        "LOMAS DE ZAYAVEDRA": true,
        "MONTE CARLO": true,
        "SANTA MARÍA": true,
        "VILLAS ALCANFORES": true,
        "VILLAS SAN FRANCISCO": true,
        "VILLAS TORRES BODET": true,
        "VILLAS URANGA": true
      },
      "72703": {
        "CONCORDIA": true,
        "CORTIJO SAN JOAQUÍN": true,
        "CUAUTLANCINGO": true,
        "DESARROLLO ATLATENCO": true,
        "LOS ENCINOS": true,
        "REAL DEL BOSQUE": true,
        "VILLAS SAN ANTONIO": true,
        "VILLAS SAN JOSÉ": true,
        "VILLAS SAN JOSÉ II": true,
        "VILLAS SAN PEDRO": true
      },
      "72704": {
        "ALCATRACES": true,
        "ARDENAS RESIDENCIAL": true,
        "CALTIARE": true,
        "CAMPESTRE SANTA PATRICIA": true,
        "FRAMBOYANES": true,
        "HACIENDA EL PALMAR": true,
        "HACIENDA SAN CARLOS": true,
        "HACIENDA SAN JOAQUÍN": true,
        "LA HERRADURA": true,
        "LOMAS SAN AGUSTÍN": true,
        "LOMAS SAN AGUSTÍN II": true,
        "LOMAS SAN AGUSTÍN III": true,
        "LOMAS SAN AGUSTÍN IV": true,
        "LOS LAURELES": true,
        "MUSKOKA RESIDENCIAL": true,
        "QUINTA REAL": true,
        "RESIDENCIAL AVE DEL PARAÍSO": true,
        "RESIDENCIAL SAN AGUSTÍN": true,
        "SAN JORGE": true,
        "SAN LUIS": true,
        "SANTA ROSA": true,
        "SECOYA RESIDENCIAL": true,
        "TERRA RESIDENCIAL": true,
        "VILLAS DALÍ": true,
        "VILLAS DE SAN FACUNDO II": true,
        "VILLAS MIRO": true,
        "VILLAS SAN JOAQUÍN I": true,
        "VILLAS SAN JOAQUÍN II": true
      },
      "72705": {
        "AMPLIACIÓN FUERTE DE GUADALUPE": true,
        "ARBOLEDA SAN DIEGO": true,
        "CUAUTLANCINGO": true,
        "EL SUSPIRO": true,
        "EUCALIPTOS": true,
        "FUERTE DE GUADALUPE": true,
        "LOMAS DE SAN JUAN": true,
        "LUCERO": true,
        "MARI CONCHIS": true,
        "ORMA FORJADORES": true,
        "PALMAS": true,
        "REAL DE SAN DIEGO": true,
        "RESIDENCIAL LUCENDI": true,
        "SAN DIEGO LOS SAUCERA": true,
        "SAN DIEGO LOS SAUCES": true,
        "VERDE": true,
        "VILLA CIPRES (ANTES DEL REY)": true,
        "VILLAS DE SAN JUAN": true,
        "VILLAS DEL RINCÓN": true,
        "VILLAS PARAÍSO": true
      },
      "72706": {
        "ALCE RESIDENCIAL": true,
        "CONJUNTO LOS OLIVOS": true,
        "HACIENDA LAS AMÉRICAS": true,
        "LA CONCORDIA": true,
        "LOS CEREZOS": true,
        "LOS ÁNGELES": true,
        "NUEVO LEÓN": true,
        "RESIDENCIAL SAN PEDRO": true,
        "VENTANA DEL ÁNGEL": true,
        "VENTANA RESIDENCIAL": true,
        "VILLAS DE CUAUTLANCINGO": true,
        "VILLAS MEDITERRANEO": true,
        "VILLAS SANTA MÓNICA": true,
        "ZAYOLAN": true,
        "ZAYOLAN II": true
      },
      "72707": {
        "IPANEMA": true,
        "MAYORCA": true,
        "TRIBECA": true,
        "VILLAS DEL ALTO": true
      },
      "72720": {
        "ATZCAPOTZALCO": true,
        "EMILIANO ZAPATA": true,
        "LÁZARO CÁRDENAS": true,
        "XALTIPA": true
      },
      "72723": {
        "GETZEMANI - EL NOPALITO": true,
        "LA CIÉNEGA": true,
        "LOMAS DE CRISTO": true,
        "VILLAS DE XALATLA": true
      },
      "72724": {
        "VILLA OLÍMPICA": true
      },
      "72730": {
        "CHAUTENCO": true,
        "PASEOS DE CAMELINAS": true,
        "SANCTORUM": true
      },
      "72733": {
        "BOSQUE SANCTORUM": true
      },
      "72735": {
        "BELLO HORIZONTE": true,
        "CEMANTI": true,
        "CIRUELOS": true,
        "DESARROLLO HABITACIONAL EL ARCÁNGEL": true,
        "DIAMANTE": true,
        "EL ENSUEÑO": true,
        "EL PALACIO DE BELLO HORIZONTE": true,
        "HACIENDA ZAVALETA": true,
        "INTEGRA": true,
        "LA FUENTE": true,
        "LA TRINIDAD BELLO HORIZONTE": true,
        "LIQUIDAMBAR": true,
        "MACOPILLI": true,
        "MALINALI": true,
        "MORILLOTLA ZAVALETA": true,
        "OLIN": true,
        "PROYECTO 15": true,
        "PYLSA 30": true,
        "SANTA CECILIA": true,
        "VILLA DE ZAVALETA I": true,
        "VILLA DE ZAVALETA II": true,
        "VILLAS CAPRI": true,
        "VILLAS CHAUTENCO": true,
        "VILLAS CITLALI": true,
        "VILLAS DE MORILLOTLA": true,
        "VILLAS DE SANTIAGO": true,
        "VILLAS DE SANTIAGO II": true,
        "VILLAS PALERMO": true,
        "VILLAS QUETZALCOATL": true,
        "VILLAS SAN CARLOS": true,
        "VILLAS XOCHITL": true,
        "VIVA H 1998": true,
        "VIVA II": true,
        "VIVA III": true,
        "XEL-HUA": true
      }
    },
    "JUAN C. BONILLA": {
      "72640": {
        "CUANALÁ": true
      },
      "72669": {
        "SAN GABRIEL OMETOXTLA": true
      }
    },
    "PUEBLA": {
      "72000": {
        "CENTRO": true,
        "SAN FRANCISCO": true
      },
      "72010": {
        "INFONAVIT BOSQUES 5 DE FEBRERO": true,
        "RESIDENCIAL SANTA MARÍA": true,
        "SANTA MARÍA LA RIVERA": true
      },
      "72020": {
        "EL RIEGO SUR": true,
        "FRANCISCO VILLA": true,
        "PINO SUÁREZ": true,
        "SAN JERÓNIMO": true,
        "SAN JOSÉ CUATRO CAMINOS": true,
        "SAN RAFAEL ORIENTE": true,
        "VILLAS DEL MESÓN I": true,
        "VILLAS DEL MESÓN II": true
      },
      "72023": {
        "ZONA CEMENTOS ATOYAC": true
      },
      "72029": {
        "SAN RAFAEL PONIENTE": true
      },
      "72030": {
        "AQUILES SERDÁN": true,
        "SAN FELIPE HUEYOTLIPAN": true
      },
      "72040": {
        "DEL VALLE": true,
        "FUENTES LA PRADERA": true,
        "FUTURA": true,
        "JESÚS GONZÁLEZ ORTÉGA": true,
        "LA PEDRERA": true,
        "PLAZUELAS SAN JOSÉ": true,
        "RANCHO COLORADO": true,
        "RINCÓN DORADO": true,
        "SENDERO DEL FRESNO": true,
        "VALLE DEL ÁNGEL": true,
        "VILLAS SAN FELIPE": true
      },
      "72044": {
        "EX-RANCHO COLORADO": true,
        "JORGE MURAD MACLUF": true,
        "PLAZA PEDRERA": true,
        "PLAZA SAN ALBERTO": true,
        "SAN BERNARDO": true
      },
      "72045": {
        "ZONA CAPU": true
      },
      "72050": {
        "CLEOTILDE TORRES": true,
        "FRANCISCO VILLA (HOY 26 DE MAYO)": true,
        "LAS CUARTILLAS": true,
        "LOS ARCOS": true,
        "LOS ÍDOLOS": true,
        "SAN MIGUEL HUEYOTLIPAN": true,
        "TORRES 475": true,
        "UNIÓN": true,
        "VILLA KAROL": true
      },
      "72060": {
        "LAS POZAS": true,
        "REAL DEL MONTE": true,
        "VILLA POSADAS": true
      },
      "72062": {
        "RANCHO POSADAS": true
      },
      "72070": {
        "AQUILES SERDÁN": true,
        "LAS HADAS MUNDIAL 86": true,
        "NUEVA AURORA POPULAR": true,
        "PLAZA SAN PEDRO": true,
        "QUETZALCOATL": true,
        "RANCHO COLORADO": true,
        "S.A.R.H.": true,
        "VALLE DORADO": true
      },
      "72080": {
        "DEL REFUGIO": true,
        "MAESTRO FEDERAL": true,
        "MORELOS": true,
        "REAL DE SAN ANTONIO": true,
        "SANTA MARÍA": true
      },
      "72089": {
        "SAN ANTONIO": true,
        "SANTA ANITA": true
      },
      "72090": {
        "DOS ARBOLITOS": true,
        "JESÚS GARCIA": true,
        "LA PROVIDENCIA": true,
        "RESIDENCIAL LAS FUENTES": true,
        "SAN MATÍAS": true,
        "SAN MIGUELITO": true,
        "SAN SEBASTIÁN": true,
        "TIERRA Y LIBERTAD": true,
        "VILLA SAN ALEJANDRO": true,
        "ZONA ESMERALDA": true
      },
      "72094": {
        "EL TAMBORCITO": true
      },
      "72110": {
        "2A. SECCIÓN CLUB DE GOLF LAS FUENTES": true,
        "CLUB DE GOLF LAS FUENTES": true,
        "FUENTES DE MORATILLA": true,
        "LA CONSTANCIA": true,
        "LUZ OBRERA": true,
        "MORATILLA": true,
        "PARAÍSO DEL ANGEL": true,
        "PERPETUO SOCORRO": true,
        "RINCÓN DE MORATILLA": true,
        "SAN JOSÉ LAS FLORES": true
      },
      "72114": {
        "LOS CIPRESES": true
      },
      "72115": {
        "CAMPESTRE DEL BOSQUE": true,
        "MOLINO DE SANTO DOMINGO": true,
        "TEPETZINTLA": true
      },
      "72120": {
        "CENTRO CRUZ DEL SUR": true,
        "IGNACIO ROMERO VARGAS": true,
        "INDEPENDENCIA": true,
        "INFONAVIT HERMENEGILDO J. ALDANA": true,
        "LA VEGA": true,
        "LOS ARCOS SANTA CRUZ": true,
        "MIGUEL ABED": true,
        "SAN JOSÉ GUADALUPE": true,
        "VILLAS EL ENCANTO I": true,
        "VILLAS EL ENCANTO II": true
      },
      "72124": {
        "VILLAS INGLESAS": true,
        "VISTA HERMOSA": true
      },
      "72127": {
        "INFONAVIT LADRILLERA": true,
        "SAN JOSÉ CITLALTEPETL": true
      },
      "72130": {
        "FRANCISCO I. MADERO": true,
        "JACARANDAS": true,
        "LA AHOGADA": true,
        "LA GLORIA I": true,
        "LA GLORIA II": true,
        "LA LIBERTAD": true,
        "LAS ALAMEDAS": true,
        "LOS LAURELES": true,
        "OBRERA TEXTIL JOSÉ ABASCAL": true,
        "PATRIOTISMO": true,
        "PUERTA DE HIERRO": true,
        "RESIDENCIAL LOS ÁLAMOS": true,
        "RESIDENCIAL PRIVANZA": true,
        "SAN CARLOS": true,
        "VILLA MADERO": true
      },
      "72135": {
        "LOS VERGELES": true
      },
      "72140": {
        "AMOR": true,
        "AQUILES SERDÁN": true,
        "VALLE DEL REY": true
      },
      "72150": {
        "BOSQUES DE ZAVALETA": true,
        "BRITANIA": true,
        "CAMPESTRE EL PARAÍSO": true,
        "CIPRESES ZAVALETA": true,
        "CLUB BRITANIA": true,
        "DEL FAROL": true,
        "HUMBOLT": true,
        "INDEPENDENCIA": true,
        "JARDINES DE ZAVALETA": true,
        "LOS ARRAYANES": true,
        "LOS VIVEROS": true,
        "RESIDENCIAL EX-HACIENDA DE ZAVALETA": true,
        "RINCONADA DE LOS VIVEROS": true,
        "RINCONADA SANTA CRUZ": true,
        "RINCÓN SAN JOSÉ DEL PUENTE": true,
        "SAN JOSÉ DEL PUENTE": true,
        "SANTA CRUZ BUENAVISTA": true,
        "VILLAS CRUZ DEL SUR": true,
        "VILLAS EL NAVARRIEGO": true,
        "VILLAS LOS VIVEROS": true
      },
      "72154": {
        "LA CAÑADA (ROMERO VARGAS)": true,
        "LA LOMA (EJIDO ROMERO VARGAS": true
      },
      "72160": {
        "AMPLIACIÓN REFORMA": true,
        "LA PAZ": true,
        "PLAZA REFORMA": true,
        "REFORMA": true,
        "REFORMA SUR (LA LIBERTAD)": true
      },
      "72170": {
        "BELLAS ARTES": true,
        "BELLO HORIZONTE": true,
        "GUADALUPE (EJIDO ROMERO VARGAS)": true,
        "SANTA CRUZ GUADALUPE": true
      },
      "72176": {
        "ARCOS DEL SUR": true,
        "FUNDADORES DE ZAVALETA": true,
        "LA FLOR DE NIEVE": true,
        "ZAVALETA (ZAVALETA)": true,
        "ZONA RESIDENCIAL ANEXA ESTRELLAS DEL SUR": true
      },
      "72180": {
        "BELISARIO DOMÍNGUEZ": true,
        "LAS ANIMAS SANTA ANITA": true,
        "NUEVA ANTEQUERA": true,
        "PROVIDENCIA LAS ÁNIMAS": true
      },
      "72189": {
        "UNIDAD PALMA": true
      },
      "72190": {
        "CONCEPCIÓN LAS LAJAS": true,
        "CORTIJO LA HERRADURA": true,
        "ESTRELLA DEL SUR": true,
        "SAN JOSÉ VISTA HERMOSA": true,
        "SAN MIGUEL LA ROSA": true
      },
      "72193": {
        "ANGELOPOLIS": true,
        "CORREDOR COMERCIAL DESARROLLO ATLIXCAYOTL": true,
        "RINCONADA SUR ORIENTE": true
      },
      "72194": {
        "DEL ARTE": true,
        "RINCONADA SUR PONIENTE": true
      },
      "72200": {
        "INFONAVIT SAN PEDRO": true,
        "REVOLUCIÓN MEXICANA": true,
        "VILLA FRONTERA": true
      },
      "72210": {
        "EL PINAL": true,
        "ESMERALDA": true,
        "MALINTZI": true,
        "NACIONES UNIDAS": true,
        "ROMA": true,
        "SAN PEDRO": true,
        "TECNOLÓGICO": true,
        "TEPEYAC": true,
        "UNIDAD INDEPENDENCIA": true,
        "UNIÓN Y LIBERTAD": true
      },
      "72220": {
        "CORREDOR INDUSTRIAL LA CIÉNEGA": true,
        "MARAVILLAS": true,
        "VILLA DEPORTIVA": true,
        "VILLA MARUCA": true
      },
      "72223": {
        "ESTACIÓN NUEVA": true
      },
      "72225": {
        "JARDINES DE LA RESURRECCIÓN": true,
        "PARQUE INDUSTRIAL PUEBLA 2000": true,
        "VIVEROS DEL VALLE": true
      },
      "72228": {
        "INDIOS VERDES": true,
        "INFONAVIT SAN APARICIO": true,
        "PARQUE INDUSTRIAL RESURRECCIÓN": true,
        "SAN APARICIO LAS FUENTES": true,
        "SANTA ROSA": true,
        "TORRE FUERTE": true,
        "TRES DE MAYO": true
      },
      "72230": {
        "16 DE SEPTIEMBRE NORTE": true,
        "GUADALUPE VICTORIA NORTE": true,
        "LA LOMA NORTE": true,
        "VEINTE DE NOVIEMBRE": true,
        "ZONA INDUSTRIAL ANEXO A LA LOMA": true
      },
      "72240": {
        "ADOLFO LÓPEZ MATEOS": true,
        "LOS PINOS": true,
        "PLAZA LORETO": true,
        "VICENTE BUDIB": true
      },
      "72243": {
        "CUAUHTÉMOC": true
      },
      "72250": {
        "OBRERA CAMPESINA": true
      },
      "72260": {
        "ARBOLEDAS GUADALUPE": true,
        "FAUNA MARINA": true,
        "HIDALGO": true,
        "INFONAVIT LA CIÉNEGA (UNIDAD MOVIMIENTO OBRERO)": true,
        "INFONAVIT LA ROSA": true,
        "JOSÉ MARÍA MORELOS Y PAVÓN": true,
        "LOMAS DE LORETO": true,
        "MOCTEZUMA": true,
        "MÁRTIRES DEL TRABAJO": true,
        "PLAZAS DE GUADALUPE": true,
        "REMENTERIA": true,
        "UNIDAD CÍVICA 5 DE MAYO": true
      },
      "72266": {
        "JARDINES DE LOS FUERTES": true,
        "RENACIMIENTO": true
      },
      "72267": {
        "ARBOLEDAS SECCIÓN FUENTES": true
      },
      "72270": {
        "AZTECA": true,
        "CINCO DE MAYO": true,
        "DIEZ DE MAYO": true,
        "ITURBIDE": true,
        "LOMAS 5 DE MAYO": true,
        "LUZ DEL ALBA": true,
        "PUEBLA": true,
        "VISTA HERMOSA": true
      },
      "72280": {
        "ALDAMA": true,
        "HÉROES DEL 5 DE MAYO": true,
        "XONACA": true
      },
      "72290": {
        "BUENOS AIRES": true,
        "EL ALTO": true,
        "RINCÓN DEL BOSQUE": true,
        "XANENETLA": true
      },
      "72300": {
        "JOAQUÍN COLOMBRES": true,
        "UNIDAD MAGISTERIAL MÉXICO 68": true
      },
      "72303": {
        "VILLA VERDE": true
      },
      "72304": {
        "CAMINO A MANZANILLA": true
      },
      "72307": {
        "BOSQUES DE MANZANILLA": true
      },
      "72308": {
        "LA NUEVA RESURRECCIÓN": true,
        "MIGUEL HIDALGO (RESURRECCIÓN)": true
      },
      "72309": {
        "INFONAVIT MANUEL RIVERA ANAYA": true
      },
      "72310": {
        "ARBOLEDAS DE AMALUCAN": true,
        "BOSQUES DE AMALUCAN": true,
        "BOSQUES DE AMALUCAN 1RA SECCIÓN": true,
        "BOSQUES DE AMALUCAN 2DA SECCIÓN": true,
        "BOSQUES DEL PILAR": true,
        "BOSQUES SAN SEBASTIÁN": true,
        "CONJUNTO HABITACIONAL SAN ANDRÉS": true,
        "DEL VALLE": true,
        "HACIENDA LOS CAPULINES I": true,
        "HACIENDA LOS CAPULINES II": true,
        "INFONAVIT AMALUCAN": true,
        "INFONAVIT BOSQUES SAN SEBASTÍAN": true,
        "LUMBRERAS DE AMALUCAN (JARDINES)": true,
        "MILITAR PLAZA AMALUCAN II": true,
        "PLAZAS AMALUCAN": true,
        "REAL CAMPESTRE": true,
        "REAL DEL BOSQUE": true,
        "SAN BALTAZAR LA RESURRECCIÓN": true,
        "SANTA MARGARITA": true,
        "VILLA FRESCURA VI": true,
        "VILLAS REAL CAMPESTRE II": true
      },
      "72314": {
        "SAN ANTONIO ABAD": true
      },
      "72320": {
        "CHAPULTEPEC": true,
        "CIUDAD SATÉLITE": true,
        "LOS ÁLAMOS": true,
        "UNIDAD SATÉLITE MAGISTERIAL": true,
        "ÁLAMOS VISTA HERMOSA": true
      },
      "72330": {
        "CRISTÓBAL COLÓN": true,
        "EL PORVENIR": true
      },
      "72340": {
        "AMÉRICA NORTE": true,
        "AMÉRICA SUR": true,
        "CAMPO MILITAR 25": true,
        "EL CRISTO": true,
        "GREGORIO RAMOS": true,
        "SAN LUIS GONZAGA": true
      },
      "72350": {
        "GONZALO BAUTISTA O´FARRIL": true,
        "HERMOSA PROVINCIA": true,
        "LOMAS DE CHAPULTEPEC": true,
        "LOS ÁLAMOS TOLTEPEC": true,
        "PEDREGAL": true,
        "PUENTE BRAVO": true,
        "ROSALES 1A. SECCIÓN": true,
        "ROSALES 2A. SECCIÓN": true,
        "UNIDAD SAN ÁNGEL (SAN SALVADOR CH.)": true,
        "UNIDAD Y PROGRESO": true,
        "VILLA DE REYES": true
      },
      "72359": {
        "HUIXCOLOTERA": true
      },
      "72360": {
        "AMALUQUILLA": true,
        "LA PALMA": true,
        "LOMAS FLOR DEL BOSQUE": true,
        "PARAÍSO": true,
        "SAN JUAN FLOR DEL BOSQUE": true,
        "VERACRUZ": true
      },
      "72365": {
        "EL SALVADOR": true,
        "HISTORIADORES": true
      },
      "72370": {
        "AGRÍCOLA RESURGIMIENTO": true,
        "HUMBOLDT NORTE": true,
        "HUMBOLDT SUR": true,
        "LA GLORIA": true,
        "MIGUEL ALEMÁN": true,
        "MIGUEL NEGRETE": true
      },
      "72373": {
        "RESURGIMIENTO CD. NORTE": true
      },
      "72377": {
        "ACOCOTA": true,
        "LA LUZ": true,
        "LOS REMEDIOS": true
      },
      "72380": {
        "DOS DE ABRIL": true,
        "EL CHAMIZAL": true,
        "IGNACIO ZARAGOZA": true,
        "SANTA BÁRBARA NORTE": true,
        "SANTA BÁRBARA SUR": true,
        "VICENTE SUÁREZ": true
      },
      "72390": {
        "EL ENCINAR 1RA. SECCIÓN": true,
        "EL ENCINAR 2A. SECCIÓN": true,
        "FRANCISCO JAVIER CLAVIJERO": true
      },
      "72400": {
        "AMANECER": true,
        "EL VERGEL": true,
        "ESMERALDA": true,
        "LAS ÁNIMAS": true,
        "LAS ÁNIMAS CENTRO COMERCIAL": true,
        "OASIS": true,
        "O´FARRIL": true,
        "PLAZA EXPRESS": true,
        "RINCÓN DE LAS ANIMAS": true,
        "SANTA CRUZ LOS ANGELES": true,
        "VILLA MAGNA": true
      },
      "72403": {
        "VILLA ERIKA": true,
        "VILLA GÉNESIS": true
      },
      "72410": {
        "BENITO JUÁREZ": true,
        "EL ÁGUILA": true,
        "GRANJAS ATOYAC": true,
        "GUSTAVO DÍAZ ORDAZ": true,
        "INFONAVIT 12 DE MAYO DE 1918": true,
        "LA NORIA": true,
        "LOS VOLCANES": true,
        "NUEVA DEL CARMEN": true,
        "RESIDENCIAL LA ENCOMIENDA DE LA NORIA": true,
        "RIVERA DE SANTIAGO": true,
        "SAN MIGUEL LAS PAJARITAS": true,
        "SANTIAGO": true,
        "TORRE LAS ÁNIMAS": true
      },
      "72420": {
        "CHULA VISTA": true,
        "GABRIEL PASTOR 1A SECCIÓN": true,
        "INSURGENTES CHULAVISTA": true
      },
      "72423": {
        "EL INGENIERO": true,
        "HÉROE DE NACOZARI": true
      },
      "72424": {
        "ALPHA 2": true
      },
      "72425": {
        "GABRIEL PASTOR 2A SECCIÓN": true
      },
      "72430": {
        "AGUA AZUL (BALNEARIO)": true,
        "PRADOS AGUA AZUL": true,
        "REFORMA AGUA AZUL": true,
        "RIVERA DEL ATOYAC": true,
        "VILLA FLORENCIA": true
      },
      "72440": {
        "BOULEVARES": true,
        "EL CERRITO": true,
        "GIRASOL": true,
        "LA TEJA": true,
        "LOS ANGELES MAYORAZGO": true,
        "PLAZA AMÉRICA": true,
        "PLAZA CRYSTAL": true,
        "VILLA ENCANTADA": true
      },
      "72450": {
        "EL PARAÍSO": true,
        "EL PATRIMONIO": true,
        "EL PROGRESO": true,
        "LEOBARDO COCA": true,
        "LOMAS CLUB DE GOLF": true,
        "SAN JOSÉ MAYORAZGO": true,
        "VICENTE FERRER": true,
        "VILLAS EVEREST": true
      },
      "72453": {
        "BOSQUES DE ANGELOPOLIS": true,
        "MAYORAZGO": true
      },
      "72456": {
        "EL MAYORAZGO": true,
        "EVEREST": true,
        "MOLINO DE ENMEDIO": true
      },
      "72459": {
        "AZUL": true,
        "BOSQUES DE ATOYAC": true
      },
      "72460": {
        "CENTRO COMERCIAL PUEBLA": true,
        "CLUB DE GOLF MAYORAZGO": true,
        "CLUB DE GOLF PUEBLA": true,
        "FOVISSSTE SAN ROQUE": true,
        "RINCÓN ARBOLEDAS": true
      },
      "72464": {
        "EL ENCANTO": true,
        "EL SAUCEDAL": true,
        "EX-RANCHO VAQUERÍAS": true,
        "GEOVILLAS LA VISTA": true,
        "INFONAVIT MATEO DE REGIL RODRÍGUEZ": true,
        "LA CIMA": true,
        "MATEO SECCIÓN SAN JOSÉ MARAVILLAS": true,
        "RINCÓN DE LOS CIPRESES I": true,
        "UEMAC": true,
        "VANGUARDIA MAGISTERIAL": true
      },
      "72468": {
        "CAMPESTRE MAYORAZGO": true,
        "RINCONADA LAS TORRES": true
      },
      "72470": {
        "ELEGANZA": true,
        "EMPERADOR": true,
        "GERONA": true,
        "GRANJAS BUGAMBILIAS": true,
        "GRANJAS DEL SUR": true,
        "INFONAVIT EL CARMEN (GASTRONÓMICOS)": true,
        "INFONAVIT SAN BARTOLO": true,
        "INFONAVIT XAXALPA": true,
        "LOMAS DEL SUR": true,
        "POPULAR CASTILLOTLA": true,
        "POPULAR COATEPEC": true,
        "POPULAR EMILIANO ZAPATA": true,
        "PUEBLA TEXTIL": true,
        "SAN JORGE": true,
        "TECALI": true,
        "VICENTE GUERRERO": true,
        "VILLAS AMÉRICA": true,
        "VILLAS DEL CARMEN": true,
        "VISTA HERMOSA CD.SUR": true
      },
      "72474": {
        "16 DE SEPTIEMBRE SUR": true,
        "ARBOLEDAS DE LOMA BELLA": true,
        "DAMISAL": true,
        "EL FRESNO I": true,
        "EL FRESNO II": true,
        "INFONAVIT LOMA BELLA": true,
        "JARDINES DE BUGAMBILIAS": true,
        "JARDÍN": true,
        "LAS TORRES": true,
        "LOMA ENCANTADA": true,
        "RANCHO CHAPULCO": true,
        "VILLA DEL SUR": true
      },
      "72477": {
        "LOMA LINDA": true
      },
      "72478": {
        "UNIDAD ALTA VISTA": true
      },
      "72480": {
        "CIPRESES DE MAYORAZGO": true,
        "ECLIPSE": true,
        "EX-HACIENDA MAYORAZGO": true,
        "GALAXIA LA LAGUNA": true,
        "GEOVILLAS LAS GARZAS": true,
        "GRANJAS MAYORAZGO": true,
        "INFONAVIT LA CARMELITA": true,
        "INFONAVIT LA VICTORIA": true,
        "INFONAVIT SAN MIGUEL MAYORAZGO": true,
        "LAS CARMELITAS": true,
        "LOS CANTAROS": true,
        "MISIÓN DEL MAYORAZGO": true,
        "RINCONADA LOS ARCOS 1": true,
        "RINCONADA LOS ARCOS 2": true,
        "SAN FRANCISCO MAYORAZGO": true,
        "SAN JOSÉ LA LAGUNA": true,
        "SAN JOSÉ LOS PINOS": true,
        "SAN JUAN BOSCO": true,
        "TRES CERRITOS": true,
        "VILLAS DE SAN FRANCISCO MAYORAZGO": true,
        "VILLAS MONARCAS": true
      },
      "72482": {
        "LAS MERCEDES II": true
      },
      "72483": {
        "HABITAD PARA LA HUMANIDAD DE MÉXICO": true,
        "TRES CERRITOS": true
      },
      "72484": {
        "PASEOS DEL RÍO": true
      },
      "72490": {
        "2A. AMPLIACIÓN UNIÓN ANTORCHISTA": true,
        "2DA. AMPLIACIÓN GUADALUPE HIDALGO": true,
        "AMPLIACIÓN UNIÓN ANTORCHISTA": true,
        "ANTIGUA HACIENDA": true,
        "ARBOLEDAS DEL PEDREGAL": true,
        "CABAÑAS DE SANTA MARÍA": true,
        "EL TRIUNFO": true,
        "FELIPE CARRILLO PUERTO": true,
        "GRANJAS PUEBLA": true,
        "GUADALUPE HIDALGO": true,
        "HACIENDA DEL SUR": true,
        "HACIENDA DEL SUR II": true,
        "HACIENDA EL COBRE": true,
        "HACIENDA EL COBRE 3A. SECCIÓN": true,
        "INFONAVIT AGUA SANTA": true,
        "INFONAVIT FUENTES DE SAN BARTOLO": true,
        "JOYAS DEL SUR": true,
        "LA CHISPA": true,
        "LA GIRALDA": true,
        "LOMAS DE ATOYAC": true,
        "LOMAS DE CASTILLOTLA": true,
        "LOMAS DE SAN VALENTÍN": true,
        "LOMAS DEL SOL": true,
        "LOS CEREZOS": true,
        "LOS LIMONES": true,
        "LUIS DONALDO COLOSIO": true,
        "LUNA": true,
        "MAGISTERIAL PERIFERICO SUR": true,
        "MARBELLA": true,
        "NUEVA DEMOCRACIA": true,
        "NUEVO PLAN DE AYALA": true,
        "REGINA": true,
        "RINCÓN DE LOS CIPRESES": true,
        "S.U.T.E.R.M.": true,
        "SAN RAMÓN 1A SECCIÓN": true,
        "SAN RAMÓN 2A SECCIÓN": true,
        "SAN RAMÓN 3A SECCIÓN": true,
        "SAN RAMÓN 4A SECCIÓN": true,
        "UNIDAD ANTORCHISTA": true,
        "VILLAS DEL SOL": true,
        "VILLAS DIAMANTE II": true,
        "VILLAS EL ENSUEÑO": true,
        "VILLAS PERISUR": true,
        "VILLAS SAN ANTONIO IV": true
      },
      "72492": {
        "INFONAVIT SAN MIGUEL MAYORAZGO 1A SECCIÓN": true,
        "LAS MERCEDES": true
      },
      "72494": {
        "3RA AMPLIACIÓN GUADALUPE HIDALGO": true,
        "CONCEPCIÓN SUR": true,
        "HACIENDA EL COBRE 2A. SECCIÓN": true,
        "HACIENDA SAN JOSÉ 3A. SECCIÓN": true,
        "LOS HÉROES DE PUEBLA II": true,
        "MAGISTERIAL CHAPULCO": true,
        "PEDREGAL DE GUADALUPE HIDALGO": true,
        "SAN ALFONSO": true,
        "SAN JOSÉ CHAPULCO": true,
        "VICTOR PUEBLA": true
      },
      "72496": {
        "LOMAS DE SAN RAMÓN": true
      },
      "72498": {
        "2 DE OCTUBRE": true,
        "AMPLIACIÓN JARDINES DE JUAN BOSCO": true,
        "AMPLIACIÓN VALLE DEL PARAÍSO": true,
        "BOSQUES DE LA CAÑADA": true,
        "EDUCADORES": true,
        "EL CASTILLO": true,
        "FEDERACIÓN CETEMISTA": true,
        "FLOR DEL SUR": true,
        "GALAXIA CASTILLOTLA": true,
        "GEOVILLAS CASTILLOTLA": true,
        "HACIENDA DE CASTILLOTLA": true,
        "HACIENDA SAN DIEGO": true,
        "HACIENDA SAN DIEGO 2": true,
        "HACIENDA SANTA CLARA": true,
        "HACIENDA SANTA FE": true,
        "INFONAVIT SAN RAMÓN": true,
        "JARDINES DE CASTILLOTLA": true,
        "JARDINES DE CASTILLOTLA 5A. SECCIÓN": true,
        "JARDINES DE JUAN BOSCO": true,
        "JARDINES DE SAN RAMÓN": true,
        "JARDÍN DE LOS PINOS": true,
        "LA CARMELITA": true,
        "LOS PINOS": true,
        "LOS PINOS I": true,
        "LOS PINOS II": true,
        "LOS REYES": true,
        "NUEVA JERUSALÉN": true,
        "OCEANÍA": true,
        "PASEOS DE CASTILLOTLA": true,
        "PRADOS DEL SUR": true,
        "SAN AGUSTÍN": true,
        "SAN BERNABE TEMOXTITLA": true,
        "SAN CARLOS CASTILLOTLA": true,
        "SAN ISIDRO CASTILLOTLA": true,
        "SAN ISIDRO CASTILLOTLA SECCIÓN A": true,
        "SANTA CATARINA COATEPEC": true,
        "SANTA ISABEL CASTILLOTLA": true,
        "VALLE DEL PARAÍSO": true,
        "VALLE DEL SUR": true,
        "VILLA DEL TRATADO": true,
        "VILLAS REALES": true
      },
      "72500": {
        "ANALCO": true,
        "BANCO DE PUEBLA": true,
        "BELLA VISTA": true,
        "SAN ÁNGEL": true
      },
      "72501": {
        "AZCARATE": true
      },
      "72503": {
        "BANDINI SECCIÓN": true
      },
      "72504": {
        "PLAZA EUROPA": true
      },
      "72505": {
        "ÁLVARO OBREGÓN": true
      },
      "72510": {
        "JOSÉ LÓPEZ PORTILLO (CD.NIÑOS)": true,
        "SEIS DE ENERO": true
      },
      "72520": {
        "BOSQUES LA CALERA": true,
        "EL MIRADOR (LA CALERA)": true,
        "HÉROES DE PUEBLA": true,
        "JARDINES DE LA JOYA": true,
        "LA CALERA": true,
        "LA JOYA": true,
        "LOS PINITOS": true,
        "QUINTAS DEL BOSQUE": true,
        "RINCONES DE LA CALERA": true,
        "VILLA ALEGRE": true
      },
      "72523": {
        "LOMAS DEL PEDREGAL": true
      },
      "72530": {
        "ANZURES": true,
        "EL CARMEN": true,
        "EL MIRADOR": true,
        "LA TARJETA": true,
        "LADRILLERA DE BENITEZ": true,
        "PLAZA DORADA": true,
        "PUEBLA": true
      },
      "72532": {
        "MARÍA LUISA": true
      },
      "72533": {
        "ANTIGUA FRANCISCO VILLA": true,
        "EL ÁNGEL": true
      },
      "72534": {
        "CARMEN HUEXOTITLA": true,
        "HUEXOTITLA": true
      },
      "72538": {
        "MOTOLINIA": true
      },
      "72540": {
        "EL ESFUERZO NACIONAL": true,
        "INFONAVIT LA FLOR": true,
        "INSURGENTES ORIENTE": true,
        "SAN IGNACIO": true,
        "SANTA MÓNICA": true,
        "VILLA LAS FLORES": true
      },
      "72543": {
        "ALSESECA": true
      },
      "72550": {
        "FOVISSSTE DAMISAR (SAN BALTAZAR CAMPECHE)": true,
        "INSURGENTES CENTRO": true,
        "LAS PALMAS": true,
        "SAN BALTAZAR CAMPECHE": true,
        "SAN BALTAZAR LINDAVISTA": true
      },
      "72560": {
        "INFONAVIT LA MARGARITA": true,
        "LOS PILARES": true,
        "SANTA JULIA": true,
        "UNIDAD GUADALUPE": true,
        "VILLA SAN PABLO": true
      },
      "72564": {
        "JARDINES DE LA MONTAÑA": true,
        "LOS SOLES": true,
        "VILLA SATÉLITE CALERA": true
      },
      "72565": {
        "ARBOLEDAS DEL SUR": true,
        "VALLE DEL SOL": true
      },
      "72567": {
        "LAS BRISAS": true,
        "VILLA CARMEL": true
      },
      "72570": {
        "22 DE SEPTIEMBRE": true,
        "CORONEL MIGUEL AUZA": true,
        "FOVISSSTE SAN MANUEL": true,
        "JARDINES DE SAN MANUEL": true,
        "LA HACIENDA": true
      },
      "72573": {
        "LA JOYA (ANEXO LOMAS SAN MIGUEL)": true,
        "LOMAS SAN MIGUEL": true
      },
      "72574": {
        "BRITANIA LA CALERA": true,
        "HERITAGE II": true,
        "JARDINES DE SAINT GERMAIN": true,
        "LOMAS DEL MÁRMOL": true
      },
      "72575": {
        "HERITAGE I": true,
        "LOMAS DEL ÁNGEL": true,
        "LOMAS SAN ALFONSO": true,
        "PASEOS DEL BOSQUE": true,
        "SANTA MARÍA LA CALERA": true
      },
      "72580": {
        "BUGAMBILIAS": true,
        "FUNDADORES": true,
        "LAGULENA": true,
        "LOS GAVILANES": true,
        "SAN EZEQUIEL": true,
        "VESTA HERA": true
      },
      "72582": {
        "LAS AVES": true,
        "LAS COLORADAS": true
      },
      "72583": {
        "ALCANFORES": true,
        "LOS CAPRICHOS": true,
        "LOS FAISANES": true,
        "RANCHO SAN JOSÉ XILOTZINGO": true,
        "RESIDENCIAL XILOTZINGO": true,
        "SAN JUAN XILOTZINGO": true,
        "SAN LUIS": true,
        "SAN RAFAEL XILOTZINGO": true
      },
      "72584": {
        "EXHACIENDA CHAPULCO": true,
        "JARDINES DE SANTIAGO": true,
        "LOS TENORES": true,
        "RESIDENCIAL JHESHED": true
      },
      "72587": {
        "GRANJAS SAN ISIDRO": true,
        "INFONAVIT SAN JORGE": true,
        "LA MORA": true
      },
      "72589": {
        "UNIVERSIDADES": true,
        "VILLA UNIVERSITARIA": true
      },
      "72590": {
        "ARBOLEDAS DE SAN IGNACIO": true,
        "BARRIOS DE ARBOLEDAS": true,
        "BOSQUES DE LOS HÉROES": true,
        "HACIENDA SAN JOSÉ": true,
        "INFONAVIT LUIS N. MORONES": true,
        "LAS GLORIAS": true,
        "LOS HÉROES DE PUEBLA": true,
        "SAN JOSÉ CARPINTERO": true,
        "SAN MIGUEL": true,
        "UNIVERSIDAD": true,
        "UNIVERSITARIA": true,
        "VILLAS PERIFÉRICO": true
      },
      "72592": {
        "CIUDAD UNIVERSITARIA": true
      },
      "72593": {
        "GEOVILLAS LOS ENCINOS": true,
        "INFONAVIT SAN JOSÉ XILOTZINGO": true,
        "MAGISTERIAL": true,
        "RINCÓN DE SAN IGNACIO": true,
        "S.A.R.H. XILOTZINGO": true
      },
      "72594": {
        "VISTA ALEGRE": true
      }
    },
    "SAN ANDRÉS CHOLULA": {
      "72803": {
        "CORTIJO SAN ANDRÉS": true,
        "DE SAN ANDRÉS": true,
        "FLORAL": true,
        "LOS SAPOS": true,
        "QUINTAS DE ATZALA": true,
        "REAL DE CHOLULA": true,
        "REAL DEL PEDREGAL": true,
        "RINCONADA DE ATZALA": true,
        "RINCONADA DE SAN ANDRÉS": true,
        "SAN ANDRÉS": true,
        "SAN MATEO": true
      },
      "72805": {
        "LA VIRGEN": true,
        "LAS CUMBRES": true,
        "LÁZARO CÁRDENAS": true,
        "PASEOS DE CHOLULA": true,
        "SAN JOSÉ": true,
        "SANTA TERESA": true,
        "VILLAS LOLITA": true
      },
      "72810": {
        "AZTLÁN": true,
        "BERTHA": true,
        "DE LA SANTÍSIMA": true,
        "EL PUENTE": true,
        "FUTURA": true,
        "LA ALFONSINA": true,
        "LA AUREOLA": true,
        "LAS AMÉRICAS": true,
        "LUMAHA": true,
        "SAN ANDRÉS CHOLULA CENTRO": true,
        "SAN JUAN AQUIAHUAC": true,
        "SAN MIGUEL": true,
        "SANTA CATARINA": true,
        "SANTA MARÍA": true,
        "SANTIAGO XICOHTENCO": true,
        "SANTO NIÑO": true,
        "ZONA DE PROFESORES": true
      },
      "72813": {
        "ATZALA": true,
        "BOSQUES DE MORILLOTLA": true,
        "CAMPESTRE MORILLOTLA": true,
        "EX-HACIENDA DE SANTA TERESA": true,
        "LA ESCONDIDA": true,
        "LA RIVERA": true,
        "LOS ARRAYANES": true,
        "LOS ENCINOS": true,
        "LOS VOLCANES": true,
        "MORILLOTLA": true,
        "QUINTAS DE MORILLOTLA": true,
        "REAL DE MORILLOTLA": true,
        "REAL DE SAN PEDRO": true,
        "RESIDENCIAL RINCONADA DE MORILLOTLA": true,
        "RINCÓN DE ATZALA": true
      },
      "72814": {
        "ALMANARES CHOLOLLAN": true,
        "EL BARREAL": true,
        "JARDINES DE LOS CIPRESES": true,
        "JOYAS ARQUEOLÓGICAS": true,
        "QUETZALLI": true,
        "RESIDENCIAL BARRIO REAL": true,
        "RINCÓN DE LAS AMÉRICAS": true,
        "SAN ANDRÉS": true,
        "SANTA EMMA": true
      },
      "72815": {
        "GUADALUPANA O FINCA SAN ANDRÉS": true,
        "LOS POTRILLOS": true,
        "SAN ANDRESITO": true,
        "SAN MIGUEL": true,
        "SAN PEDRO COLOMOXCO": true,
        "SANTA MARÍA CUACO": true
      },
      "72817": {
        "ACTIPAC": true,
        "EL ARENAL": true,
        "LA MAGDALENA": true,
        "MAPLE": true
      },
      "72819": {
        "UNIVERSIDAD DE LAS AMÉRICAS": true
      },
      "72820": {
        "CIUDAD JUDICIAL": true,
        "RESERVA TERRITORIAL ATLIXCAYOTL": true,
        "RINCÓN DE ATLIXCAYOTL": true,
        "SAN BERNARDINO LA TRINIDAD": true,
        "SAN BERNARDINO TLAXCALANCINGO": true,
        "SANTA MARÍA": true,
        "XINACATLA": true
      },
      "72823": {
        "COYOTEPEC": true,
        "CUAYANTLA": true,
        "LOS CABALLOS": true,
        "LOS CEDROS": true,
        "TEPECUITLALPA": true
      },
      "72824": {
        "ARCÁNGELES DE MORILLOTLA": true,
        "ARCÁNGELES XALTEPEC": true,
        "EMILIANO ZAPATA": true,
        "JARDINES DE SAN CARLOS": true,
        "LAS GALVIAS RESIDENCIAL": true,
        "RIVIERA DEL GARDA": true,
        "UNIVERSIDAD DEL VALLE DE MÉXICO": true,
        "VILLAS DE MORILLOTLA": true,
        "VILLAS DE SAN ANTONIO": true,
        "VILLAS MIRAGE": true,
        "VISTAS DEL ÁNGEL": true,
        "ÁNGELES DE MORILLOTLA": true
      },
      "72825": {
        "ATLIXCAYOTL 2000": true,
        "EL MOLINITO": true,
        "EX-HACIENDA CORTIJO DE SAN MARTINITO": true,
        "GEOVILLAS SANTA CLARA SECCIÓN I Y II": true,
        "GOBERNADORES": true,
        "LA FORTUNA": true,
        "LA VIGA": true,
        "LAS MERCEDES": true,
        "LAS ÁNIMAS": true,
        "LYRA": true,
        "MAGISTERIO 2000 II": true,
        "MAYAQUEN": true,
        "MIRA": true,
        "MISIÓN DE SAN MARTINITO": true,
        "MOLINO VIEJO": true,
        "ORIÓN": true,
        "OYAMETL": true,
        "PASEOS DE SAN ANDRÉS": true,
        "PASEOS DEL ÁNGEL": true,
        "REAL DE SANTA CLARA I": true,
        "REAL DE SANTA CLARA II": true,
        "RINCONADA DE LA FORTUNA": true,
        "RINCÓN DE ÁNGELES": true,
        "SAN MARTINITO": true,
        "SANTA FÉ": true,
        "VILLA DE LOS ANGELES I": true,
        "VILLA DE LOS ÁNGELES II": true,
        "VILLA FLORESTA": true,
        "VILLAS ORIÓN": true,
        "VILLAS ORIÓN II": true,
        "ÁNGELES": true
      },
      "72826": {
        "EL DESEO": true,
        "PARQUE DE LA CASTELLANA": true,
        "PARQUE DE LA PLATA": true,
        "PARQUE EL CAIRO": true,
        "PARQUE EL NILO": true,
        "PARQUE TERRANOVA": true,
        "PARQUE VENETO": true,
        "PARQUE VICTORIA": true,
        "PUEBLA BLANCA": true,
        "VISTA MARQUES": true
      },
      "72828": {
        "GALEOTITLA": true,
        "SAN ANTONIO CACALOTEPEC": true,
        "SAN DIEGO": true,
        "SAN JUAN": true,
        "SAN LUIS": true,
        "SAN MIGUEL": true,
        "SANTA MARÍA ACUYAH 1": true,
        "XICOTZINGO": true
      },
      "72830": {
        "ALTA VISTA": true,
        "EL SECRETO": true,
        "LA VISTA CONTRY CLUB": true,
        "LOMAS DE ANGELÓPOLIS": true,
        "LOMAS DE ANGELÓPOLIS II": true,
        "LOMAS DE ANGELÓPOLIS PRIVANZA": true,
        "RINCÓN DE LOS REYES": true,
        "VALLE REAL": true,
        "VISTA REAL": true,
        "VISTA REAL DEL SUR": true
      },
      "72833": {
        "CENTRO COMERCIAL PALMAS PLAZA": true,
        "CONCEPCIÓN GUADALUPE": true,
        "CORTIJO ANGELOPOLIS": true,
        "FUENTES DE ANGELOPOLIS": true,
        "PUERTA PARAÍSO": true,
        "RESIDENCIAL LAS PALMAS": true,
        "TORRES DE PLATA": true
      },
      "72835": {
        "GEOVILLAS ATLIXCAYOTL LA HACIENDA": true,
        "LAS SINFONÍAS": true,
        "MOMOSA": true,
        "RESIDENCIAL EL PILAR": true,
        "RESIDENCIAL SAN ÁNGEL": true,
        "VILLAS DE ATLIXCO": true
      },
      "72836": {
        "AMPLIACIÓN CONCEPCIÓN LA CRUZ": true,
        "CONCEPCIÓN LA CRUZ": true,
        "CORREDOR EMPRESARIAL BOULEVARD ATLIXCO": true,
        "GEOVILLAS ATLIXCAYOTL": true,
        "JARDINES DE SAN JOSÉ": true,
        "LA CIMA": true,
        "PONTEVEDRA": true
      },
      "72837": {
        "CAMINO REAL A CHOLULA": true,
        "EX-HACIENDA CONCEPCIÓN BUENAVISTA": true,
        "HACIENDA DE SAN ANDRÉS": true,
        "LA CONCEPCIÓN": true,
        "LA CUCHILLA": true,
        "RESIDENCIAL CAMINO REAL": true,
        "RESIDENCIAL LA ESCONDIDA": true,
        "RESIDENCIAL ZAVALETA": true,
        "RINCÓN DE SAN ANDRÉS": true,
        "SAN BERNARDO": true,
        "SAN MARCOS": true,
        "VILLA ALEJANDRA": true,
        "VILLA DE ZAVALETA": true,
        "VILLA GÉNESIS": true,
        "VISTAS DEL VOLCÁN": true
      },
      "72840": {
        "LA CANDELARIA": true,
        "LA MISIÓN": true,
        "LA PURÍSIMA": true,
        "PUERTA SAN RAFAEL": true,
        "SAN ISIDRO": true,
        "SAN MIGUEL": true,
        "SAN RAFAEL COMAC": true,
        "SANTA MARÍA TONANTZINTLA": true
      },
      "72843": {
        "SAN DIEGO": true
      },
      "72846": {
        "LA CANDELARIA": true,
        "LA PURÍSIMA": true,
        "SAN FRANCISCO ACATEPEC": true,
        "SAN PEDRO": true,
        "SANTIAGO": true,
        "TEXCOCO": true,
        "VILLA ROMA": true
      }
    },
    "SAN PEDRO CHOLULA": {
      "72750": {
        "BOSQUES DE SAINT GERMAIN": true,
        "GEOVILLAS EL CAMPANARIO": true,
        "JOSÉ ÁNGELES": true,
        "LA CAÑADA": true,
        "RESIDENCIAL LA CARCAÑA": true,
        "RINCÓN DE SANTA BÁRBARA": true,
        "SAN JUAN TLAUTLA": true,
        "SAN MIGUEL": true,
        "SAN PABLO TECAMAC": true,
        "SAN SEBASTIÁN TEPALCATEPEC": true,
        "SANTA BÁRBARA ALMOLOYA": true
      },
      "72754": {
        "LA PRADERA": true,
        "LA RINCONADA": true,
        "MOMOXPAN": true,
        "MOMOXPAN 2A SECCIÓN": true,
        "REAL BRITANIA": true,
        "RESIDENCIAL BOSQUES DE SAN PEDRO": true,
        "RESIDENCIAL BOULEVARES MOMOXPAN": true,
        "RESIDENCIAL JARDINES DEL ROSAL": true,
        "SAN JOSÉ": true,
        "UNIKO": true
      },
      "72755": {
        "SAN DIEGO": true
      },
      "72757": {
        "RAFAEL ÁVILA CAMACHO": true
      },
      "72760": {
        "CHOLULA": true,
        "CHOLULA DE RIVADABIA CENTRO": true,
        "ESMERALDA": true,
        "FLORENCIA": true,
        "RESIDENCIAL DE JESÚS": true,
        "RESIDENCIAL LOS PINOS": true,
        "RINCÓN DE LA ARBORADA": true,
        "SAN AGUSTÍN CALVARIO": true,
        "SAN FRANCISCO CUAPAN": true,
        "SAN GREGORIO ZACAPECHPAN": true,
        "SANTIAGO CHOLULA INFONAVIT": true,
        "SANTIAGO MIXQUITLA": true,
        "VILLAS SAN DIEGO": true
      },
      "72762": {
        "ECCEHOMO": true,
        "INFONAVIT SANTA MARÍA EL AGORA": true,
        "LA MAGDALENA": true,
        "LA SANTÍSIMA": true,
        "LLANOS SANTA MARÍA": true,
        "SANTA MARÍA XIXITLA": true
      },
      "72764": {
        "AMATES": true,
        "ARBOLEDAS DE ZEREZOTLA": true,
        "BOSQUES DE ZEREZOTLA": true,
        "CASA BLANCA": true,
        "CERRITO DE GUADALUPE": true,
        "CHOLOLLAN": true,
        "CLUB DE GOLF LA HUERTA": true,
        "EL HALLAZGO": true,
        "HACIENDA VALLE DE ZEREZOTLA": true,
        "JARDINES DEL ALBA": true,
        "LA QUERENCIA": true,
        "LOS VIÑEDOS": true,
        "PLAZUELA DE SAN PEDRO": true,
        "QUINTAS DE CORTES": true,
        "SAN CARLOS": true,
        "SAN JUAN CALVARIO": true,
        "SANTA CECILIA": true,
        "SANTA MARTHA": true,
        "SENDA DEL SOL": true,
        "VILLA DE CORTÉS": true,
        "VILLA ZEREZOTLA": true,
        "VILLAS MAGNOLIA": true,
        "ZEREZOTLA": true
      },
      "72765": {
        "GUADALUPE": true,
        "SAN CRISTÓBAL TEPONTLA": true,
        "VILLA CRISTAL": true
      },
      "72766": {
        "RESIDENCIAL VILLAS CHOLULA": true,
        "SAN DIEGO CUACHAYOTLA": true
      },
      "72767": {
        "SAN COSME TEXINTLA": true,
        "SAN MATÍAS COCOYOTLA": true
      },
      "72768": {
        "ARCOIRIS": true,
        "BOSQUES DE GRANADA": true,
        "BOSQUES DE SANTA ROSA": true,
        "CAMPESTRE ARCOIRIS": true,
        "CAÑADA DE SANTIAGO": true,
        "JARDINES DE SAN DIEGO 2DA. SECCIÓN": true,
        "JARDINES SAN DIEGO": true,
        "RESIDENCIAL ATITLA": true,
        "RESIDENCIAL DEL BOSQUE": true,
        "SAN DIEGO LOS SAUCES": true
      },
      "72770": {
        "CASAS YERAN": true,
        "JESÚS TLATEMPA": true,
        "LLANOS DE JESÚS TLATEMPA": true,
        "LÁZARO CÁRDENAS": true,
        "SANTA MARÍA ACUEXCOMAC": true,
        "VILLAS PARAÍSO": true
      },
      "72772": {
        "ARBOLEDAS DE SAN ANTONIO": true,
        "LLANOS DE TLALTEMPA": true,
        "SANTA MÓNICA": true
      },
      "72774": {
        "ÁLVARO OBREGÓN": true
      },
      "72775": {
        "AMPLIACIÓN MOMOXPAN": true,
        "CAMINO REAL": true,
        "CIPRESES DE SANTIAGO": true,
        "RESIDENCIAL TORRECILLAS": true,
        "SANTIAGO MOMOXPAN": true,
        "VILLA MANANTIALES": true,
        "VILLAS JARDINES": true
      },
      "72776": {
        "EL PILAR": true,
        "FUENTES DE SAINT GERMAINT": true,
        "LA CARCAÑA": true,
        "LA JOYA": true,
        "LAS QUINTAS": true,
        "LAS VILLAS": true,
        "LOS PINOS": true,
        "OBSIDIANA": true,
        "QUETZALCOATL": true,
        "QUINTA MAÑANITAS": true,
        "RESIDENCIAL EX-HACIENDA LA CARCAÑA": true,
        "RIVADAVIA": true,
        "VILLAS DEL ATLACO": true,
        "XOCHITLCALI": true
      },
      "72777": {
        "EX-HACIENDA LA CARCAÑA": true,
        "FUENTES DE LA CARCAÑA": true,
        "JARDINES DE LA CARCAÑA": true,
        "LA FUSIÓN": true,
        "LOMAS DE LA CARCAÑA": true,
        "REAL DE PALMAS": true,
        "RESIDENCIAL EL CAMPANARIO": true,
        "RESIDENCIAL SAN PEDRO": true
      },
      "72778": {
        "LOS FRAILES": true,
        "SAN MIGUEL": true
      }
    }
  },
  "QUERÉTARO": {
    "CORREGIDORA": {
      "76900": {
        "AMPLIACIÓN EL PUEBLITO": true,
        "CATALINA": true,
        "DON BOSCO": true,
        "EL PUEBLITO CENTRO": true,
        "EL ROCIO RESIDENCIAL": true,
        "EL SORGO": true,
        "EL ZORZAL": true,
        "EMILIANO ZAPATA": true,
        "GALLEGOS": true,
        "HACIENDAS DEL PUEBLITO": true,
        "HUERTAS DE LA VIRGEN": true,
        "LA ANTIGUA": true,
        "LA CIÉNEGA": true,
        "LA PIRÁMIDE": true,
        "LAS FLORES": true,
        "LAS PALOMAS": true,
        "LOS FRAILES": true,
        "LOS NOGALES": true,
        "MISIONES DE CORREGIDORA": true,
        "MISIÓN LA ESPERANZA": true,
        "ORQUÍDEAS": true,
        "PORTAL DEL ÁNGEL": true,
        "PRIVADA BELLAVISTA": true,
        "PRIVADA DE LAS CAPILLAS": true,
        "PUEBLO NUEVO": true,
        "QUINTAS DEL BOSQUE": true,
        "RESIDENCIAL BELLAVISTA DIAMANTE": true,
        "RESIDENCIAL BELLAVISTA MEZQUITES": true,
        "RINCONADA DE LA VIRGEN": true,
        "RINCÓN COLONIAL": true,
        "SAN MIGUELITO": true,
        "SANTUARIOS DEL CERRITO": true,
        "TALAVERA": true,
        "VILLA ANTIGUA": true,
        "VILLAS DE LA CORREGIDORA": true
      },
      "76902": {
        "ACUEDUCTO CANDILES": true,
        "AMSTEL I": true,
        "AMSTEL II": true,
        "AMSTEL IV": true,
        "AMSTEL V": true,
        "EL BATÁN": true,
        "EL FORTÍN": true,
        "EL POCITO": true,
        "EL PÓRTICO": true,
        "EL ROBLE": true,
        "LAS DELICIAS": true,
        "LOS PINOS": true,
        "MISIÓN DE SANTA SOFÍA": true,
        "MISIÓN DE SANTIAGO": true,
        "PRIVADA CAMPESTRE": true,
        "RINCÓN CAMPESTRE": true,
        "SAN JOSÉ DE LOS OLVERA": true,
        "SANTA LUCÍA": true,
        "TABACHINES": true,
        "VALLE DE LOS OLIVOS": true,
        "VILLAS CAMPESTRE": true,
        "VILLAS CAMPESTRE 2A. SECCIÓN": true,
        "VILLAS DE TEJEDA": true,
        "ÁMSTERDAM": true
      },
      "76903": {
        "BERNARDO QUINTANA ARRIOJA": true,
        "BOULEVARES DEL CIMATARIO": true,
        "CAMELINAS": true,
        "CAMINO REAL": true,
        "CLAUSTROS DEL CAMPESTRE": true,
        "COLINAS DEL SOL": true,
        "COLINAS DEL SUR": true,
        "CUMBRES DEL ROBLE": true,
        "EL RISCO RESIDENCIAL": true,
        "FRANCISCO VILLA": true,
        "JOSÉ MARÍA TRUCHUELO": true,
        "LOMAS DEL CAMPESTRE": true,
        "LOMAS DEL MIRADOR": true,
        "LOS CANDILES": true,
        "LOS OLIVOS": true,
        "MISIÓN CANDILES": true,
        "MISIÓN DE SAN CARLOS": true,
        "MISIÓN MARIANA": true,
        "RESIDENCIAL ANDREA": true,
        "RINCONADA CAMPESTRE": true,
        "TIERRA Y LIBERTAD": true,
        "VALLE DIAMANTE": true,
        "VALLE REAL RESIDENCIAL": true,
        "VENCEREMOS": true,
        "VILLAS FONTANA": true,
        "VISTA CAMPESTRE": true
      },
      "76904": {
        "AMPLIACIÓN HUERTAS DEL CARMEN": true,
        "AZAHAR RESIDENCIAL": true,
        "COLINAS DEL BOSQUE 1A SECCIÓN": true,
        "COLINAS DEL REMANSO": true,
        "COLINAS DEL SANTUARIO": true,
        "DE LA SACA": true,
        "EL PRADO RESIDENCIAL": true,
        "EL PUEBLITO": true,
        "FILOSOFAL": true,
        "HACIENDA REAL TEJEDA": true,
        "HACIENDA SAN GABRIEL": true,
        "HUERTAS EL CARMEN": true,
        "LA GAVIA": true,
        "LA HACIENDA": true,
        "LAS FUENTES": true,
        "LOS MENDOZA": true,
        "LOS OLVERA": true,
        "LOS PÁJAROS": true,
        "LUZ MARÍA": true,
        "MARAVILLAS": true,
        "MISIÓN ANTIGUA": true,
        "MISIÓN MARBELLA": true,
        "MISIÓN SAN JOAQUÍN": true,
        "PANORAMA": true,
        "PEDREGAL DE SCHOENSTATT": true,
        "PIRULES": true,
        "PRIVADA LAS MARIPOSAS": true,
        "RESIDENCIAL LA VISTA": true,
        "RESIDENCIAL LOS VITRALES": true,
        "TEJEDA": true
      },
      "76905": {
        "BAHAMAS": true,
        "BALCONES DE VISTA REAL": true,
        "BOSQUES DE VIENA": true,
        "COLINAS DEL BOSQUE 2A SECCIÓN": true,
        "EL PARAÍSO": true,
        "LOMAS DEL SUR": true,
        "LOS CIPRESES": true,
        "POPULAR ECOLÓGICA VALLE DE ORO": true,
        "PRADERAS DEL BOSQUE": true,
        "SAN AGUSTÍN": true,
        "VISTA HERMOSA": true,
        "VISTA REAL Y COUNTRY CLUB": true
      },
      "76906": {
        "PUNTA ESMERALDA": true,
        "SANTA BÁRBARA 1A SECCIÓN": true,
        "SANTA BÁRBARA 2A SECCIÓN": true
      },
      "76907": {
        "1° DE MAYO": true,
        "20 DE ENERO": true,
        "20 DE ENERO 2A SECCIÓN": true,
        "21 DE MARZO": true,
        "ALTOS DEL PUEBLITO": true,
        "BALCONES DE LA NEGRETA": true,
        "COLINAS DEL SUR": true,
        "EL MILAGRITO": true,
        "ESPÍRITU SANTO": true,
        "JARDINES DE LA NEGRETA": true,
        "LA NEGRETA": true,
        "LOMAS DE LA CRUZ": true,
        "LOS REYES": true,
        "LUIS DONALDO COLOSIO": true,
        "MISIÓN REGINA": true,
        "MISIÓN SAN JOSÉ": true,
        "MISIÓN SAN JUAN": true,
        "PRADOS DE BALVANERA": true,
        "RINCÓN DE GUADALUPE": true,
        "VALLE ARBOLEDAS": true,
        "VALLE DE ARAGÓN 1A SECCIÓN": true,
        "VALLE DE LOS PINOS": true,
        "VALLE DE SANTIAGO": true,
        "VILLAS DE LAS FLORES": true
      },
      "76908": {
        "AMANECER BALVANERA": true,
        "AMPLIACIÓN LOS ÁNGELES": true,
        "BALVANERA": true,
        "COLINAS DE BALVANERA": true,
        "COLINAS DE LOS ÁNGELES": true,
        "FEDERAL DEL RÍO": true,
        "LA PALMA": true,
        "LAS CABAÑAS": true,
        "LOMAS DE BALVANERA": true,
        "LOS ARRAYANES": true,
        "LOS ÁNGELES": true,
        "MEDITERRÁNEO I": true,
        "MEDITERRÁNEO II": true,
        "MEDITERRÁNEO III": true,
        "MORALTA RESIDENCIAL": true,
        "NIÑOS HÉROES DE CHAPULTEPEC": true,
        "PIRÁMIDES": true,
        "PIRÁMIDES 3A. SECCIÓN": true,
        "PRADERAS DE LOS ÁNGELES": true,
        "PUEBLITO COLONIAL": true,
        "PUERTA DE PIEDRA": true,
        "RESIDENCIAL LAS TROJES": true,
        "RINCONADA MEDITERRÁNEO": true,
        "SANTA VIRGINIA": true,
        "TROJITAS": true,
        "VALLE DORADO 2000": true
      },
      "76910": {
        "CARLOTA HACIENDA VANEGAS": true,
        "CASA MAGNA": true,
        "DESARROLLO HIDALGO (DESARROLLO ZAPATA)": true,
        "JARDINES DE LA CORREGIDORA": true,
        "PASEOS DEL BOSQUE": true,
        "PUERTA REAL": true,
        "SAN JERÓNIMO": true,
        "TERRANOVA": true
      },
      "76912": {
        "CRUZ DE FUEGO": true,
        "LOS MEZQUITES": true,
        "MAGISTERIAL": true,
        "SAN MATEO": true
      },
      "76930": {
        "CANTABRIA RESIDENCIAL": true,
        "RESIDENCIAL SANTA FE": true,
        "SAN JUANICO": true,
        "SANTA MARÍA MAGDALENA": true,
        "VEREDAS": true
      }
    },
    "EL MARQUÉS": {
      "76240": {
        "DEL PANTEÓN": true,
        "EL CERRITO": true,
        "JARDÍN": true,
        "LA CAÑADA CENTRO": true,
        "LA PRESA (SAN ANTONIO)": true,
        "SAN JOSÉ (DEL BAÑO)": true,
        "VILLAS LA CAÑADA": true
      },
      "76244": {
        "CRUZ ALTA": true,
        "EL PINITO": true,
        "EL ZAPOTE": true,
        "HUERTA GRANDE (1ER DE DOLORES)": true,
        "RINCONADA EL CAPRICHO": true,
        "SAN FELIPE": true,
        "SAN FRANCISCO": true,
        "SAN JUAN (SAN JUAN DE DIOS)": true,
        "SANTA MARÍA DE GUADALUPE": true,
        "SOCAVÓN": true
      },
      "76246": {
        "ADARA LIFESTYLE": true,
        "ALLEZA MIRADOR": true,
        "BOSQUE DE LOS ENCINOS": true,
        "CAPITAL SUR": true,
        "CIUDAD MADERAS": true,
        "CIUDAD MADERAS MONTAÑA": true,
        "COLINAS DE LA PIEDAD": true,
        "COLORILANDIA": true,
        "CUMBRES DE CONÍN": true,
        "CUMBRES DE CONÍN TERCERA SECCIÓN": true,
        "DEL PARQUE RESIDENCIAL": true,
        "EL CARMEN": true,
        "EL DURAZNO": true,
        "EL MIRADOR": true,
        "EL ORGANAL": true,
        "EL ROSARIO": true,
        "EURO BUSINESS (PARQUE INDUSTRIAL)": true,
        "GENERAL LÁZARO CÁRDENAS (EL COLORADO)": true,
        "LA CAÑADA": true,
        "LA PIEDAD (SAN MIGUEL COLORADO)": true,
        "LOMA DE LA CRUZ": true,
        "LUCEPOLIS": true,
        "MAGADI RESIDENCIAL": true,
        "MALLORCA RESIDENCE": true,
        "MASCARDI RESIDENCIAL": true,
        "MELISSANI RESIDENCIAL": true,
        "MONTE DE LA CALAVERA": true,
        "PARQUE INDUSTRIAL BERNARDO QUINTANA": true,
        "PARQUE INDUSTRIAL EL MARQUÉS": true,
        "PARQUE INDUSTRIAL FINSA QUERÉTARO": true,
        "PARQUE INDUSTRIAL LA NORIA": true,
        "PARQUE TECNOLÓGICO INNOVACIÓN QUERÉTARO": true,
        "PIAMONTE": true,
        "PROVENZA RESIDENCIAL": true,
        "REAL SOLARE": true,
        "RIMACHI": true,
        "RINCONADA DEL PEDREGAL": true,
        "RINCONES DEL MARQUES": true,
        "SAN CRISTOBAL (EL COLORADO)": true,
        "SAN ISIDRO MIRANDA": true,
        "SEGUNDO BARRIO DE DOLORES": true,
        "SENDAS RESIDENCIAL": true,
        "VILLA CATANIA": true,
        "VILLAS DE SAN JOSÉ (AMPLIACIÓN LA PIEDAD)": true,
        "VILLAS LA PIEDAD": true,
        "VIZCAYA PARQUE RESIDENCIAL": true,
        "ZEN HOUSE": true,
        "ZEN HOUSE II": true,
        "ZEN LIFE RESIDENCIAL I": true,
        "ZEN LIFE RESIDENCIAL II": true
      }
    },
    "QUERÉTARO": {
      "76000": {
        "CENTRO": true,
        "LA CRUZ": true,
        "MARIANO ESCOBEDO": true,
        "RINCONADA DE MORELOS": true,
        "RINCÓN DE SAN ANDRÉS": true,
        "SAN JOSÉ INN": true,
        "VICENTE GUERRERO": true
      },
      "76010": {
        "LAS CAMPANAS": true,
        "NIÑOS HÉROES": true
      },
      "76017": {
        "CENTRO UNIVERSITARIO (U.A.Q.)": true
      },
      "76020": {
        "BOSQUES DEL ACUEDUCTO": true,
        "CALESA": true,
        "DILIGENCIAS": true,
        "EL CORTIJO": true,
        "JARDINES DE QUERÉTARO": true,
        "LA CRUZ": true,
        "PATHÉ": true,
        "SAN JAVIER": true
      },
      "76024": {
        "CALESA 2A SECCIÓN": true,
        "DEL RÍO": true,
        "EL CORTIJO": true,
        "EL CORTIJO II": true,
        "EL OASIS": true,
        "KARINA": true,
        "LA PEÑITA": true,
        "SEMINARIO": true,
        "VILLA LOS ARCOS": true
      },
      "76025": {
        "LA PASTORA": true
      },
      "76026": {
        "GOYENECHE": true
      },
      "76027": {
        "ARBOLEDAS DEL RÍO": true
      },
      "76028": {
        "UNIVERSIDAD": true
      },
      "76030": {
        "CASA BLANCA": true,
        "CIMATARIO": true,
        "EL CARRIZAL": true,
        "EL PRADO": true,
        "ESTRELLA": true,
        "LAS FUENTES": true,
        "LAS MISIONES": true,
        "MODERNA": true,
        "SAN ÁNGEL": true
      },
      "76036": {
        "RINCONADA FRAY JUAN": true
      },
      "76037": {
        "MARIANO DE LAS CASAS": true
      },
      "76040": {
        "ALAMEDA": true,
        "ANDALUCÍA": true,
        "ARAGÓN": true,
        "LAS PALMAS": true,
        "MERCURIO": true,
        "OBSERVATORIO": true,
        "PANAMERICANO": true,
        "VALLE ALAMEDA": true,
        "VILLAS DEL SUR": true
      },
      "76046": {
        "EL LAUREL": true,
        "PANORÁMICO": true,
        "VILLAS DEL SOL": true
      },
      "76047": {
        "EL MARQUÉS": true,
        "QUINTAS DEL MARQUÉS": true
      },
      "76048": {
        "ARQUITOS": true
      },
      "76049": {
        "LOMA BONITA": true
      },
      "76050": {
        "CARRETAS": true
      },
      "76057": {
        "HIDALGO": true
      },
      "76058": {
        "SAN FRANCISQUITO": true
      },
      "76059": {
        "PLAZA DE LAS AMÉRICAS": true
      },
      "76060": {
        "CUMBRES DEL MIRADOR": true,
        "LOMA DORADA": true,
        "MILENIO III": true,
        "SÁMARA HABITAT": true,
        "VISTA DORADA": true
      },
      "76063": {
        "CUESTA BONITA": true,
        "LA VIRGEN": true,
        "PEDREGAL DE VISTA HERMOSA": true,
        "VILLAS DEL ORIENTE": true,
        "VISTA HERMOSA": true
      },
      "76067": {
        "LA LAGUNA": true
      },
      "76069": {
        "2 DE ABRIL": true,
        "8 DE DICIEMBRE": true,
        "BUGAMBILIAS": true,
        "EL BOSQUE": true,
        "EL LIMONAR": true,
        "HÉRCULES": true,
        "JARDINES DE HÉRCULES": true,
        "LA CUESTA": true,
        "LA ESTACIÓN": true,
        "LA ESTACIÓN 2A. SECCIÓN": true,
        "NUEVO MORELOS": true,
        "SAN JOSÉ DE LOS PERALES": true,
        "TEJAS": true
      },
      "76070": {
        "CONJUNTO TERRANOVA": true,
        "CORREGIDORA (BUROCRATA)": true,
        "EL RETIRO": true,
        "LOMA LINDA": true,
        "PRADOS DEL MIRADOR": true,
        "VISTA": true
      },
      "76074": {
        "LA ALHAMBRA": true,
        "PALOMAR DEL DUQUE": true,
        "VISTA ALEGRE": true,
        "VISTA ALEGRE 2A. SECCIÓN": true,
        "VISTA ALEGRE 3A. SECCIÓN": true
      },
      "76078": {
        "VILLAS VALLE ALAMEDA": true
      },
      "76079": {
        "BALAUSTRADAS": true,
        "QUINTA BALAUSTRADAS": true
      },
      "76080": {
        "LOMAS DE CASA BLANCA": true,
        "PRESIDENTES": true
      },
      "76085": {
        "ALTOS DEL CIMATARIO": true,
        "ARTE MEXICANO": true,
        "AZTECA": true,
        "BOSQUES DEL CIMATARIO": true,
        "COLINAS DEL SUR": true,
        "EL MARQUÉS QUERETANO": true,
        "FRATERNIDAD DE SANTIAGO": true,
        "LA UNIÓN": true,
        "LOMAS DEL CIMATARIO": true,
        "LOMAS DEL VALLE": true,
        "LÁZARO CÁRDENAS III": true,
        "RINCÓN DEL CIMATARIO": true,
        "UNIVERSO 2000": true,
        "VISTAS DEL CIMATARIO": true
      },
      "76086": {
        "REFORMA AGRARIA": true,
        "REFORMA AGRARIA 1A SECCIÓN": true,
        "REFORMA AGRARIA 2A SECC": true,
        "REFORMA AGRARIA 3A SECC": true,
        "REFORMA AGRARIA 4A SECC": true,
        "REFORMA AGRARIA 5A SECC": true
      },
      "76087": {
        "BELLAVISTA": true,
        "BOSQUES DE LAS LOMAS": true,
        "BOSQUES DE QUERÉTARO": true,
        "BOSQUES DEL CIMATARIO 2A. SECCIÓN": true,
        "CAMPESTRE ITALIANA": true,
        "COMERCIANTES": true,
        "CONSTELACIÓN": true,
        "CUITLÁHUAC": true,
        "HUERTAS DEL CIMATARIO": true,
        "JARDINES DEL CIMATARIO": true,
        "LINDEROS DEL CIMATARIO": true,
        "LOMAS DE PASTEUR": true,
        "LÁZARO CÁRDENAS": true,
        "MANANTIALES DEL CIMATARIO": true,
        "MISIÓN CIMATARIO": true,
        "MONTE BLANCO I": true,
        "MONTE BLANCO II": true,
        "MONTE BLANCO III": true,
        "PEDREGAL DEL CIMATARIO": true,
        "PRADERAS DEL SOL": true,
        "PRADOS DE QUERÉTARO": true,
        "PRADOS DEL CIMATARIO": true,
        "RAQUEL TREJO ORTIZ": true,
        "SAN ANDRÉS": true,
        "UNIDAD ROMA": true,
        "VILLAS DEL CIMATARIO": true,
        "VILLAS DEL RINCÓN": true,
        "VISTA AZUL": true,
        "ZAPATA VIVE": true
      },
      "76090": {
        "CENTRO SUR": true,
        "COLINAS DEL CIMATARIO": true
      },
      "76093": {
        "CLAUSTROS DE LA CATEDRAL": true,
        "CLAUSTROS DE LA CORREGIDORA 2": true,
        "CLAUSTROS DE LA CORREGIDORA I": true,
        "CLAUSTROS DE LAS MISIONES": true,
        "CLAUSTROS DE SANTIAGO": true,
        "CLAUSTROS DEL MARQUES": true,
        "CLAUSTROS DEL SUR": true,
        "RESIDENCIAL CENTRO SUR": true,
        "RESIDENCIAL ÁNGELES": true
      },
      "76099": {
        "PLAZAS DEL SOL 1A SECCIÓN": true,
        "PLAZAS DEL SOL 2A SECCIÓN": true,
        "PLAZAS DEL SOL 3A SECCIÓN": true
      },
      "76100": {
        "ATENAS": true,
        "BLEU": true,
        "DOLCE TERRA": true,
        "EL BORDO": true,
        "EL DESTINO": true,
        "GOBERNANTES": true,
        "HACIENDA JURIQUILLA SANTA FE": true,
        "JURICA": true,
        "JURICA PINAR": true,
        "LA CASTELLANA": true,
        "LAS CAMPANAS": true,
        "MURANO": true,
        "PRIVADA DE LOS PORTONES": true,
        "Q HOME VALLEY": true,
        "RINCONADA JURICA": true,
        "VALLE DE FRESNOS": true,
        "VALLE DE JURIQUILLA": true,
        "VIVE": true
      },
      "76110": {
        "AMPLIACIÓN SATÉLITE": true,
        "COSMOS (SATELITE)": true,
        "JOSEFA ORTIZ DE DOMÍNGUEZ II": true,
        "JOSEFA ORTIZ DE DOMÍNGUEZ III": true,
        "LOMAS DE SATÉLITE": true,
        "SATÉLITE": true,
        "SATÉLITE SECCIÓN ANDADORES": true,
        "SATÉLITE SECCIÓN CONDOMINIOS": true
      },
      "76113": {
        "ALBORADA": true,
        "BOSQUES DEL SOL": true,
        "EL ARCÁNGEL": true,
        "EL SOL": true,
        "EL SOL RESIDENCIAL": true,
        "LA LUNA": true,
        "LOS FRAMBOYANES": true,
        "PLAN SANTA MARÍA": true,
        "RANCHO SAN PEDRO": true,
        "RINCONADA DEL SOL": true,
        "SANTA ISABEL": true,
        "TONATIUH": true,
        "TONATIUH 2A. SECCIÓN": true,
        "TONATIUH 3A. SECCIÓN": true,
        "TONATIUH 4A. SECCIÓN": true,
        "VALLE DE SAN PEDRO": true,
        "VALLE DE SAN PEDRO 2A SECCIÓN": true
      },
      "76114": {
        "DON MANUEL": true,
        "EL ROCIO II": true,
        "EL ROCÍO": true,
        "LA HUERTA": true,
        "LOMAS DEL CARMEN": true,
        "LOS CASTAÑOS": true,
        "LOS SAUCES": true,
        "PUERTA DEL SOL II": true,
        "SENDERO": true
      },
      "76115": {
        "EL GARAMBULLO": true,
        "PARQUE SANTIAGO": true
      },
      "76116": {
        "25 DE DICIEMBRE": true,
        "AMPLIACIÓN PATRIA NUEVA": true,
        "BENITO JUÁREZ": true,
        "BUGAMBILIAS RESIDENCIAL": true,
        "CERRITO COLORADO": true,
        "CERRITO COLORADO II": true,
        "CERRITO COLORADO III": true,
        "CERRITO COLORADO IV": true,
        "CERRITO COLORADO V": true,
        "CERRITO COLORADO VI": true,
        "CERRITO COLORADO VII": true,
        "CHE GUEVARA (AXAYACATL)": true,
        "CHULA VISTA I": true,
        "CHULA VISTA II": true,
        "CIUDAD DEL SOL": true,
        "CIUDAD DEL SOL SECCIÓN VALLE DE SANTIAGO": true,
        "COLINAS DEL PONIENTE": true,
        "EUCALIPTOS": true,
        "EX-HACIENDA SANTANA": true,
        "GEO PLAZAS": true,
        "GEO VILLAS": true,
        "JARDINES DE AZUCENAS": true,
        "JOSEFA ORTIZ DE DOMÍNGUEZ IV": true,
        "LA CORDILLERA": true,
        "LA FLORESTA": true,
        "LA LOMA": true,
        "LA PEÑA": true,
        "LAS AZUCENAS": true,
        "LAS CAMELINAS": true,
        "LOMA IX": true,
        "LOMA REAL": true,
        "LOMAS DE SAN ÁNGEL": true,
        "LOS ENCINOS": true,
        "MISIÓN DE CARRILLO": true,
        "MISIÓN DE CARRILLO II": true,
        "MISIÓN DEL PARQUE RESIDENCIAL": true,
        "PATRIA NUEVA": true,
        "PLAZA IKAL": true,
        "PRADOS DEL RINCÓN 2A. SECCIÓN": true,
        "PUERTA DEL SOL": true,
        "PUERTA NAVARRA": true,
        "QUERENA": true,
        "REAL DE LA LOMA": true,
        "RINCONADA DE LAS FUENTES": true,
        "RINCONADA DEL CERRITO": true,
        "ROCIO SANZ": true,
        "SIERRA COLORADA": true,
        "TENOCHTITLÁN": true,
        "TENOCHTITLÁN II": true,
        "TEOTIHUACAN": true,
        "VILLAS DE GUADALUPE": true,
        "VISTAS DEL VALLE": true
      },
      "76117": {
        "CENTENARIO": true,
        "COLINAS DE SANTA CRUZ 1A SECCIÓN": true,
        "COLINAS DE SANTA CRUZ 2A SECCIÓN": true,
        "COMEVI": true,
        "DESARROLLO FAMILIAR": true,
        "FERNANDO DE TAPIA": true,
        "FRANCISCO JAVIER MINA": true,
        "FUNDADORES": true,
        "INSURGENTES": true,
        "JARDÍNES DEL SOL": true,
        "LA ESMERALDA": true,
        "LADERAS DE SAN PEDRO": true,
        "MISIÓN FUNDADORES": true,
        "PEDREGAL DE BUENOS AIRES": true,
        "PRADOS DEL RINCÓN": true,
        "RUBÉN JARAMILLO": true,
        "SAN MARCOS": true,
        "SAN MARCOS I": true,
        "SAN PEDRO MÁRTIR": true
      },
      "76118": {
        "10 DE ABRIL": true,
        "15 DE MAYO": true,
        "5 DE FEBRERO": true,
        "EDUARDO LOARCA CASTILLO": true,
        "EL ROMERILLAL": true,
        "EL TEPEYAC": true,
        "FRANCISCO VILLA I": true,
        "FRANCISCO VILLA II": true,
        "HACIENDA MOMPANÍ": true,
        "INDEPENDENCIA": true,
        "JARDINES DE JURICA": true,
        "KATZURA": true,
        "LEYES DE REFORMA": true,
        "LIBERTADORES": true,
        "LOMA BONITA": true,
        "LOMAS DEL PEDREGAL 2A. SECCIÓN": true,
        "LUIS DONALDO COLOSIO": true,
        "MIGUEL HIDALGO": true,
        "MONTE ALBÁN": true,
        "MONTE VERDE": true,
        "MONTE VESUBIO": true,
        "MORELOS": true,
        "PARAÍSO": true,
        "PASEOS DE SAN MIGUEL": true,
        "PRADOS DE LOMA BONITA": true,
        "REAL DEL MARQUES RESIDENCIAL": true,
        "REVOLUCIÓN": true,
        "ROSENDO SALAZAR": true,
        "SAN MIGUEL": true,
        "VILLAS DE SAN MIGUEL": true
      },
      "76120": {
        "BENITO JUÁREZ": true,
        "SANTIAGO": true
      },
      "76121": {
        "ALTOS DE SAN PABLO": true,
        "CONQUISTADORES": true,
        "FELIPE ÁNGELES": true,
        "LA ESPERANZA": true,
        "LAS AMÉRICAS": true,
        "LAS AMÉRICAS SAN PABLO": true,
        "MOVIMIENTO OBRERO": true,
        "NUEVA ESPERANZA": true,
        "PUESTA DEL SOL": true,
        "SAN PABLO III (INFONAVIT)": true,
        "SAN PABLO IV (INFONAVIT)": true,
        "TLANESE": true
      },
      "76125": {
        "BALCONES DE SAN PABLO": true,
        "BELLAVISTA": true,
        "CIPRESES": true,
        "DESARROLLO SAN PABLO": true,
        "DESARROLLO SAN PABLO I": true,
        "DESARROLLO SAN PABLO II": true,
        "DESARROLLO SAN ÁNGEL": true,
        "FOVISSSTE SAN PABLO I": true,
        "FOVISSSTE SAN PABLO II": true,
        "JARDINES DE ALBORADA": true,
        "JOSÉ MARÍA BUSTAMANTE": true,
        "LA CONDESA": true,
        "LATINOAMERICANA": true,
        "LOMAS DE SAN PABLO": true,
        "LOMAS DEL MIRADOR": true,
        "LOS ROBLES": true,
        "MARGARITAS": true,
        "MISIÓN BUCARELI SUR": true,
        "NUEVO HORIZONTE": true,
        "PROYECCIÓN 2000": true,
        "PUNTA SAN CARLOS": true,
        "RIVERA Y TAMAYO": true,
        "SAN PABLO": true,
        "SAN PABLO I (INFONAVIT)": true,
        "SAN PABLO II (INFONAVIT)": true,
        "SERGIO VILLASEÑOR": true,
        "TERRAZAS DE SAN PABLO": true,
        "VALLE DE SAN PABLO": true
      },
      "76127": {
        "ARCO DE PIEDRA": true,
        "CUITLÁHUAC": true,
        "EL SALITRE": true,
        "LOMAS DEL SALITRE": true,
        "PALMARES": true,
        "PARQUE INDUSTRIAL JURICA": true,
        "RAQUET CLUB": true
      },
      "76130": {
        "INDUSTRIAL": true,
        "OBRERA": true
      },
      "76134": {
        "AMPOLLETAS": true,
        "EL MIRADOR": true,
        "EL TINTERO": true,
        "EL TINTERO DOS (LAS MARGARITAS)": true,
        "NUEVO CARRILLO": true,
        "PLUTARCO ELÍAS CALLES": true,
        "PRIVADA BELLAVISTA": true,
        "RANCHO BELLAVISTA": true,
        "SAN SEBASTIÁN": true,
        "SANTA MÓNICA": true,
        "SOLIDARIDAD 90": true,
        "VILLAS DEL TULE": true
      },
      "76135": {
        "5 DE FEBRERO": true,
        "CUARTEL GENERAL 17/A": true,
        "LAS FLORES": true,
        "SAN ANTONIO DE LA PUNTA": true,
        "SANTO NIÑO": true
      },
      "76136": {
        "JOSÉ MARÍA ARTEAGA": true
      },
      "76137": {
        "DEL VALLE": true,
        "EL CHAMIZAL": true,
        "FERROCARRILES SECCIÓN RINCONADA SANTA ANITA": true,
        "FUENTES RESIDENCIAL": true,
        "JARDINES DEL VALLE": true,
        "LA AURORA": true,
        "LA SIERRITA": true,
        "SAN ANTONIO DEL MAUREL": true,
        "SAN JOSÉ 2A SECCIÓN": true,
        "SANTA MAGDALENA": true,
        "SANTA MARÍA MAGDALENA": true
      },
      "76138": {
        "EL ARCO": true,
        "EL HIGO": true,
        "EL PROGRESO": true,
        "EL TINTERO": true,
        "FELIPE CARRILLO PUERTO": true,
        "LAS TERESAS": true,
        "LUIS DONALDO COLOSIO": true,
        "RINCONADA ZIMAPÁN": true,
        "SANTA MÓNICA 1A SECCIÓN": true,
        "SANTA MÓNICA 2A SECC": true,
        "VALLE DEL MEZQUITAL": true,
        "VILLAS DE SANTA MÓNICA": true
      },
      "76139": {
        "CARRILLO": true,
        "LA HIGUERA": true,
        "LOS LAURELES": true,
        "LOS TABACHINES": true,
        "MANUEL JURADO": true,
        "SAN DIEGO": true,
        "SAN JOSÉ": true
      },
      "76140": {
        "ARBOLEDAS": true,
        "ARBOLEDAS DEL PARQUE": true,
        "BALCONES COLONIALES": true,
        "CEDROS ALCATRACES": true,
        "CEDROS TILIPANES": true,
        "COLINAS DEL PARQUE": true,
        "LAS PLAZAS": true,
        "PARQUE QUERÉTARO 2000": true,
        "PRIVADA ARBOLEDAS": true,
        "SAN PEDRITO PEÑUELAS": true,
        "VILLAS DEL PARQUE": true,
        "VISTA 2000": true,
        "VIVEROS RESIDENCIAL": true,
        "ÁLAMOS DEL LAGO": true
      },
      "76144": {
        "BALCONES DEL ACUEDUCTO": true,
        "BOLAÑOS": true,
        "EL PEDREGAL DE QUERÉTARO": true,
        "PUERTA DEL CIELO": true,
        "RANCHO SAN ANTONIO": true
      },
      "76146": {
        "ALTOS DEL MARQUÉS": true,
        "BOLAÑOS": true,
        "EL CAMPANARIO": true,
        "LA CIMA": true,
        "LA ESPIGA": true,
        "LA PURÍSIMA": true,
        "LA VISTA RESIDENCIAL": true,
        "LOMAS DEL CAMPANARIO II": true,
        "LOMAS DEL CAMPANARIO III": true,
        "LOMAS DEL MARQUÉS": true,
        "MIRADORES DEL MARQUES": true,
        "PASEO SAN JUNÍPERO": true,
        "RESIDENCIAL EL REFUGIO": true,
        "VILLAS PALMIRA": true
      },
      "76147": {
        "ANTORCHISTA": true,
        "BUENOS AIRES": true,
        "CINCO HALCONES": true,
        "COLINAS DE MENCHACA": true,
        "COLINAS DE MENCHACA 2A SECCIÓN": true,
        "CONSTITUYENTES": true,
        "CUAUHTÉMOC": true,
        "DIANA LAURA ROJAS": true,
        "EJIDO MENCHACA (LOS PINOS)": true,
        "EL ARCÁNGEL (LA GUAYINA)": true,
        "ENRIQUE BURGOS (LA RINCONADA)": true,
        "EPIGMENIO GONZÁLEZ (EL OASIS)": true,
        "FRAY JUNÍPERO SERRA": true,
        "GENERACIÓN 2000": true,
        "IGNACIO PÉREZ": true,
        "INDEPENDENCIA": true,
        "JARDINES DE SAN JOSÉ": true,
        "JARDINES DE SAN JOSÉ 2A. SECCIÓN": true,
        "JARDINES DE SAN JOSÉ 3A. SECCIÓN": true,
        "LA CANTERA": true,
        "LA LADERA": true,
        "LA LADERA (MENCHACA III)": true,
        "LA TINAJA": true,
        "LAS FUENTES": true,
        "LIBERTADORES DE AMÉRICA": true,
        "LIC. ALFREDO ESTRADA ROMERO": true,
        "LOMAS DE MENCHACA": true,
        "LOMAS DE SAN JOSÉ": true,
        "LOMAS DE SAN MIGUEL": true,
        "LOS ARROYITOS": true,
        "LOS HUERTOS": true,
        "MENCHACA I": true,
        "MENCHACA II": true,
        "MENCHACA III": true,
        "MONARCA": true,
        "MUJERES INDEPENDIENTES": true,
        "NUEVA CREACIÓN": true,
        "NUEVO MENCHACA": true,
        "OASIS": true,
        "PALMAS DE SAN JOSÉ": true,
        "PEDREGAL DE SAN JOSÉ": true,
        "PRIVALIA AMBIENTA": true,
        "RANCHO MENCHACA": true,
        "RANCHO MENCHACA (EX-HACIENDA MENCHACA)": true,
        "RANCHO QUEMADO": true,
        "REAL DE ESPAÑA": true,
        "RENACIMIENTO": true,
        "RINCONADA LAS JOYAS": true,
        "SAN FELIPE": true,
        "SAN JOSÉ EL ALTO": true,
        "SAN ÁNGEL": true,
        "SANTA FÉ": true,
        "VALLES DE SAN JOSÉ": true,
        "VICTORIA POPULAR": true,
        "VILLAS DE SAN JOSÉ": true,
        "VISTANA": true
      },
      "76148": {
        "ALAMEDA RESIDENCIAL": true,
        "AMALIA SOLÓRZANO": true,
        "AMPLIACIÓN AMALIA SOLÓRZANO": true,
        "ANEXO A LA ECÓLOGIA": true,
        "BELÉN": true,
        "BOSQUES DE BUENAVISTA": true,
        "BOSQUES DE ITURBIDE": true,
        "BOSQUES DE LA HACIENDA": true,
        "COLINAS DE SAN PABLO": true,
        "CUESTA AZUL": true,
        "DESARROLLO CENTRO NORTE": true,
        "EL CASTAÑO": true,
        "EL CASTAÑO II": true,
        "EL PARQUE": true,
        "EL VERGEL": true,
        "EURÍPIDES": true,
        "JARDINES DE SANTIAGO": true,
        "JARDINES DE VILLAS DE SANTIAGO": true,
        "LA LADERA": true,
        "LA RUECA": true,
        "LIBERTAD": true,
        "LOMAS DE SAN PEDRITO": true,
        "LOMAS DE SAN PEDRITO (SECCIÓN PORTALES)": true,
        "LOS CIRUELOS": true,
        "LOS PADILLA": true,
        "LOS SABINOS": true,
        "MALLORCA": true,
        "MIRADOR SAN XAVIER": true,
        "MISIÓN BUCARELI NORTE": true,
        "MISIÓN RIVIERA": true,
        "NUEVA ESPERANZA": true,
        "NUEVO SAN PEDRITO": true,
        "ORIÓN": true,
        "PASEOS DE LA CUESTA": true,
        "PASEOS DEL PEDREGAL": true,
        "PEÑUELAS": true,
        "PUERTA DE BELÉN": true,
        "REFORMA AGRARIA RADICAL": true,
        "RICARDO FLORES MAGÓN": true,
        "RINCONES DEL PARQUE": true,
        "SAN PEDRITO ECOLÓGICO": true,
        "SAN PEDRITO LOS ARCOS": true,
        "SAN PEDRITO PEÑUELAS I": true,
        "SAN PEDRITO PEÑUELAS II": true,
        "SAN PEDRITO PEÑUELAS III": true,
        "SAN PEDRITO PEÑUELAS IV": true,
        "UNIDAD NACIONAL": true,
        "VALLE DE SAN PEDRITO PEÑUELAS": true,
        "VILLAS DE SANTIAGO": true,
        "VILLAS FONTANA": true
      },
      "76149": {
        "MISIÓN DE CONCÁ": true,
        "MISIÓN SAN JERÓNIMO": true
      },
      "76150": {
        "ASALIAS": true,
        "BUGAMBILIAS": true,
        "CONSTITUYENTES FOVISSSTE": true,
        "EL FÉNIX": true,
        "FELIPE ÁNGELES": true,
        "GÉMINIS": true,
        "LA ERA": true,
        "LA ESTACIÓN F.F.C.C.": true,
        "LA FLORIDA": true,
        "LA PIEDAD": true,
        "LA POPULAR": true,
        "LAS PALOMAS": true,
        "LOS ALCANFORES": true,
        "LOS FRESNOS": true,
        "LOS MOLINOS": true,
        "LOS VITRALES": true,
        "MOLINOS DE LA ERA": true,
        "PARQUE INDUSTRIAL LA MONTAÑA": true,
        "RINCONADA LOS PIRULES": true,
        "RINCONADA SAN JOSÉ": true,
        "SAN PABLO TECNOLÓGICO": true,
        "SAN ROQUE": true,
        "SAUCES": true,
        "TECNOLÓGICO 2000": true,
        "VILLAS TECNOLÓGICO": true
      },
      "76154": {
        "EL RETABLO": true
      },
      "76155": {
        "VIVEROS DE QUERÉTARO": true
      },
      "76156": {
        "CONSTITUYENTES DE 1824": true,
        "LOS ALCANFORES SECCIÓN NORTE": true,
        "LOS EUCALIPTOS": true,
        "SAN GREGORIO": true
      },
      "76157": {
        "SANTA CATARINA": true
      },
      "76158": {
        "CONJUNTO VICTORIA": true,
        "DEPARTAMENTAL PARQUES": true,
        "EL PORVENIR": true,
        "ESPAÑA": true,
        "LAS PEÑAS": true,
        "LAS PEÑITAS": true,
        "LOS FAROLES": true,
        "PARQUES": true,
        "PRADOS DEL TECNOLÓGICO": true,
        "REAL DEL PARQUE": true,
        "TECNOLÓGICO": true
      },
      "76159": {
        "5 DE FEBRERO": true,
        "BALCÓN CAMPESTRE": true,
        "FRESNOS": true,
        "LA CIMA": true,
        "LOS GIRASOLES": true,
        "QUERÉTARO": true,
        "REAL DE SAN PABLO": true,
        "REAL JURICA": true,
        "RINCONADA SAN JOAQUÍN": true,
        "SAN PABLO": true
      },
      "76160": {
        "EL CERRITO": true,
        "EL TEPETATE": true,
        "LAS BRUJAS": true,
        "LAS HADAS": true,
        "MONTECARLO": true,
        "PRIVADA BUGAMBILIAS": true,
        "RESIDENCIAL PARQUE DEL ÁLAMO": true,
        "RINCONADA DE LOS ALAMOS": true,
        "ROMY": true,
        "ÁLAMOS 1A SECCIÓN": true,
        "ÁLAMOS 2A SECCIÓN": true,
        "ÁLAMOS 3A SECCIÓN": true
      },
      "76164": {
        "LAS ROSAS": true,
        "NACOZARI": true
      },
      "76165": {
        "GUADALUPE VICTORIA (SAHOP)": true,
        "LOS CEDROS": true,
        "LOS CLAUSTROS": true,
        "MARGARITAS": true,
        "SAN SEBASTIÁN": true
      },
      "76166": {
        "LA TRINIDAD": true
      },
      "76168": {
        "CLAUSTROS DEL PARQUE": true,
        "INDUSTRIA DEL HIERRO": true,
        "JACARANDAS": true,
        "LAS GEMAS": true,
        "LINDAVISTA": true,
        "LOMAS DE LINDAVISTA": true,
        "MEGA PLAZA": true,
        "QUINTA LA LABORCILLA": true,
        "RESIDENCIAL BOSQUES": true
      },
      "76169": {
        "PLAZA BOULEVARES": true,
        "PLAZA DEL PARQUE": true,
        "PRIVADA LA LABORCILLA": true
      },
      "76170": {
        "COLIBRÍ": true,
        "EUCALIPTOS I": true,
        "EUCALIPTOS II": true,
        "EUCALIPTOS III": true,
        "LA CAPILLA": true,
        "LA REJA": true
      },
      "76175": {
        "LOS VIRREYES": true
      },
      "76176": {
        "PRADOS DE LA CAPILLA": true
      },
      "76177": {
        "CAROLINA": true,
        "DEMETRIO VALLEJO": true,
        "FRIDA KAHLO": true,
        "GALINDAS RESIDENCIAL": true,
        "HACIENDA GALINDO": true,
        "LA CARAMBADA": true,
        "MODELO": true,
        "PROVINCIA SANTA ELENA": true,
        "RESIDENCIAL FRONDOSO": true,
        "RESIDENCIAL GEMA": true,
        "RESIDENCIAL LA GLORIA": true,
        "RESIDENCIAL LA TOSCANA": true,
        "RESIDENCIAL VILLA JARDÍN": true,
        "RINCONADA LA CAPILLA": true,
        "VILLAS DE SAN ANTONIO": true
      },
      "76178": {
        "EL ROSARIO": true,
        "ENSUEÑO": true,
        "LA SANDIA": true,
        "RESIDENCIAL LOS ÁNGELES": true,
        "VILLA LAS ARBOLEDAS": true
      },
      "76179": {
        "C.E.A.": true,
        "EL SILLAR": true,
        "QUINTA ALICIA": true,
        "RESIDENCIAL ITALIA": true,
        "SANTIAGO": true
      },
      "76180": {
        "ANÁHUAC": true,
        "EL JACAL": true,
        "JARDINES DE LA HACIENDA": true,
        "LA GRANJA": true,
        "LA JOYA": true,
        "LAS PLAZAS": true,
        "MAGISTERIAL": true,
        "MISIÓN PUNTA LA JOYA": true,
        "ORQUÍDEAS": true,
        "PLAZA EUGENIA": true
      },
      "76185": {
        "CLAUSTROS DEL CAMPESTRE": true,
        "HACIENDA SAN MIGUEL": true,
        "MANSIONES DEL VALLE": true
      },
      "76190": {
        "CLUB CAMPESTRE": true,
        "DEL VALLE": true,
        "LOMAS DE QUERÉTARO": true,
        "LOS PILARES": true,
        "RINCÓN DE SAN ANTONIO": true
      },
      "76197": {
        "FIDEL VELÁZQUEZ SÁNCHEZ": true
      },
      "76199": {
        "PRADOS DEL CAMPESTRE": true
      },
      "76212": {
        "EL RINCÓN DE OJO DE AGUA": true
      },
      "76215": {
        "JOFRE": true
      },
      "76220": {
        "MONTENEGRO": true
      },
      "76223": {
        "PINTILLO": true
      },
      "76225": {
        "BUENAVISTA": true
      },
      "76226": {
        "ACEQUIA BLANCA": true,
        "CAMPESTRE JURIQUILLA": true,
        "CUADRILLA JURIQUILLA": true,
        "ECOLÓGICO LA RICA": true,
        "GRAND JURIQUILLA": true,
        "GRAND PRESERVE": true,
        "JURICA MISIONES": true,
        "JURIQUILLA": true,
        "LOMA JURIQUILLA": true,
        "LOMAS DE JURIQUILLA": true,
        "LOMAS DE SAN ISIDRO": true,
        "REAL DE JURIQUILLA": true,
        "REAL DE JURIQUILLA PRADOS": true,
        "RINCÓN DEL LAGO": true,
        "SAN ISIDRO": true,
        "SAN JOSÉ BUENAVISTA": true,
        "VILLAS DEL MESÓN": true
      },
      "76227": {
        "CERRO PRIETO": true
      },
      "76229": {
        "EL PIE": true
      },
      "76230": {
        "ALTAVISTA JURIQUILLA": true,
        "ALTOS JURIQUILLA": true,
        "AZTECA": true,
        "BALCONES DE JURIQUILLA": true,
        "CALETTO": true,
        "COLINAS DE JURIQUILLA": true,
        "CUMBRES DE JURIQUILLA": true,
        "CUMBRES DEL LAGO": true,
        "HACIENDA GRANDE": true,
        "INDEPENDENCIA": true,
        "JURICA ACUEDUCTO": true,
        "JURICA LA SOLANA": true,
        "JURICA TOLIMÁN": true,
        "JURIQUILLA LA CONDESA": true,
        "JURIQUILLA PRIVADA": true,
        "JURIQUILLA SANTA FE": true,
        "LA CAÑADA JURIQUILLA": true,
        "LA SOLANA": true,
        "LOS NARANJOS": true,
        "MAYORAL": true,
        "NUEVO JURIQUILLA": true,
        "NUEVO PARAÍSO": true,
        "PARAÍSO DIAMANTE": true,
        "PASEO DEL PIROPO": true,
        "PUNTA JURIQUILLA": true,
        "RANCHO LARGO": true,
        "RINCONADA SANTINI": true,
        "SAN FRANCISCO JURIQUILLA": true
      },
      "76233": {
        "SANTA ROSA DE JAUREGUI": true
      },
      "76235": {
        "CAMPESTRE HUERTAS LA JOYA": true,
        "EL RINCÓN": true,
        "LOS VIÑEDOS": true,
        "PUERTA VERONA": true,
        "SANTA MARÍA DE LOS REYES": true,
        "SONTERRA": true,
        "TRES CANTOS RESIDENCIAL": true
      },
      "76237": {
        "SAN PEDRITO EL ALTO (EL OBRAJE)": true
      },
      "76238": {
        "LAS ÁGUILAS": true,
        "NUEVO HORIZONTE": true,
        "PRADOS DE MIRANDA": true,
        "PRADOS DEL MIRADOR (CUESTA CHINA)": true,
        "SANTA JUANITA MIRANDA": true
      }
    }
  },
  "SAN LUIS POTOSI": {
    "SAN LUIS POTOSÍ": {
      "78000": {
        "SAN LUIS POTOSÍ CENTRO": true
      },
      "78037": {
        "CERRADA TLAXCALA": true,
        "LA PAZ": true
      },
      "78038": {
        "PRIVADA CARACOL": true,
        "TLAXCALA": true
      },
      "78040": {
        "HIDALGO": true
      },
      "78048": {
        "COLONIA JUAN ALVAREZ": true
      },
      "78049": {
        "COLONIAL HUERTA REAL": true,
        "CONJUNTO PEDRO MORENO": true,
        "FRESNOS DEL RÍO": true,
        "JUAN ÁLVAREZ": true,
        "PRIVADA ALTAMIRANO": true,
        "PRIVADA EL CAMPANARIO": true,
        "PRIVADA RESIDENCIAL REAL DE ÁLVAREZ": true,
        "RESIDENCIAL LAS MORAS": true,
        "RIBERA DE SANTIAGO": true,
        "RINCONADA DE SANTIAGO": true,
        "RINCONADA SAN JUAN": true,
        "SANTIAGO DEL RÍO": true,
        "VILLAS DE PEDRO MORENO": true
      },
      "78100": {
        "ALBEA": true,
        "ARBOLEDAS TANGAMANGA": true,
        "BARRIO VERGEL": true,
        "CAMPESINA": true,
        "CERCA DEL CIELO": true,
        "COMPOSTELA": true,
        "COMPOSTELA II": true,
        "EL MILAGRO": true,
        "EL OASIS": true,
        "HUACHICHILES": true,
        "LOS ALCATRACES": true,
        "LOS MAGUEYES": true,
        "LOS PUERTOS": true,
        "LOS TULES": true,
        "LUIS CÓRDOVA REYES": true,
        "MATAMOROS": true,
        "MOLINOS DEL REY": true,
        "MÁRTIRES DE LA REVOLUCIÓN": true,
        "MÁRTIRES DE RÍO BLANCO": true,
        "NUEVA CREACIÓN": true,
        "REAL DE PEÑASCO": true,
        "RINCONADA DE LOS MAGUEYES": true,
        "RINCÓN VERDE": true,
        "RUBÉN JARAMILLO": true,
        "TERCERA CHICA": true,
        "TORREMOLINOS": true,
        "TORREMOLINOS DOS": true,
        "TORRES DE SAN FRANCISCO": true,
        "VALLE SAN JOSÉ": true,
        "VILLA ESPERANZA": true,
        "VILLA FONTANA": true,
        "VILLA MARÍA": true,
        "ÁRBOL DEL GALLO": true
      },
      "78106": {
        "LA MOREÑA": true
      },
      "78107": {
        "GARITA DE SALTILLO": true,
        "LA TUNA": true
      },
      "78109": {
        "JARDINES DEL RÍO": true,
        "LAS FLORES": true,
        "LOS GIRASOLES": true,
        "VILLA DE LAS FLORES": true
      },
      "78110": {
        "CAMINO REAL": true,
        "CERRADA LOS ÁNGELES": true,
        "DIVISIÓN DEL NORTE": true,
        "EL SAUCITO": true,
        "EULALIO GUTIÉRREZ": true,
        "IMPERIO AZTECA": true,
        "MARÍA AMELIA": true,
        "SAN ARTURO": true,
        "VILLAS DEL ROBLE": true,
        "VIVE RESIDENCIAL": true
      },
      "78115": {
        "COLONIA SANTA ROSA": true
      },
      "78116": {
        "DEL SAUCE": true,
        "EL SAUZALITE": true,
        "EL SAUZALITO": true,
        "JARDINES DEL SAUZAL": true,
        "PRIVADA SAN ANGELÍN": true,
        "RANCHO LA CRUZ": true,
        "RESIDENCIAL SAUZALITO": true,
        "RINCONADAS": true,
        "SALAZARES": true,
        "SAN ANGELÍN": true,
        "SAN ANGELÍN II": true,
        "SAN FERNANDO": true,
        "SANTA ROSA": true,
        "VILLAS DEL SAUCITO": true,
        "VILLAS DEL SAUZALITO": true
      },
      "78117": {
        "EL ARENAL": true,
        "EL TABACAL": true,
        "GEOVILLAS DE SAN LUIS": true,
        "GRANJAS LA ESTRELLA": true,
        "JARDINES DE MARÍA CECILIA": true,
        "LA ANGOSTURA": true,
        "LOS PINOS": true,
        "MARAVILLAS": true,
        "MARÍA CECILIA": true,
        "MARÍA CECILIA NORTE": true,
        "PLAN PONCIANO ARRIAGA": true,
        "PRIVADA MARÍA CECILIA": true,
        "PUNTA DEL VALLE": true,
        "RINCONADAS DE MARÍA CECILIA": true,
        "SAN ANGELÍN III": true,
        "SANTA ROSALÍA": true,
        "VILLA DE LAS FLORES II": true,
        "VILLAS DE SANTIAGO": true,
        "VILLAS DEL AJUSCO": true,
        "VILLAS DEL SAUCE": true
      },
      "78120": {
        "CONDADO DEL SAUZAL": true,
        "EL ROSEDAL": true,
        "FUENTES DEL SAUCE": true,
        "HIDALGO": true,
        "LA FORESTAL": true,
        "LAS BRISAS": true,
        "LAS FUENTES CONJUNTO HABITACIONAL": true,
        "LOS LIMONES": true,
        "MEDITERRÁNEA RESIDENCIAL": true,
        "PRIVADA VISTA HERMOSA": true,
        "PRIVADA VISTA REAL": true,
        "RESIDENCIAL VILLERÍAS": true,
        "SAN ÁNGEL": true,
        "VILLAS DEL ROSEDAL": true,
        "WENCESLAO VICTORIA": true
      },
      "78130": {
        "ARBOLEDAS DE JACARANDAS": true,
        "ARGENTA": true,
        "BUENOS AIRES": true,
        "EL MEZQUITAL": true,
        "HACIENDA DE JUAN PABLO": true,
        "HACIENDAS DEL MEZQUITAL": true,
        "JUAN PABLO": true,
        "LOMAS DEL MEZQUITAL": true,
        "LOS OLIVOS": true,
        "LUIS DONALDO COLOSIO": true,
        "MARTÍNEZ DEL MEZQUITAL": true,
        "MORALES SAUCITO": true,
        "MORELOS": true,
        "PASEO DE LAS ARBOLEDAS II": true,
        "PRIVADA CAMPO REAL": true,
        "RINCONADA DEL MEZQUITAL": true,
        "RURAL ATLAS": true,
        "SAN GERARDO": true,
        "SAN HUMBERTO": true,
        "SAN MIGUEL": true,
        "SONATA RESIDENCIAL": true,
        "VALLE DEL MEZQUITAL": true,
        "VALLE ESCONDIDO": true,
        "VILLAS DEL MEZQUITAL": true,
        "VISTA DEL SOL": true
      },
      "78133": {
        "ALBORADA": true,
        "PASEO DE LAS ARBOLEDAS": true,
        "VILLAS DE BUENOS AIRES I": true,
        "VILLAS DE BUENOS AIRES II": true,
        "VILLAS DE BUENOS AIRES III": true
      },
      "78135": {
        "BOSQUES DE JACARANDAS": true,
        "DIEZ DE ABRIL": true,
        "PRIVADA DEL MOLINO": true,
        "PRIVADA SAN GABRIEL": true,
        "RESIDENCIAL TRES CÁNTAROS": true,
        "RINCONADA MINERVA JACARANDAS": true
      },
      "78136": {
        "CASANOVA": true,
        "HACIENDA DE SANTIAGO": true,
        "JARDINES DE JACARANDAS": true,
        "LA GLORIA RESIDENCIAL": true,
        "LAS JULIAS": true,
        "LOMAS DEL MEZQUITAL SEGUNDA SECCIÓN": true,
        "LOS TULIPANES": true,
        "PRIVADA DEL ARROYO": true,
        "SALINAS DE GORTARI": true,
        "VALLE DE SAN JOAQUÍN": true,
        "VALLE DEL CAMPESTRE": true,
        "VILLAS DE JACARANDAS": true
      },
      "78137": {
        "HACIENDA DE JACARANDAS": true,
        "LA HACIENDA": true,
        "VALLE DEL TECNOLÓGICO": true
      },
      "78140": {
        "INDUSTRIAL AVIACIÓN": true,
        "NORTE": true,
        "RETORNOS": true
      },
      "78143": {
        "ANDALUCÍA": true,
        "CANTERÍAS": true,
        "CIELO RESIDENCIAL IV": true,
        "COLONIAL 20 DE NOVIEMBRE": true,
        "ECUESTRE": true,
        "EL CIELO RESIDENCIAL": true,
        "EL PEÑOL": true,
        "ESPERANZA": true,
        "LAS MORENAS": true,
        "MARÍA BONITA": true,
        "MOCTEZUMA": true,
        "PEDROZA": true,
        "POTOSÍ RÍOVERDE": true,
        "RESIDENCIAL VALLE AZTECA": true,
        "RINCONADAS DEL PARQUE": true,
        "SAN SEBASTIÁN": true,
        "TERCERA GRANDE": true,
        "TERREMOTO": true,
        "VILLAKANO": true,
        "VILLAS DE LA VICTORIA": true,
        "VILLAS DE SAN JOSÉ": true
      },
      "78144": {
        "JARDINES DEL BOSQUE": true,
        "LOMAS DEL RÍO": true,
        "PRIVADA DEL MANANTIAL": true,
        "SANTA INÉS": true,
        "TORRES DE MÉXICO": true,
        "VALLE VERDE": true,
        "VILLAS DEL SAUCITO": true
      },
      "78145": {
        "FRACCIONAMIENTO LOMAS DEL CAMPESTRE": true,
        "UNIDAD HABITACIONAL JACARANDAS INFONAVIT": true
      },
      "78146": {
        "LOMAS DEL CAMINO": true,
        "NARANJOS": true,
        "TECNOLÓGICO": true,
        "VALLE DE JACARANDAS": true
      },
      "78147": {
        "CAMELINAS": true,
        "CONJUNTO RESIDENCIAL LAS PALMAS": true,
        "LOMAS DEL SOL": true,
        "LOS MOLINOS": true,
        "PASEO DE LOS AGAVES": true,
        "RINCONADA LOMAS DEL SOL": true,
        "SAN ALBERTO": true
      },
      "78148": {
        "JACARANDAS": true
      },
      "78150": {
        "FOVISSSTE": true,
        "LAS PIEDRAS": true,
        "MORALES INFONAVIT": true,
        "NUEVO MORALES": true,
        "SANTA LUCÍA": true
      },
      "78153": {
        "ALBINO GARCÍA": true,
        "ARBOLEDAS DEL CAMPESTRE": true,
        "CAMPESTRE DE GOLF": true,
        "CAMPESTRE DE SAN LUIS": true,
        "DEL RÍO": true,
        "EUCALIPTOS CAMPESTRE": true,
        "PRIVADA SAN CARLOS": true,
        "RINCONADA RÍO CAMPESTRE": true,
        "VILLA CAMPESTRE": true
      },
      "78154": {
        "CAMPESTRE MORALES": true,
        "LOMAS DE MORALES": true,
        "LOS PIRULES": true,
        "VERDE CAMPESTRE": true
      },
      "78165": {
        "MUÑOZ": true
      },
      "78170": {
        "AEROPUERTO": true,
        "CALLEJÓN DE LAS FLORES": true,
        "EL CORTIJO": true,
        "LAS PALOMAS": true,
        "LOS REYES": true,
        "LOS REYITOS": true,
        "PEDRO MORENO": true,
        "PRIVADA DEL REY": true,
        "PRIVADA GRANIZO": true,
        "PUENTE DEL RÍO": true,
        "SAN JUAN": true,
        "VILLAS DEL NOGAL": true
      },
      "78173": {
        "INDUSTRIAL AVIACIÓN 2A SECCIÓN": true,
        "PRIVADA DEL BOSQUE": true
      },
      "78174": {
        "DAMIÁN CARMONA": true,
        "GUANOS": true,
        "JUAN DEL JARRO": true,
        "LA ESTACIÓN DEL RÍO": true,
        "LOS VERGELES": true,
        "LOS ÁLAMOS": true,
        "LOS ÁLAMOS I": true,
        "MISIÓN DE SANTIAGO": true,
        "PRIVADA BENITO JUÁREZ": true,
        "PRIVADA LOS ÁNGELES": true,
        "PRIVADA RÍO SANTIAGO": true,
        "PRIVADA SAN MARTÍN": true,
        "SAN GUILLERMO": true,
        "TLÁLOC": true,
        "VILLAS SAN CARLOS": true,
        "VILLAS VICENZA": true
      },
      "78175": {
        "CONDESA": true,
        "HACIENDA DE BRAVO": true,
        "LA MOREÑA": true,
        "MADRIGAL": true,
        "MATEHUALA": true,
        "RINCONADA DE LAS ARBOLEDAS": true,
        "RINCONADA DE LAS FLORES": true
      },
      "78176": {
        "EL CALVARIO": true,
        "MANUEL JOSÉ OTHÓN INFONAVIT": true,
        "PRIVADA JACARANDAS": true,
        "SAN JAVIER": true
      },
      "78177": {
        "GARCÍA DIEGO": true
      },
      "78178": {
        "SAN PEDRO": true
      },
      "78180": {
        "CENTRO LOGÍSTICO IMMSA": true,
        "ENNALT": true,
        "MORALES": true,
        "POLVILLO": true,
        "RESIDENCIAL MORALES": true
      },
      "78183": {
        "ALTO LAGO RESIDENCIAL": true,
        "COTOS EL ÁNGEL": true,
        "HORIZONTES RESIDENCIAL": true,
        "VILLA MAGNA": true
      },
      "78200": {
        "DEL VALLE": true,
        "FUENTES DEL BOSQUE": true,
        "JARDINES DE LA RIVERA": true,
        "RESIDENCIAL EL DORADO": true
      },
      "78209": {
        "EL PARQUE": true
      },
      "78210": {
        "BELLAS LOMAS": true,
        "CUMBRES DE SAN LUIS": true,
        "LOMA ALTA": true,
        "LOMAS PRIMERA SECCIÓN": true,
        "LOMAS SEGUNDA SECCIÓN": true,
        "LOS FILTROS": true
      },
      "78213": {
        "BURÓCRATAS DEL ESTADO": true
      },
      "78214": {
        "LOMA LINDA": true,
        "LOMA VERDE": true,
        "MIRAVALLE": true,
        "PRIVADA PUESTA DEL SOL": true,
        "VILLANTIGUA": true
      },
      "78215": {
        "CLUB DE GOLF LA LOMA": true,
        "LA VISTA": true,
        "LOMA DORADA": true,
        "LOMAS DE CHAULTEPEC": true,
        "LOMAS DEL TECNOLÓGICO": true,
        "MONTERRA": true
      },
      "78216": {
        "LOMAS CUARTA SECCIÓN": true,
        "LOMAS TERCERA SECCIÓN": true,
        "SANTA MÓNICA": true
      },
      "78218": {
        "CONJUNTO VICTORIA": true,
        "LA LOMA": true,
        "LAS HACIENDAS": true,
        "NUEVA RINCONADA DE LOS ANDES": true,
        "RESIDENCIAL PUNTA SAN LUIS": true,
        "RINCONADA DE LOS ANDES": true,
        "VILLAS DEL PEDREGAL": true
      },
      "78219": {
        "LOMAS DE LOS FILTROS": true
      },
      "78220": {
        "BUSQUETA": true,
        "LINDAVISTA": true,
        "POLANCO": true
      },
      "78230": {
        "BUGAMBILIAS": true,
        "HUERTA REAL": true,
        "HUERTA REAL PLUS": true,
        "LA VICTORIA": true,
        "LAS GARZAS": true,
        "LOS ÁNGELES": true,
        "PEDRO MONTOYA": true,
        "VALLE DE SANTIAGO": true,
        "VILLAS DE ANÁHUAC": true,
        "ZACATECAS": true
      },
      "78234": {
        "ARBOLEDA": true
      },
      "78235": {
        "LA HUERTA": true,
        "PRIVADA LAS HUERTAS": true
      },
      "78236": {
        "VISTA VERDE": true
      },
      "78238": {
        "VALLE DE TEQUISQUIAPAN": true
      },
      "78239": {
        "LAS NORIAS": true,
        "SAN RAFAEL": true
      },
      "78240": {
        "AVENIDA": true,
        "VIRREYES": true
      },
      "78250": {
        "ARBOLEDA TEQUIS": true,
        "CAPITÁN CALDERA": true,
        "MARIANO ÁVILA": true,
        "PARQUE ESPAÑA": true,
        "PRIVADA ÁLAMOS": true,
        "RINCONADA VALLE DE BRAVO": true,
        "TEQUISQUIAPAN": true,
        "VALLE DE BRAVO": true,
        "VALLE DE BRAVO II": true,
        "VILLAS VALLARTA": true,
        "VISTA HERMOSA": true
      },
      "78258": {
        "COLONIA LAGO AZUL": true
      },
      "78260": {
        "FORESTA DE TEQUIS": true,
        "LAS ÁGUILAS": true,
        "RINCONADA DE LOS CIPRESES": true
      },
      "78268": {
        "PRADOS DE SAN LUIS": true
      },
      "78269": {
        "TANGAMANGA": true
      },
      "78270": {
        "BURÓCRATA": true,
        "CUAUHTÉMOC": true,
        "FUNDADORES": true,
        "JARDÍN": true,
        "RÍO AZUL": true
      },
      "78280": {
        "ALAMITOS": true,
        "DEL REAL": true,
        "ESTADIO": true,
        "HIMNO NACIONAL": true,
        "ISSSTE": true,
        "JARDINES DEL ESTADIO": true
      },
      "78290": {
        "DOMINO": true,
        "LAS LOMAS": true,
        "UNIVERSITARIA": true,
        "VIVEROS": true
      },
      "78294": {
        "COLINAS DEL PARQUE": true,
        "GARITA DE JALISCO": true,
        "RESIDENCIAL DEL PARQUE": true
      },
      "78295": {
        "ALPES": true,
        "CERRADA DEL PEDREGAL RESIDENCIAL": true,
        "CORDILLERA": true,
        "CUMBRE DEL PEDREGAL": true,
        "DEL ROBLE RESIDENCIAL": true,
        "DESARROLLO DEL PEDREGAL": true,
        "LA HERRADURA": true,
        "LAS TERRAZAS DEL PEDREGAL": true,
        "LOMAS DEL PREDREGAL": true,
        "PRIVADAS DEL PEDREGAL": true,
        "SIERRAZUL RESIDENCIAL": true,
        "VILLALTA RESIDENCIAL": true,
        "VILLANDARES RESIDENCIAL": true,
        "VILLAS DEL MARQUÉS RESIDENCIAL": true
      },
      "78298": {
        "ACACIAS": true
      },
      "78300": {
        "CALABRIA": true,
        "CONSTITUCIÓN (POPULAR)": true,
        "FERROCARRILERA": true,
        "POPULAR": true,
        "VILLA TOSCANA": true
      },
      "78306": {
        "FRACCIONAMIENTO DEPORTIVO FFCC": true
      },
      "78307": {
        "JALAPA": true
      },
      "78308": {
        "ESPAÑA": true
      },
      "78309": {
        "AVANTRAM": true,
        "AVENIDA MÉXICO": true,
        "INDUSTRIAL MEXICANA": true,
        "LA TROJE": true
      },
      "78310": {
        "AZTECA NORTE": true,
        "LIBRADO RIVERA": true,
        "MONTECILLO": true,
        "SAN LUIS": true
      },
      "78318": {
        "MANUEL JOSÉ OTHÓN": true,
        "SAN ANTONIO": true
      },
      "78319": {
        "INSURGENTES": true
      },
      "78320": {
        "EL PASEO": true,
        "FRANCISCO I MADERO": true
      },
      "78328": {
        "LAS GAVIOTAS": true,
        "NUEVO PASEO": true
      },
      "78330": {
        "BOLÍVAR": true,
        "INDEPENDENCIA": true
      },
      "78338": {
        "DE LA ROSA": true
      },
      "78339": {
        "SAN MIGUELITO": true
      },
      "78340": {
        "ENCANTO": true,
        "EUCALIPTOS": true,
        "GUADALUPE": true,
        "JULIÁN CARRILLO": true,
        "NIÑOS HÉROES": true,
        "SAN JUAN DE GUADALUPE": true,
        "TORRES DEL SANTUARIO": true
      },
      "78349": {
        "SAN SEBASTIÁN": true
      },
      "78350": {
        "CONSTITUCIÓN": true,
        "JARDINES DE NUEVO PASEO": true,
        "REVOLUCIÓN": true,
        "RINCONADA VALPARAÍSO": true,
        "SAN LUIS REY": true,
        "SANTA FE SUR": true
      },
      "78356": {
        "VALLE DEL SANTUARIO": true
      },
      "78357": {
        "COLONIA RICARDO FLORES MAGÓN": true
      },
      "78358": {
        "VILLA RICA": true
      },
      "78359": {
        "SAN JUAN DE GUADALUPE": true
      },
      "78360": {
        "5 DE MAYO": true,
        "APOSTÓLICA": true,
        "CÚPULAS DEL SANTUARIO": true,
        "GENERAL IGNACIO MARTÍNEZ": true,
        "GRACIANO SÁNCHEZ 1A SECCIÓN": true,
        "GRACIANO SÁNCHEZ 2A SECCIÓN": true,
        "LOS ARQUITOS": true,
        "MERCADO": true,
        "PRIVADA REGIA": true
      },
      "78363": {
        "UNIVERSIDAD POLITÉCNICA DE SAN LUIS POTOSÍ": true
      },
      "78364": {
        "LAS FLORES": true,
        "TIERRA BLANCA": true
      },
      "78365": {
        "CAMPESTRE JUAN SILOS": true
      },
      "78366": {
        "COLONIA LOS ARQUITOS EN SAN LUIS POTOSÍ": true
      },
      "78367": {
        "PRIMAVERA": true
      },
      "78368": {
        "XICOTENCATL": true
      },
      "78369": {
        "BALCONES DEL VALLE": true,
        "HIMNO NACIONAL 2A SECC": true
      },
      "78370": {
        "6 DE JUNIO": true,
        "PROGRESO": true
      },
      "78377": {
        "AREA RESIDENCIAL": true,
        "DALIAS DEL LLANO": true,
        "DEL LLANO": true
      },
      "78378": {
        "ESPAÑITA": true
      },
      "78379": {
        "ANÁHUAC": true,
        "LAS PILITAS": true,
        "SAN MANUEL": true,
        "VALLE DEL POTOSÍ": true
      },
      "78380": {
        "BELLAS LOMAS": true,
        "EL PEÑASCAL": true,
        "LOMAS DE BELLAVISTA": true,
        "LOMAS DE LA VIRGEN": true,
        "PRADOS SATÉLITE": true,
        "SAN JUAN GUADALUPE": true,
        "SANTUARIO": true,
        "SATÉLITE FRANCISCO I MADERO": true,
        "SIMÓN DIAZ": true,
        "VIVEROS SATÉLITE": true
      },
      "78384": {
        "LOMAS DE SATÉLITE": true,
        "TARRAGONA RESIDENCIAL": true,
        "TEPEYAC": true
      },
      "78385": {
        "AGUA REAL": true,
        "AGUAZAL": true,
        "ANTORCHA POPULAR": true,
        "LOS PINOS": true,
        "NUEVO PROGRESO": true,
        "PRIVADA DIAMANTE RESIDENCIAL": true,
        "PRIVADA RINCONADA DEL PROGRESO": true,
        "PRIVADA SANTA CLARA": true,
        "PUERTA DE PIEDRA": true,
        "RESIDENCIAL DEL BOSQUE": true,
        "RESIDENCIAL SALK": true,
        "SIMÓN DIAZ AGUAJE": true,
        "SIMÓN DIAZ INFONAVIT": true,
        "SIMÓN DÍAZ (INDECO)": true,
        "VALLE DE LAS ROSAS": true,
        "VALLE DEL PROGRESO": true
      },
      "78387": {
        "SAN LEONEL": true
      },
      "78388": {
        "CONSTITUYENTES": true
      },
      "78389": {
        "5 DE FEBRERO": true,
        "COLORINES": true,
        "DIAGONAL": true,
        "GOLONDRINAS": true,
        "MARBELLA CONJUNTO RESIDENCIAL": true,
        "PRIVADA ESPAÑITA": true,
        "RINCONADA DE LOS OLIVOS": true,
        "VILLA ESPAÑOLA": true
      },
      "78390": {
        "CENTRO DE ABASTOS": true,
        "FLORENCIA": true,
        "HERMENEGILDO J ALDANA": true,
        "JAIME TORRES BODET": true,
        "JARDINES DE ORIENTE": true,
        "LOS ALMENDROS": true,
        "MAYAMIL": true,
        "PRADOS GLORIETA": true,
        "PRIVADA REAL": true,
        "PROVIDENCIA": true,
        "RICARDO B ANAYA": true,
        "SANTA FÉ": true,
        "SOL": true,
        "UNIDAD PONCIANO ARRIAGA 3A SECCIÓN": true
      },
      "78394": {
        "ABASTOS INFONAVIT": true,
        "ARCO IRIS": true,
        "AZTECA": true,
        "CECILIA OCCELLI": true,
        "CIELO CLARO LAS MERCEDES": true,
        "COLONIAL ABASTOS": true,
        "DEL RÍO": true,
        "EJIDAL LA LIBERTAD": true,
        "EL PALMAR": true,
        "EL PALMERAL": true,
        "EL PORTAL": true,
        "ENRAMADAS": true,
        "INFONAVIT CIUDAD 2000": true,
        "JARDINES DE LA LIBERTAD": true,
        "JARDINES DEL ROSARIO": true,
        "LA LIBERTAD II": true,
        "LAS MERCEDES": true,
        "LAS PALMAS": true,
        "LIBERTAD": true,
        "LIBERTAD DE MÉXICO": true,
        "LIBERTAD INFONAVIT ABASTOS": true,
        "LOS MOLINOS": true,
        "LOS SILOS": true,
        "MISIÓN DEL PALMAR": true,
        "PARQUE HERRADURA": true,
        "PASEO DE LOS AGAVES": true,
        "PRADERAS DEL REAL": true,
        "PRADOS DE SAN VICENTE SEGUNDA SECCIÓN": true,
        "PRADOS DE SAN VICENTE TERCERA SECCIÓN": true,
        "PRADOS ORIENTE": true,
        "RANCHO LA LIBERTAD": true,
        "RANCHO VIEJO": true,
        "SAN CRISTÓBAL": true,
        "SAN JORGE": true,
        "SAN XAVIER": true,
        "SEMINARIO LA MISIÓN": true,
        "SEMINARIO RESIDENCIAL": true,
        "SILOS ZONA DORADA": true,
        "TORRE DE BABEL": true,
        "VILLA DE LAS TORRES": true,
        "VILLA MOLINOS": true,
        "VILLAS DEL SOL": true
      },
      "78396": {
        "ESTRELLA DE ORIENTE": true,
        "JOSÉ DE GÁLVEZ": true,
        "MINAS DEL REAL": true,
        "OBISPADO": true,
        "PRADOS DE SAN VICENTE": true,
        "RESIDENCIAL CUMBRES": true,
        "RICARDO B ANAYA 2A SECC": true,
        "VILLA JARDÍN": true
      },
      "78399": {
        "CAPRICORNIO": true,
        "CENTRAL": true,
        "CONJUNTO RUBÍ": true,
        "EL NARANJAL VALLE DORADO": true,
        "ESMERALDA": true,
        "GLORIETA": true,
        "HOLANDA": true,
        "JARDINES DEL SUR": true,
        "LAS JOYAS": true,
        "NUEVO VALLE DORADO": true,
        "RESIDENCIAL LAS MINAS": true,
        "RINCONADA DE VALLE DORADO": true,
        "SAN PATRICIO": true,
        "TALLERES": true,
        "VALLE DE DALIAS": true,
        "VALLE DORADO": true
      }
    },
    "SOLEDAD DE GRACIANO SÁNCHEZ": {
      "78430": {
        "16 DE SEPTIEMBRE": true,
        "ARBOLEDAS DE SOLEDAD": true,
        "BUENAVENTURA": true,
        "CALDERA": true,
        "CANTAGUA PRIVADA RESIDENCIAL": true,
        "EL JARALITO": true,
        "EL ROBLE": true,
        "EL ZAPOTE": true,
        "ESCONTRIA": true,
        "EXPROPIACIÓN PETROLERA": true,
        "FRACCIÓN RIVERA": true,
        "FRANCISCO VILLA": true,
        "GRAND SOLEDAD": true,
        "LA RIVERA": true,
        "LAS CANTERAS": true,
        "LAS CAPILLAS": true,
        "LAS CRUCES": true,
        "LAS FLORES": true,
        "LAS HIGUERAS": true,
        "LAS HUERTAS": true,
        "LOS LIRIOS": true,
        "LOS OLIVOS": true,
        "LOS PIRULES": true,
        "LOS VIÑEDOS": true,
        "LOS ÁNGELES": true,
        "LUIS DONALDO COLOSIO": true,
        "MA. LAURA": true,
        "MARÍA FERNANDA": true,
        "NOGALIA": true,
        "PASEO DE SAN FERNANDO": true,
        "PIPILA": true,
        "PRIVADA CENTENARIO": true,
        "PRIVADA NUESTRA SEÑORA DE LA SOLEDAD": true,
        "PRIVADA VILLA VERONA": true,
        "PUERTA REAL": true,
        "PUESTA DEL SOL": true,
        "RANCHO NUEVO": true,
        "RESIDENCIAL LAS FLORES": true,
        "RESIDENCIAL LOS LAURELES": true,
        "RINCONADA DE LAS FLORES": true,
        "SAN GERARDO": true,
        "SAN JUANITA": true,
        "SAN PABLO": true,
        "SOLEDAD DE GRACIANO SÁNCHEZ CENTRO": true,
        "TEXTIL": true,
        "VILLA DORADA": true,
        "VILLAS DE SOLEDAD": true,
        "VILLAS DEL SOL": true
      },
      "78432": {
        "BOSQUES DEL MÁRQUEZ": true,
        "EL LAUREL": true,
        "EL MÁRQUEZ": true
      },
      "78433": {
        "ARBOLEDAS": true,
        "CAMPO BELLO": true,
        "COVADONGA": true,
        "HACIENDA DE SANTO TOMÁS": true,
        "HACIENDA DEL BARRANCO": true,
        "HUERTA DEL ÁNGEL": true,
        "LA COFRADÍA": true,
        "LA CONSTANCIA": true,
        "LA MISIÓN": true,
        "LA RAZA": true,
        "LAS AMÉRICAS": true,
        "LAS HADAS": true,
        "LOMAS DE SAN FELIPE": true,
        "LOS FRESNOS": true,
        "MEZQUITE": true,
        "MONTE VERDE": true,
        "MORELOS": true,
        "NOGALES RESIDENCIAL": true,
        "PORTONES DEL REAL": true,
        "PORTÓN DE SAN CARLOS": true,
        "PORTÓN DE SAN JOSÉ": true,
        "PORTÓN NARANJA": true,
        "POTRERO DE ADENTRO": true,
        "PRIVADA DE LOS PINOS": true,
        "PRIVADA FRESNOS": true,
        "PRIVADA SAN JORGE": true,
        "PRIVADA SAN LORENZO": true,
        "RESIDENCIAL SANTIAGO": true,
        "SAN FELIPE": true,
        "SAN JOSÉ": true,
        "SAN JOSÉ DEL BARRO": true,
        "SANTA LUCÍA": true,
        "SANTA TERESA": true,
        "SANTO TOMÁS": true,
        "TOSCANA RESIDENCIAL": true,
        "URBANA MORELOS": true,
        "VALLE DE BELLAVISTA": true,
        "VALLE DE SAN PATRICIO": true,
        "VALLE DE SANTIAGO": true,
        "VALLE DEL ECUESTRE": true,
        "VILLAS DE SAN LORENZO": true,
        "VIZCAYA": true
      },
      "78434": {
        "ARCANO RESIDENCIAL": true,
        "ARCOS DE SAN PEDRO": true,
        "CENTRAL": true,
        "CERRADA DE LAS HUERTAS": true,
        "CERRADA DEL REAL": true,
        "CONJUNTO LAS AVES": true,
        "DEL PRADO RESIDENCIAL": true,
        "EL BARRANCO": true,
        "EL CANTO RESIDENCIAL": true,
        "EL MORRO": true,
        "EL TORO": true,
        "ESCOBILLAL": true,
        "HACIENDA LAS MARGARITAS": true,
        "HACIENDA SAN MIGUEL": true,
        "HOGARES POPULARES PAVÓN 1A SECCIÓN": true,
        "HOGARES POPULARES PAVÓN 2A SECCIÓN": true,
        "HOGARES POPULARES PAVÓN 3A SECCIÓN": true,
        "JARDÍN CHAPULTEPEC": true,
        "LA HACIENDA": true,
        "LA HUERTA": true,
        "LA LOMA": true,
        "LA LOMITA 1A SECCIÓN": true,
        "LA LOMITA 2A SECCIÓN": true,
        "LA LOMITA 3A SECCIÓN": true,
        "LA VIRGEN": true,
        "LETTO": true,
        "LOS AGAVES": true,
        "MAZZADA RESIDENCIAL": true,
        "MURETTO": true,
        "NIÑOS HÉROES": true,
        "PASEO DE SAN FRANCISCO": true,
        "PRIVADA CHAPULTEPEC": true,
        "PRIVADA ITURBIDE": true,
        "PRIVADA PUERTA SOCORRO": true,
        "PRIVADA SAN PEDRO": true,
        "PROVIDENCIA": true,
        "RANCHO PAVÓN INFONAVIT": true,
        "REAL PROVIDENCIA": true,
        "RESIDENCIAL PAVÓN": true,
        "RINCONADA CHAPULTEPEC": true,
        "RINCONADA SAN PEDRO": true,
        "SAN ANDRÉS": true,
        "SAN FRANCISCO": true,
        "SAN PEDRO INFONAVIT": true,
        "SPELLO RESIDENCIAL": true,
        "URBANA CENTRAL DE MAQUINARIA": true,
        "VALLE DE LA VIRGEN": true,
        "VILLA FONTANA": true,
        "VILLAS DEL MORRO": true,
        "VITTANOVA RESIDENCIAL": true
      },
      "78435": {
        "BOSQUES DE SAN FRANCISCO": true,
        "CERRADA DEL BOSQUE": true,
        "LA HORMIGA": true,
        "LAS PALMAS": true,
        "LOS PUENTES": true,
        "QUINTAS DE DON ROBERTO": true,
        "RINCONADA DE LAS ROSAS": true,
        "SAN ANTONIO INFONAVIT": true,
        "SAN FRANCISCO": true,
        "VALLE DE SAN ISIDRO": true
      },
      "78436": {
        "5O PLANO DE LA GENOVEVO RIVAS GUILLÉN": true,
        "AZALEAS": true,
        "BUGAMBILIAS": true,
        "CONJUNTO RESIDENCIAL Y PLAZA SANTA CLARA": true,
        "EL POLVORÍN": true,
        "FIDEL VELÁZQUEZ": true,
        "GENERAL GENOVEVO RIVAS GUILLEN": true,
        "GENERAL GENOVEVO RIVAS GUILLÉN SEGUNDA SECCIÓN": true,
        "GENERAL GENOVEVO RIVAS GUILLÉN TERCERA SECCIÓN": true,
        "HOGARES FERROCARRILEROS 1A SECC": true,
        "HOGARES FERROCARRILEROS 2A SECC": true,
        "HOGARES FERROCARRILEROS 3A SECC": true,
        "LAS CANTERAS": true,
        "LOS ÁLAMOS": true,
        "MISIÓN DE SAN PEDRO": true,
        "NUEVO TESTAMENTO": true,
        "PRADERAS DEL MAUREL": true,
        "PUENTE REAL": true,
        "QUINTAS SOLEDAD": true,
        "RANCHO BLANCO": true,
        "REAL DEL BOSQUE": true,
        "SAN ANTONIO": true,
        "SAN FRANCISCO DE ASÍS NORTE": true,
        "VILLAS DE SAN FRANCISCO": true,
        "VILLAS GLORIETA": true
      },
      "78437": {
        "21 DE MARZO": true,
        "BENITO JUÁREZ": true,
        "EL LAUREL": true,
        "EL LAVADERO": true,
        "FRANCISCO SARABIA": true,
        "GRACIANO SÁNCHEZ": true,
        "JARDINES DE ORIENTE": true,
        "JARDINES DEL VALLE": true,
        "NUEVO FORESTA": true,
        "REFORMA 2DA. SECCIÓN": true,
        "SAN FRANCISCO DE ASÍS": true,
        "SANTA MÓNICA": true,
        "UNIDAD MILITAR FORESTA": true,
        "UNIDAD PONCIANO ARRIAGA": true,
        "UNIDAD PONCIANO ARRIAGA 2A SECC": true,
        "VALLE REAL": true,
        "VILLAS DEL POTOSÍ": true
      },
      "78438": {
        "9 DE MAYO": true,
        "ARBOLEDAS DE ORIENTE": true,
        "ARBOLEDAS II": true,
        "BOSQUE REAL": true,
        "BOSQUES DE ORIENTE": true,
        "COLINAS DEL BOSQUE": true,
        "COLINAS DEL MÁRQUEZ": true,
        "CONJUNTO DEL REAL": true,
        "DEL BOSQUE": true,
        "DERECHOS HUMANOS": true,
        "EJIDO LOS GÓMEZ": true,
        "EL GARAMBULLAL DOS": true,
        "EL REFUGIO": true,
        "EL TANQUESITO": true,
        "EL TUCÁN": true,
        "EMILIANO ZAPATA": true,
        "FORESTA": true,
        "HACIENDA DE LAS CRUCES": true,
        "HACIENDA DE LOS MORALES": true,
        "HACIENDA DEL POTRERO": true,
        "HOGARES OBREROS": true,
        "JARDÍNES DEL SOL": true,
        "JOSÉ CARMEN HERNÁNDEZ MONCADA": true,
        "LA CRUZ": true,
        "LA LIBERTAD": true,
        "LA SIERRA": true,
        "LOS CACTUS": true,
        "LOS GÓMEZ": true,
        "LOS HORNOS": true,
        "MONTE GRANADO": true,
        "PRADOS DE SOLEDAD": true,
        "PRIMERO DE MAYO": true,
        "PRIMERO DE MAYO 2A. SECCIÓN": true,
        "PRIVADA HACIENDA COCOYOC": true,
        "PRIVADA HACIENDA DE SAN AGUSTÍN": true,
        "PRIVADA HACIENDA GUADALUPE": true,
        "PRIVADA HACIENDA LA ESTANCIA": true,
        "PRIVADA HACIENDA SAN GABRIEL": true,
        "PRIVADA HACIENDA SAN MATEO": true,
        "PRIVADA QUINTA DEL SOL": true,
        "PRIVADA QUINTA EL MÁRQUEZ": true,
        "PRIVADA SAN SEBASTIÁN": true,
        "PRIVADA SANTA FE": true,
        "PUERTA DEL SOL": true,
        "PUNTA DIAMANTE RESIDENCIAL": true,
        "QUINTA TERRA": true,
        "QUINTAS DE LA HACIENDA": true,
        "QUINTAS DE LA HACIENDA 2": true,
        "QUINTAS DE LA HACIENDA 3A SECC": true,
        "QUINTAS VALLADOLID": true,
        "RANCHO BLANCO": true,
        "RANCHO LA LIBERTAD": true,
        "REAL DE SAN PEDRO": true,
        "REAL DE SAN PEDRO II": true,
        "RESIDENCIAL MAYORAZGO": true,
        "RINCONADA B ANAYA": true,
        "RINCONADA DE CACTUS": true,
        "RINCONADA DE LOS HORNOS": true,
        "RINCONADA DEL PALMAR": true,
        "ROBERTO CERVANTES": true,
        "SAN LUIS 1": true,
        "SAN RAFAEL": true,
        "SANTA CRUZ": true,
        "SIERRA BONITA": true,
        "VALLE DE GARAMBULLOS": true,
        "VALLE DE LAS DUNAS": true,
        "VALLE DEL AGAVE": true,
        "VALLE DEL ALTIPLANO": true,
        "VALLE DEL ALTIPLANO 2A. SECC.": true,
        "VALLE DEL CACTUS": true,
        "VALLE DEL HUIZACHE": true,
        "VALLE DEL MAGUEY": true,
        "VILLA ALBORADA": true,
        "VILLA JARDÍN": true,
        "VILLA RICA": true,
        "VILLAS DE FORESTA": true,
        "VILLAS DEL CACTUS": true,
        "VILLAS DEL SOL": true
      }
    }
  },
  "SINALOA": {
    "CULIACÁN": {
      "80000": {
        "CENTRO": true
      },
      "80010": {
        "ARBOLEDAS": true
      },
      "80013": {
        "CIUDAD UNIVERSITARIA": true
      },
      "80014": {
        "ALBATERRA": true
      },
      "80015": {
        "LOMAS DE SAN JERÓNIMO": true
      },
      "80016": {
        "16 DE SEPTIEMBRE": true
      },
      "80017": {
        "EL MIRADOR": true
      },
      "80018": {
        "LAS CUCAS": true
      },
      "80019": {
        "ROTARISMO": true
      },
      "80020": {
        "FOVISSSTE DIAMANTE": true
      },
      "80025": {
        "VILLA DEL PEDREGAL": true
      },
      "80026": {
        "ISSSTESIN": true
      },
      "80027": {
        "CUAUHTÉMOC": true
      },
      "80028": {
        "AGUSTINA RAMÍREZ": true
      },
      "80029": {
        "FINCAS DEL HUMAYA": true
      },
      "80030": {
        "BURÓCRATA": true
      },
      "80034": {
        "COMUNICADORES": true
      },
      "80040": {
        "FOVISSSTE ABELARDO DE LA TORRE": true
      },
      "80050": {
        "HERMANOS FLORES MAGÓN": true
      },
      "80054": {
        "4 DE MARZO": true
      },
      "80055": {
        "UNIVERSIDAD 94 II": true
      },
      "80058": {
        "PRADERA DORADA": true
      },
      "80059": {
        "CANACO": true
      },
      "80060": {
        "LA CAMPIÑA": true
      },
      "80063": {
        "LOS SABINOS": true
      },
      "80064": {
        "LA LIMITA DE ITAJE": true
      },
      "80065": {
        "PONTEVEDRA": true
      },
      "80070": {
        "VICENTE GUERRERO": true
      },
      "80080": {
        "EL BARRIO": true
      },
      "80088": {
        "VILLA SATÉLITE": true
      },
      "80090": {
        "LAS VEGAS": true
      },
      "80093": {
        "NOVENA ZONA MILITAR": true
      },
      "80100": {
        "LOS ÁLAMOS": true
      },
      "80103": {
        "UNIDAD DE SERVICIOS EDUCATIVOS A DESCENTRALIZAR": true
      },
      "80104": {
        "LAS FLORES": true
      },
      "80105": {
        "RECURSOS HIDRÁULICOS": true
      },
      "80106": {
        "BLOOM": true
      },
      "80107": {
        "COUNTRY COURTS": true
      },
      "80109": {
        "UNIDAD DE SERVICIOS ESTATALES": true
      },
      "80110": {
        "EL VALLADO": true
      },
      "80120": {
        "INDUSTRIAL BRAVO": true
      },
      "80128": {
        "LOS PINOS": true
      },
      "80130": {
        "AEROPUERTO": true
      },
      "80135": {
        "NUEVO BACHIGUALATO": true
      },
      "80139": {
        "CULIACÁN (CULIACÁN)": true
      },
      "80140": {
        "CAMPO BELLO": true
      },
      "80143": {
        "TERRANOVA": true
      },
      "80144": {
        "TORRES AEROPUERTO": true
      },
      "80145": {
        "PARQUE INDUSTRIAL ORIÓN": true
      },
      "80150": {
        "SAN RAFAEL": true
      },
      "80155": {
        "RINCÓN DEL VALLE": true
      },
      "80159": {
        "INFONAVIT LAS FLORES": true
      },
      "80160": {
        "INDUSTRIAL EL PALMITO": true
      },
      "80170": {
        "MORELOS": true
      },
      "80176": {
        "BALCONES DE SAN MIGUEL": true
      },
      "80177": {
        "LOMA LINDA": true
      },
      "80178": {
        "CAÑADAS": true
      },
      "80179": {
        "INFONAVIT CAÑADAS": true
      },
      "80180": {
        "GUSTAVO DÍAZ ORDAZ": true
      },
      "80184": {
        "BALCONES DEL VALLE": true
      },
      "80189": {
        "INFONAVIT BARRANCOS": true
      },
      "80190": {
        "ADOLFO LÓPEZ MATEOS": true
      },
      "80194": {
        "DOMINGO RUBÍ": true
      },
      "80197": {
        "ESTHELA ORTIZ DE TOLEDO": true
      },
      "80199": {
        "AMADO NERVO": true
      },
      "80200": {
        "JORGE ALMADA": true
      },
      "80210": {
        "BENITO JUÁREZ": true
      },
      "80220": {
        "GUADALUPE": true
      },
      "80225": {
        "INSTITUTO TECNOLÓGICO REGIONAL DE CULIACÁN": true
      },
      "80227": {
        "MONTEBELLO": true
      },
      "80228": {
        "COLINAS DE SAN MIGUEL": true
      },
      "80230": {
        "ANTONIO ROSALES": true
      },
      "80240": {
        "GUADALUPE VICTORIA": true
      },
      "80246": {
        "BANJERCITO": true
      },
      "80247": {
        "5 DE FEBRERO": true
      },
      "80248": {
        "LA ESPERANZA": true
      },
      "80249": {
        "CAMPESINA EL BARRIO": true
      },
      "80250": {
        "LOMAS DE GUADALUPE": true
      },
      "80260": {
        "EMILIANO ZAPATA": true
      },
      "80270": {
        "10 DE MAYO": true
      },
      "80279": {
        "REPÚBLICA MEXICANA": true
      },
      "80280": {
        "MEZQUITILLO": true
      },
      "80290": {
        "LAS HUERTAS": true
      },
      "80294": {
        "UNIÓN ANTORCHISTA": true
      },
      "80295": {
        "LAS ILUSIONES": true
      },
      "80296": {
        "LA COSTERA": true
      },
      "80297": {
        "CNOP": true
      },
      "80298": {
        "HUIZACHES": true
      },
      "80299": {
        "MERCADO DE ABASTOS": true
      },
      "80308": {
        "AGUARUTO CENTRO": true
      }
    },
    "MAZATLÁN": {
      "82000": {
        "BALCONES DE LOMA LINDA": true
      },
      "82010": {
        "CAMPO BELLO": true
      },
      "82013": {
        "FERROCARRILERA": true
      },
      "82014": {
        "SAN ÁNGEL": true
      },
      "82015": {
        "TRÓPICO DE CÁNCER": true
      },
      "82016": {
        "BRISAS DEL MAR": true
      },
      "82017": {
        "TELLERIA": true
      },
      "82018": {
        "INSURGENTES": true
      },
      "82019": {
        "TIERRA Y LIBERTAD": true
      },
      "82020": {
        "12 DE MAYO": true
      },
      "82028": {
        "CASAS ECONÓMICAS": true
      },
      "82030": {
        "MONTUOSA": true
      },
      "82035": {
        "SÁNCHEZ TABOADA": true
      },
      "82037": {
        "FRANCISCO SOLÍS": true
      },
      "82038": {
        "OBRERA": true
      },
      "82040": {
        "GABRIEL LEYVA": true
      },
      "82043": {
        "JOSÉ DE NAZARET": true
      },
      "82047": {
        "OCTAVA ZONA NAVAL (PUERTO MAZATLÁN)": true
      },
      "82050": {
        "ALFREDO V. BONFIL": true
      },
      "82059": {
        "CASA REDONDA": true
      },
      "82060": {
        "FRANCISCO I MADERO": true
      },
      "82070": {
        "EJIDO RINCÓN DE URÍAS": true
      },
      "82080": {
        "GENERAL RAFAEL BUELNA": true
      },
      "82089": {
        "CENTRAL TERMOÉLECTRICA JOSÉ ACEVES POZOS": true
      },
      "82090": {
        "LAS FLORES": true
      },
      "82099": {
        "VILLA DE GUADALUPE": true
      },
      "82100": {
        "SÁBALO COUNTRY CLUB": true
      },
      "82102": {
        "MARINA EL CID": true
      },
      "82103": {
        "PARAÍSO MARINA": true
      },
      "82110": {
        "EL CID": true
      },
      "82112": {
        "AZUL PACIFIC": true
      },
      "82113": {
        "CLUB REAL": true
      },
      "82118": {
        "RINCÓN COLONIAL": true
      },
      "82120": {
        "EL TOREO": true
      },
      "82123": {
        "JARDINES DE LA ALAMEDA": true
      },
      "82124": {
        "VEREDAS RESIDENCIAL": true
      },
      "82125": {
        "RINCÓN DE LAS PLAZAS": true
      },
      "82126": {
        "HACIENDA LAS CRUCES": true
      },
      "82127": {
        "FRANCISCO VILLA": true
      },
      "82128": {
        "INFONAVIT PLAYAS": true
      },
      "82129": {
        "HACIENDA DEL SEMINARIO": true
      },
      "82130": {
        "MAR DE CORTÉS": true
      },
      "82132": {
        "PORTOMOLINO": true
      },
      "82133": {
        "LAS MISIONES": true
      },
      "82134": {
        "MONTE VERDE": true
      },
      "82136": {
        "MONTEBELLO": true
      },
      "82137": {
        "HUERTOS FAMILIARES": true
      },
      "82138": {
        "FOVISSSTE PLAYA AZUL": true
      },
      "82139": {
        "LA CANTERA": true
      },
      "82140": {
        "ESTADIO": true
      },
      "82143": {
        "CASA BLANCA": true
      },
      "82144": {
        "GIRASOLES": true
      },
      "82146": {
        "SEMBRADORES DE LA AMISTAD": true
      },
      "82147": {
        "MARÍA FERNANDA": true
      },
      "82148": {
        "PLAYAS DEL SOL": true
      },
      "82149": {
        "FLAMINGOS": true
      },
      "82150": {
        "OLÍMPICA": true
      },
      "82153": {
        "ANTONIO TOLEDO CORRO": true
      },
      "82154": {
        "PORTAL DE LOS OLIVOS": true
      },
      "82155": {
        "RUBÉN JARAMILLO": true
      },
      "82156": {
        "VILLAS DEL ESTERO": true
      },
      "82157": {
        "LA CIMA RESIDENCIAL": true
      },
      "82158": {
        "FEDERICO VELARDE": true
      },
      "82159": {
        "ESPERANZA FOVISSSTE": true
      },
      "82160": {
        "LUIS ECHEVERRÍA ALVAREZ": true
      },
      "82163": {
        "BURÓCRATA": true
      },
      "82164": {
        "SALVADOR ALLENDE": true
      },
      "82165": {
        "JABALÍES": true
      },
      "82170": {
        "CONSTITUCIÓN": true
      },
      "82180": {
        "BENITO JUÁREZ": true
      },
      "82183": {
        "OBRERA INDUSTRIAL": true
      },
      "82185": {
        "LOMA ATRAVESADA": true
      },
      "82186": {
        "AZTECA": true
      },
      "82187": {
        "SAN RAFAEL": true
      },
      "82188": {
        "ANÁHUAC": true
      },
      "82190": {
        "LOMAS DE LAS TORRES": true
      },
      "82195": {
        "PALMARES": true
      },
      "82197": {
        "PRIMAVERA": true
      },
      "82198": {
        "LOS ACANTOS": true
      },
      "82199": {
        "HIGUERAS RESIDENCIAL": true
      }
    }
  },
  "VERACRUZ": {
    "BOCA DEL RÍO": {
      "94290": {
        "BOCA DEL RÍO CENTRO": true,
        "CAMINO REAL": true,
        "COSTA DEL SOL": true,
        "EL ESTERO": true,
        "HICACAL": true,
        "HICACAL II": true,
        "ISSSFAM MILITAR": true,
        "LA TAMPIQUERA": true,
        "PESCADORES": true,
        "RESIDENCIAL EL DORADO": true,
        "RICARDO FLORES MAGÓN": true,
        "RÍO JAMAPA": true
      },
      "94293": {
        "CORDILLERAS": true,
        "EL MORRO LAS COLONIAS": true,
        "GARDENIAS": true,
        "GRACIANO SÁNCHEZ ROMO": true,
        "INFONAVIT EL MORRO": true,
        "LOMAS DEL MAR": true,
        "LOS ARCOS": true,
        "LOS DELFINES": true,
        "PLAYA HERMOSA": true,
        "RESIDENCIAL LA JOYA": true,
        "SAN JOSÉ": true
      },
      "94294": {
        "COSTA VERDE": true,
        "ESTATUTO JURIDICO": true,
        "FOVISSSTE": true,
        "GALAXIA": true,
        "JARDINES DE VIRGINIA": true,
        "SUTSEM": true,
        "VIRGINIA": true
      },
      "94295": {
        "BONOS DEL AHORRO NACIONAL": true,
        "CASAS TAMSA": true,
        "LINDA VISTA": true,
        "MARCO ANTONIO MUÑOZ": true,
        "NUEVA ERA": true,
        "REMES": true,
        "RIGO": true,
        "VISTA ALEGRE": true
      },
      "94296": {
        "HÍPICO": true,
        "MANLIO FABIO ALTAMIRANO (LECHEROS)": true,
        "MANUEL NIETO": true,
        "REVOLUCIÓN": true,
        "TAMSA": true,
        "VIRGINIA CORDERO DE MURILLO VIDAL": true
      },
      "94297": {
        "8 DE MARZO": true,
        "9 DE MARZO": true,
        "AMPLIACIÓN MIGUEL ALEMÁN": true,
        "CUBIKA": true,
        "DANTE DELGADO RANAURO": true,
        "EJIDO PRIMERO DE MAYO NORTE": true,
        "EJIDO PRIMERO DE MAYO SUR": true,
        "EL MANANTIAL": true,
        "FERNANDO GUTIÉRREZ BARRIOS": true,
        "GOBIERNO ESTATAL": true,
        "GUILLERMO LÓPEZ PORTILLO": true,
        "INFONAVIT LAS VEGAS": true,
        "JOSÉ LÓPEZ PORTILLO": true,
        "LAS VEGAS II": true,
        "MIGUEL ALEMÁN VALDÉS": true,
        "MILITAR": true,
        "PLAN DE AYALA": true,
        "UGOCEP": true,
        "VENUSTIANO CARRANZA": true,
        "VENUSTIANO CARRANZA 3A SECCIÓN": true
      },
      "94298": {
        "ADALBERTO TEJEDA": true,
        "AMPLIACIÓN VILLA RICA": true,
        "BENITO JUÁREZ": true,
        "JOYAS DE MOCAMBO (GRANJAS LOS PINOS)": true,
        "LA CUCHILLA": true,
        "LAS AMÉRICAS": true,
        "LUIS ECHEVERRÍA ALVAREZ": true,
        "LÁZARO CÁRDENAS": true,
        "OBRERA": true,
        "PLAYA DE ORO MOCAMBO": true,
        "VILLA RICA": true,
        "YLANG YLANG": true
      },
      "94299": {
        "COSTA DE ORO": true,
        "DE LAS AMÉRICAS": true,
        "JARDINES DE MOCAMBO": true,
        "PETROLERA (HERIBERTO KEHOE)": true
      }
    },
    "VERACRUZ": {
      "91694": {
        "VILLARÍN": true
      },
      "91700": {
        "MADERO": true,
        "PINO SUÁREZ": true,
        "VERACRUZ CENTRO": true
      },
      "91708": {
        "COLONIA MADERO": true
      },
      "91709": {
        "AMPLIACIÓN PUERTO DE VERACRUZ": true,
        "FAROS": true,
        "PUERTO DE VERACRUZ": true
      },
      "91710": {
        "LA ARMADA": true,
        "UNIDAD VERACRUZANA": true
      },
      "91712": {
        "MIGUEL HIDALGO": true
      },
      "91713": {
        "LOS REYES": true,
        "LUIS GÓMEZ ZEPEDA": true,
        "NUEVA ESPERANZA": true,
        "POPULARES": true,
        "VÍAS FÉRREAS": true
      },
      "91714": {
        "CHIVERÍA INFONAVIT": true
      },
      "91715": {
        "ASOCIACIÓN CIVIL": true,
        "EL VERGEL": true
      },
      "91716": {
        "BENITO JUÁREZ": true
      },
      "91717": {
        "CASA BLANCA": true,
        "LOMAS DE TARIMOYA": true,
        "LÁZARO CÁRDENAS": true,
        "LÁZARO CÁRDENAS II": true,
        "NIÑOS HÉROES": true,
        "TRIUNFO UNIDO": true
      },
      "91718": {
        "PROLONGACIÓN MIGUEL HIDALGO (POPULARES)": true
      },
      "91720": {
        "21 DE ABRIL": true
      },
      "91726": {
        "2 CAMINOS": true,
        "AEROPUERTO": true,
        "ALBATROS": true,
        "AMPLIACIÓN LAS BAJADAS": true,
        "CLAUSTROS DE SAN JUAN SECCIÓN NORTE": true,
        "CLAUSTROS DE SAN JUAN SECCIÓN SUR": true,
        "COLINAS DE SAN MARCOS": true,
        "COSTA SOL": true,
        "EL FÉNIX": true,
        "EL PARAÍSO": true,
        "EMANCIPACIÓN CAMPESINA": true,
        "HACIENDA LOS PORTALES SECCIÓN NORTE": true,
        "HACIENDA LOS PORTALES SECCIÓN SUR": true,
        "LA POCHOTA": true,
        "LAS BAJADAS": true,
        "LIBERTAD DE EXPRESIÓN": true,
        "LOS ALMENDROS": true,
        "LOS CARRILES": true,
        "LOS LAURELES": true,
        "LOS MANGOS": true,
        "NUEVO VERACRUZ": true,
        "PUEBLOS MÁGICOS": true,
        "XANA": true,
        "XANA II": true
      },
      "91727": {
        "AGUSTÍN ACOSTA LAGUNES": true,
        "CABALLERIZAS": true,
        "DORA MARÍA TREVIÑO": true,
        "LA LAGUNA": true,
        "LA LOMA": true,
        "LOS VOLCANES": true
      },
      "91728": {
        "PANADEROS": true
      },
      "91729": {
        "COYOL BOLÍVAR I": true,
        "COYOL BOLÍVAR II": true,
        "POCITOS Y RIVERA": true
      },
      "91730": {
        "VILLA DE GUADALUPE": true
      },
      "91739": {
        "HERIBERTO JARA CORONA": true,
        "JULIO TEJEDA": true
      },
      "91740": {
        "CHAPULTEPEC": true
      },
      "91749": {
        "SAN ISIDRO": true
      },
      "91750": {
        "PASCUAL ORTIZ RUBIO": true
      },
      "91755": {
        "CRISTÓBAL COLÓN": true
      },
      "91756": {
        "MÉXICO": true
      },
      "91757": {
        "PRIMERO DE MAYO": true
      },
      "91758": {
        "COLONIA PINO SUAREZ": true
      },
      "91759": {
        "VENUSTIANO CARRANZA": true
      },
      "91760": {
        "EL COYOL": true,
        "EL LAGO": true
      },
      "91769": {
        "MARÍA ESTHER ZUNO DE ECHEVERRÍA": true
      },
      "91770": {
        "ADOLFO RUIZ CORTÍNES": true
      },
      "91777": {
        "EMILIANO ZAPATA": true,
        "GEOVILLAS DEL PUERTO": true,
        "LAURELES": true,
        "PERIODISMO VERAZ": true,
        "PREDIO 1": true,
        "PREDIO 2": true,
        "PREDIO 3": true,
        "PREDIO 4": true,
        "RAFAEL DÍAZ SERDAN": true,
        "SIGLO XXI": true
      },
      "91778": {
        "ADOLFO LÓPEZ MATEOS": true
      },
      "91779": {
        "COYOL FOVISSSTE": true,
        "COYOL FRAMBOYANES": true,
        "COYOL MAGISTERIO": true,
        "COYOL SECCION A": true,
        "COYOL SECCION IV": true,
        "COYOL ZONA C": true,
        "COYOL ZONA D": true,
        "EL COYOL (1A SECCIÓN)": true,
        "FICUS": true,
        "LAS PALMAS": true
      },
      "91780": {
        "EL COYOL": true,
        "EL COYOL IVEC": true,
        "LOS FAROS": true,
        "NEZAHUALCÓYOTL": true,
        "VISTA MAR": true
      },
      "91788": {
        "INFONAVIT MEDANO BUENAVISTA": true,
        "SETSE": true
      },
      "91789": {
        "CANDIDO AGUILAR": true
      },
      "91790": {
        "AMPLIACIÓN CUAUHTÉMOC": true,
        "CUAUHTÉMOC": true,
        "LAGUNA REAL": true
      },
      "91799": {
        "ARIES": true,
        "PEDRO IGNACIO MATA": true
      },
      "91800": {
        "ASTILLEROS DE VERACRUZ": true,
        "CAMINO REAL": true,
        "VILLA RICA 1": true,
        "VILLA RICA 2": true
      },
      "91809": {
        "DEL NORTE": true,
        "INFONAVIT LAS BRISAS": true,
        "LAS BRISAS": true,
        "LAS HORTALIZAS": true,
        "LAS HORTALIZAS FOVISSSTE": true,
        "LOMAS DE RÍO MEDIO": true,
        "LOMAS DE RÍO MEDIO II": true,
        "LOMAS DE RÍO MEDIO III": true,
        "LOMBARDO TOLEDANO": true,
        "MARINA MERCANTE": true,
        "RÍO MEDIO": true
      },
      "91810": {
        "PLAYA LINDA": true
      },
      "91817": {
        "LOMAS DEL VERGEL": true
      },
      "91820": {
        "FERNANDO LÓPEZ ARIAS": true
      },
      "91826": {
        "AGRÍCOLA INDUSTRIAL": true,
        "BUENAVISTA": true,
        "CORTÉS": true,
        "GEOVILLAS CAMPESTRE": true,
        "PALMA REAL": true,
        "PALMA REAL II": true,
        "RINCÓN DE PALMA REAL": true,
        "SÁNCHEZ": true
      },
      "91829": {
        "ADOLFO RUIZ CORTINES IPE": true
      },
      "91840": {
        "EMPLEADOS MUNICIPALES": true
      },
      "91841": {
        "TABLAJEROS": true
      },
      "91850": {
        "BUENAVISTA INFONAVIT": true,
        "RESERVA TARIMOYA I": true
      },
      "91855": {
        "10 DE FEBRERO": true,
        "BOSQUES DE TARIMOYA": true,
        "EJIDO TARIMOYA": true,
        "LAS TORRES": true,
        "LOMAS DEL ÁNGEL": true,
        "RESERVA TARIMOYA II": true,
        "RESERVA TARIMOYA III": true,
        "SANTA TERESA": true
      },
      "91859": {
        "QUINTA MARÍA": true
      },
      "91860": {
        "MIGUEL ÁNGEL DE QUEVEDO": true
      },
      "91870": {
        "LOS PINITOS": true,
        "LOS PINOS": true,
        "TECNOLÓGICO": true
      },
      "91880": {
        "JARDÍN": true,
        "RINCÓN MEXICANO": true
      },
      "91890": {
        "VIRGILIO URIBE": true
      },
      "91891": {
        "INDEPENDENCIA": true
      },
      "91897": {
        "FORMANDO HOGAR": true
      },
      "91898": {
        "MIGUEL ALEMÁN": true
      },
      "91899": {
        "MANUEL CONTRERAS": true
      },
      "91900": {
        "RICARDO FLORES MAGÓN": true
      },
      "91910": {
        "IGNACIO ZARAGOZA": true
      },
      "91916": {
        "ELECTRICISTAS": true
      },
      "91918": {
        "MODERNO": true
      },
      "91919": {
        "REFORMA": true
      },
      "91920": {
        "DEL MAESTRO": true
      },
      "91928": {
        "COLONIA LAS ENFERMERAS EN VERACRUZ": true
      },
      "91930": {
        "MILITAR (AHORRO POSTAL)": true
      },
      "91936": {
        "LAS ANTILLAS": true
      },
      "91938": {
        "GRANJAS VERACRUZ": true
      },
      "91940": {
        "FLORESTA": true
      },
      "91947": {
        "ARTICULO 123": true,
        "MALIBRAN": true
      },
      "91948": {
        "ARBOLEDAS": true,
        "EL JOBO": true,
        "FLORES DEL VALLE": true
      },
      "91960": {
        "FRANCISCO VILLA": true
      },
      "91963": {
        "COLONIA CENTRAL DE ABASTOS": true,
        "COLONIA RAFAEL DÍAZ SERDAN": true
      },
      "91965": {
        "MARÍA C DE ROJAS": true
      },
      "91968": {
        "ENRIQUE C REBSAMEN": true
      },
      "91969": {
        "LAS RAZAS": true
      }
    }
  },
  "YUCATÁN": {
    "MÉRIDA": {
      "97000": {
        "MÉRIDA CENTRO": true
      },
      "97003": {
        "LOS REYES": true
      },
      "97050": {
        "ALCALÁ MARTÍN": true
      },
      "97059": {
        "SEÑORIAL": true
      },
      "97060": {
        "CARRILLO ANCONA": true
      },
      "97069": {
        "INALÁMBRICA": true
      },
      "97070": {
        "DOLORES PATRON": true
      },
      "97080": {
        "LA HUERTA": true
      },
      "97088": {
        "SANTA CECILIA": true
      },
      "97089": {
        "CUPULES": true
      },
      "97098": {
        "LOURDES": true
      },
      "97099": {
        "WASPA": true
      },
      "97100": {
        "ITZIMNA": true
      },
      "97107": {
        "MANOLA": true
      },
      "97108": {
        "LAS ARBOLEDAS": true
      },
      "97109": {
        "FERROCARRILEROS": true
      },
      "97110": {
        "REVOLUCIÓN (CORDEMEX)": true
      },
      "97113": {
        "MONTEBELLO": true
      },
      "97114": {
        "MONTE ALBÁN": true
      },
      "97115": {
        "SODZIL NORTE": true
      },
      "97116": {
        "SAN ANTONIO CUCUL": true
      },
      "97117": {
        "SAN RAMON NORTE": true
      },
      "97118": {
        "PLAN DE AYALA": true
      },
      "97119": {
        "BENITO JUÁREZ NTE": true
      },
      "97120": {
        "CAMPESTRE": true
      },
      "97125": {
        "MÉXICO": true
      },
      "97127": {
        "BUENAVISTA": true
      },
      "97128": {
        "MÉXICO NORTE": true
      },
      "97129": {
        "EMILIANO ZAPATA NTE": true
      },
      "97130": {
        "TORREMOLINOS": true
      },
      "97133": {
        "MONTECRISTO": true
      },
      "97134": {
        "MAYA": true
      },
      "97135": {
        "JARDINES DE MÉRIDA": true
      },
      "97136": {
        "FELIPE CARRILLO PUERTO NTE": true
      },
      "97137": {
        "MÉXICO ORIENTE": true
      },
      "97138": {
        "JARDINES DEL NORESTE": true
      },
      "97139": {
        "PRADO NORTE": true
      },
      "97140": {
        "LÓPEZ MATEOS": true
      },
      "97142": {
        "UNIDAD HABITACIONAL CTM": true
      },
      "97143": {
        "POLÍGONO 108": true
      },
      "97144": {
        "EMILIANO ZAPATA OTE": true
      },
      "97145": {
        "LAS PALMAS": true
      },
      "97146": {
        "NUEVA ALEMÁN": true
      },
      "97147": {
        "NUEVO YUCATÁN": true
      },
      "97148": {
        "MIGUEL ALEMÁN": true
      },
      "97149": {
        "SAN ESTEBAN": true
      },
      "97150": {
        "INDUSTRIAL": true
      },
      "97155": {
        "FENIX": true
      },
      "97156": {
        "LOS REYES": true
      },
      "97157": {
        "LÁZARO CÁRDENAS OTE": true
      },
      "97158": {
        "CHUMINOPOLIS": true
      },
      "97159": {
        "MÁXIMO ANCONA": true
      },
      "97160": {
        "DEL PARQUE": true
      },
      "97165": {
        "MELCHOR OCAMPO": true
      },
      "97166": {
        "FIDEL VELÁZQUEZ": true
      },
      "97167": {
        "EMILIO PORTES GIL": true
      },
      "97168": {
        "DEL CARMEN": true
      },
      "97169": {
        "ESPERANZA": true
      },
      "97170": {
        "CHICHEN-ITZA": true
      },
      "97173": {
        "VERGEL": true
      },
      "97174": {
        "VILLAS LA MACARENA": true
      },
      "97175": {
        "AMALIA SOLÓRZANO": true
      },
      "97176": {
        "MISNÉ II": true
      },
      "97177": {
        "AZCORRA": true
      },
      "97178": {
        "BENITO JUÁREZ OTE": true
      },
      "97179": {
        "MIRAFLORES": true
      },
      "97180": {
        "VICENTE SOLÍS": true
      },
      "97189": {
        "CANTO": true
      },
      "97190": {
        "MORELOS": true
      },
      "97195": {
        "NUEVA KUKULKAN": true
      },
      "97196": {
        "SALVADOR ALVARADO SUR": true
      },
      "97198": {
        "AMPLIACIÓN GRANJAS": true
      },
      "97199": {
        "MARÍA LUISA": true
      },
      "97203": {
        "CORDELEROS DE CHUBURNA": true
      },
      "97204": {
        "XCUMPICH": true
      },
      "97205": {
        "RESIDENCIAL HACIENDA REAL": true
      },
      "97206": {
        "EL ROSARIO": true
      },
      "97207": {
        "VILLAS DE CHUBURNA": true
      },
      "97208": {
        "MALAGA": true
      },
      "97209": {
        "JARDINES DE CHUBURNA": true
      },
      "97210": {
        "TANLUM": true
      },
      "97215": {
        "COLONIAL BUENAVISTA": true
      },
      "97217": {
        "FOVISSSTE": true
      },
      "97218": {
        "ROMA": true
      },
      "97219": {
        "FRANCISCO VILLA": true
      },
      "97220": {
        "NUEVA HIDALGO": true
      },
      "97225": {
        "PASEO DE LAS FUENTES": true
      },
      "97226": {
        "EL PORVENIR": true
      },
      "97227": {
        "JACINTO CANEK": true
      },
      "97229": {
        "LUIS ECHEVERRÍA ALVAREZ": true
      },
      "97230": {
        "BOJORQUEZ": true
      },
      "97237": {
        "CENTRAL DE ABASTO": true
      },
      "97238": {
        "NORA QUINTANA": true
      },
      "97239": {
        "YUCALPETEN SECC FLORIDA": true
      },
      "97240": {
        "FRANCISCO I MADERO": true
      },
      "97245": {
        "LÓPEZ PORTILLO": true
      },
      "97246": {
        "JUAN PABLO II SECC. MÉRIDA 2000": true
      },
      "97247": {
        "SAN LORENZO": true
      },
      "97249": {
        "JARDINES DE NUEVA MULSAY III": true
      },
      "97250": {
        "NUEVA SAMBULA": true
      },
      "97255": {
        "BICENTENARIO": true
      },
      "97256": {
        "ÁLVARO TORRES": true
      },
      "97260": {
        "OBRERA": true
      },
      "97267": {
        "MANZANA 115": true
      },
      "97268": {
        "DELIO MORENO CANTON": true
      },
      "97269": {
        "MELITON SALAZAR": true
      },
      "97270": {
        "DOLORES OTERO": true
      },
      "97277": {
        "MERCEDES BARRERA": true
      },
      "97278": {
        "CASTILLA CAMARA": true
      },
      "97279": {
        "SANTA ROSA": true
      },
      "97280": {
        "CINCO COLONIAS": true
      },
      "97284": {
        "LOMAS DEL SUR": true
      },
      "97285": {
        "BELLAVISTA": true
      },
      "97286": {
        "LAS BRISAS DEL SUR": true
      },
      "97287": {
        "DEL SUR": true
      },
      "97288": {
        "CIUDAD INDUSTRIAL": true
      },
      "97289": {
        "LA HACIENDA": true
      },
      "97290": {
        "SAN ANTONIO XLUCH": true
      },
      "97295": {
        "MÉRIDA (LICENCIADO MANUEL CRESCENCIO REJÓN)": true
      },
      "97296": {
        "SAN MARCOS NOCOH": true
      },
      "97297": {
        "VILLAS QUETZAL": true
      },
      "97298": {
        "ZACILHA": true
      },
      "97299": {
        "SAN JOSÉ TECOH": true
      }
    }
  }
},
  startFields: function () {
    try {
      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onProvinceChange();

      document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onProvinceChange);
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').addEventListener("change", _CUSTOM_COD_FORM_PROVINCES.onCityChange);
    } catch (e) {
      console.log(e);
    }
  },
  onProvinceChange: function () {
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;

    var html = "";

    if (!_CUSTOM_COD_FORM_PROVINCES.data[value]) {
      html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
      _CUSTOM_COD_FORM_PROVINCES.onCityChange();
      return;
    }

    html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });

    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').innerHTML = html;

    document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value = "";
    _CUSTOM_COD_FORM_PROVINCES.onCityChange();
  },
  onCityChange: function () {
    var provValue = document.querySelector('#_rsi-cod-form-modal-form [data-type="province_country_field"]').value;
    var value = document.querySelector('#_rsi-cod-form-modal-form [data-type="city_country_field"]').value;

    var html = "";

    if (!_CUSTOM_COD_FORM_PROVINCES.data[provValue]) {
      html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
      return;
    }

    if (!_CUSTOM_COD_FORM_PROVINCES.data[provValue][value]) {
      html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
      document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
      return;
    }

    html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';

    Object.keys(_CUSTOM_COD_FORM_PROVINCES.data[provValue][value]).sort().forEach(function (item) {
      html += '<option value="' + item + '">' + item + '</option>';
    });

    document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').innerHTML = html;
    document.querySelector('#_rsi-cod-form-modal-form [data-type="zip_country_field"]').value = "";
  }
};


function _COD_FORM_ON_OPEN_INIT_END_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_DEF_COVERAGE();
    }
  } catch (e) {
    console.log(e);
  }
  _CUSTOM_COD_FORM_PROVINCES.startFields();
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_COVERAGE();
    }

    var onTimeout = function () {
      if (typeof _CUSTOM_COD_FORM_PROVINCES !== "undefined") {
        _CUSTOM_COD_FORM_PROVINCES.startFields();
      } else {
        setTimeout(onTimeout, 500);
      }
    }

    setTimeout(onTimeout, 500);
  } catch (e) {
    console.log(e);
  }
}

function _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF() {
  try {
    if (typeof _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE === "function") {
      _COD_FORM_ON_OPEN_INIT_END_EMBEDDED_DEF_COVERAGE();
    }

    _COD_FORM_ON_OPEN_INIT_END_EMBEDDED();
  } catch (e) {
    console.log(e);
  }
}

var _COD_FORM_CITY_LABEL = "";
var _COD_FORM_ZIP_LABEL = "";

function _COD_FORM_OVERWRITE_INIT() {
  _rsi.s.form.fields.items_array.forEach(function (item) {
    if (item.type == "province_country_field" || item.type == "province") {
      item.type = "province_country_field";
      item.backendFields.name = "province_country_field";
      item.backendFields.elementType = "select";

      var options = [];

      Object.keys(_CUSTOM_COD_FORM_PROVINCES.data).forEach(key => {
        options.push({
          label: key,
          value: key
        })
      })


      item.backendFields.options = options;
    } else if (item.type == "city") {
      item.type = "city_country_field";
      item.backendFields.name = "city";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_CITY_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_CITY_LABEL) {
        _COD_FORM_CITY_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_CITY_LABEL
      }];
      item.backendFields.options = options;
    } else if (item.type == "zip_code") {
      item.type = "zip_country_field";
      item.backendFields.name = "zip_code";
      item.backendFields.elementType = "select";
      if (item.n) {
        if (item.n.ph) {
          _COD_FORM_ZIP_LABEL = item.n.ph;
        }
      }
      if (!_COD_FORM_ZIP_LABEL) {
        _COD_FORM_ZIP_LABEL = item.label;
      }
      var options = [{
        value: "", label: _COD_FORM_ZIP_LABEL
      }];
      item.backendFields.options = options;
    }
  });

  try {
    if (typeof _COD_FORM_OVERWRITE_INIT_COVERAGE === "function") {
      if (!_COD_FORM_OVERWRITE_INIT_COVERAGE()) {
        return false;
      }
    }
  } catch (e) {
    console.log(e);
  }

  return true;
}